export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  Config: { input: any; output: any; }
  ConversationContext: { input: any; output: any; }
  ConversationOptionsInput: { input: any; output: any; }
  Date: { input: any; output: any; }
  DiagnosisOptionsInput: { input: any; output: any; }
  OpaqueDataScalar: { input: any; output: any; }
  PatientProperties: { input: any; output: any; }
  Payload: { input: any; output: any; }
  RagRuleCitation: { input: any; output: any; }
  RuleRef: { input: any; output: any; }
  StartKey: { input: any; output: any; }
  Statement: { input: any; output: any; }
  StructuredDebugInfo: { input: any; output: any; }
  SummaryOptionsInput: { input: any; output: any; }
  UpdateSummaryErrors: { input: any; output: any; }
  VisitStatus: { input: any; output: any; }
};

export enum AdjustmentReason {
  AcuteToChronic = 'AcuteToChronic',
  BackgroundToActive = 'BackgroundToActive',
  ChronicToAcute = 'ChronicToAcute',
  DividByZero = 'DividByZero',
  EqualNegativeSubtype = 'EqualNegativeSubtype',
  NegativeSymptom = 'NegativeSymptom',
  RedivideSubtypesLift = 'RedivideSubtypesLift',
  ReduceIncidence = 'ReduceIncidence',
  SoftenActiveFindings = 'SoftenActiveFindings'
}

export type BuildCaseOptions = {
  computeValidation?: InputMaybe<Scalars['Boolean']['input']>;
  detectSuspected?: InputMaybe<Scalars['Boolean']['input']>;
  includeEncounter?: InputMaybe<Scalars['Boolean']['input']>;
  includeImpliedFindings?: InputMaybe<Scalars['Boolean']['input']>;
  includeInvalidated?: InputMaybe<Scalars['Boolean']['input']>;
  includePrompt?: InputMaybe<Scalars['Boolean']['input']>;
  includeSkip?: InputMaybe<Scalars['Boolean']['input']>;
  numericalOp?: InputMaybe<NumericalRefinementOperation>;
  onlySkip?: InputMaybe<Scalars['Boolean']['input']>;
};

export enum CrCausality {
  Association = 'ASSOCIATION',
  DiseaseCausesFinding = 'DISEASE_CAUSES_FINDING',
  DiseaseIsaFinding = 'DISEASE_ISA_FINDING',
  FindingCausesDisease = 'FINDING_CAUSES_DISEASE',
  FindingIsaDisease = 'FINDING_ISA_DISEASE',
  Uncorrelated = 'UNCORRELATED'
}

export type CaseCondition = {
  __typename?: 'CaseCondition';
  ddMode?: Maybe<Scalars['String']['output']>;
  feature?: Maybe<Feature>;
  payload?: Maybe<CaseConditionPayload>;
  sortType?: Maybe<SortType>;
  type?: Maybe<Scalars['String']['output']>;
};

export type CaseConditionInput = {
  ddMode?: InputMaybe<Scalars['String']['input']>;
  featureid: Scalars['ID']['input'];
  payload?: InputMaybe<CaseConditionPayloadInput>;
  sortType?: InputMaybe<SortType>;
  type: Scalars['String']['input'];
};

export type CaseConditionPayload = {
  __typename?: 'CaseConditionPayload';
  feature?: Maybe<Feature>;
  val?: Maybe<Scalars['Int']['output']>;
};

export type CaseConditionPayloadInput = {
  featureid?: InputMaybe<Scalars['ID']['input']>;
  selector?: InputMaybe<Scalars['String']['input']>;
  val?: InputMaybe<Scalars['Int']['input']>;
};

export enum CaseFindingPresentationType {
  ActiveFinding = 'ACTIVE_FINDING',
  BackgroundFinding = 'BACKGROUND_FINDING',
  MainFinding = 'MAIN_FINDING'
}

export type CaseMetaData = {
  __typename?: 'CaseMetaData';
  clinicId?: Maybe<Scalars['String']['output']>;
  etag?: Maybe<Scalars['String']['output']>;
};

export type CitationData = {
  __typename?: 'CitationData';
  DOI?: Maybe<Scalars['String']['output']>;
  HIndex?: Maybe<Scalars['Int']['output']>;
  SJR?: Maybe<Scalars['Int']['output']>;
  containerTitle?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  kahunId?: Maybe<Scalars['ID']['output']>;
  pubmedID?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  url?: Maybe<Scalars['String']['output']>;
  vancouver?: Maybe<Scalars['String']['output']>;
};

export type CitationDiseaseData = {
  __typename?: 'CitationDiseaseData';
  citationId: Scalars['ID']['output'];
  count?: Maybe<Scalars['Int']['output']>;
  findings?: Maybe<Array<Maybe<RCohort>>>;
  subtypes?: Maybe<Array<Maybe<RCohort>>>;
  type?: Maybe<CitationType>;
};

export type CitationMutations = {
  __typename?: 'CitationMutations';
  addLlmMainRuleFeedback?: Maybe<LlmAuditLogData>;
  deleteLlmRuleFeedback?: Maybe<Scalars['Boolean']['output']>;
  updateLlmRuleFeedback?: Maybe<LlmAuditLogData>;
};


export type CitationMutationsAddLlmMainRuleFeedbackArgs = {
  comment: Scalars['String']['input'];
  payload: Scalars['String']['input'];
  ruleSourceId: Scalars['String']['input'];
  ruleTargetId: Scalars['String']['input'];
  ruleTypeId: Scalars['String']['input'];
  status: Scalars['Int']['input'];
  tags?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  uniqueRuleId: Scalars['String']['input'];
  user: Scalars['String']['input'];
};


export type CitationMutationsDeleteLlmRuleFeedbackArgs = {
  id: Scalars['String']['input'];
};


export type CitationMutationsUpdateLlmRuleFeedbackArgs = {
  comment: Scalars['String']['input'];
  id: Scalars['String']['input'];
  payload?: InputMaybe<Scalars['Payload']['input']>;
  status: Scalars['Int']['input'];
  tags?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type CitationQueries = {
  __typename?: 'CitationQueries';
  getLlmAuditLog?: Maybe<Array<Maybe<LlmAuditLogData>>>;
};


export type CitationQueriesGetLlmAuditLogArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
};

export enum CitationType {
  Direct = 'direct',
  FromSource = 'fromSource',
  Intermediate = 'intermediate'
}

export type Citations = {
  __typename?: 'Citations';
  citationsData?: Maybe<Array<Maybe<CitationData>>>;
  totalCount?: Maybe<Scalars['Int']['output']>;
};

export type ClinicData = {
  __typename?: 'ClinicData';
  config?: Maybe<Scalars['Config']['output']>;
  date?: Maybe<Scalars['Float']['output']>;
  displayName?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  mergedConfiguration?: Maybe<Scalars['Config']['output']>;
  name?: Maybe<Scalars['String']['output']>;
};

export type ClinicMutations = {
  __typename?: 'ClinicMutations';
  addUser?: Maybe<Result>;
  addUserComment?: Maybe<Result>;
  assignId?: Maybe<Result>;
  copyCaseToClinic?: Maybe<Result>;
  createCode?: Maybe<ShareCodeData>;
  delUser?: Maybe<Result>;
  deleteClinic?: Maybe<Result>;
  deleteCode?: Maybe<Result>;
  renameClinic?: Maybe<Result>;
  setConfig?: Maybe<Result>;
  updateFinished?: Maybe<ShareCodeData>;
  updatePatientProperties?: Maybe<Result>;
  updateSeenByUser?: Maybe<ShareCodeData>;
};


export type ClinicMutationsAddUserArgs = {
  role?: InputMaybe<UserRoles>;
  user?: InputMaybe<Scalars['ID']['input']>;
};


export type ClinicMutationsAddUserCommentArgs = {
  code?: InputMaybe<Scalars['String']['input']>;
  comment?: InputMaybe<Scalars['String']['input']>;
};


export type ClinicMutationsAssignIdArgs = {
  ehrid?: InputMaybe<Scalars['String']['input']>;
  shareid?: InputMaybe<Scalars['String']['input']>;
};


export type ClinicMutationsCopyCaseToClinicArgs = {
  caseId?: InputMaybe<Scalars['String']['input']>;
  destClinicId?: InputMaybe<Scalars['String']['input']>;
};


export type ClinicMutationsCreateCodeArgs = {
  ehrid?: InputMaybe<Scalars['String']['input']>;
  long?: InputMaybe<Scalars['Boolean']['input']>;
  patientProperties?: InputMaybe<PatientPropertiesInput>;
  shareid?: InputMaybe<Scalars['String']['input']>;
};


export type ClinicMutationsDelUserArgs = {
  user?: InputMaybe<Scalars['ID']['input']>;
};


export type ClinicMutationsDeleteCodeArgs = {
  code?: InputMaybe<Scalars['String']['input']>;
};


export type ClinicMutationsRenameClinicArgs = {
  newDisplayName?: InputMaybe<Scalars['String']['input']>;
  newName?: InputMaybe<Scalars['String']['input']>;
};


export type ClinicMutationsSetConfigArgs = {
  config?: InputMaybe<Scalars['Config']['input']>;
};


export type ClinicMutationsUpdateFinishedArgs = {
  shareid?: InputMaybe<Scalars['String']['input']>;
};


export type ClinicMutationsUpdatePatientPropertiesArgs = {
  code?: InputMaybe<Scalars['String']['input']>;
  patientProperties?: InputMaybe<PatientPropertiesInput>;
  shareid?: InputMaybe<Scalars['String']['input']>;
  visitStatus?: InputMaybe<Scalars['VisitStatus']['input']>;
};


export type ClinicMutationsUpdateSeenByUserArgs = {
  code?: InputMaybe<Scalars['String']['input']>;
  isSeen?: InputMaybe<Scalars['Boolean']['input']>;
  user?: InputMaybe<Scalars['String']['input']>;
};

export type ClinicQueries = {
  __typename?: 'ClinicQueries';
  data?: Maybe<ClinicData>;
  filteredVisits?: Maybe<Visits>;
  /** @deprecated Renamed to getCodeById as there are now two ways of identifying patient codes */
  getCode?: Maybe<ShareCodeData>;
  getCodeByDigits?: Maybe<ShareCodeData>;
  getCodeById?: Maybe<ShareCodeData>;
  isClinicNameAvailable?: Maybe<Scalars['Boolean']['output']>;
  /** @deprecated use recentVisits instead */
  recentCodes?: Maybe<Array<Maybe<ShareCodeData>>>;
  recentVisits?: Maybe<Visits>;
  userData?: Maybe<UserData>;
  users?: Maybe<Array<Maybe<UserData>>>;
};


export type ClinicQueriesFilteredVisitsArgs = {
  filter?: InputMaybe<FilterInput>;
  isFinished?: InputMaybe<Scalars['Boolean']['input']>;
  limitRequested?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Order>;
  sortKey?: InputMaybe<Scalars['String']['input']>;
  startKey?: InputMaybe<Scalars['StartKey']['input']>;
};


export type ClinicQueriesGetCodeArgs = {
  code?: InputMaybe<Scalars['ID']['input']>;
};


export type ClinicQueriesGetCodeByDigitsArgs = {
  code?: InputMaybe<Scalars['String']['input']>;
};


export type ClinicQueriesGetCodeByIdArgs = {
  ehrid?: InputMaybe<Scalars['ID']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  shareid?: InputMaybe<Scalars['ID']['input']>;
};


export type ClinicQueriesRecentCodesArgs = {
  daysPrior?: InputMaybe<Scalars['Int']['input']>;
  exclusiveStartDate?: InputMaybe<Scalars['Float']['input']>;
  exclusiveStartId?: InputMaybe<Scalars['String']['input']>;
  isFinished?: InputMaybe<Scalars['Boolean']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
};


export type ClinicQueriesRecentVisitsArgs = {
  daysPrior?: InputMaybe<Scalars['Int']['input']>;
  isFinished?: InputMaybe<Scalars['Boolean']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Order>;
  startKey?: InputMaybe<Scalars['StartKey']['input']>;
};

export type ClinicalReasoning = {
  __typename?: 'ClinicalReasoning';
  complicationOf?: Maybe<EtiologiesOfComplication>;
  debugFlow?: Maybe<ClinicalReasoningFlow>;
  disease?: Maybe<Array<Maybe<QualifiedFeature>>>;
  diseaseCitations?: Maybe<Citations>;
  diseaseGivenDependentFindings?: Maybe<Scalars['Float']['output']>;
  diseaseGivenDependentFindingsUnNormalized?: Maybe<Scalars['Float']['output']>;
  diseaseGivenIndependentFindings?: Maybe<Scalars['Float']['output']>;
  findings?: Maybe<Array<Maybe<ClinicalReasoningFinding>>>;
  flags?: Maybe<Array<Maybe<Flag>>>;
  forcedInBestMatch?: Maybe<Scalars['Boolean']['output']>;
  forcedInHighestProb?: Maybe<Scalars['Boolean']['output']>;
  forcedInSort?: Maybe<Array<Maybe<SortType>>>;
  id: Scalars['ID']['output'];
  inInitialDisorders?: Maybe<Scalars['Boolean']['output']>;
  inTopCR?: Maybe<Scalars['Boolean']['output']>;
  inTopCRPerSortType?: Maybe<Array<Maybe<SortType>>>;
  inTopSubTypeCrPerSortType?: Maybe<Array<Maybe<SortType>>>;
  incidence?: Maybe<Scalars['Float']['output']>;
  incidenceDescription?: Maybe<Scalars['String']['output']>;
  isKahunDisorder?: Maybe<Scalars['Boolean']['output']>;
  isRedundant?: Maybe<Scalars['Boolean']['output']>;
  liftWithDependentFindings?: Maybe<Scalars['Float']['output']>;
  matchedRankings?: Maybe<Array<Maybe<MatchedRanking>>>;
  missingPresentingSymptoms?: Maybe<Scalars['Boolean']['output']>;
  patientIncidence?: Maybe<Scalars['Float']['output']>;
  presentableDisease?: Maybe<Scalars['Boolean']['output']>;
  prevalence?: Maybe<Scalars['Float']['output']>;
  prevalenceDescription?: Maybe<Scalars['String']['output']>;
  redundantDueTo?: Maybe<QualifiedFeature>;
  redundantDueToBySort?: Maybe<Array<Maybe<RedundantBySort>>>;
  score?: Maybe<Scalars['Float']['output']>;
  scores?: Maybe<Array<Maybe<ScoreByType>>>;
  selectedBySort?: Maybe<Array<Maybe<SortType>>>;
  subTypes?: Maybe<Array<Maybe<QualifiedFeature>>>;
  urgency?: Maybe<Scalars['Float']['output']>;
};

export type ClinicalReasoningFinding = {
  __typename?: 'ClinicalReasoningFinding';
  absolutePredictiveValue?: Maybe<Scalars['Float']['output']>;
  actualLiftInDD?: Maybe<Scalars['Float']['output']>;
  basedOnFindingGivenDisease?: Maybe<Scalars['Boolean']['output']>;
  causality?: Maybe<CrCausality>;
  /** @deprecated No longer supported */
  citations?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  diseaseGivenDependentFindingsMinusFindingUnNormalized?: Maybe<Scalars['Float']['output']>;
  diseaseGivenFinding?: Maybe<Scalars['Float']['output']>;
  diseaseIncidenceRate?: Maybe<Scalars['Float']['output']>;
  distribution?: Maybe<Array<Maybe<RangeInDistribution>>>;
  duration?: Maybe<MeasurementRange>;
  etgDiseaseGivenFinding?: Maybe<Scalars['Float']['output']>;
  etgFindingGivenDisease?: Maybe<Scalars['Float']['output']>;
  etgFindingGivenDiseaseBayes?: Maybe<Scalars['Float']['output']>;
  etgRiskFactor?: Maybe<Scalars['Float']['output']>;
  etiologySection?: Maybe<EtiologySection>;
  /** @deprecated No longer supported */
  finding?: Maybe<QualifiedFeature>;
  findingGivenDisease?: Maybe<Scalars['Float']['output']>;
  flags?: Maybe<Array<Maybe<Flag>>>;
  foundInPatient?: Maybe<FoundInPatient>;
  gfinding?: Maybe<GroupedFeatureResponse>;
  id?: Maybe<Scalars['ID']['output']>;
  isDirect?: Maybe<Scalars['Boolean']['output']>;
  leak?: Maybe<Scalars['Float']['output']>;
  likelihoodRatio?: Maybe<Scalars['Float']['output']>;
  noData?: Maybe<Scalars['Boolean']['output']>;
  outcomeDiseaseGivenFinding?: Maybe<Scalars['Float']['output']>;
  outcomeFindingGivenDisease?: Maybe<Scalars['Float']['output']>;
  outcomeFindingGivenDiseaseBayes?: Maybe<Scalars['Float']['output']>;
  percentExact?: Maybe<Scalars['Boolean']['output']>;
  percentRange?: Maybe<Range>;
  prevalence?: Maybe<Scalars['Float']['output']>;
  prevalenceDescription?: Maybe<Scalars['String']['output']>;
  qualifiedFeatureRequestId?: Maybe<Scalars['String']['output']>;
  redundantDueTo?: Maybe<Scalars['String']['output']>;
  relativePredictiveValue?: Maybe<Scalars['Float']['output']>;
  score?: Maybe<Scalars['Float']['output']>;
  sourceQF?: Maybe<QualifiedFeature>;
  sourceQFIndex?: Maybe<Scalars['Int']['output']>;
  specificity?: Maybe<Scalars['Float']['output']>;
  typedId?: Maybe<Scalars['String']['output']>;
};

export type ClinicalReasoningFlow = {
  __typename?: 'ClinicalReasoningFlow';
  denominatorSteps?: Maybe<Array<Maybe<ClinicalReasoningFlowStep>>>;
  numeratorSteps?: Maybe<Array<Maybe<ClinicalReasoningFlowStep>>>;
  ratioSteps?: Maybe<Array<Maybe<ClinicalReasoningFlowStep>>>;
};

export type ClinicalReasoningFlowGraph = {
  __typename?: 'ClinicalReasoningFlowGraph';
  paths?: Maybe<Array<Maybe<ClinicalReasoningFlowPath>>>;
};

export type ClinicalReasoningFlowPath = {
  __typename?: 'ClinicalReasoningFlowPath';
  cappedProb?: Maybe<Scalars['Float']['output']>;
  edgeids?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};

export type ClinicalReasoningFlowStep = {
  __typename?: 'ClinicalReasoningFlowStep';
  adjustedValue?: Maybe<Scalars['Float']['output']>;
  adjustmentReasons?: Maybe<Array<Maybe<AdjustmentReason>>>;
  findingId?: Maybe<Scalars['String']['output']>;
  graph?: Maybe<ClinicalReasoningFlowGraph>;
  isRisk?: Maybe<Scalars['Boolean']['output']>;
  sourceIndex?: Maybe<Scalars['Int']['output']>;
  typedId?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['Float']['output']>;
};

export type ClusterSuggestion = {
  __typename?: 'ClusterSuggestion';
  category?: Maybe<DiseaseCategoryType>;
  items?: Maybe<Array<Maybe<PatientSuggestion>>>;
  title?: Maybe<Feature>;
};

export type ClusterTree = {
  __typename?: 'ClusterTree';
  clinicalReasoning?: Maybe<Array<Maybe<ClinicalReasoning>>>;
  clusters?: Maybe<Array<DiseaseCluster>>;
  roots?: Maybe<Array<Scalars['ID']['output']>>;
};

export enum CodeSet {
  Kahun = 'kahun',
  Loinc = 'loinc',
  Snomed = 'snomed',
  Synonym = 'synonym'
}

export type CohortInput = {
  cohortId?: InputMaybe<Scalars['ID']['input']>;
  qf?: InputMaybe<QualifiedFeatureInput>;
  type: CohortInputType;
};

export enum CohortInputType {
  CohortId = 'CohortId',
  QfInput = 'QFInput'
}

export type ComplexMeasurementUnits = {
  denominator?: InputMaybe<Array<InputMaybe<MeasurementUnits>>>;
  numerator?: InputMaybe<Array<InputMaybe<MeasurementUnits>>>;
};

export type ComplexUnits = {
  __typename?: 'ComplexUnits';
  denominator?: Maybe<Array<Maybe<MeasurementUnits>>>;
  numerator?: Maybe<Array<Maybe<MeasurementUnits>>>;
};

export type ConfigParam = {
  key: Scalars['String']['input'];
  numValue?: InputMaybe<Scalars['Float']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

export enum ConnectionStrength {
  Medium = 'MEDIUM',
  None = 'NONE',
  Strong = 'STRONG',
  Weak = 'WEAK'
}

export type ConversationAnswer = {
  findings?: InputMaybe<Array<InputMaybe<GroupedFeature>>>;
  questionType: ConversationQuestionType;
  skipped?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ConversationExchange = {
  __typename?: 'ConversationExchange';
  answer?: Maybe<Array<Maybe<ConversationExchangeAnswer>>>;
  messages?: Maybe<Array<Maybe<ConversationInfoMessage>>>;
  patientAnswer?: Maybe<ConversationPatientAnswer>;
  progress?: Maybe<Scalars['Float']['output']>;
  question?: Maybe<ConversationQuestion>;
  state?: Maybe<ConversationState>;
};

export type ConversationExchangeAnswer = {
  __typename?: 'ConversationExchangeAnswer';
  finding?: Maybe<QualifiedFeature>;
  findingAlias?: Maybe<Scalars['String']['output']>;
  patientAnswer?: Maybe<ConversationPatientAnswer>;
  refinementId?: Maybe<Scalars['ID']['output']>;
  suggestionId?: Maybe<Scalars['ID']['output']>;
};

export type ConversationInfoMessage = {
  __typename?: 'ConversationInfoMessage';
  confirm?: Maybe<Scalars['Boolean']['output']>;
  confirmText?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  infoText?: Maybe<Scalars['String']['output']>;
  locale?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
};

export type ConversationOptions = {
  askAllergies?: InputMaybe<Scalars['Boolean']['input']>;
  askBackgroundDisorderSuggestions?: InputMaybe<Scalars['Boolean']['input']>;
  askMedication?: InputMaybe<Scalars['Boolean']['input']>;
  backgroundCategory?: InputMaybe<Scalars['Boolean']['input']>;
  candidatesLimitDiseasesForNextStep?: InputMaybe<Scalars['Int']['input']>;
  candidatesUseTopPerCuratedForNextStep?: InputMaybe<Scalars['Boolean']['input']>;
  clusterProbThreshold?: InputMaybe<Scalars['Float']['input']>;
  clustersLessLikelyMax?: InputMaybe<Scalars['Int']['input']>;
  clustersMostLikelyThreshold?: InputMaybe<Scalars['Int']['input']>;
  familyHistoryPanelId?: InputMaybe<Scalars['String']['input']>;
  forceReasoningComputation?: InputMaybe<Scalars['Boolean']['input']>;
  heightInInches?: InputMaybe<Scalars['Boolean']['input']>;
  includeDiseaseCitations?: InputMaybe<Scalars['Boolean']['input']>;
  increaseNegatedSymptomsLift?: InputMaybe<Scalars['Boolean']['input']>;
  labQuestions?: InputMaybe<Scalars['Boolean']['input']>;
  limitBackgroundToRiskPanel?: InputMaybe<Scalars['Boolean']['input']>;
  maxNumOfQuestions?: InputMaybe<Scalars['Int']['input']>;
  medicalHistoryPanelId?: InputMaybe<Scalars['String']['input']>;
  minBackgroundInformation?: InputMaybe<Scalars['Float']['input']>;
  minRefinementInformation?: InputMaybe<Scalars['Float']['input']>;
  minimumInformation?: InputMaybe<Scalars['Float']['input']>;
  missingPresentingSymptomsFactor?: InputMaybe<Scalars['Float']['input']>;
  nextStepUsingPossibleComplications?: InputMaybe<Scalars['Boolean']['input']>;
  nextSuggestionsListLimit?: InputMaybe<Scalars['Float']['input']>;
  notifyStatusChanges?: InputMaybe<Scalars['Boolean']['input']>;
  numericalQualification?: InputMaybe<Scalars['Boolean']['input']>;
  patientSortIncidenceExp?: InputMaybe<Scalars['Float']['input']>;
  planExpectedEntropySmoothFactor?: InputMaybe<Scalars['Float']['input']>;
  policies?: InputMaybe<Scalars['String']['input']>;
  reduceIncidenceRate?: InputMaybe<Scalars['Boolean']['input']>;
  shouldStop?: InputMaybe<Scalars['Boolean']['input']>;
  sortTypeForNextStep?: InputMaybe<SortType>;
  sortTypeForResults?: InputMaybe<SortType>;
  summaryOptions?: InputMaybe<SummaryOptions>;
  temperatureInFahrenheit?: InputMaybe<Scalars['Boolean']['input']>;
  tripleQuestionCount?: InputMaybe<Scalars['Int']['input']>;
  tripleQuestionPercentage?: InputMaybe<Scalars['Float']['input']>;
  urgencySortIncidenceExp?: InputMaybe<Scalars['Float']['input']>;
  urgencySubTypeMin?: InputMaybe<Scalars['Float']['input']>;
  useDefaultPolicies?: InputMaybe<Scalars['Boolean']['input']>;
  usePPVForBackgroundComp?: InputMaybe<Scalars['Boolean']['input']>;
  usePainScaleOf10?: InputMaybe<Scalars['Boolean']['input']>;
  useTopDiseasesFromEachCluster?: InputMaybe<Scalars['Int']['input']>;
  volunteerBackground?: InputMaybe<Scalars['Boolean']['input']>;
  volunteerPanelId?: InputMaybe<Scalars['String']['input']>;
  weightInPounds?: InputMaybe<Scalars['Boolean']['input']>;
};

export enum ConversationPatientAnswer {
  No = 'no',
  Unknown = 'unknown',
  Yes = 'yes'
}

export type ConversationQueries = {
  __typename?: 'ConversationQueries';
  buildSavedCase?: Maybe<SavedCaseResponse>;
  saveAsNewCase?: Maybe<ConversationState>;
  start?: Maybe<ConversationState>;
  state?: Maybe<ConversationState>;
};


export type ConversationQueriesBuildSavedCaseArgs = {
  buildCaseOptions?: InputMaybe<BuildCaseOptions>;
  caseId?: InputMaybe<Scalars['ID']['input']>;
  context?: InputMaybe<Scalars['ConversationContext']['input']>;
  conversationOptions?: InputMaybe<Scalars['ConversationOptionsInput']['input']>;
  options?: InputMaybe<ConversationOptions>;
};


export type ConversationQueriesSaveAsNewCaseArgs = {
  context?: InputMaybe<Scalars['ConversationContext']['input']>;
  conversationOptions?: InputMaybe<Scalars['ConversationOptionsInput']['input']>;
  options?: InputMaybe<ConversationOptions>;
  readOnly?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ConversationQueriesStartArgs = {
  clinicId?: InputMaybe<Scalars['String']['input']>;
  conversationOptions?: InputMaybe<Scalars['ConversationOptionsInput']['input']>;
  existingCaseId?: InputMaybe<Scalars['String']['input']>;
  options?: InputMaybe<ConversationOptions>;
  patientCase?: InputMaybe<PatientCaseInput>;
  privateMode?: InputMaybe<Scalars['Boolean']['input']>;
  saveToCase?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ConversationQueriesStateArgs = {
  context?: InputMaybe<Scalars['ConversationContext']['input']>;
  conversationId?: InputMaybe<Scalars['ID']['input']>;
  conversationOptions?: InputMaybe<Scalars['ConversationOptionsInput']['input']>;
  endExchangeIndex?: InputMaybe<Scalars['Int']['input']>;
  options?: InputMaybe<ConversationOptions>;
  panel?: InputMaybe<Scalars['ID']['input']>;
  privateMode?: InputMaybe<Scalars['Boolean']['input']>;
  saveToCase?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ConversationQuestion = {
  __typename?: 'ConversationQuestion';
  basedOnReasoning?: Maybe<Scalars['Boolean']['output']>;
  debugInfo?: Maybe<Scalars['StructuredDebugInfo']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  elapsed?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  question?: Maybe<PatientQuestion>;
  questionChoiceType?: Maybe<QuestionChoiceType>;
  questionType?: Maybe<ConversationQuestionType>;
  suggestions?: Maybe<Array<Maybe<PatientSuggestion>>>;
};

export enum ConversationQuestionType {
  Age = 'AGE',
  Allergies = 'ALLERGIES',
  BackgroundSuggestion = 'BACKGROUND_SUGGESTION',
  ChiefComplaint = 'CHIEF_COMPLAINT',
  Date = 'DATE',
  Duration = 'DURATION',
  Final = 'FINAL',
  Form = 'FORM',
  FreeText = 'FREE_TEXT',
  FreeTextShort = 'FREE_TEXT_SHORT',
  Gender = 'GENDER',
  InsufficientData = 'INSUFFICIENT_DATA',
  Labs = 'LABS',
  Medications = 'MEDICATIONS',
  MultipleChiefComplaint = 'MULTIPLE_CHIEF_COMPLAINT',
  OtherComplaint = 'OTHER_COMPLAINT',
  Pregnancy = 'PREGNANCY',
  ReasonForVisit = 'REASON_FOR_VISIT',
  Suggestion = 'SUGGESTION',
  VolunteerBackgroud = 'VOLUNTEER_BACKGROUD',
  VolunteerFamilyHistory = 'VOLUNTEER_FAMILY_HISTORY'
}

export type ConversationResponse = {
  __typename?: 'ConversationResponse';
  hasMore?: Maybe<Scalars['Boolean']['output']>;
  messages?: Maybe<Array<Maybe<ConversationInfoMessage>>>;
  question?: Maybe<ConversationQuestion>;
};

export enum ConversationStage {
  ChiefComplaintComplete = 'CHIEF_COMPLAINT_COMPLETE',
  DemographicComplete = 'DEMOGRAPHIC_COMPLETE',
  Start = 'START'
}

export type ConversationState = {
  __typename?: 'ConversationState';
  abandoned?: Maybe<ConversationState>;
  addAnswer?: Maybe<ConversationState>;
  addFindings?: Maybe<ConversationState>;
  caseBasedOn?: Maybe<Scalars['String']['output']>;
  caseId?: Maybe<Scalars['String']['output']>;
  caseReadOnly?: Maybe<Scalars['Boolean']['output']>;
  context?: Maybe<Scalars['ConversationContext']['output']>;
  /** @deprecated conversation id is caseId.conv */
  conversationId?: Maybe<Scalars['String']['output']>;
  ddClusters?: Maybe<DdResponse>;
  debugInfo?: Maybe<Scalars['StructuredDebugInfo']['output']>;
  diagnosis?: Maybe<Array<Maybe<ClinicalReasoning>>>;
  doExchange?: Maybe<ConversationExchange>;
  done?: Maybe<ConversationState>;
  entropy?: Maybe<Scalars['Float']['output']>;
  etag?: Maybe<Scalars['String']['output']>;
  exchanges?: Maybe<Array<Maybe<ConversationExchange>>>;
  gender?: Maybe<Scalars['String']['output']>;
  /** @deprecated use patietnIcd instead */
  icd?: Maybe<Array<Maybe<IcdCode>>>;
  infoMessages?: Maybe<Array<Maybe<ConversationInfoMessage>>>;
  initialMessages?: Maybe<Array<Maybe<ConversationInfoMessage>>>;
  isDone?: Maybe<Scalars['Boolean']['output']>;
  mutualInformation?: Maybe<Scalars['Float']['output']>;
  navigationRecommendation?: Maybe<PolicyRecommendation>;
  nextQuestion?: Maybe<ConversationQuestion>;
  nextResponse?: Maybe<ConversationResponse>;
  nextSuggestions?: Maybe<PatientSuggestions>;
  options?: Maybe<Scalars['ConversationOptionsInput']['output']>;
  patientCase?: Maybe<SavedCase>;
  patientFindings?: Maybe<Array<Maybe<GroupedFeatureResponse>>>;
  patientIcd?: Maybe<StateIcdCodes>;
  persist?: Maybe<ConversationState>;
  primaryDDClusters?: Maybe<Array<Maybe<Scalars['ID']['output']>>>;
  progress?: Maybe<Scalars['Float']['output']>;
  /** @deprecated use debugInfo for complete debug tree */
  protocolDebug?: Maybe<Scalars['StructuredDebugInfo']['output']>;
  recommendations?: Maybe<Array<Maybe<PolicyRecommendation>>>;
  stage?: Maybe<ConversationStage>;
  summary?: Maybe<SummeryData>;
  undo?: Maybe<ConversationState>;
  urgent?: Maybe<DdUrgency>;
};


export type ConversationStateAbandonedArgs = {
  abandonedStatus?: InputMaybe<SubStatus>;
};


export type ConversationStateAddAnswerArgs = {
  answer?: InputMaybe<ConversationAnswer>;
};


export type ConversationStateAddFindingsArgs = {
  findings?: InputMaybe<Array<InputMaybe<GroupedFeature>>>;
};


export type ConversationStateDoExchangeArgs = {
  missingInCase?: InputMaybe<MissingInCaseAction>;
  patient?: InputMaybe<Array<InputMaybe<GroupedFeature>>>;
  patientVolunteered?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
};

export type ConversationSummary = {
  __typename?: 'ConversationSummary';
  exchanges?: Maybe<Array<Maybe<ConversationSummaryExchange>>>;
};

export type ConversationSummaryAnswer = {
  __typename?: 'ConversationSummaryAnswer';
  text?: Maybe<Scalars['String']['output']>;
};

export type ConversationSummaryExchange = {
  __typename?: 'ConversationSummaryExchange';
  answer?: Maybe<ConversationSummaryAnswer>;
  question?: Maybe<ConversationSummaryQuestion>;
  section?: Maybe<SummarySectionType>;
};

export type ConversationSummaryQuestion = {
  __typename?: 'ConversationSummaryQuestion';
  text?: Maybe<Scalars['String']['output']>;
};

export type CreatedCode = {
  __typename?: 'CreatedCode';
  digitCode?: Maybe<Scalars['ID']['output']>;
  ehrid?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  shareid?: Maybe<Scalars['String']['output']>;
};

export enum DdFlagType {
  Atypical = 'ATYPICAL',
  BecauseOf = 'BECAUSE_OF',
  Common = 'COMMON',
  ExplainedBy = 'EXPLAINED_BY',
  FlareUp = 'FLARE_UP',
  GoodMatch = 'GOOD_MATCH',
  HighPredictiveValue = 'HIGH_PREDICTIVE_VALUE',
  NoCorrolation = 'NO_CORROLATION',
  Rare = 'RARE',
  Urgent = 'URGENT'
}

export type DdResponse = {
  __typename?: 'DDResponse';
  adaptiveGrouping?: Maybe<ClusterTree>;
  allFindings?: Maybe<Array<Maybe<QualifiedFeature>>>;
  citations?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  clinicalReasoning?: Maybe<Array<Maybe<ClinicalReasoning>>>;
  clustersToConsider?: Maybe<Array<Maybe<DiseaseCluster>>>;
  debugInfo?: Maybe<Scalars['StructuredDebugInfo']['output']>;
  debugReport?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  debugSheet?: Maybe<Sheet>;
  debugSheets?: Maybe<Array<Maybe<DebugSheet>>>;
  diseaseClusters?: Maybe<Array<Maybe<DiseaseCluster>>>;
  meetsConditions?: Maybe<Array<Maybe<MeetCondition>>>;
  nextStep?: Maybe<NextStep>;
  options?: Maybe<Scalars['DiagnosisOptionsInput']['output']>;
  protocols?: Maybe<PolicyProtocolOutput>;
  strength?: Maybe<Scalars['Float']['output']>;
  strengthForSortType?: Maybe<Array<Maybe<StrengthForSortType>>>;
  suggestions?: Maybe<PatientSuggestions>;
  summaryInsights?: Maybe<SummaryInsights>;
  urgencyBySortType?: Maybe<Array<Maybe<UrgencyByType>>>;
};


export type DdResponseAdaptiveGroupingArgs = {
  config?: InputMaybe<Array<InputMaybe<ConfigParam>>>;
};


export type DdResponseNextStepArgs = {
  limitSuggestions?: InputMaybe<Scalars['Int']['input']>;
};


export type DdResponseSuggestionsArgs = {
  limitSuggestions?: InputMaybe<Scalars['Int']['input']>;
};

export type DdUrgency = {
  __typename?: 'DDUrgency';
  urgencyLevelId?: Maybe<Scalars['ID']['output']>;
  urgent?: Maybe<Scalars['Boolean']['output']>;
};

export type DebugSheet = {
  __typename?: 'DebugSheet';
  name?: Maybe<Scalars['String']['output']>;
  sheet?: Maybe<Sheet>;
};

export type Description = {
  __typename?: 'Description';
  text?: Maybe<Scalars['String']['output']>;
  url?: Maybe<Scalars['String']['output']>;
};

export type DiseaseCategory = {
  __typename?: 'DiseaseCategory';
  findings?: Maybe<Array<Maybe<FindingGroup>>>;
  type?: Maybe<DiseaseCategoryType>;
};

export enum DiseaseCategoryType {
  Association = 'ASSOCIATION',
  Background = 'BACKGROUND',
  Etiology = 'ETIOLOGY',
  Imaging = 'IMAGING',
  NoCorrelation = 'NO_CORRELATION',
  Other = 'OTHER',
  OutcomeComplication = 'OUTCOME_COMPLICATION',
  OutcomeSigns = 'OUTCOME_SIGNS',
  OutcomeSignsOnly = 'OUTCOME_SIGNS_ONLY',
  OutcomeSymptomOnly = 'OUTCOME_SYMPTOM_ONLY',
  OutcomeTest = 'OUTCOME_TEST',
  OutcomeVitalsign = 'OUTCOME_VITALSIGN',
  Overview = 'OVERVIEW',
  OverviewTopPpv = 'OVERVIEW_TOP_PPV',
  OverviewTopSensitivity = 'OVERVIEW_TOP_SENSITIVITY',
  PatientFinding = 'PATIENT_FINDING',
  PatientFindingsDecendants = 'PATIENT_FINDINGS_DECENDANTS',
  Population = 'POPULATION',
  Risks = 'RISKS'
}

export type DiseaseCluster = {
  __typename?: 'DiseaseCluster';
  bestCrId?: Maybe<Scalars['ID']['output']>;
  citations?: Maybe<Citations>;
  clusterIds?: Maybe<Array<Maybe<Scalars['ID']['output']>>>;
  clusterType?: Maybe<Scalars['String']['output']>;
  crIds?: Maybe<Array<Maybe<Scalars['ID']['output']>>>;
  flags?: Maybe<Array<Maybe<DdFlagType>>>;
  id: Scalars['ID']['output'];
  likelihood?: Maybe<Scalars['String']['output']>;
  scores?: Maybe<ScoreByType>;
  sortType?: Maybe<SortType>;
  title?: Maybe<QualifiedFeature>;
  urgencyId?: Maybe<Scalars['ID']['output']>;
};

export enum DiseaseFindingDirection {
  Association = 'association',
  Following = 'following',
  Preceeding = 'preceeding'
}

export type DiseaseFindingMetrics = {
  __typename?: 'DiseaseFindingMetrics';
  category?: Maybe<DiseaseCategoryType>;
  direction?: Maybe<DiseaseFindingDirection>;
  finding?: Maybe<RCohort>;
  id: Scalars['ID']['output'];
  metrics?: Maybe<RPairMetrics>;
  presentingSymptom?: Maybe<Scalars['Boolean']['output']>;
  subcohort?: Maybe<RCohort>;
};

export type DiseaseFindingPairsMetrics = {
  __typename?: 'DiseaseFindingPairsMetrics';
  disease: Scalars['ID']['output'];
  finding: Scalars['ID']['output'];
  metrics?: Maybe<RPairMetrics>;
};

export type DiseaseForPlan = {
  __typename?: 'DiseaseForPlan';
  cluster?: Maybe<DiseaseCluster>;
  complicationOf?: Maybe<QualifiedFeature>;
  complicationOfObj?: Maybe<EtiologiesOfComplication>;
  crFindings?: Maybe<Array<Maybe<ClinicalReasoningFinding>>>;
  crId?: Maybe<Scalars['String']['output']>;
  disease?: Maybe<QualifiedFeature>;
  diseaseCitations?: Maybe<Citations>;
  inTopCRPerSortType?: Maybe<Array<Maybe<SortType>>>;
  patientIncidence?: Maybe<Scalars['Float']['output']>;
  prob?: Maybe<Scalars['Float']['output']>;
  selectedBySortType?: Maybe<Array<Maybe<SortType>>>;
};

export type DiseaseForPlanInput = {
  disease?: InputMaybe<QualifiedFeatureInput>;
  prob?: InputMaybe<Scalars['Float']['input']>;
};

export type DiseaseReference = {
  __typename?: 'DiseaseReference';
  ageDistribution?: Maybe<RAgeDistribution>;
  citations?: Maybe<Citations>;
  citationsDVData?: Maybe<Array<Maybe<CitationDiseaseData>>>;
  disease?: Maybe<Array<Maybe<QualifiedFeature>>>;
  findings?: Maybe<Array<Maybe<DiseaseFindingMetrics>>>;
  id: Scalars['ID']['output'];
  metrics?: Maybe<RUnaryMetrics>;
};

export type DiseaseReferenceOptions = {
  category?: InputMaybe<Scalars['String']['input']>;
};

export type DiseasesAliasing = {
  d1?: InputMaybe<Scalars['String']['input']>;
  d2?: InputMaybe<Scalars['String']['input']>;
};

export type Distribution = {
  __typename?: 'Distribution';
  id?: Maybe<Scalars['String']['output']>;
  parts?: Maybe<Array<Maybe<DistributionPart>>>;
};

export type DistributionPart = {
  __typename?: 'DistributionPart';
  label?: Maybe<Scalars['String']['output']>;
  rangeFinish?: Maybe<Scalars['Float']['output']>;
  rangeStart?: Maybe<Scalars['Float']['output']>;
  value?: Maybe<Scalars['Float']['output']>;
};

export type Edge = {
  __typename?: 'Edge';
  /** @deprecated Graph Refactor */
  citations?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** @deprecated Graph Refactor */
  citationsObj?: Maybe<Citations>;
  id: Scalars['ID']['output'];
  lift?: Maybe<Scalars['Float']['output']>;
  prob?: Maybe<Scalars['Float']['output']>;
  /** @deprecated Graph Refactor */
  publications?: Maybe<Array<Maybe<Scalars['RuleRef']['output']>>>;
  ruleValueId?: Maybe<Scalars['String']['output']>;
  ruleValues?: Maybe<Array<Maybe<RuleStat>>>;
  source?: Maybe<Array<Maybe<QualifiedFeature>>>;
  sourceID: Scalars['String']['output'];
  target?: Maybe<Array<Maybe<QualifiedFeature>>>;
  targetID: Scalars['String']['output'];
  type?: Maybe<RuleType>;
  usedInComputation?: Maybe<Scalars['Boolean']['output']>;
};

export type EdgeWithTextualReferences = {
  __typename?: 'EdgeWithTextualReferences';
  priority?: Maybe<Scalars['Int']['output']>;
  rvWithTextualReference?: Maybe<Array<Maybe<TextualWithRuleReference>>>;
  source?: Maybe<Scalars['String']['output']>;
  target?: Maybe<Scalars['String']['output']>;
};

export type EtiologiesOfComplication = {
  __typename?: 'EtiologiesOfComplication';
  etiologies?: Maybe<Array<Maybe<EtiologyOfComplication>>>;
};

export type EtiologyOfComplication = {
  __typename?: 'EtiologyOfComplication';
  disease?: Maybe<QualifiedFeature>;
  sensitivity?: Maybe<Scalars['Float']['output']>;
};

export enum EtiologySection {
  Causality = 'CAUSALITY',
  Etiology = 'ETIOLOGY',
  Risk = 'RISK'
}

export enum Exactness {
  Computed = 'Computed',
  Exact = 'Exact',
  ExpertEstimation = 'ExpertEstimation'
}

export type Feature = NamedNode & {
  __typename?: 'Feature';
  alias?: Maybe<Scalars['String']['output']>;
  category?: Maybe<Feature>;
  children?: Maybe<FeatureSet>;
  childrenSetType?: Maybe<Scalars['String']['output']>;
  conceptType?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Description>;
  featureType: Scalars['String']['output'];
  groupHeaders?: Maybe<Array<Maybe<Feature>>>;
  hasRefinement?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['ID']['output'];
  inferredChildren?: Maybe<Array<Maybe<Feature>>>;
  inferredParents?: Maybe<Array<Maybe<Feature>>>;
  inferredQualifiers?: Maybe<Array<Maybe<Qualifier>>>;
  name: Scalars['String']['output'];
  organSystem?: Maybe<Feature>;
  parents?: Maybe<FeatureSet>;
  patientDescription?: Maybe<Scalars['String']['output']>;
  qualifierSearch?: Maybe<Array<Qualifier>>;
  qualifierSpec?: Maybe<Array<Maybe<QualifierSpec>>>;
  qualifiers?: Maybe<Array<Maybe<Qualifier>>>;
  range?: Maybe<MeasurementRange>;
  shortname?: Maybe<Scalars['String']['output']>;
  skipDuration?: Maybe<Scalars['Boolean']['output']>;
  snomedid?: Maybe<Scalars['String']['output']>;
  snowmedid?: Maybe<Scalars['String']['output']>;
  subGroups?: Maybe<Array<Maybe<GroupRelation>>>;
  superGroups?: Maybe<Array<Maybe<GroupRelation>>>;
  urgency?: Maybe<Scalars['Float']['output']>;
  urgencyId?: Maybe<Scalars['ID']['output']>;
};


export type FeatureChildrenArgs = {
  depth?: InputMaybe<Scalars['Int']['input']>;
};


export type FeatureParentsArgs = {
  depth?: InputMaybe<Scalars['Int']['input']>;
};


export type FeatureQualifierSearchArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  relation?: InputMaybe<Scalars['ID']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
};

export type FeatureSearchResult = {
  __typename?: 'FeatureSearchResult';
  hasRefinement?: Maybe<Scalars['Boolean']['output']>;
  match?: Maybe<Scalars['String']['output']>;
  result?: Maybe<Feature>;
};

export type FeatureSet = {
  __typename?: 'FeatureSet';
  features?: Maybe<Array<Maybe<Feature>>>;
  tree?: Maybe<Array<Maybe<TreeNode>>>;
};

export type FilterInput = {
  code?: InputMaybe<Scalars['String']['input']>;
  fullNameFilter?: InputMaybe<Scalars['String']['input']>;
  patientProperties?: InputMaybe<PatientPropertiesInput>;
  toVisitDate?: InputMaybe<Scalars['Date']['input']>;
};

export type FindingGroup = {
  __typename?: 'FindingGroup';
  category?: Maybe<DiseaseCategoryType>;
  children?: Maybe<Array<Maybe<Scalars['ID']['output']>>>;
  complete?: Maybe<Scalars['Boolean']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  maxAbsolutePredictiveValue?: Maybe<Scalars['Float']['output']>;
  maxDiseaseGivneFinding?: Maybe<Scalars['Float']['output']>;
  maxFindingGivenDisease?: Maybe<Scalars['Float']['output']>;
  parent: ClinicalReasoningFinding;
  type?: Maybe<FindingGroupType>;
};

export enum FindingGroupType {
  ClosedSet = 'CLOSED_SET',
  Incidence = 'INCIDENCE',
  Leaf = 'LEAF',
  Procedure = 'PROCEDURE',
  Qualifiers = 'QUALIFIERS',
  Subtypes = 'SUBTYPES'
}

export enum FindingSource {
  Criteria = 'CRITERIA',
  Ehr = 'EHR',
  Implied = 'IMPLIED',
  Patient = 'PATIENT',
  PatientFreeText = 'PATIENT_FREE_TEXT',
  PatientVolunteer = 'PATIENT_VOLUNTEER',
  Physician = 'PHYSICIAN',
  Possible = 'POSSIBLE'
}

export type Flag = {
  __typename?: 'Flag';
  ref?: Maybe<QualifiedFeature>;
  type?: Maybe<DdFlagType>;
};

export enum FoundInPatient {
  Has = 'HAS',
  Hasnot = 'HASNOT',
  HasnotSupertype = 'HASNOT_SUPERTYPE',
  HasSubtype = 'HAS_SUBTYPE',
  Unknown = 'UNKNOWN'
}

export type FreeTextToPatientResponse = {
  __typename?: 'FreeTextToPatientResponse';
  debug?: Maybe<Scalars['StructuredDebugInfo']['output']>;
  nlpProcceeorResponse?: Maybe<Scalars['String']['output']>;
  patientFindings?: Maybe<Array<Maybe<GroupedFeatureResponse>>>;
};

export enum GVersionState {
  Candidate = 'CANDIDATE',
  Failed = 'FAILED',
  /** @deprecated No longer supported */
  Invalid = 'INVALID',
  /** @deprecated No longer supported */
  Loading = 'LOADING',
  New = 'NEW',
  /** @deprecated No longer supported */
  Obsolete = 'OBSOLETE',
  Ready = 'READY'
}

export type GeneratedGrounding = GeneratedOutput & {
  __typename?: 'GeneratedGrounding';
  error?: Maybe<Scalars['Boolean']['output']>;
  errorText?: Maybe<Scalars['String']['output']>;
  etag?: Maybe<Scalars['String']['output']>;
  generating?: Maybe<Scalars['Boolean']['output']>;
  grounding?: Maybe<Grounding>;
};

export type GeneratedOutput = {
  error?: Maybe<Scalars['Boolean']['output']>;
  errorText?: Maybe<Scalars['String']['output']>;
  etag?: Maybe<Scalars['String']['output']>;
  generating?: Maybe<Scalars['Boolean']['output']>;
};

export type Graph = {
  __typename?: 'Graph';
  /** @deprecated Graph Refactor */
  citationsObj?: Maybe<Citations>;
  edges?: Maybe<Array<Maybe<Edge>>>;
  nodes?: Maybe<Array<Maybe<Node>>>;
};

export type GraphResponse = {
  __typename?: 'GraphResponse';
  graph?: Maybe<Graph>;
};

export type GroundedSentence = {
  __typename?: 'GroundedSentence';
  sentence?: Maybe<Scalars['String']['output']>;
  statements?: Maybe<Array<Maybe<GroundedStatement>>>;
};

export type GroundedStatement = {
  __typename?: 'GroundedStatement';
  connectionStrength?: Maybe<ConnectionStrength>;
  edgesWithTextualReferences?: Maybe<Array<Maybe<EdgeWithTextualReferences>>>;
  elementA?: Maybe<NodeValidation>;
  elementB?: Maybe<NodeValidation>;
  hypothesis?: Maybe<StatementHypothesis>;
  id: Scalars['ID']['output'];
  reference?: Maybe<GraphResponse>;
  runningIndex?: Maybe<Scalars['Int']['output']>;
  statement?: Maybe<Scalars['Statement']['output']>;
  text?: Maybe<Scalars['String']['output']>;
  wordIndexForReferencePoint?: Maybe<Scalars['Int']['output']>;
  wordsIndices?: Maybe<Array<Maybe<Scalars['Int']['output']>>>;
};

export type GroundedSummaryText = GeneratedOutput & SummaryText & {
  __typename?: 'GroundedSummaryText';
  altGuidelines?: Maybe<Array<Maybe<RagGuideline>>>;
  citations?: Maybe<Array<Maybe<RagCitation>>>;
  error?: Maybe<Scalars['Boolean']['output']>;
  errorText?: Maybe<Scalars['String']['output']>;
  etag?: Maybe<Scalars['String']['output']>;
  generating?: Maybe<Scalars['Boolean']['output']>;
  grounding?: Maybe<GeneratedGrounding>;
  guidelines?: Maybe<Array<Maybe<RagGuideline>>>;
  text?: Maybe<Scalars['String']['output']>;
};

export type Grounding = {
  __typename?: 'Grounding';
  debugData?: Maybe<Scalars['StructuredDebugInfo']['output']>;
  sentences?: Maybe<Array<Maybe<GroundedSentence>>>;
};

export type GroupRelation = {
  __typename?: 'GroupRelation';
  feature?: Maybe<Feature>;
  type?: Maybe<SubGroupType>;
};

export type GroupedFeature = {
  feature?: InputMaybe<QualifiedFeatureInput>;
  group?: InputMaybe<CaseFindingPresentationType>;
  skip?: InputMaybe<Scalars['Boolean']['input']>;
  source?: InputMaybe<FindingSource>;
};

export type GroupedFeatureResponse = {
  __typename?: 'GroupedFeatureResponse';
  feature?: Maybe<QualifiedFeature>;
  group?: Maybe<CaseFindingPresentationType>;
  skip?: Maybe<Scalars['Boolean']['output']>;
  source?: Maybe<FindingSource>;
  validation?: Maybe<ValidationStatus>;
};

export type IcdCode = {
  __typename?: 'ICDCode';
  code?: Maybe<Scalars['String']['output']>;
  desc?: Maybe<Scalars['String']['output']>;
  dueTo?: Maybe<Array<Maybe<QualifiedFeature>>>;
};

export type KbSolverProblem = {
  __typename?: 'KBSolverProblem';
  entityid?: Maybe<Scalars['String']['output']>;
  kind?: Maybe<Scalars['String']['output']>;
  message?: Maybe<Scalars['String']['output']>;
  payload?: Maybe<Scalars['String']['output']>;
};

export type KbSolverProblemsResponse = {
  __typename?: 'KBSolverProblemsResponse';
  problems?: Maybe<Array<Maybe<KbSolverProblem>>>;
};

export type KeyValue = {
  __typename?: 'KeyValue';
  key?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

export type LambdaTestResult = {
  __typename?: 'LambdaTestResult';
  success?: Maybe<Scalars['String']['output']>;
};

export type LiftScore = {
  __typename?: 'LiftScore';
  liftScore?: Maybe<Scalars['Float']['output']>;
  qualifiedFeature?: Maybe<QualifiedFeature>;
};

export type LlmAuditLogData = {
  __typename?: 'LlmAuditLogData';
  citationId?: Maybe<Scalars['String']['output']>;
  comment?: Maybe<Scalars['String']['output']>;
  date?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  payload?: Maybe<Scalars['Payload']['output']>;
  ruleSourceId?: Maybe<Scalars['String']['output']>;
  ruleTargetId?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['Int']['output']>;
  tags?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  type?: Maybe<Scalars['String']['output']>;
  uniqueRuleId?: Maybe<Scalars['String']['output']>;
  user?: Maybe<Scalars['String']['output']>;
};

export type LlmCommentData = {
  __typename?: 'LlmCommentData';
  comment?: Maybe<Scalars['String']['output']>;
  date?: Maybe<Scalars['Float']['output']>;
  edited?: Maybe<Scalars['Boolean']['output']>;
  editedDate?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  user?: Maybe<Scalars['String']['output']>;
};

export type LlmRuleTags = {
  __typename?: 'LlmRuleTags';
  category?: Maybe<Scalars['String']['output']>;
  displayName?: Maybe<Scalars['String']['output']>;
  tag?: Maybe<Scalars['String']['output']>;
};

export type LoadedModelInfo = {
  __typename?: 'LoadedModelInfo';
  commitSerial?: Maybe<Scalars['Float']['output']>;
  revision?: Maybe<Scalars['String']['output']>;
};

export type LoaderInfoResult = {
  __typename?: 'LoaderInfoResult';
  date?: Maybe<Scalars['Float']['output']>;
  lastevent?: Maybe<Scalars['String']['output']>;
  processed?: Maybe<Scalars['Int']['output']>;
  processedtotal?: Maybe<Scalars['Int']['output']>;
  shard?: Maybe<Scalars['Int']['output']>;
  shardtotal?: Maybe<Scalars['Int']['output']>;
  state?: Maybe<Scalars['String']['output']>;
  version?: Maybe<Scalars['String']['output']>;
};

export type MatchedRanking = {
  __typename?: 'MatchedRanking';
  condition?: Maybe<CaseCondition>;
  matchType?: Maybe<MatchedRankingType>;
};

export enum MatchedRankingType {
  ChildOfTargetCondition = 'CHILD_OF_TARGET_CONDITION',
  Exact = 'EXACT',
  ParentOfTargetCondition = 'PARENT_OF_TARGET_CONDITION'
}

export type MeasurementRange = {
  __typename?: 'MeasurementRange';
  complexUnits?: Maybe<ComplexUnits>;
  high?: Maybe<Scalars['Float']['output']>;
  low?: Maybe<Scalars['Float']['output']>;
  units?: Maybe<MeasurementUnits>;
};

export type MeasurementRangeInput = {
  complexUnits?: InputMaybe<ComplexMeasurementUnits>;
  high?: InputMaybe<Scalars['Float']['input']>;
  low?: InputMaybe<Scalars['Float']['input']>;
  units?: InputMaybe<MeasurementUnits>;
};

export enum MeasurementUnits {
  BeatsPerMinute = 'BeatsPerMinute',
  Celsius = 'Celsius',
  Centimeters = 'Centimeters',
  Days = 'Days',
  Deciliter = 'Deciliter',
  Fahrenheit = 'Fahrenheit',
  Feet = 'Feet',
  Femtoliter = 'Femtoliter',
  GigaUnits = 'GigaUnits',
  GramCreatinine = 'GramCreatinine',
  GramHemoglobin = 'GramHemoglobin',
  Grams = 'Grams',
  Hours = 'Hours',
  Inches = 'Inches',
  KgBodyWeight = 'KgBodyWeight',
  KiloUnits = 'KiloUnits',
  KilogramH2O = 'KilogramH2O',
  Kilograms = 'Kilograms',
  Liter = 'Liter',
  MegaUnits = 'MegaUnits',
  MeterSquare = 'MeterSquare',
  Meters = 'Meters',
  MicroUnits = 'MicroUnits',
  Micrograms = 'Micrograms',
  Microliter = 'Microliter',
  MilliMole = 'MilliMole',
  MilliOsmolality = 'MilliOsmolality',
  MilliUnits = 'MilliUnits',
  Milliequivalent = 'Milliequivalent',
  Milligrams = 'Milligrams',
  Milliliter = 'Milliliter',
  Millimeters = 'Millimeters',
  MmHg = 'MmHg',
  Mole = 'Mole',
  Months = 'Months',
  Na = 'NA',
  NanoMole = 'NanoMole',
  Nanograms = 'Nanograms',
  Pack = 'Pack',
  Percent = 'Percent',
  PercentOfNormal = 'PercentOfNormal',
  PicoMole = 'PicoMole',
  Picograms = 'Picograms',
  Pounds = 'Pounds',
  Priority = 'Priority',
  Seconds = 'Seconds',
  Times = 'Times',
  Units = 'Units',
  Weeks = 'Weeks',
  Years = 'Years'
}

export type MeetCondition = {
  __typename?: 'MeetCondition';
  condition?: Maybe<CaseCondition>;
  firstFilterRank?: Maybe<Scalars['Int']['output']>;
  inInitialDisorders?: Maybe<Scalars['Boolean']['output']>;
  meets?: Maybe<Scalars['Boolean']['output']>;
  payload?: Maybe<MeetConditionPayload>;
  score?: Maybe<Scalars['Float']['output']>;
  shouldBeInInitialDisorders?: Maybe<Scalars['Boolean']['output']>;
  totalRank?: Maybe<Scalars['Int']['output']>;
};

export type MeetConditionPayload = {
  __typename?: 'MeetConditionPayload';
  caseFeatureVal?: Maybe<Scalars['Int']['output']>;
  extraFeatureVal?: Maybe<Scalars['Int']['output']>;
};

export type MetricsEdge = {
  __typename?: 'MetricsEdge';
  id?: Maybe<Scalars['String']['output']>;
  incidence?: Maybe<Scalars['Float']['output']>;
  lift?: Maybe<Scalars['Float']['output']>;
  prob?: Maybe<Scalars['Float']['output']>;
  sourceid?: Maybe<Scalars['String']['output']>;
  stats?: Maybe<Array<Maybe<MetricsEdgeStat>>>;
  targetid?: Maybe<Scalars['String']['output']>;
  type?: Maybe<RuleType>;
};

export type MetricsEdgeStat = {
  __typename?: 'MetricsEdgeStat';
  lastCommitDate?: Maybe<Scalars['Float']['output']>;
  rate?: Maybe<Scalars['Float']['output']>;
  ruleValue?: Maybe<RuleValue>;
  unit?: Maybe<MetricsRuleUnits>;
};

export type MetricsNode = {
  __typename?: 'MetricsNode';
  desc?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  leak?: Maybe<Scalars['Float']['output']>;
  name?: Maybe<Scalars['String']['output']>;
};

export type MetricsPath = {
  __typename?: 'MetricsPath';
  causality?: Maybe<Scalars['String']['output']>;
  causeId?: Maybe<Scalars['String']['output']>;
  edges?: Maybe<Array<Maybe<MetricsEdge>>>;
  effectId?: Maybe<Scalars['String']['output']>;
  nodes?: Maybe<Array<Maybe<MetricsNode>>>;
  prob?: Maybe<Scalars['Float']['output']>;
};

export type MetricsPreloadResult = {
  __typename?: 'MetricsPreloadResult';
  success?: Maybe<Scalars['String']['output']>;
};

export enum MetricsRuleUnits {
  HazardRatio = 'HAZARD_RATIO',
  Incidence = 'INCIDENCE',
  LifetimePerrcent = 'LIFETIME_PERRCENT',
  Lift = 'LIFT',
  Nlr = 'NLR',
  Npv = 'NPV',
  OddsRatio = 'ODDS_RATIO',
  Percent = 'PERCENT',
  Plr = 'PLR',
  Ppv = 'PPV',
  RelativeRisk = 'RELATIVE_RISK',
  Specificity = 'SPECIFICITY'
}

export enum MissingInCaseAction {
  AnswerNo = 'ANSWER_NO',
  Skip = 'SKIP'
}

export type Mutation = {
  __typename?: 'Mutation';
  addLlmRuleAuditComment?: Maybe<LlmCommentData>;
  addNewTag?: Maybe<LlmRuleTags>;
  citation?: Maybe<CitationMutations>;
  clinic?: Maybe<ClinicMutations>;
  clinicByName?: Maybe<ClinicMutations>;
  copyPatientCase?: Maybe<Scalars['String']['output']>;
  deleteLlmRuleComment?: Maybe<Scalars['Boolean']['output']>;
  deleteTag?: Maybe<Scalars['Boolean']['output']>;
  lambdaTests?: Maybe<LambdaTestResult>;
  mergePatientCase?: Maybe<UpdateCaseResponse>;
  metricsPreload?: Maybe<MetricsPreloadResult>;
  reload?: Maybe<ReloadResult>;
  sendFeedback?: Maybe<Scalars['Boolean']['output']>;
  setVersionRunningEnv?: Maybe<Scalars['Boolean']['output']>;
  setVersionState?: Maybe<Scalars['Boolean']['output']>;
  storeOpaqueData?: Maybe<Scalars['String']['output']>;
  storePatientCase?: Maybe<Scalars['String']['output']>;
  updateGatewaySchemas?: Maybe<Scalars['String']['output']>;
  updateLlmRuleComment?: Maybe<LlmCommentData>;
  updateOpaqueData?: Maybe<Scalars['String']['output']>;
  updatePatientCase?: Maybe<UpdateCaseResponse>;
  updateSummary?: Maybe<UpdateSummaryResponse>;
  user?: Maybe<UserMutations>;
  warmup_dd?: Maybe<Scalars['String']['output']>;
};


export type MutationAddLlmRuleAuditCommentArgs = {
  comment: Scalars['String']['input'];
  ruleFeedbackId: Scalars['String']['input'];
  user: Scalars['String']['input'];
};


export type MutationAddNewTagArgs = {
  category?: InputMaybe<Scalars['String']['input']>;
  displayName?: InputMaybe<Scalars['String']['input']>;
  tagName: Scalars['String']['input'];
};


export type MutationCitationArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
};


export type MutationClinicArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
};


export type MutationClinicByNameArgs = {
  name?: InputMaybe<Scalars['String']['input']>;
};


export type MutationCopyPatientCaseArgs = {
  clinicId?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
};


export type MutationDeleteLlmRuleCommentArgs = {
  id: Scalars['String']['input'];
  ruleFeedbackId: Scalars['String']['input'];
};


export type MutationDeleteTagArgs = {
  category?: InputMaybe<Scalars['String']['input']>;
  tagName: Scalars['String']['input'];
};


export type MutationLambdaTestsArgs = {
  cases?: InputMaybe<Scalars['String']['input']>;
  concurrency?: InputMaybe<Scalars['Int']['input']>;
  ddVariant?: InputMaybe<Scalars['String']['input']>;
  devEnv?: InputMaybe<Scalars['String']['input']>;
  disableLogs?: InputMaybe<Scalars['Int']['input']>;
  filter?: InputMaybe<Scalars['String']['input']>;
  headline?: InputMaybe<Scalars['String']['input']>;
  keepFunctions?: InputMaybe<Scalars['Int']['input']>;
  loops?: InputMaybe<Scalars['String']['input']>;
  makeSanityCheck?: InputMaybe<Scalars['Boolean']['input']>;
  modelVersion?: InputMaybe<Scalars['String']['input']>;
  multiFilter?: InputMaybe<Scalars['String']['input']>;
  panel?: InputMaybe<Scalars['String']['input']>;
  project?: InputMaybe<Scalars['String']['input']>;
  tagsFilter?: InputMaybe<Scalars['String']['input']>;
  taskVersion?: InputMaybe<Scalars['String']['input']>;
};


export type MutationMergePatientCaseArgs = {
  id?: InputMaybe<Scalars['String']['input']>;
  patientCaseInput?: InputMaybe<SavedCaseInput>;
};


export type MutationMetricsPreloadArgs = {
  env?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<Scalars['String']['input']>;
  shards?: InputMaybe<Scalars['Int']['input']>;
  taskversion?: InputMaybe<Scalars['String']['input']>;
};


export type MutationSendFeedbackArgs = {
  clinicName?: InputMaybe<Scalars['String']['input']>;
  rating?: InputMaybe<Scalars['Int']['input']>;
  sender?: InputMaybe<Scalars['String']['input']>;
  sharedCase?: InputMaybe<Scalars['String']['input']>;
  sharedCaseId?: InputMaybe<Scalars['String']['input']>;
  text?: InputMaybe<Scalars['String']['input']>;
  urlPrefix?: InputMaybe<Scalars['String']['input']>;
};


export type MutationSetVersionRunningEnvArgs = {
  env?: InputMaybe<Scalars['String']['input']>;
  runningEnv?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  version?: InputMaybe<Scalars['String']['input']>;
};


export type MutationSetVersionStateArgs = {
  env?: InputMaybe<Scalars['String']['input']>;
  state?: InputMaybe<GVersionState>;
  version?: InputMaybe<Scalars['String']['input']>;
};


export type MutationStoreOpaqueDataArgs = {
  auto?: InputMaybe<Scalars['Boolean']['input']>;
  data?: InputMaybe<StoredData>;
  type?: InputMaybe<Scalars['String']['input']>;
};


export type MutationStorePatientCaseArgs = {
  auto?: InputMaybe<Scalars['Boolean']['input']>;
  clinicId?: InputMaybe<Scalars['String']['input']>;
  partnerId?: InputMaybe<Scalars['String']['input']>;
  patientCaseInput?: InputMaybe<SavedCaseInput>;
  readOnly?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationUpdateLlmRuleCommentArgs = {
  comment: Scalars['String']['input'];
  id: Scalars['String']['input'];
  ruleFeedbackId: Scalars['String']['input'];
};


export type MutationUpdateOpaqueDataArgs = {
  data?: InputMaybe<StoredData>;
  id?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
};


export type MutationUpdatePatientCaseArgs = {
  clinicId?: InputMaybe<Scalars['String']['input']>;
  etag?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  patientCaseInput?: InputMaybe<SavedCaseInput>;
};


export type MutationUpdateSummaryArgs = {
  caseId?: InputMaybe<Scalars['String']['input']>;
  clinicId?: InputMaybe<Scalars['String']['input']>;
  summaryInput?: InputMaybe<SummaryInput>;
};

export type NamedNode = {
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  shortname?: Maybe<Scalars['String']['output']>;
};

export type NextStep = {
  __typename?: 'NextStep';
  debugSheet?: Maybe<Sheet>;
  suggestedFeatures?: Maybe<Array<Maybe<SuggestedFeature>>>;
};

export type Node = {
  __typename?: 'Node';
  causality?: Maybe<NodeCausality>;
  /** @deprecated Graph Refactor */
  citations?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** @deprecated Graph Refactor */
  citationsObj?: Maybe<Citations>;
  id: Scalars['ID']['output'];
  isConnected?: Maybe<Scalars['Boolean']['output']>;
  percentRange?: Maybe<Range>;
  probability?: Maybe<Scalars['Float']['output']>;
  qfs?: Maybe<Array<Maybe<QualifiedFeature>>>;
  /** @deprecated Graph Refactor */
  sourceQF?: Maybe<QualifiedFeature>;
  sourceQFIndex?: Maybe<Scalars['Int']['output']>;
  type?: Maybe<NodeType>;
};

export enum NodeCausality {
  DiseaseCausesNode = 'DISEASE_CAUSES_NODE',
  Mixed = 'MIXED',
  NodeCausesDisease = 'NODE_CAUSES_DISEASE',
  Uncorrelated = 'UNCORRELATED'
}

export enum NodeMatch {
  Exact = 'EXACT',
  None = 'NONE',
  Sibling = 'SIBLING',
  Subtype = 'SUBTYPE',
  Supertype = 'SUPERTYPE'
}

export enum NodeType {
  Disease = 'DISEASE',
  Finding = 'FINDING',
  FindingSubtype = 'FINDING_SUBTYPE',
  Inner = 'INNER'
}

export type NodeValidation = {
  __typename?: 'NodeValidation';
  diff?: Maybe<Scalars['String']['output']>;
  element?: Maybe<Scalars['String']['output']>;
  match?: Maybe<NodeMatch>;
};

export enum NumericalRefinementOperation {
  Merge = 'MERGE',
  None = 'NONE',
  ReplaceWithDetailed = 'REPLACE_WITH_DETAILED'
}

export type OpaqueData = {
  __typename?: 'OpaqueData';
  format?: Maybe<Scalars['String']['output']>;
  payload?: Maybe<Scalars['String']['output']>;
};

export type OpaqueDataInput = {
  format?: InputMaybe<Scalars['String']['input']>;
  payload?: InputMaybe<Scalars['String']['input']>;
};

export enum Order {
  Asc = 'Asc',
  Desc = 'Desc'
}

export type Panel = NamedNode & {
  __typename?: 'Panel';
  category?: Maybe<Feature>;
  children?: Maybe<Array<Maybe<Panel>>>;
  featureType?: Maybe<Scalars['String']['output']>;
  findings?: Maybe<Array<Maybe<QualifiedFeature>>>;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  organSystem?: Maybe<Feature>;
  panelGroup?: Maybe<Feature>;
  panelSubgroup?: Maybe<Feature>;
  shortname?: Maybe<Scalars['String']['output']>;
  snowmedid?: Maybe<Scalars['String']['output']>;
};

export type PathOptions = {
  adaptiveGrouping?: InputMaybe<Scalars['Boolean']['input']>;
  addPrevalenceSmoothFactor?: InputMaybe<Scalars['Boolean']['input']>;
  association?: InputMaybe<Scalars['Boolean']['input']>;
  candidatesLimitDiseases?: InputMaybe<Scalars['Int']['input']>;
  candidatesUseTopPerCurated?: InputMaybe<Scalars['Boolean']['input']>;
  childInherentParentEtiologies?: InputMaybe<Scalars['Boolean']['input']>;
  clusterByClosetsAncestorsInCurated?: InputMaybe<Scalars['Boolean']['input']>;
  clusterProbThreshold?: InputMaybe<Scalars['Float']['input']>;
  clustersLessLikelyMax?: InputMaybe<Scalars['Int']['input']>;
  clustersMostLikelyThreshold?: InputMaybe<Scalars['Int']['input']>;
  cohdPrevalences?: InputMaybe<Scalars['Boolean']['input']>;
  explainActiveUsingBackgroundDisorder?: InputMaybe<Scalars['Boolean']['input']>;
  extraEtiologySmoothFactor?: InputMaybe<Scalars['Boolean']['input']>;
  flexClustering?: InputMaybe<Scalars['Boolean']['input']>;
  flexClustering_COLLAPSE_CAP?: InputMaybe<Scalars['Float']['input']>;
  flexClustering_COLLAPSE_CAP_RATIO?: InputMaybe<Scalars['Float']['input']>;
  forceRecompute?: InputMaybe<Scalars['Boolean']['input']>;
  includeFlareUpsInDD?: InputMaybe<Scalars['Boolean']['input']>;
  includePathsGoingViaClosedSet?: InputMaybe<Scalars['Boolean']['input']>;
  includeRedundantInReport?: InputMaybe<Scalars['Boolean']['input']>;
  increaseNegatedSymptomsLift?: InputMaybe<Scalars['Boolean']['input']>;
  isa?: InputMaybe<Scalars['Boolean']['input']>;
  isaAsAssociation?: InputMaybe<Scalars['Boolean']['input']>;
  lambdaStructure?: InputMaybe<Scalars['Boolean']['input']>;
  leakByConceptType?: InputMaybe<Scalars['Boolean']['input']>;
  limitDiseasesSpace?: InputMaybe<Scalars['Boolean']['input']>;
  longPathsStartedInPopulation?: InputMaybe<Scalars['Boolean']['input']>;
  missingPresentingSymptomsFactor?: InputMaybe<Scalars['Float']['input']>;
  newKahunScore?: InputMaybe<Scalars['Boolean']['input']>;
  nodeEnablers?: InputMaybe<Scalars['Boolean']['input']>;
  noisyOrAsMax?: InputMaybe<Scalars['Boolean']['input']>;
  outputUsedPaths?: InputMaybe<Scalars['Boolean']['input']>;
  pathRejectTriggerLiftCap?: InputMaybe<Scalars['Float']['input']>;
  patientSortIncidenceExp?: InputMaybe<Scalars['Float']['input']>;
  population?: InputMaybe<Scalars['Boolean']['input']>;
  reduceBackgroundActiveSymptomProb?: InputMaybe<Scalars['Boolean']['input']>;
  reduceChronicDiseaseVsAcuteSymptomProb?: InputMaybe<Scalars['Boolean']['input']>;
  reduceDiamondShape?: InputMaybe<Scalars['Boolean']['input']>;
  reduceIncidenceRate?: InputMaybe<Scalars['Boolean']['input']>;
  softenActiveFindingLift?: InputMaybe<Scalars['Boolean']['input']>;
  sourceCauseTarget?: InputMaybe<Scalars['Boolean']['input']>;
  targetCauseSource?: InputMaybe<Scalars['Boolean']['input']>;
  traverseToSubTypeFinding?: InputMaybe<Scalars['Boolean']['input']>;
  urgencySortIncidenceExp?: InputMaybe<Scalars['Float']['input']>;
  urgencySubTypeMin?: InputMaybe<Scalars['Float']['input']>;
  useIncideneRelation?: InputMaybe<Scalars['Boolean']['input']>;
  useOnlyDiseasesToContain?: InputMaybe<Scalars['Boolean']['input']>;
  vStructure?: InputMaybe<Scalars['Boolean']['input']>;
  validLiftLimit?: InputMaybe<Scalars['Int']['input']>;
};

export type PatientCaseInput = {
  findings?: InputMaybe<Array<InputMaybe<GroupedFeature>>>;
};

export type PatientFinding = {
  __typename?: 'PatientFinding';
  category?: Maybe<DiseaseCategoryType>;
  clinicalReasoning?: Maybe<ClinicalReasoningFinding>;
};

export type PatientPropertiesInput = {
  date_of_birth?: InputMaybe<Scalars['Date']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  encounter_text?: InputMaybe<Scalars['String']['input']>;
  first_name?: InputMaybe<Scalars['String']['input']>;
  last_name?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  visit_date?: InputMaybe<Scalars['Date']['input']>;
  zip_code?: InputMaybe<Scalars['String']['input']>;
};

export type PatientQuestion = {
  __typename?: 'PatientQuestion';
  locale?: Maybe<Scalars['String']['output']>;
  text?: Maybe<Scalars['String']['output']>;
};

export type PatientSuggestion = {
  __typename?: 'PatientSuggestion';
  bestSubtype?: Maybe<QualifiedFeature>;
  canBeUnknown?: Maybe<Scalars['Boolean']['output']>;
  category?: Maybe<DiseaseCategoryType>;
  defaultFindingGivenDisease?: Maybe<Scalars['Float']['output']>;
  defaultFindingGivenDiseaseAdjustedEntropy?: Maybe<Scalars['Float']['output']>;
  entropy?: Maybe<Scalars['Float']['output']>;
  entropyNo?: Maybe<Scalars['Float']['output']>;
  entropyYes?: Maybe<Scalars['Float']['output']>;
  expectation?: Maybe<Scalars['Float']['output']>;
  findingEntropy?: Maybe<Scalars['Float']['output']>;
  findingLeak?: Maybe<Scalars['Float']['output']>;
  findingLeakAdjustedEntropy?: Maybe<Scalars['Float']['output']>;
  findingProbability?: Maybe<Scalars['Float']['output']>;
  inPatient?: Maybe<Scalars['Boolean']['output']>;
  inPatientId?: Maybe<Scalars['String']['output']>;
  mutualInformation?: Maybe<Scalars['Float']['output']>;
  mutualInformationUrgencyDifferentiation?: Maybe<Scalars['Float']['output']>;
  options?: Maybe<PatientSuggestionOptions>;
  perDiseaseMetrics?: Maybe<Array<Maybe<SuggestionDiseaseMetric>>>;
  question?: Maybe<PatientQuestion>;
  questionType?: Maybe<ConversationQuestionType>;
  refinementLocationRange?: Maybe<Feature>;
  refinementQuestionType?: Maybe<QuestionChoiceType>;
  refinements?: Maybe<Array<Maybe<QualifiedFeature>>>;
  suggestion?: Maybe<QualifiedFeature>;
  urgency?: Maybe<Scalars['Float']['output']>;
};

export type PatientSuggestionAutoComplete = {
  __typename?: 'PatientSuggestionAutoComplete';
  allow?: Maybe<Scalars['Boolean']['output']>;
  categories?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};

export type PatientSuggestionOptions = {
  __typename?: 'PatientSuggestionOptions';
  autoComplete?: Maybe<PatientSuggestionAutoComplete>;
};

export type PatientSuggestions = {
  __typename?: 'PatientSuggestions';
  clustered?: Maybe<Array<Maybe<ClusterSuggestion>>>;
  clusters?: Maybe<Array<Maybe<DiseaseCluster>>>;
  debugReport?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  debugSheet?: Maybe<Sheet>;
  diseases?: Maybe<Array<Maybe<DiseaseForPlan>>>;
  suggestions?: Maybe<Array<Maybe<PatientSuggestion>>>;
};

export enum PatientSummaryMode {
  Patient = 'PATIENT',
  Provider = 'PROVIDER'
}

export enum Permissions {
  AllClinicAccess = 'ALL_CLINIC_ACCESS',
  ClinicBackoffice = 'CLINIC_BACKOFFICE',
  ClinicCustomize = 'CLINIC_CUSTOMIZE',
  ClinicDelete = 'CLINIC_DELETE',
  ClinicEditPatientsData = 'CLINIC_EDIT_PATIENTS_DATA',
  ClinicGetPatientsData = 'CLINIC_GET_PATIENTS_DATA',
  ClinicManageUsers = 'CLINIC_MANAGE_USERS',
  CodeDelete = 'CODE_DELETE',
  Condition = 'CONDITION',
  CopyCasesBetweenClinics = 'COPY_CASES_BETWEEN_CLINICS',
  Graph = 'GRAPH',
  Model = 'MODEL',
  Mutations = 'MUTATIONS',
  Reasoning = 'REASONING'
}

export type PlanLimits = {
  category?: InputMaybe<DiseaseCategoryType>;
  limit?: InputMaybe<Scalars['Int']['input']>;
};

export type Policy = {
  __typename?: 'Policy';
  id?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
};

export type PolicyProtocolOutput = {
  __typename?: 'PolicyProtocolOutput';
  questions?: Maybe<Array<Maybe<PolicyQuestion>>>;
  recommendations?: Maybe<Array<Maybe<PolicyRecommendation>>>;
};

export type PolicyQuestion = {
  __typename?: 'PolicyQuestion';
  policyName?: Maybe<Scalars['String']['output']>;
  policyid?: Maybe<Scalars['ID']['output']>;
  protocolName?: Maybe<Scalars['String']['output']>;
  protocolid?: Maybe<Scalars['ID']['output']>;
  recommendations?: Maybe<Array<Maybe<QualifiedFeature>>>;
  suggestionFeature?: Maybe<QualifiedFeature>;
};

export type PolicyRecommendation = {
  __typename?: 'PolicyRecommendation';
  feature?: Maybe<QualifiedFeature>;
  policyName?: Maybe<Scalars['String']['output']>;
  policyid?: Maybe<Scalars['ID']['output']>;
  protocolName?: Maybe<Scalars['String']['output']>;
  protocolid?: Maybe<Scalars['ID']['output']>;
};

export type PossibleCauses = {
  __typename?: 'PossibleCauses';
  etag?: Maybe<Scalars['String']['output']>;
  possibleCauses?: Maybe<Array<Maybe<SummaryDiseaseCluster>>>;
};

export type QfDetails = {
  __typename?: 'QFDetails';
  name?: Maybe<Scalars['String']['output']>;
};

export type QfMetrics = {
  __typename?: 'QFMetrics';
  id?: Maybe<Scalars['String']['output']>;
  incidence?: Maybe<Scalars['Float']['output']>;
  incidenceDescription?: Maybe<Scalars['String']['output']>;
  incidenceSource?: Maybe<Scalars['String']['output']>;
  prevalence?: Maybe<Scalars['Float']['output']>;
  prevalenceDescription?: Maybe<Scalars['String']['output']>;
  prevalenceSource?: Maybe<Scalars['String']['output']>;
  urgency?: Maybe<Scalars['Float']['output']>;
};

export type QfsCorrelate = {
  __typename?: 'QFSCorrelate';
  correlate?: Maybe<Scalars['String']['output']>;
  qfs1?: Maybe<QfDetails>;
  qfs2?: Maybe<QfDetails>;
};

export type QualifiedFeature = {
  __typename?: 'QualifiedFeature';
  feature?: Maybe<Feature>;
  id: Scalars['ID']['output'];
  mandatory?: Maybe<Qualifier>;
  name: Scalars['String']['output'];
  negate?: Maybe<Scalars['Boolean']['output']>;
  qualifiers?: Maybe<Array<Maybe<Qualifier>>>;
  skip?: Maybe<Scalars['Boolean']['output']>;
};

export type QualifiedFeatureInput = {
  alias?: InputMaybe<Scalars['String']['input']>;
  feature?: InputMaybe<Scalars['ID']['input']>;
  negate?: InputMaybe<Scalars['Boolean']['input']>;
  qualifiedFeatureRequestId?: InputMaybe<Scalars['String']['input']>;
  qualifiers?: InputMaybe<Array<QualifierInput>>;
};

export type Qualifier = {
  __typename?: 'Qualifier';
  feature?: Maybe<Feature>;
  freeText?: Maybe<Scalars['String']['output']>;
  group?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  negate?: Maybe<Scalars['Boolean']['output']>;
  range?: Maybe<MeasurementRange>;
  relation: Relation;
  source?: Maybe<FindingSource>;
  value?: Maybe<Feature>;
};

export type QualifierInput = {
  encrypted?: InputMaybe<Scalars['String']['input']>;
  freeText?: InputMaybe<Scalars['String']['input']>;
  negate?: InputMaybe<Scalars['Boolean']['input']>;
  range?: InputMaybe<MeasurementRangeInput>;
  relation: Scalars['ID']['input'];
  source?: InputMaybe<FindingSource>;
  value?: InputMaybe<Scalars['ID']['input']>;
};

export type QualifierSearchResult = {
  __typename?: 'QualifierSearchResult';
  match?: Maybe<Scalars['String']['output']>;
  result?: Maybe<Qualifier>;
};

export type QualifierSpec = {
  __typename?: 'QualifierSpec';
  mandatory?: Maybe<Scalars['Boolean']['output']>;
  range?: Maybe<FeatureSet>;
  relation: Relation;
};

export type Query = {
  __typename?: 'Query';
  allTags?: Maybe<Array<Maybe<LlmRuleTags>>>;
  checkForPII?: Maybe<UpdateSummaryResponse>;
  citation?: Maybe<CitationQueries>;
  citationData?: Maybe<Array<Maybe<CitationData>>>;
  clinic?: Maybe<ClinicQueries>;
  clinicByName?: Maybe<ClinicQueries>;
  codeVersion?: Maybe<Scalars['Int']['output']>;
  conversation?: Maybe<ConversationQueries>;
  dd?: Maybe<DdResponse>;
  defaultPanels?: Maybe<Array<Maybe<Panel>>>;
  diagnosisModel?: Maybe<LoadedModelInfo>;
  feature?: Maybe<Feature>;
  featureSearch?: Maybe<Array<Maybe<Feature>>>;
  freeTextToPatientCase?: Maybe<FreeTextToPatientResponse>;
  gatewayModel?: Maybe<LoadedModelInfo>;
  getLlmComments?: Maybe<Array<Maybe<LlmCommentData>>>;
  getUserRoles?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  graph?: Maybe<GraphResponse>;
  graphByCohorts?: Maybe<GraphResponse>;
  groundText?: Maybe<Grounding>;
  info?: Maybe<Scalars['String']['output']>;
  metricsEdges?: Maybe<Array<Maybe<MetricsEdge>>>;
  metricsNodes?: Maybe<Array<Maybe<MetricsNode>>>;
  metricsPaths?: Maybe<Array<Maybe<MetricsPath>>>;
  metricsQF?: Maybe<Array<Maybe<QfMetrics>>>;
  panel?: Maybe<Panel>;
  panels?: Maybe<Array<Maybe<Panel>>>;
  patientCaseMetaData?: Maybe<CaseMetaData>;
  patientSummary?: Maybe<Summary>;
  patientSummaryByCase?: Maybe<Summary>;
  plan?: Maybe<PatientSuggestions>;
  policies?: Maybe<Array<Maybe<Policy>>>;
  qfsCorrelate?: Maybe<QfsCorrelate>;
  qfsCorrelateLists?: Maybe<Array<Maybe<QfsCorrelate>>>;
  qualifiedFeatureLookup?: Maybe<QualifiedFeature>;
  qualifiedFeatureSearch?: Maybe<Array<Maybe<QualifiedFeature>>>;
  qualifiedFeatures?: Maybe<Array<Maybe<QualifiedFeature>>>;
  qualifierSearch?: Maybe<Array<Maybe<Qualifier>>>;
  reference?: Maybe<ReferenceQueries>;
  relation?: Maybe<Relation>;
  restoreOpaqueData?: Maybe<RestoredData>;
  restorePatientCase?: Maybe<SavedCase>;
  rule?: Maybe<Array<Maybe<RuleValue>>>;
  runLoadersStatus?: Maybe<Array<Maybe<RunLoadersStatusResult>>>;
  user?: Maybe<UserQueries>;
};


export type QueryAllTagsArgs = {
  category?: InputMaybe<Scalars['String']['input']>;
};


export type QueryCheckForPiiArgs = {
  input?: InputMaybe<Scalars['String']['input']>;
};


export type QueryCitationArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryCitationDataArgs = {
  ids?: InputMaybe<Array<Scalars['ID']['input']>>;
};


export type QueryClinicArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryClinicByNameArgs = {
  name?: InputMaybe<Scalars['String']['input']>;
};


export type QueryDdArgs = {
  adaptiveRatio?: InputMaybe<Scalars['Float']['input']>;
  caseId?: InputMaybe<Scalars['String']['input']>;
  clinicId?: InputMaybe<Scalars['String']['input']>;
  comment?: InputMaybe<Scalars['String']['input']>;
  conditions?: InputMaybe<Array<InputMaybe<CaseConditionInput>>>;
  depth?: InputMaybe<Scalars['Int']['input']>;
  diagnosisOptions?: InputMaybe<Scalars['DiagnosisOptionsInput']['input']>;
  diseasesToAdd?: InputMaybe<Array<InputMaybe<QualifiedFeatureInput>>>;
  diseasesToConsider?: InputMaybe<Array<InputMaybe<QualifiedFeatureInput>>>;
  diseasesToDiscard?: InputMaybe<Array<InputMaybe<QualifiedFeatureInput>>>;
  includeCitations?: InputMaybe<Scalars['Boolean']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  nextStepDiseasesToConsider?: InputMaybe<Array<InputMaybe<QualifiedFeatureInput>>>;
  panelsToConsider?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  pathOptions?: InputMaybe<PathOptions>;
  patientCaseInput?: InputMaybe<PatientCaseInput>;
  qualifiedFeatures?: InputMaybe<Array<InputMaybe<QualifiedFeatureInput>>>;
  sortTypes?: InputMaybe<Array<InputMaybe<SortType>>>;
};


export type QueryFeatureArgs = {
  id: Scalars['ID']['input'];
};


export type QueryFeatureSearchArgs = {
  filter?: InputMaybe<SearchFilter>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
};


export type QueryFreeTextToPatientCaseArgs = {
  text?: InputMaybe<Scalars['String']['input']>;
};


export type QueryGetLlmCommentsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  ruleFeedbackId: Scalars['String']['input'];
};


export type QueryGraphArgs = {
  nodes?: InputMaybe<Array<InputMaybe<GroupedFeature>>>;
  root?: InputMaybe<QualifiedFeatureInput>;
  simplify?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryGraphByCohortsArgs = {
  active?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  background?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  root?: InputMaybe<Scalars['ID']['input']>;
  simplify?: InputMaybe<Scalars['Boolean']['input']>;
  subtypes?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
};


export type QueryGroundTextArgs = {
  caseId?: InputMaybe<Scalars['String']['input']>;
  disease?: InputMaybe<QualifiedFeatureInput>;
  patientCase?: InputMaybe<PatientCaseInput>;
  text: Scalars['String']['input'];
};


export type QueryMetricsEdgesArgs = {
  edgeids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type QueryMetricsNodesArgs = {
  nodeids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type QueryMetricsPathsArgs = {
  causeids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  causeqfs?: InputMaybe<Array<InputMaybe<QualifiedFeatureInput>>>;
  effectIsDisease?: InputMaybe<Scalars['Boolean']['input']>;
  effectids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  effectqfs?: InputMaybe<Array<InputMaybe<QualifiedFeatureInput>>>;
  patient?: InputMaybe<PatientCaseInput>;
};


export type QueryMetricsQfArgs = {
  qfs?: InputMaybe<Array<InputMaybe<QualifiedFeatureInput>>>;
};


export type QueryPanelArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryPatientCaseMetaDataArgs = {
  id?: InputMaybe<Scalars['String']['input']>;
};


export type QueryPatientSummaryArgs = {
  clinicId?: InputMaybe<Scalars['String']['input']>;
  conversationOptions?: InputMaybe<ConversationOptions>;
  conversationOptionsInput?: InputMaybe<Scalars['ConversationOptionsInput']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  mode?: InputMaybe<PatientSummaryMode>;
  options?: InputMaybe<SummaryOptions>;
  summaryOptions?: InputMaybe<Scalars['SummaryOptionsInput']['input']>;
  waitUntilReady?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryPatientSummaryByCaseArgs = {
  diseases?: InputMaybe<Array<InputMaybe<QualifiedFeatureInput>>>;
  options?: InputMaybe<SummaryOptions>;
  patientCaseInput?: InputMaybe<PatientCaseInput>;
  suggestions?: InputMaybe<Array<InputMaybe<QualifiedFeatureInput>>>;
  summaryOptions?: InputMaybe<Scalars['SummaryOptionsInput']['input']>;
};


export type QueryPlanArgs = {
  caseId?: InputMaybe<Scalars['String']['input']>;
  categories?: InputMaybe<Array<InputMaybe<DiseaseCategoryType>>>;
  clinicId?: InputMaybe<Scalars['String']['input']>;
  diagnosisOptions?: InputMaybe<Scalars['DiagnosisOptionsInput']['input']>;
  diseases?: InputMaybe<Array<InputMaybe<DiseaseForPlanInput>>>;
  diseasesAliasing?: InputMaybe<Array<InputMaybe<DiseasesAliasing>>>;
  limitPerCategory?: InputMaybe<Array<InputMaybe<PlanLimits>>>;
  limitSuggestions?: InputMaybe<Scalars['Int']['input']>;
  pathOptions?: InputMaybe<PathOptions>;
  patientCaseInput?: InputMaybe<PatientCaseInput>;
};


export type QueryQfsCorrelateArgs = {
  qfs1?: InputMaybe<Array<InputMaybe<QualifiedFeatureInput>>>;
  qfs2?: InputMaybe<Array<InputMaybe<QualifiedFeatureInput>>>;
};


export type QueryQfsCorrelateListsArgs = {
  qfsList1?: InputMaybe<Array<InputMaybe<Array<InputMaybe<QualifiedFeatureInput>>>>>;
  qfsList2?: InputMaybe<Array<InputMaybe<Array<InputMaybe<QualifiedFeatureInput>>>>>;
};


export type QueryQualifiedFeatureLookupArgs = {
  categories?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  codeset?: InputMaybe<CodeSet>;
  term?: InputMaybe<Scalars['String']['input']>;
};


export type QueryQualifiedFeatureSearchArgs = {
  ancestors?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  categories?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  customPatientFacingPropertyValues?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  feature?: InputMaybe<Scalars['ID']['input']>;
  gender?: InputMaybe<Scalars['ID']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  panelIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  patientFacing?: InputMaybe<Scalars['Boolean']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
};


export type QueryQualifiedFeaturesArgs = {
  qfs?: InputMaybe<Array<InputMaybe<QualifiedFeatureInput>>>;
};


export type QueryQualifierSearchArgs = {
  features?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  relation?: InputMaybe<Scalars['ID']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
};


export type QueryRelationArgs = {
  id: Scalars['ID']['input'];
};


export type QueryRestoreOpaqueDataArgs = {
  id?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
};


export type QueryRestorePatientCaseArgs = {
  clinicId?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
};


export type QueryRuleArgs = {
  ids?: InputMaybe<Array<Scalars['ID']['input']>>;
};


export type QueryRunLoadersStatusArgs = {
  env?: InputMaybe<Scalars['String']['input']>;
};

export enum QuestionChoiceType {
  ChooseMuliple = 'ChooseMuliple',
  ChooseNumeric = 'ChooseNumeric',
  ChooseOne = 'ChooseOne'
}

export type RAgeDistribution = {
  __typename?: 'RAgeDistribution';
  ranges?: Maybe<Array<Maybe<RAgeDistributionRange>>>;
};

export type RAgeDistributionRange = {
  __typename?: 'RAgeDistributionRange';
  from?: Maybe<Scalars['Float']['output']>;
  to?: Maybe<Scalars['Float']['output']>;
  value?: Maybe<Scalars['Float']['output']>;
};

export type RCohort = {
  __typename?: 'RCohort';
  id: Scalars['ID']['output'];
  qfs?: Maybe<Array<Maybe<QualifiedFeature>>>;
};

export type RMetric = {
  __typename?: 'RMetric';
  exactness?: Maybe<Exactness>;
  value?: Maybe<Scalars['Float']['output']>;
};

export type RPairMetrics = {
  __typename?: 'RPairMetrics';
  NLR?: Maybe<RMetric>;
  PLR?: Maybe<RMetric>;
  incidence?: Maybe<RMetric>;
  ppv?: Maybe<RMetric>;
  rrisk_cause?: Maybe<RMetric>;
  rrisk_effect?: Maybe<RMetric>;
  sensitivity?: Maybe<RMetric>;
  specificity?: Maybe<RMetric>;
};

export type RUnaryMetrics = {
  __typename?: 'RUnaryMetrics';
  duration?: Maybe<MeasurementRange>;
  incidence?: Maybe<Scalars['Float']['output']>;
  leak?: Maybe<Scalars['Float']['output']>;
  prevalence?: Maybe<Scalars['Float']['output']>;
  prevalenceDescription?: Maybe<Scalars['String']['output']>;
  urgency?: Maybe<Scalars['Float']['output']>;
};

export type RagCitation = {
  __typename?: 'RagCitation';
  ruleCitations?: Maybe<Array<Maybe<Scalars['RagRuleCitation']['output']>>>;
  rvids?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  text?: Maybe<Scalars['String']['output']>;
};

export type RagGuideline = {
  __typename?: 'RagGuideline';
  id?: Maybe<Scalars['String']['output']>;
  properties?: Maybe<Array<Maybe<KeyValue>>>;
  source?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  url?: Maybe<Scalars['String']['output']>;
};

export type Range = {
  __typename?: 'Range';
  max?: Maybe<Scalars['Float']['output']>;
  min?: Maybe<Scalars['Float']['output']>;
};

export type RangeInDistribution = {
  __typename?: 'RangeInDistribution';
  findingGivenDisease?: Maybe<Scalars['Float']['output']>;
  from?: Maybe<Scalars['Float']['output']>;
  prevalence?: Maybe<Scalars['Float']['output']>;
  to?: Maybe<Scalars['Float']['output']>;
};

export type RedundantBySort = {
  __typename?: 'RedundantBySort';
  redundantDueTo?: Maybe<QualifiedFeature>;
  sortType?: Maybe<SortType>;
};

export type ReferenceQueries = {
  __typename?: 'ReferenceQueries';
  disease?: Maybe<DiseaseReference>;
  diseaseWithFinding?: Maybe<DiseaseReference>;
};


export type ReferenceQueriesDiseaseArgs = {
  disease?: InputMaybe<CohortInput>;
  options?: InputMaybe<DiseaseReferenceOptions>;
};


export type ReferenceQueriesDiseaseWithFindingArgs = {
  disease?: InputMaybe<CohortInput>;
  finding?: InputMaybe<CohortInput>;
  options?: InputMaybe<DiseaseReferenceOptions>;
};

export type Relation = NamedNode & {
  __typename?: 'Relation';
  essence?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  multi?: Maybe<Scalars['Boolean']['output']>;
  name: Scalars['String']['output'];
  range?: Maybe<FeatureSet>;
  shortname?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
};

export type ReloadResult = {
  __typename?: 'ReloadResult';
  success?: Maybe<Scalars['String']['output']>;
};

export type RestoredData = {
  __typename?: 'RestoredData';
  data?: Maybe<Scalars['OpaqueDataScalar']['output']>;
  features?: Maybe<Array<Maybe<GroupedFeatureResponse>>>;
};

export type Result = {
  __typename?: 'Result';
  status?: Maybe<Scalars['String']['output']>;
};

export type Row = {
  __typename?: 'Row';
  cols?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};

export type RuleStat = {
  __typename?: 'RuleStat';
  edgeStat?: Maybe<MetricsEdgeStat>;
  /** @deprecated see edgeStat */
  lift?: Maybe<Scalars['Float']['output']>;
  overloadSource?: Maybe<Array<Maybe<QualifiedFeature>>>;
  overloadSourceType?: Maybe<RuleType>;
  overloadTarget?: Maybe<Array<Maybe<QualifiedFeature>>>;
  overloadTargetType?: Maybe<RuleType>;
  /** @deprecated see edgeStat */
  prob?: Maybe<Scalars['Float']['output']>;
  ruleValue?: Maybe<RuleValue>;
  type?: Maybe<RuleType>;
};

export enum RuleType {
  Association = 'ASSOCIATION',
  Companion = 'COMPANION',
  Isa = 'ISA',
  Lift = 'LIFT',
  SourceCauseTarget = 'SOURCE_CAUSE_TARGET',
  Subtype = 'SUBTYPE',
  TargetCauseSource = 'TARGET_CAUSE_SOURCE'
}

export type RuleValue = {
  __typename?: 'RuleValue';
  /** @deprecated Graph Refactor */
  citations?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  citationsObj?: Maybe<CitationData>;
  /** @deprecated Graph Refactor */
  distribution?: Maybe<Array<Maybe<DistributionPart>>>;
  exactCitation?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['ID']['output'];
  /** @deprecated Graph Refactor */
  lift?: Maybe<Scalars['Float']['output']>;
  /** @deprecated Graph Refactor */
  overloadSourceType?: Maybe<RuleType>;
  /** @deprecated Graph Refactor */
  overloadTargetType?: Maybe<RuleType>;
  /** @deprecated Graph Refactor */
  prob?: Maybe<Scalars['Float']['output']>;
  ruleValueId?: Maybe<Scalars['String']['output']>;
  source?: Maybe<Array<Maybe<QualifiedFeature>>>;
  target?: Maybe<Array<Maybe<QualifiedFeature>>>;
  type?: Maybe<RuleType>;
};

export type RunLoadersStatusResult = {
  __typename?: 'RunLoadersStatusResult';
  casesBatch?: Maybe<Scalars['String']['output']>;
  codeversion?: Maybe<Scalars['Int']['output']>;
  commit?: Maybe<Scalars['String']['output']>;
  commitserial?: Maybe<Scalars['Float']['output']>;
  featuresurl?: Maybe<Scalars['String']['output']>;
  filter?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  loaders?: Maybe<Array<Maybe<LoaderInfoResult>>>;
  revision?: Maybe<Scalars['String']['output']>;
  runningEnv?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  shardtotal?: Maybe<Scalars['Int']['output']>;
  startedat?: Maybe<Scalars['Float']['output']>;
  state?: Maybe<GVersionState>;
  url?: Maybe<Scalars['String']['output']>;
  version?: Maybe<Scalars['String']['output']>;
};

export type SavedCase = {
  __typename?: 'SavedCase';
  clinicId?: Maybe<Scalars['String']['output']>;
  data?: Maybe<OpaqueData>;
  etag?: Maybe<Scalars['String']['output']>;
  findings?: Maybe<Array<Maybe<SavedCaseGroup>>>;
  lastModified?: Maybe<Scalars['String']['output']>;
  partnerId?: Maybe<Scalars['String']['output']>;
};

export type SavedCaseGroup = {
  __typename?: 'SavedCaseGroup';
  features?: Maybe<Array<Maybe<GroupedFeatureResponse>>>;
  group?: Maybe<Scalars['String']['output']>;
};

export type SavedCaseGroupInput = {
  features?: InputMaybe<Array<InputMaybe<GroupedFeature>>>;
  group?: InputMaybe<Scalars['String']['input']>;
};

export type SavedCaseInput = {
  data?: InputMaybe<OpaqueDataInput>;
  findings?: InputMaybe<Array<InputMaybe<SavedCaseGroupInput>>>;
};

export type SavedCaseResponse = {
  __typename?: 'SavedCaseResponse';
  data?: Maybe<OpaqueData>;
  findings?: Maybe<Array<Maybe<GroupedFeatureResponse>>>;
};

export enum SavedCaseStatus {
  Fail = 'FAIL',
  Mismatch = 'MISMATCH',
  Success = 'SUCCESS'
}

export type ScoreByType = {
  __typename?: 'ScoreByType';
  adjusted?: Maybe<Scalars['Float']['output']>;
  adjustedNormalized?: Maybe<Scalars['Float']['output']>;
  normalized?: Maybe<Scalars['Float']['output']>;
  postClusterAdjustment?: Maybe<Scalars['Float']['output']>;
  sortType?: Maybe<SortType>;
  unnormalized?: Maybe<Scalars['Float']['output']>;
};

export enum SearchFilter {
  All = 'ALL',
  Conditions = 'CONDITIONS',
  Demographics = 'DEMOGRAPHICS',
  History = 'HISTORY',
  Symptoms = 'SYMPTOMS',
  Tests = 'TESTS'
}

export type ShareCodeData = {
  __typename?: 'ShareCodeData';
  comment?: Maybe<Scalars['String']['output']>;
  date?: Maybe<Scalars['Float']['output']>;
  digitCode?: Maybe<Scalars['ID']['output']>;
  ehrid?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  patientProperties?: Maybe<Scalars['PatientProperties']['output']>;
  seen?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  shareid?: Maybe<Scalars['String']['output']>;
  visitStatus?: Maybe<Scalars['VisitStatus']['output']>;
  visitStatusStructure?: Maybe<VisitStatusStructure>;
};

export type ShareCodeShortData = {
  __typename?: 'ShareCodeShortData';
  date?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
};

export type Sheet = {
  __typename?: 'Sheet';
  rows?: Maybe<Array<Maybe<Row>>>;
};

export enum SortType {
  BestMatch = 'BestMatch',
  PatientProb = 'PatientProb',
  Prob = 'Prob',
  Urgency = 'Urgency'
}

export type StateIcdCodes = {
  __typename?: 'StateICDCodes';
  diseases?: Maybe<Array<Maybe<IcdCode>>>;
  findings?: Maybe<Array<Maybe<IcdCode>>>;
};

export enum StatementHypothesis {
  Association = 'ASSOCIATION',
  Causes = 'CAUSES',
  DoesNotCause = 'DOES_NOT_CAUSE',
  RiskFactor = 'RISK_FACTOR'
}

export type StoredData = {
  data?: InputMaybe<Scalars['OpaqueDataScalar']['input']>;
  features?: InputMaybe<Array<InputMaybe<GroupedFeature>>>;
};

export type StrengthForSortType = {
  __typename?: 'StrengthForSortType';
  sortType?: Maybe<SortType>;
  strength?: Maybe<Scalars['Float']['output']>;
};

export enum SubGroupType {
  DueTo = 'DUE_TO',
  LimitedTo = 'LIMITED_TO',
  Subtype = 'SUBTYPE'
}

export enum SubStatus {
  Incomplete = 'INCOMPLETE',
  Skipped = 'SKIPPED'
}

export type SuggestedFeature = {
  __typename?: 'SuggestedFeature';
  category?: Maybe<DiseaseCategoryType>;
  liftScores?: Maybe<Array<Maybe<LiftScore>>>;
  qualifiedFeature?: Maybe<QualifiedFeature>;
  sumDiseaseGivenFinding?: Maybe<Scalars['Float']['output']>;
  sumLiftScores?: Maybe<Scalars['Float']['output']>;
};

export type SuggestionDiseaseMetric = {
  __typename?: 'SuggestionDiseaseMetric';
  adjustedBinaryEntropy?: Maybe<Scalars['Float']['output']>;
  disease?: Maybe<QualifiedFeature>;
  diseaseGivenFinding?: Maybe<Scalars['Float']['output']>;
  diseaseIndex?: Maybe<Scalars['Int']['output']>;
  findingGivenDisease?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  likelihoodRatioNeg?: Maybe<Scalars['Float']['output']>;
  likelihoodRatioPos?: Maybe<Scalars['Float']['output']>;
  pairMetrics?: Maybe<RPairMetrics>;
  relativeRisk?: Maybe<Scalars['Float']['output']>;
  specificity?: Maybe<Scalars['Float']['output']>;
  suggestion?: Maybe<QualifiedFeature>;
};

export type Summary = {
  __typename?: 'Summary';
  assessment?: Maybe<GroundedSummaryText>;
  caseEtag?: Maybe<Scalars['String']['output']>;
  conversation?: Maybe<ConversationSummary>;
  data?: Maybe<SummeryData>;
  findings?: Maybe<Array<Maybe<GroupedFeatureResponse>>>;
  lastModified?: Maybe<Scalars['String']['output']>;
  navigationAdvice?: Maybe<PolicyRecommendation>;
  /** @deprecated depracated, use possibleCauses */
  possibleCause?: Maybe<Array<Maybe<SummaryDiseaseCluster>>>;
  possibleCauses?: Maybe<PossibleCauses>;
  problemList?: Maybe<Array<Maybe<SummaryProblem>>>;
  recommendations?: Maybe<Array<Maybe<PolicyRecommendation>>>;
  status?: Maybe<Scalars['String']['output']>;
  validCase?: Maybe<ValidCaseInfo>;
  workup?: Maybe<SummaryText>;
  workupActionItems?: Maybe<WorkupActionItems>;
  /** @deprecated use workupActionItems */
  workupList?: Maybe<Array<Maybe<WorkupItem>>>;
};

export type SummaryDiseaseCluster = {
  __typename?: 'SummaryDiseaseCluster';
  explanation?: Maybe<GroundedSummaryText>;
  icd?: Maybe<Array<Maybe<SummaryIcdCode>>>;
  id: Scalars['ID']['output'];
  inTopCRPerSortType?: Maybe<Array<Maybe<SortType>>>;
  likelihood?: Maybe<Scalars['String']['output']>;
  scores?: Maybe<ScoreByType>;
  title?: Maybe<QualifiedFeature>;
  urgencyId?: Maybe<Scalars['ID']['output']>;
};

export type SummaryIcdCode = {
  __typename?: 'SummaryICDCode';
  code?: Maybe<Scalars['String']['output']>;
  desc?: Maybe<Scalars['String']['output']>;
};

export type SummaryInput = {
  age?: InputMaybe<Scalars['Int']['input']>;
  gender?: InputMaybe<Scalars['String']['input']>;
  height?: InputMaybe<Scalars['String']['input']>;
  main?: InputMaybe<Scalars['String']['input']>;
  sections?: InputMaybe<Array<InputMaybe<SummerySectionInput>>>;
  visitReason?: InputMaybe<Array<InputMaybe<SummaryVisitReasonInput>>>;
  weight?: InputMaybe<Scalars['String']['input']>;
};

export type SummaryInsights = {
  __typename?: 'SummaryInsights';
  assessment?: Maybe<GroundedSummaryText>;
  explanations?: Maybe<Array<Maybe<SummaryDiseaseCluster>>>;
  sections?: Maybe<Array<Maybe<SummerySection>>>;
  workup?: Maybe<GroundedSummaryText>;
};

export type SummaryOptions = {
  discardNoForNegate?: InputMaybe<Scalars['Boolean']['input']>;
  heightInInches?: InputMaybe<Scalars['Boolean']['input']>;
  showAssessment?: InputMaybe<Scalars['Boolean']['input']>;
  showIcdCodes?: InputMaybe<Scalars['Boolean']['input']>;
  weightInPounds?: InputMaybe<Scalars['Boolean']['input']>;
};

export type SummaryProblem = {
  __typename?: 'SummaryProblem';
  icd?: Maybe<Array<Maybe<SummaryIcdCode>>>;
  problem?: Maybe<QualifiedFeature>;
};

export enum SummarySectionType {
  Assessment = 'assessment',
  Dd = 'dd',
  FreeForm = 'free_form',
  Hpi = 'hpi',
  Imaging = 'imaging',
  Labs = 'labs',
  Other = 'other',
  Pe = 'pe',
  Plan = 'plan',
  ReasonForVisit = 'reason_for_visit',
  Referral = 'referral',
  Ros = 'ros',
  Suggested = 'suggested',
  TriageAdvice = 'triage_advice'
}

export type SummaryText = {
  error?: Maybe<Scalars['Boolean']['output']>;
  errorText?: Maybe<Scalars['String']['output']>;
  etag?: Maybe<Scalars['String']['output']>;
  generating?: Maybe<Scalars['Boolean']['output']>;
  text?: Maybe<Scalars['String']['output']>;
};

export type SummaryVisitReason = {
  __typename?: 'SummaryVisitReason';
  id?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
};

export type SummaryVisitReasonInput = {
  id?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};

export type SummeryData = {
  __typename?: 'SummeryData';
  age?: Maybe<Scalars['Int']['output']>;
  gender?: Maybe<Scalars['String']['output']>;
  height?: Maybe<Scalars['String']['output']>;
  main?: Maybe<Scalars['String']['output']>;
  sections?: Maybe<Array<Maybe<SummerySection>>>;
  visitReason?: Maybe<Array<Maybe<SummaryVisitReason>>>;
  weight?: Maybe<Scalars['String']['output']>;
};

export type SummerySection = {
  __typename?: 'SummerySection';
  content?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  type?: Maybe<SummarySectionType>;
};

export type SummerySectionInput = {
  content?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<SummarySectionType>;
};

export enum Test {
  X = 'x',
  Y = 'y'
}

export type TextualWithRuleReference = {
  __typename?: 'TextualWithRuleReference';
  priority?: Maybe<Scalars['Int']['output']>;
  ruleValue?: Maybe<RuleValue>;
  textual?: Maybe<Scalars['String']['output']>;
};

export type TreeNode = {
  __typename?: 'TreeNode';
  child?: Maybe<Array<Maybe<Scalars['ID']['output']>>>;
  depth?: Maybe<Scalars['Int']['output']>;
  parent?: Maybe<Array<Maybe<Scalars['ID']['output']>>>;
  self: Scalars['ID']['output'];
};

export enum UserRoles {
  KahunBackofficeUsers = 'Kahun_Backoffice_Users',
  KahunClinicAdmins = 'Kahun_Clinic_Admins',
  KahunClinicManager = 'Kahun_Clinic_Manager',
  KahunClinicSuperAdmins = 'Kahun_Clinic_Super_Admins',
  KahunClinicUser = 'Kahun_Clinic_User',
  KahunPatientDemoUsers = 'Kahun_PatientDemo_Users'
}

export type UngroundedSummaryText = GeneratedOutput & SummaryText & {
  __typename?: 'UngroundedSummaryText';
  error?: Maybe<Scalars['Boolean']['output']>;
  errorText?: Maybe<Scalars['String']['output']>;
  etag?: Maybe<Scalars['String']['output']>;
  generating?: Maybe<Scalars['Boolean']['output']>;
  text?: Maybe<Scalars['String']['output']>;
};

export type UpdateCaseResponse = {
  __typename?: 'UpdateCaseResponse';
  etag?: Maybe<Scalars['String']['output']>;
  status?: Maybe<SavedCaseStatus>;
};

export type UpdateSummaryResponse = {
  __typename?: 'UpdateSummaryResponse';
  errors?: Maybe<Scalars['UpdateSummaryErrors']['output']>;
  etag?: Maybe<Scalars['String']['output']>;
  status?: Maybe<SavedCaseStatus>;
};

export type UrgencyByType = {
  __typename?: 'UrgencyByType';
  sortType?: Maybe<SortType>;
  urgencyLevelId?: Maybe<Scalars['ID']['output']>;
};

export type UserData = {
  __typename?: 'UserData';
  email?: Maybe<Scalars['String']['output']>;
  role?: Maybe<UserRoles>;
};

export type UserMutations = {
  __typename?: 'UserMutations';
  createClinic?: Maybe<ClinicData>;
};


export type UserMutationsCreateClinicArgs = {
  config?: InputMaybe<Scalars['Config']['input']>;
  displayName?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};

export type UserQueries = {
  __typename?: 'UserQueries';
  clinics?: Maybe<Array<Maybe<ClinicData>>>;
  data?: Maybe<UserData>;
  isClinicNameAvailable?: Maybe<Scalars['Boolean']['output']>;
};


export type UserQueriesClinicsArgs = {
  onlyMyClinics?: InputMaybe<Scalars['Boolean']['input']>;
};


export type UserQueriesIsClinicNameAvailableArgs = {
  name?: InputMaybe<Scalars['String']['input']>;
};

export type ValidCaseInfo = {
  __typename?: 'ValidCaseInfo';
  etag?: Maybe<Scalars['String']['output']>;
  isValid?: Maybe<Scalars['Boolean']['output']>;
  reason?: Maybe<Scalars['String']['output']>;
};

export enum ValidationStatus {
  Invalidated = 'invalidated',
  None = 'none',
  RequiresValidation = 'requires_validation',
  Validated = 'validated',
  ValidationFollowup = 'validation_followup'
}

export type VisitStatusStructure = {
  __typename?: 'VisitStatusStructure';
  age?: Maybe<Scalars['Int']['output']>;
  chiefComplaint?: Maybe<Feature>;
  gender?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  visitReason?: Maybe<Array<Maybe<Feature>>>;
};

export type Visits = {
  __typename?: 'Visits';
  count?: Maybe<Scalars['Int']['output']>;
  startKey?: Maybe<Scalars['StartKey']['output']>;
  visits?: Maybe<Array<Maybe<ShareCodeData>>>;
};

export type WorkupActionItems = GeneratedOutput & {
  __typename?: 'WorkupActionItems';
  altGuidelines?: Maybe<Array<Maybe<RagGuideline>>>;
  citations?: Maybe<Array<Maybe<RagCitation>>>;
  error?: Maybe<Scalars['Boolean']['output']>;
  errorText?: Maybe<Scalars['String']['output']>;
  etag?: Maybe<Scalars['String']['output']>;
  generating?: Maybe<Scalars['Boolean']['output']>;
  guidelines?: Maybe<Array<Maybe<RagGuideline>>>;
  items?: Maybe<Array<Maybe<WorkupItem>>>;
};

export type WorkupItem = {
  __typename?: 'WorkupItem';
  category?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
};

export type FindingMetricsFragment_DiseaseFindingMetrics_finding_RCohort_qfs_QualifiedFeature_feature_Feature_organSystem_Feature = (
  { __typename?: 'Feature' }
  & Pick<Feature, 'id' | 'name' | 'shortname'>
);

export type FindingMetricsFragment_DiseaseFindingMetrics_finding_RCohort_qfs_QualifiedFeature_feature_Feature_category_Feature = (
  { __typename?: 'Feature' }
  & Pick<Feature, 'id' | 'name' | 'shortname'>
);

export type FindingMetricsFragment_DiseaseFindingMetrics_finding_RCohort_qfs_QualifiedFeature_feature_Feature_qualifierSpec_QualifierSpec_relation_Relation = (
  { __typename?: 'Relation' }
  & Pick<Relation, 'name' | 'id' | 'type'>
);

export type FindingMetricsFragment_DiseaseFindingMetrics_finding_RCohort_qfs_QualifiedFeature_feature_Feature_qualifierSpec_QualifierSpec = (
  { __typename?: 'QualifierSpec' }
  & Pick<QualifierSpec, 'mandatory'>
  & { relation: FindingMetricsFragment_DiseaseFindingMetrics_finding_RCohort_qfs_QualifiedFeature_feature_Feature_qualifierSpec_QualifierSpec_relation_Relation }
);

export type FindingMetricsFragment_DiseaseFindingMetrics_finding_RCohort_qfs_QualifiedFeature_feature_Feature_description_Description = (
  { __typename?: 'Description' }
  & Pick<Description, 'url' | 'text'>
);

export type FindingMetricsFragment_DiseaseFindingMetrics_finding_RCohort_qfs_QualifiedFeature_feature_Feature_range_MeasurementRange_complexUnits_ComplexUnits = (
  { __typename?: 'ComplexUnits' }
  & Pick<ComplexUnits, 'denominator' | 'numerator'>
);

export type FindingMetricsFragment_DiseaseFindingMetrics_finding_RCohort_qfs_QualifiedFeature_feature_Feature_range_MeasurementRange = (
  { __typename?: 'MeasurementRange' }
  & Pick<MeasurementRange, 'low' | 'high' | 'units'>
  & { complexUnits?: Maybe<FindingMetricsFragment_DiseaseFindingMetrics_finding_RCohort_qfs_QualifiedFeature_feature_Feature_range_MeasurementRange_complexUnits_ComplexUnits> }
);

export type FindingMetricsFragment_DiseaseFindingMetrics_finding_RCohort_qfs_QualifiedFeature_feature_Feature_inferredParents_Feature = (
  { __typename?: 'Feature' }
  & Pick<Feature, 'id' | 'name'>
);

export type FindingMetricsFragment_DiseaseFindingMetrics_finding_RCohort_qfs_QualifiedFeature_feature_Feature_inferredChildren_Feature = (
  { __typename?: 'Feature' }
  & Pick<Feature, 'id' | 'name'>
);

export type FindingMetricsFragment_DiseaseFindingMetrics_finding_RCohort_qfs_QualifiedFeature_feature_Feature_qualifiers_Qualifier_relation_Relation = (
  { __typename?: 'Relation' }
  & Pick<Relation, 'name' | 'id' | 'type' | 'multi' | 'essence'>
);

export type FindingMetricsFragment_DiseaseFindingMetrics_finding_RCohort_qfs_QualifiedFeature_feature_Feature_qualifiers_Qualifier_value_Feature_category_Feature = (
  { __typename?: 'Feature' }
  & Pick<Feature, 'id' | 'name' | 'shortname'>
);

export type FindingMetricsFragment_DiseaseFindingMetrics_finding_RCohort_qfs_QualifiedFeature_feature_Feature_qualifiers_Qualifier_value_Feature_description_Description = (
  { __typename?: 'Description' }
  & Pick<Description, 'text'>
);

export type FindingMetricsFragment_DiseaseFindingMetrics_finding_RCohort_qfs_QualifiedFeature_feature_Feature_qualifiers_Qualifier_value_Feature_range_MeasurementRange = (
  { __typename?: 'MeasurementRange' }
  & Pick<MeasurementRange, 'low' | 'high' | 'units'>
  & { complexUnits?: Maybe<FindingMetricsFragment_DiseaseFindingMetrics_finding_RCohort_qfs_QualifiedFeature_feature_Feature_range_MeasurementRange_complexUnits_ComplexUnits> }
);

export type FindingMetricsFragment_DiseaseFindingMetrics_finding_RCohort_qfs_QualifiedFeature_feature_Feature_qualifiers_Qualifier_value_Feature_parents_FeatureSet_features_Feature = (
  { __typename?: 'Feature' }
  & Pick<Feature, 'id' | 'name' | 'childrenSetType'>
);

export type FindingMetricsFragment_DiseaseFindingMetrics_finding_RCohort_qfs_QualifiedFeature_feature_Feature_qualifiers_Qualifier_value_Feature_parents_FeatureSet = (
  { __typename?: 'FeatureSet' }
  & { features?: Maybe<Array<Maybe<FindingMetricsFragment_DiseaseFindingMetrics_finding_RCohort_qfs_QualifiedFeature_feature_Feature_qualifiers_Qualifier_value_Feature_parents_FeatureSet_features_Feature>>> }
);

export type FindingMetricsFragment_DiseaseFindingMetrics_finding_RCohort_qfs_QualifiedFeature_feature_Feature_qualifiers_Qualifier_value_Feature = (
  { __typename?: 'Feature' }
  & Pick<Feature, 'name' | 'shortname' | 'id' | 'patientDescription'>
  & { category?: Maybe<FindingMetricsFragment_DiseaseFindingMetrics_finding_RCohort_qfs_QualifiedFeature_feature_Feature_qualifiers_Qualifier_value_Feature_category_Feature>, description?: Maybe<FindingMetricsFragment_DiseaseFindingMetrics_finding_RCohort_qfs_QualifiedFeature_feature_Feature_qualifiers_Qualifier_value_Feature_description_Description>, range?: Maybe<FindingMetricsFragment_DiseaseFindingMetrics_finding_RCohort_qfs_QualifiedFeature_feature_Feature_qualifiers_Qualifier_value_Feature_range_MeasurementRange>, parents?: Maybe<FindingMetricsFragment_DiseaseFindingMetrics_finding_RCohort_qfs_QualifiedFeature_feature_Feature_qualifiers_Qualifier_value_Feature_parents_FeatureSet> }
);

export type FindingMetricsFragment_DiseaseFindingMetrics_finding_RCohort_qfs_QualifiedFeature_feature_Feature_qualifiers_Qualifier_range_MeasurementRange = (
  { __typename?: 'MeasurementRange' }
  & Pick<MeasurementRange, 'low' | 'high' | 'units'>
  & { complexUnits?: Maybe<FindingMetricsFragment_DiseaseFindingMetrics_finding_RCohort_qfs_QualifiedFeature_feature_Feature_range_MeasurementRange_complexUnits_ComplexUnits> }
);

export type FindingMetricsFragment_DiseaseFindingMetrics_finding_RCohort_qfs_QualifiedFeature_feature_Feature_qualifiers_Qualifier = (
  { __typename?: 'Qualifier' }
  & Pick<Qualifier, 'name' | 'negate' | 'freeText' | 'source'>
  & { relation: FindingMetricsFragment_DiseaseFindingMetrics_finding_RCohort_qfs_QualifiedFeature_feature_Feature_qualifiers_Qualifier_relation_Relation, value?: Maybe<FindingMetricsFragment_DiseaseFindingMetrics_finding_RCohort_qfs_QualifiedFeature_feature_Feature_qualifiers_Qualifier_value_Feature>, range?: Maybe<FindingMetricsFragment_DiseaseFindingMetrics_finding_RCohort_qfs_QualifiedFeature_feature_Feature_qualifiers_Qualifier_range_MeasurementRange> }
);

export type FindingMetricsFragment_DiseaseFindingMetrics_finding_RCohort_qfs_QualifiedFeature_feature_Feature_inferredQualifiers_Qualifier = (
  { __typename?: 'Qualifier' }
  & Pick<Qualifier, 'name' | 'negate' | 'freeText' | 'source'>
  & { relation: FindingMetricsFragment_DiseaseFindingMetrics_finding_RCohort_qfs_QualifiedFeature_feature_Feature_qualifiers_Qualifier_relation_Relation, value?: Maybe<FindingMetricsFragment_DiseaseFindingMetrics_finding_RCohort_qfs_QualifiedFeature_feature_Feature_qualifiers_Qualifier_value_Feature>, range?: Maybe<FindingMetricsFragment_DiseaseFindingMetrics_finding_RCohort_qfs_QualifiedFeature_feature_Feature_qualifiers_Qualifier_range_MeasurementRange> }
);

export type FindingMetricsFragment_DiseaseFindingMetrics_finding_RCohort_qfs_QualifiedFeature_feature_Feature = (
  { __typename?: 'Feature' }
  & Pick<Feature, 'name' | 'id' | 'shortname' | 'patientDescription' | 'alias' | 'skipDuration' | 'hasRefinement'>
  & { organSystem?: Maybe<FindingMetricsFragment_DiseaseFindingMetrics_finding_RCohort_qfs_QualifiedFeature_feature_Feature_organSystem_Feature>, category?: Maybe<FindingMetricsFragment_DiseaseFindingMetrics_finding_RCohort_qfs_QualifiedFeature_feature_Feature_category_Feature>, qualifierSpec?: Maybe<Array<Maybe<FindingMetricsFragment_DiseaseFindingMetrics_finding_RCohort_qfs_QualifiedFeature_feature_Feature_qualifierSpec_QualifierSpec>>>, description?: Maybe<FindingMetricsFragment_DiseaseFindingMetrics_finding_RCohort_qfs_QualifiedFeature_feature_Feature_description_Description>, range?: Maybe<FindingMetricsFragment_DiseaseFindingMetrics_finding_RCohort_qfs_QualifiedFeature_feature_Feature_range_MeasurementRange>, inferredParents?: Maybe<Array<Maybe<FindingMetricsFragment_DiseaseFindingMetrics_finding_RCohort_qfs_QualifiedFeature_feature_Feature_inferredParents_Feature>>>, inferredChildren?: Maybe<Array<Maybe<FindingMetricsFragment_DiseaseFindingMetrics_finding_RCohort_qfs_QualifiedFeature_feature_Feature_inferredChildren_Feature>>>, qualifiers?: Maybe<Array<Maybe<FindingMetricsFragment_DiseaseFindingMetrics_finding_RCohort_qfs_QualifiedFeature_feature_Feature_qualifiers_Qualifier>>>, inferredQualifiers?: Maybe<Array<Maybe<FindingMetricsFragment_DiseaseFindingMetrics_finding_RCohort_qfs_QualifiedFeature_feature_Feature_inferredQualifiers_Qualifier>>> }
);

export type FindingMetricsFragment_DiseaseFindingMetrics_finding_RCohort_qfs_QualifiedFeature_qualifiers_Qualifier = (
  { __typename?: 'Qualifier' }
  & Pick<Qualifier, 'name' | 'negate' | 'freeText' | 'source'>
  & { relation: FindingMetricsFragment_DiseaseFindingMetrics_finding_RCohort_qfs_QualifiedFeature_feature_Feature_qualifiers_Qualifier_relation_Relation, value?: Maybe<FindingMetricsFragment_DiseaseFindingMetrics_finding_RCohort_qfs_QualifiedFeature_feature_Feature_qualifiers_Qualifier_value_Feature>, range?: Maybe<FindingMetricsFragment_DiseaseFindingMetrics_finding_RCohort_qfs_QualifiedFeature_feature_Feature_qualifiers_Qualifier_range_MeasurementRange> }
);

export type FindingMetricsFragment_DiseaseFindingMetrics_finding_RCohort_qfs_QualifiedFeature_mandatory_Qualifier_relation_Relation = (
  { __typename?: 'Relation' }
  & Pick<Relation, 'name' | 'id' | 'type'>
);

export type FindingMetricsFragment_DiseaseFindingMetrics_finding_RCohort_qfs_QualifiedFeature_mandatory_Qualifier_value_Feature = (
  { __typename?: 'Feature' }
  & Pick<Feature, 'name' | 'id'>
);

export type FindingMetricsFragment_DiseaseFindingMetrics_finding_RCohort_qfs_QualifiedFeature_mandatory_Qualifier_range_MeasurementRange = (
  { __typename?: 'MeasurementRange' }
  & Pick<MeasurementRange, 'low' | 'high' | 'units'>
  & { complexUnits?: Maybe<FindingMetricsFragment_DiseaseFindingMetrics_finding_RCohort_qfs_QualifiedFeature_feature_Feature_range_MeasurementRange_complexUnits_ComplexUnits> }
);

export type FindingMetricsFragment_DiseaseFindingMetrics_finding_RCohort_qfs_QualifiedFeature_mandatory_Qualifier = (
  { __typename?: 'Qualifier' }
  & Pick<Qualifier, 'freeText'>
  & { relation: FindingMetricsFragment_DiseaseFindingMetrics_finding_RCohort_qfs_QualifiedFeature_mandatory_Qualifier_relation_Relation, value?: Maybe<FindingMetricsFragment_DiseaseFindingMetrics_finding_RCohort_qfs_QualifiedFeature_mandatory_Qualifier_value_Feature>, range?: Maybe<FindingMetricsFragment_DiseaseFindingMetrics_finding_RCohort_qfs_QualifiedFeature_mandatory_Qualifier_range_MeasurementRange> }
);

export type FindingMetricsFragment_DiseaseFindingMetrics_finding_RCohort_qfs_QualifiedFeature = (
  { __typename?: 'QualifiedFeature' }
  & Pick<QualifiedFeature, 'id' | 'name' | 'negate' | 'skip'>
  & { feature?: Maybe<FindingMetricsFragment_DiseaseFindingMetrics_finding_RCohort_qfs_QualifiedFeature_feature_Feature>, qualifiers?: Maybe<Array<Maybe<FindingMetricsFragment_DiseaseFindingMetrics_finding_RCohort_qfs_QualifiedFeature_qualifiers_Qualifier>>>, mandatory?: Maybe<FindingMetricsFragment_DiseaseFindingMetrics_finding_RCohort_qfs_QualifiedFeature_mandatory_Qualifier> }
);

export type FindingMetricsFragment_DiseaseFindingMetrics_finding_RCohort = (
  { __typename?: 'RCohort' }
  & Pick<RCohort, 'id'>
  & { qfs?: Maybe<Array<Maybe<FindingMetricsFragment_DiseaseFindingMetrics_finding_RCohort_qfs_QualifiedFeature>>> }
);

export type FindingMetricsFragment_DiseaseFindingMetrics_subcohort_RCohort_qfs_QualifiedFeature = (
  { __typename?: 'QualifiedFeature' }
  & Pick<QualifiedFeature, 'id' | 'name' | 'negate' | 'skip'>
  & { feature?: Maybe<FindingMetricsFragment_DiseaseFindingMetrics_finding_RCohort_qfs_QualifiedFeature_feature_Feature>, qualifiers?: Maybe<Array<Maybe<FindingMetricsFragment_DiseaseFindingMetrics_finding_RCohort_qfs_QualifiedFeature_qualifiers_Qualifier>>>, mandatory?: Maybe<FindingMetricsFragment_DiseaseFindingMetrics_finding_RCohort_qfs_QualifiedFeature_mandatory_Qualifier> }
);

export type FindingMetricsFragment_DiseaseFindingMetrics_subcohort_RCohort = (
  { __typename?: 'RCohort' }
  & Pick<RCohort, 'id'>
  & { qfs?: Maybe<Array<Maybe<FindingMetricsFragment_DiseaseFindingMetrics_subcohort_RCohort_qfs_QualifiedFeature>>> }
);

export type FindingMetricsFragment_DiseaseFindingMetrics_metrics_RPairMetrics_sensitivity_RMetric = (
  { __typename?: 'RMetric' }
  & Pick<RMetric, 'value' | 'exactness'>
);

export type FindingMetricsFragment_DiseaseFindingMetrics_metrics_RPairMetrics_specificity_RMetric = (
  { __typename?: 'RMetric' }
  & Pick<RMetric, 'value' | 'exactness'>
);

export type FindingMetricsFragment_DiseaseFindingMetrics_metrics_RPairMetrics_ppv_RMetric = (
  { __typename?: 'RMetric' }
  & Pick<RMetric, 'value' | 'exactness'>
);

export type FindingMetricsFragment_DiseaseFindingMetrics_metrics_RPairMetrics_rrisk_cause_RMetric = (
  { __typename?: 'RMetric' }
  & Pick<RMetric, 'value' | 'exactness'>
);

export type FindingMetricsFragment_DiseaseFindingMetrics_metrics_RPairMetrics_rrisk_effect_RMetric = (
  { __typename?: 'RMetric' }
  & Pick<RMetric, 'value' | 'exactness'>
);

export type FindingMetricsFragment_DiseaseFindingMetrics_metrics_RPairMetrics_incidence_RMetric = (
  { __typename?: 'RMetric' }
  & Pick<RMetric, 'value' | 'exactness'>
);

export type FindingMetricsFragment_DiseaseFindingMetrics_metrics_RPairMetrics_NLR_RMetric = (
  { __typename?: 'RMetric' }
  & Pick<RMetric, 'value' | 'exactness'>
);

export type FindingMetricsFragment_DiseaseFindingMetrics_metrics_RPairMetrics_PLR_RMetric = (
  { __typename?: 'RMetric' }
  & Pick<RMetric, 'value' | 'exactness'>
);

export type FindingMetricsFragment_DiseaseFindingMetrics_metrics_RPairMetrics = (
  { __typename?: 'RPairMetrics' }
  & { sensitivity?: Maybe<FindingMetricsFragment_DiseaseFindingMetrics_metrics_RPairMetrics_sensitivity_RMetric>, specificity?: Maybe<FindingMetricsFragment_DiseaseFindingMetrics_metrics_RPairMetrics_specificity_RMetric>, ppv?: Maybe<FindingMetricsFragment_DiseaseFindingMetrics_metrics_RPairMetrics_ppv_RMetric>, rrisk_cause?: Maybe<FindingMetricsFragment_DiseaseFindingMetrics_metrics_RPairMetrics_rrisk_cause_RMetric>, rrisk_effect?: Maybe<FindingMetricsFragment_DiseaseFindingMetrics_metrics_RPairMetrics_rrisk_effect_RMetric>, incidence?: Maybe<FindingMetricsFragment_DiseaseFindingMetrics_metrics_RPairMetrics_incidence_RMetric>, NLR?: Maybe<FindingMetricsFragment_DiseaseFindingMetrics_metrics_RPairMetrics_NLR_RMetric>, PLR?: Maybe<FindingMetricsFragment_DiseaseFindingMetrics_metrics_RPairMetrics_PLR_RMetric> }
);

export type FindingMetricsFragment = (
  { __typename?: 'DiseaseFindingMetrics' }
  & Pick<DiseaseFindingMetrics, 'id' | 'direction' | 'category' | 'presentingSymptom'>
  & { finding?: Maybe<FindingMetricsFragment_DiseaseFindingMetrics_finding_RCohort>, subcohort?: Maybe<FindingMetricsFragment_DiseaseFindingMetrics_subcohort_RCohort>, metrics?: Maybe<FindingMetricsFragment_DiseaseFindingMetrics_metrics_RPairMetrics> }
);

export type DiseaseAgeDistributionFragment_RAgeDistribution_ranges_RAgeDistributionRange = (
  { __typename?: 'RAgeDistributionRange' }
  & Pick<RAgeDistributionRange, 'from' | 'to' | 'value'>
);

export type DiseaseAgeDistributionFragment = (
  { __typename?: 'RAgeDistribution' }
  & { ranges?: Maybe<Array<Maybe<DiseaseAgeDistributionFragment_RAgeDistribution_ranges_RAgeDistributionRange>>> }
);

export type UnaryMetricsFragment_RUnaryMetrics_duration_MeasurementRange = (
  { __typename?: 'MeasurementRange' }
  & Pick<MeasurementRange, 'low' | 'high' | 'units'>
);

export type UnaryMetricsFragment = (
  { __typename?: 'RUnaryMetrics' }
  & Pick<RUnaryMetrics, 'incidence' | 'prevalence' | 'prevalenceDescription' | 'urgency'>
  & { duration?: Maybe<UnaryMetricsFragment_RUnaryMetrics_duration_MeasurementRange> }
);

export type DiseaseReferenceDataFragment_DiseaseReference_disease_QualifiedFeature = (
  { __typename?: 'QualifiedFeature' }
  & Pick<QualifiedFeature, 'id' | 'name' | 'negate' | 'skip'>
  & { feature?: Maybe<FindingMetricsFragment_DiseaseFindingMetrics_finding_RCohort_qfs_QualifiedFeature_feature_Feature>, qualifiers?: Maybe<Array<Maybe<FindingMetricsFragment_DiseaseFindingMetrics_finding_RCohort_qfs_QualifiedFeature_qualifiers_Qualifier>>>, mandatory?: Maybe<FindingMetricsFragment_DiseaseFindingMetrics_finding_RCohort_qfs_QualifiedFeature_mandatory_Qualifier> }
);

export type DiseaseReferenceDataFragment_DiseaseReference_findings_DiseaseFindingMetrics = (
  { __typename?: 'DiseaseFindingMetrics' }
  & Pick<DiseaseFindingMetrics, 'id' | 'direction' | 'category' | 'presentingSymptom'>
  & { finding?: Maybe<FindingMetricsFragment_DiseaseFindingMetrics_finding_RCohort>, subcohort?: Maybe<FindingMetricsFragment_DiseaseFindingMetrics_subcohort_RCohort>, metrics?: Maybe<FindingMetricsFragment_DiseaseFindingMetrics_metrics_RPairMetrics> }
);

export type DiseaseReferenceDataFragment_DiseaseReference_citations_Citations_citationsData_CitationData = (
  { __typename?: 'CitationData' }
  & Pick<CitationData, 'id' | 'kahunId' | 'vancouver' | 'url' | 'title' | 'containerTitle' | 'DOI'>
);

export type DiseaseReferenceDataFragment_DiseaseReference_citations_Citations = (
  { __typename?: 'Citations' }
  & Pick<Citations, 'totalCount'>
  & { citationsData?: Maybe<Array<Maybe<DiseaseReferenceDataFragment_DiseaseReference_citations_Citations_citationsData_CitationData>>> }
);

export type DiseaseReferenceDataFragment_DiseaseReference_citationsDVData_CitationDiseaseData_findings_RCohort_qfs_QualifiedFeature = (
  { __typename?: 'QualifiedFeature' }
  & Pick<QualifiedFeature, 'id' | 'name' | 'negate' | 'skip'>
  & { feature?: Maybe<FindingMetricsFragment_DiseaseFindingMetrics_finding_RCohort_qfs_QualifiedFeature_feature_Feature>, qualifiers?: Maybe<Array<Maybe<FindingMetricsFragment_DiseaseFindingMetrics_finding_RCohort_qfs_QualifiedFeature_qualifiers_Qualifier>>>, mandatory?: Maybe<FindingMetricsFragment_DiseaseFindingMetrics_finding_RCohort_qfs_QualifiedFeature_mandatory_Qualifier> }
);

export type DiseaseReferenceDataFragment_DiseaseReference_citationsDVData_CitationDiseaseData_findings_RCohort = (
  { __typename?: 'RCohort' }
  & Pick<RCohort, 'id'>
  & { qfs?: Maybe<Array<Maybe<DiseaseReferenceDataFragment_DiseaseReference_citationsDVData_CitationDiseaseData_findings_RCohort_qfs_QualifiedFeature>>> }
);

export type DiseaseReferenceDataFragment_DiseaseReference_citationsDVData_CitationDiseaseData_subtypes_RCohort_qfs_QualifiedFeature = (
  { __typename?: 'QualifiedFeature' }
  & Pick<QualifiedFeature, 'id' | 'name' | 'negate' | 'skip'>
  & { feature?: Maybe<FindingMetricsFragment_DiseaseFindingMetrics_finding_RCohort_qfs_QualifiedFeature_feature_Feature>, qualifiers?: Maybe<Array<Maybe<FindingMetricsFragment_DiseaseFindingMetrics_finding_RCohort_qfs_QualifiedFeature_qualifiers_Qualifier>>>, mandatory?: Maybe<FindingMetricsFragment_DiseaseFindingMetrics_finding_RCohort_qfs_QualifiedFeature_mandatory_Qualifier> }
);

export type DiseaseReferenceDataFragment_DiseaseReference_citationsDVData_CitationDiseaseData_subtypes_RCohort = (
  { __typename?: 'RCohort' }
  & Pick<RCohort, 'id'>
  & { qfs?: Maybe<Array<Maybe<DiseaseReferenceDataFragment_DiseaseReference_citationsDVData_CitationDiseaseData_subtypes_RCohort_qfs_QualifiedFeature>>> }
);

export type DiseaseReferenceDataFragment_DiseaseReference_citationsDVData_CitationDiseaseData = (
  { __typename?: 'CitationDiseaseData' }
  & Pick<CitationDiseaseData, 'citationId' | 'count' | 'type'>
  & { findings?: Maybe<Array<Maybe<DiseaseReferenceDataFragment_DiseaseReference_citationsDVData_CitationDiseaseData_findings_RCohort>>>, subtypes?: Maybe<Array<Maybe<DiseaseReferenceDataFragment_DiseaseReference_citationsDVData_CitationDiseaseData_subtypes_RCohort>>> }
);

export type DiseaseReferenceDataFragment_DiseaseReference_metrics_RUnaryMetrics = (
  { __typename?: 'RUnaryMetrics' }
  & Pick<RUnaryMetrics, 'incidence' | 'prevalence' | 'prevalenceDescription' | 'urgency'>
  & { duration?: Maybe<UnaryMetricsFragment_RUnaryMetrics_duration_MeasurementRange> }
);

export type DiseaseReferenceDataFragment = (
  { __typename?: 'DiseaseReference' }
  & Pick<DiseaseReference, 'id'>
  & { disease?: Maybe<Array<Maybe<DiseaseReferenceDataFragment_DiseaseReference_disease_QualifiedFeature>>>, findings?: Maybe<Array<Maybe<DiseaseReferenceDataFragment_DiseaseReference_findings_DiseaseFindingMetrics>>>, citations?: Maybe<DiseaseReferenceDataFragment_DiseaseReference_citations_Citations>, citationsDVData?: Maybe<Array<Maybe<DiseaseReferenceDataFragment_DiseaseReference_citationsDVData_CitationDiseaseData>>>, metrics?: Maybe<DiseaseReferenceDataFragment_DiseaseReference_metrics_RUnaryMetrics> }
);

export type DiseaseReferenceOverviewDataFragment_DiseaseReference_disease_QualifiedFeature_feature_Feature_parents_FeatureSet_features_Feature = (
  { __typename?: 'Feature' }
  & Pick<Feature, 'id'>
);

export type DiseaseReferenceOverviewDataFragment_DiseaseReference_disease_QualifiedFeature_feature_Feature_parents_FeatureSet = (
  { __typename?: 'FeatureSet' }
  & { features?: Maybe<Array<Maybe<DiseaseReferenceOverviewDataFragment_DiseaseReference_disease_QualifiedFeature_feature_Feature_parents_FeatureSet_features_Feature>>> }
);

export type DiseaseReferenceOverviewDataFragment_DiseaseReference_disease_QualifiedFeature_feature_Feature_children_FeatureSet_features_Feature = (
  { __typename?: 'Feature' }
  & Pick<Feature, 'id'>
);

export type DiseaseReferenceOverviewDataFragment_DiseaseReference_disease_QualifiedFeature_feature_Feature_children_FeatureSet = (
  { __typename?: 'FeatureSet' }
  & { features?: Maybe<Array<Maybe<DiseaseReferenceOverviewDataFragment_DiseaseReference_disease_QualifiedFeature_feature_Feature_children_FeatureSet_features_Feature>>> }
);

export type DiseaseReferenceOverviewDataFragment_DiseaseReference_disease_QualifiedFeature_feature_Feature_subGroups_GroupRelation_feature_Feature = (
  { __typename?: 'Feature' }
  & Pick<Feature, 'name' | 'id' | 'shortname' | 'patientDescription' | 'alias' | 'skipDuration' | 'hasRefinement'>
  & { organSystem?: Maybe<FindingMetricsFragment_DiseaseFindingMetrics_finding_RCohort_qfs_QualifiedFeature_feature_Feature_organSystem_Feature>, category?: Maybe<FindingMetricsFragment_DiseaseFindingMetrics_finding_RCohort_qfs_QualifiedFeature_feature_Feature_category_Feature>, qualifierSpec?: Maybe<Array<Maybe<FindingMetricsFragment_DiseaseFindingMetrics_finding_RCohort_qfs_QualifiedFeature_feature_Feature_qualifierSpec_QualifierSpec>>>, description?: Maybe<FindingMetricsFragment_DiseaseFindingMetrics_finding_RCohort_qfs_QualifiedFeature_feature_Feature_description_Description>, range?: Maybe<FindingMetricsFragment_DiseaseFindingMetrics_finding_RCohort_qfs_QualifiedFeature_feature_Feature_range_MeasurementRange>, inferredParents?: Maybe<Array<Maybe<FindingMetricsFragment_DiseaseFindingMetrics_finding_RCohort_qfs_QualifiedFeature_feature_Feature_inferredParents_Feature>>>, inferredChildren?: Maybe<Array<Maybe<FindingMetricsFragment_DiseaseFindingMetrics_finding_RCohort_qfs_QualifiedFeature_feature_Feature_inferredChildren_Feature>>>, qualifiers?: Maybe<Array<Maybe<FindingMetricsFragment_DiseaseFindingMetrics_finding_RCohort_qfs_QualifiedFeature_feature_Feature_qualifiers_Qualifier>>>, inferredQualifiers?: Maybe<Array<Maybe<FindingMetricsFragment_DiseaseFindingMetrics_finding_RCohort_qfs_QualifiedFeature_feature_Feature_inferredQualifiers_Qualifier>>> }
);

export type DiseaseReferenceOverviewDataFragment_DiseaseReference_disease_QualifiedFeature_feature_Feature_subGroups_GroupRelation = (
  { __typename?: 'GroupRelation' }
  & Pick<GroupRelation, 'type'>
  & { feature?: Maybe<DiseaseReferenceOverviewDataFragment_DiseaseReference_disease_QualifiedFeature_feature_Feature_subGroups_GroupRelation_feature_Feature> }
);

export type DiseaseReferenceOverviewDataFragment_DiseaseReference_disease_QualifiedFeature_feature_Feature_superGroups_GroupRelation_feature_Feature = (
  { __typename?: 'Feature' }
  & Pick<Feature, 'name' | 'id' | 'shortname' | 'patientDescription' | 'alias' | 'skipDuration' | 'hasRefinement'>
  & { organSystem?: Maybe<FindingMetricsFragment_DiseaseFindingMetrics_finding_RCohort_qfs_QualifiedFeature_feature_Feature_organSystem_Feature>, category?: Maybe<FindingMetricsFragment_DiseaseFindingMetrics_finding_RCohort_qfs_QualifiedFeature_feature_Feature_category_Feature>, qualifierSpec?: Maybe<Array<Maybe<FindingMetricsFragment_DiseaseFindingMetrics_finding_RCohort_qfs_QualifiedFeature_feature_Feature_qualifierSpec_QualifierSpec>>>, description?: Maybe<FindingMetricsFragment_DiseaseFindingMetrics_finding_RCohort_qfs_QualifiedFeature_feature_Feature_description_Description>, range?: Maybe<FindingMetricsFragment_DiseaseFindingMetrics_finding_RCohort_qfs_QualifiedFeature_feature_Feature_range_MeasurementRange>, inferredParents?: Maybe<Array<Maybe<FindingMetricsFragment_DiseaseFindingMetrics_finding_RCohort_qfs_QualifiedFeature_feature_Feature_inferredParents_Feature>>>, inferredChildren?: Maybe<Array<Maybe<FindingMetricsFragment_DiseaseFindingMetrics_finding_RCohort_qfs_QualifiedFeature_feature_Feature_inferredChildren_Feature>>>, qualifiers?: Maybe<Array<Maybe<FindingMetricsFragment_DiseaseFindingMetrics_finding_RCohort_qfs_QualifiedFeature_feature_Feature_qualifiers_Qualifier>>>, inferredQualifiers?: Maybe<Array<Maybe<FindingMetricsFragment_DiseaseFindingMetrics_finding_RCohort_qfs_QualifiedFeature_feature_Feature_inferredQualifiers_Qualifier>>> }
);

export type DiseaseReferenceOverviewDataFragment_DiseaseReference_disease_QualifiedFeature_feature_Feature_superGroups_GroupRelation = (
  { __typename?: 'GroupRelation' }
  & Pick<GroupRelation, 'type'>
  & { feature?: Maybe<DiseaseReferenceOverviewDataFragment_DiseaseReference_disease_QualifiedFeature_feature_Feature_superGroups_GroupRelation_feature_Feature> }
);

export type DiseaseReferenceOverviewDataFragment_DiseaseReference_disease_QualifiedFeature_feature_Feature = (
  { __typename?: 'Feature' }
  & Pick<Feature, 'name' | 'id' | 'shortname' | 'patientDescription' | 'alias' | 'skipDuration' | 'hasRefinement'>
  & { parents?: Maybe<DiseaseReferenceOverviewDataFragment_DiseaseReference_disease_QualifiedFeature_feature_Feature_parents_FeatureSet>, children?: Maybe<DiseaseReferenceOverviewDataFragment_DiseaseReference_disease_QualifiedFeature_feature_Feature_children_FeatureSet>, subGroups?: Maybe<Array<Maybe<DiseaseReferenceOverviewDataFragment_DiseaseReference_disease_QualifiedFeature_feature_Feature_subGroups_GroupRelation>>>, superGroups?: Maybe<Array<Maybe<DiseaseReferenceOverviewDataFragment_DiseaseReference_disease_QualifiedFeature_feature_Feature_superGroups_GroupRelation>>>, organSystem?: Maybe<FindingMetricsFragment_DiseaseFindingMetrics_finding_RCohort_qfs_QualifiedFeature_feature_Feature_organSystem_Feature>, category?: Maybe<FindingMetricsFragment_DiseaseFindingMetrics_finding_RCohort_qfs_QualifiedFeature_feature_Feature_category_Feature>, qualifierSpec?: Maybe<Array<Maybe<FindingMetricsFragment_DiseaseFindingMetrics_finding_RCohort_qfs_QualifiedFeature_feature_Feature_qualifierSpec_QualifierSpec>>>, description?: Maybe<FindingMetricsFragment_DiseaseFindingMetrics_finding_RCohort_qfs_QualifiedFeature_feature_Feature_description_Description>, range?: Maybe<FindingMetricsFragment_DiseaseFindingMetrics_finding_RCohort_qfs_QualifiedFeature_feature_Feature_range_MeasurementRange>, inferredParents?: Maybe<Array<Maybe<FindingMetricsFragment_DiseaseFindingMetrics_finding_RCohort_qfs_QualifiedFeature_feature_Feature_inferredParents_Feature>>>, inferredChildren?: Maybe<Array<Maybe<FindingMetricsFragment_DiseaseFindingMetrics_finding_RCohort_qfs_QualifiedFeature_feature_Feature_inferredChildren_Feature>>>, qualifiers?: Maybe<Array<Maybe<FindingMetricsFragment_DiseaseFindingMetrics_finding_RCohort_qfs_QualifiedFeature_feature_Feature_qualifiers_Qualifier>>>, inferredQualifiers?: Maybe<Array<Maybe<FindingMetricsFragment_DiseaseFindingMetrics_finding_RCohort_qfs_QualifiedFeature_feature_Feature_inferredQualifiers_Qualifier>>> }
);

export type DiseaseReferenceOverviewDataFragment_DiseaseReference_disease_QualifiedFeature = (
  { __typename?: 'QualifiedFeature' }
  & Pick<QualifiedFeature, 'id' | 'name' | 'negate' | 'skip'>
  & { feature?: Maybe<DiseaseReferenceOverviewDataFragment_DiseaseReference_disease_QualifiedFeature_feature_Feature>, qualifiers?: Maybe<Array<Maybe<FindingMetricsFragment_DiseaseFindingMetrics_finding_RCohort_qfs_QualifiedFeature_qualifiers_Qualifier>>>, mandatory?: Maybe<FindingMetricsFragment_DiseaseFindingMetrics_finding_RCohort_qfs_QualifiedFeature_mandatory_Qualifier> }
);

export type DiseaseReferenceOverviewDataFragment_DiseaseReference_metrics_RUnaryMetrics = (
  { __typename?: 'RUnaryMetrics' }
  & Pick<RUnaryMetrics, 'incidence' | 'prevalence' | 'prevalenceDescription' | 'urgency'>
  & { duration?: Maybe<UnaryMetricsFragment_RUnaryMetrics_duration_MeasurementRange> }
);

export type DiseaseReferenceOverviewDataFragment_DiseaseReference_ageDistribution_RAgeDistribution = (
  { __typename?: 'RAgeDistribution' }
  & { ranges?: Maybe<Array<Maybe<DiseaseAgeDistributionFragment_RAgeDistribution_ranges_RAgeDistributionRange>>> }
);

export type DiseaseReferenceOverviewDataFragment = (
  { __typename?: 'DiseaseReference' }
  & Pick<DiseaseReference, 'id'>
  & { disease?: Maybe<Array<Maybe<DiseaseReferenceOverviewDataFragment_DiseaseReference_disease_QualifiedFeature>>>, metrics?: Maybe<DiseaseReferenceOverviewDataFragment_DiseaseReference_metrics_RUnaryMetrics>, ageDistribution?: Maybe<DiseaseReferenceOverviewDataFragment_DiseaseReference_ageDistribution_RAgeDistribution> }
);

export type DrByFeatureQuery_reference_ReferenceQueries_disease_DiseaseReference_citationsDVData_CitationDiseaseData_findings_RCohort_qfs_QualifiedFeature_feature_Feature_organSystem_Feature = (
  { __typename?: 'Feature' }
  & Pick<Feature, 'id' | 'name' | 'shortname'>
);

export type DrByFeatureQuery_reference_ReferenceQueries_disease_DiseaseReference_citationsDVData_CitationDiseaseData_findings_RCohort_qfs_QualifiedFeature_feature_Feature_qualifierSpec_QualifierSpec_relation_Relation = (
  { __typename?: 'Relation' }
  & Pick<Relation, 'name' | 'id' | 'type'>
);

export type DrByFeatureQuery_reference_ReferenceQueries_disease_DiseaseReference_citationsDVData_CitationDiseaseData_findings_RCohort_qfs_QualifiedFeature_feature_Feature_qualifierSpec_QualifierSpec = (
  { __typename?: 'QualifierSpec' }
  & Pick<QualifierSpec, 'mandatory'>
  & { relation: DrByFeatureQuery_reference_ReferenceQueries_disease_DiseaseReference_citationsDVData_CitationDiseaseData_findings_RCohort_qfs_QualifiedFeature_feature_Feature_qualifierSpec_QualifierSpec_relation_Relation }
);

export type DrByFeatureQuery_reference_ReferenceQueries_disease_DiseaseReference_citationsDVData_CitationDiseaseData_findings_RCohort_qfs_QualifiedFeature_feature_Feature_description_Description = (
  { __typename?: 'Description' }
  & Pick<Description, 'url' | 'text'>
);

export type DrByFeatureQuery_reference_ReferenceQueries_disease_DiseaseReference_citationsDVData_CitationDiseaseData_findings_RCohort_qfs_QualifiedFeature_feature_Feature_range_MeasurementRange_complexUnits_ComplexUnits = (
  { __typename?: 'ComplexUnits' }
  & Pick<ComplexUnits, 'denominator' | 'numerator'>
);

export type DrByFeatureQuery_reference_ReferenceQueries_disease_DiseaseReference_citationsDVData_CitationDiseaseData_findings_RCohort_qfs_QualifiedFeature_feature_Feature_range_MeasurementRange = (
  { __typename?: 'MeasurementRange' }
  & Pick<MeasurementRange, 'low' | 'high' | 'units'>
  & { complexUnits?: Maybe<DrByFeatureQuery_reference_ReferenceQueries_disease_DiseaseReference_citationsDVData_CitationDiseaseData_findings_RCohort_qfs_QualifiedFeature_feature_Feature_range_MeasurementRange_complexUnits_ComplexUnits> }
);

export type DrByFeatureQuery_reference_ReferenceQueries_disease_DiseaseReference_citationsDVData_CitationDiseaseData_findings_RCohort_qfs_QualifiedFeature_feature_Feature_inferredParents_Feature = (
  { __typename?: 'Feature' }
  & Pick<Feature, 'id' | 'name'>
);

export type DrByFeatureQuery_reference_ReferenceQueries_disease_DiseaseReference_citationsDVData_CitationDiseaseData_findings_RCohort_qfs_QualifiedFeature_feature_Feature_qualifiers_Qualifier_relation_Relation = (
  { __typename?: 'Relation' }
  & Pick<Relation, 'name' | 'id' | 'type' | 'multi' | 'essence'>
);

export type DrByFeatureQuery_reference_ReferenceQueries_disease_DiseaseReference_citationsDVData_CitationDiseaseData_findings_RCohort_qfs_QualifiedFeature_feature_Feature_qualifiers_Qualifier_value_Feature_description_Description = (
  { __typename?: 'Description' }
  & Pick<Description, 'text'>
);

export type DrByFeatureQuery_reference_ReferenceQueries_disease_DiseaseReference_citationsDVData_CitationDiseaseData_findings_RCohort_qfs_QualifiedFeature_feature_Feature_qualifiers_Qualifier_value_Feature_parents_FeatureSet_features_Feature = (
  { __typename?: 'Feature' }
  & Pick<Feature, 'id' | 'name' | 'childrenSetType'>
);

export type DrByFeatureQuery_reference_ReferenceQueries_disease_DiseaseReference_citationsDVData_CitationDiseaseData_findings_RCohort_qfs_QualifiedFeature_feature_Feature_qualifiers_Qualifier_value_Feature_parents_FeatureSet = (
  { __typename?: 'FeatureSet' }
  & { features?: Maybe<Array<Maybe<DrByFeatureQuery_reference_ReferenceQueries_disease_DiseaseReference_citationsDVData_CitationDiseaseData_findings_RCohort_qfs_QualifiedFeature_feature_Feature_qualifiers_Qualifier_value_Feature_parents_FeatureSet_features_Feature>>> }
);

export type DrByFeatureQuery_reference_ReferenceQueries_disease_DiseaseReference_citationsDVData_CitationDiseaseData_findings_RCohort_qfs_QualifiedFeature_feature_Feature_qualifiers_Qualifier_value_Feature = (
  { __typename?: 'Feature' }
  & Pick<Feature, 'name' | 'shortname' | 'id' | 'patientDescription'>
  & { category?: Maybe<DrByFeatureQuery_reference_ReferenceQueries_disease_DiseaseReference_citationsDVData_CitationDiseaseData_findings_RCohort_qfs_QualifiedFeature_feature_Feature_organSystem_Feature>, description?: Maybe<DrByFeatureQuery_reference_ReferenceQueries_disease_DiseaseReference_citationsDVData_CitationDiseaseData_findings_RCohort_qfs_QualifiedFeature_feature_Feature_qualifiers_Qualifier_value_Feature_description_Description>, range?: Maybe<DrByFeatureQuery_reference_ReferenceQueries_disease_DiseaseReference_citationsDVData_CitationDiseaseData_findings_RCohort_qfs_QualifiedFeature_feature_Feature_range_MeasurementRange>, parents?: Maybe<DrByFeatureQuery_reference_ReferenceQueries_disease_DiseaseReference_citationsDVData_CitationDiseaseData_findings_RCohort_qfs_QualifiedFeature_feature_Feature_qualifiers_Qualifier_value_Feature_parents_FeatureSet> }
);

export type DrByFeatureQuery_reference_ReferenceQueries_disease_DiseaseReference_citationsDVData_CitationDiseaseData_findings_RCohort_qfs_QualifiedFeature_feature_Feature_qualifiers_Qualifier = (
  { __typename?: 'Qualifier' }
  & Pick<Qualifier, 'name' | 'negate' | 'freeText' | 'source'>
  & { relation: DrByFeatureQuery_reference_ReferenceQueries_disease_DiseaseReference_citationsDVData_CitationDiseaseData_findings_RCohort_qfs_QualifiedFeature_feature_Feature_qualifiers_Qualifier_relation_Relation, value?: Maybe<DrByFeatureQuery_reference_ReferenceQueries_disease_DiseaseReference_citationsDVData_CitationDiseaseData_findings_RCohort_qfs_QualifiedFeature_feature_Feature_qualifiers_Qualifier_value_Feature>, range?: Maybe<DrByFeatureQuery_reference_ReferenceQueries_disease_DiseaseReference_citationsDVData_CitationDiseaseData_findings_RCohort_qfs_QualifiedFeature_feature_Feature_range_MeasurementRange> }
);

export type DrByFeatureQuery_reference_ReferenceQueries_disease_DiseaseReference_citationsDVData_CitationDiseaseData_findings_RCohort_qfs_QualifiedFeature_feature_Feature = (
  { __typename?: 'Feature' }
  & Pick<Feature, 'name' | 'id' | 'shortname' | 'patientDescription' | 'alias' | 'skipDuration' | 'hasRefinement'>
  & { organSystem?: Maybe<DrByFeatureQuery_reference_ReferenceQueries_disease_DiseaseReference_citationsDVData_CitationDiseaseData_findings_RCohort_qfs_QualifiedFeature_feature_Feature_organSystem_Feature>, category?: Maybe<DrByFeatureQuery_reference_ReferenceQueries_disease_DiseaseReference_citationsDVData_CitationDiseaseData_findings_RCohort_qfs_QualifiedFeature_feature_Feature_organSystem_Feature>, qualifierSpec?: Maybe<Array<Maybe<DrByFeatureQuery_reference_ReferenceQueries_disease_DiseaseReference_citationsDVData_CitationDiseaseData_findings_RCohort_qfs_QualifiedFeature_feature_Feature_qualifierSpec_QualifierSpec>>>, description?: Maybe<DrByFeatureQuery_reference_ReferenceQueries_disease_DiseaseReference_citationsDVData_CitationDiseaseData_findings_RCohort_qfs_QualifiedFeature_feature_Feature_description_Description>, range?: Maybe<DrByFeatureQuery_reference_ReferenceQueries_disease_DiseaseReference_citationsDVData_CitationDiseaseData_findings_RCohort_qfs_QualifiedFeature_feature_Feature_range_MeasurementRange>, inferredParents?: Maybe<Array<Maybe<DrByFeatureQuery_reference_ReferenceQueries_disease_DiseaseReference_citationsDVData_CitationDiseaseData_findings_RCohort_qfs_QualifiedFeature_feature_Feature_inferredParents_Feature>>>, inferredChildren?: Maybe<Array<Maybe<DrByFeatureQuery_reference_ReferenceQueries_disease_DiseaseReference_citationsDVData_CitationDiseaseData_findings_RCohort_qfs_QualifiedFeature_feature_Feature_inferredParents_Feature>>>, qualifiers?: Maybe<Array<Maybe<DrByFeatureQuery_reference_ReferenceQueries_disease_DiseaseReference_citationsDVData_CitationDiseaseData_findings_RCohort_qfs_QualifiedFeature_feature_Feature_qualifiers_Qualifier>>>, inferredQualifiers?: Maybe<Array<Maybe<DrByFeatureQuery_reference_ReferenceQueries_disease_DiseaseReference_citationsDVData_CitationDiseaseData_findings_RCohort_qfs_QualifiedFeature_feature_Feature_qualifiers_Qualifier>>> }
);

export type DrByFeatureQuery_reference_ReferenceQueries_disease_DiseaseReference_citationsDVData_CitationDiseaseData_findings_RCohort_qfs_QualifiedFeature_mandatory_Qualifier = (
  { __typename?: 'Qualifier' }
  & Pick<Qualifier, 'freeText'>
  & { relation: DrByFeatureQuery_reference_ReferenceQueries_disease_DiseaseReference_citationsDVData_CitationDiseaseData_findings_RCohort_qfs_QualifiedFeature_feature_Feature_qualifierSpec_QualifierSpec_relation_Relation, value?: Maybe<DrByFeatureQuery_reference_ReferenceQueries_disease_DiseaseReference_citationsDVData_CitationDiseaseData_findings_RCohort_qfs_QualifiedFeature_feature_Feature_inferredParents_Feature>, range?: Maybe<DrByFeatureQuery_reference_ReferenceQueries_disease_DiseaseReference_citationsDVData_CitationDiseaseData_findings_RCohort_qfs_QualifiedFeature_feature_Feature_range_MeasurementRange> }
);

export type DrByFeatureQuery_reference_ReferenceQueries_disease_DiseaseReference_citationsDVData_CitationDiseaseData_findings_RCohort_qfs_QualifiedFeature = (
  { __typename?: 'QualifiedFeature' }
  & Pick<QualifiedFeature, 'id' | 'name' | 'negate' | 'skip'>
  & { feature?: Maybe<DrByFeatureQuery_reference_ReferenceQueries_disease_DiseaseReference_citationsDVData_CitationDiseaseData_findings_RCohort_qfs_QualifiedFeature_feature_Feature>, qualifiers?: Maybe<Array<Maybe<DrByFeatureQuery_reference_ReferenceQueries_disease_DiseaseReference_citationsDVData_CitationDiseaseData_findings_RCohort_qfs_QualifiedFeature_feature_Feature_qualifiers_Qualifier>>>, mandatory?: Maybe<DrByFeatureQuery_reference_ReferenceQueries_disease_DiseaseReference_citationsDVData_CitationDiseaseData_findings_RCohort_qfs_QualifiedFeature_mandatory_Qualifier> }
);

export type DrByFeatureQuery_reference_ReferenceQueries_disease_DiseaseReference_citationsDVData_CitationDiseaseData_findings_RCohort = (
  { __typename?: 'RCohort' }
  & Pick<RCohort, 'id'>
  & { qfs?: Maybe<Array<Maybe<DrByFeatureQuery_reference_ReferenceQueries_disease_DiseaseReference_citationsDVData_CitationDiseaseData_findings_RCohort_qfs_QualifiedFeature>>> }
);

export type DrByFeatureQuery_reference_ReferenceQueries_disease_DiseaseReference_citationsDVData_CitationDiseaseData = (
  { __typename?: 'CitationDiseaseData' }
  & Pick<CitationDiseaseData, 'citationId' | 'count' | 'type'>
  & { findings?: Maybe<Array<Maybe<DrByFeatureQuery_reference_ReferenceQueries_disease_DiseaseReference_citationsDVData_CitationDiseaseData_findings_RCohort>>>, subtypes?: Maybe<Array<Maybe<DrByFeatureQuery_reference_ReferenceQueries_disease_DiseaseReference_citationsDVData_CitationDiseaseData_findings_RCohort>>> }
);

export type DrByFeatureQuery_reference_ReferenceQueries_disease_DiseaseReference = (
  { __typename?: 'DiseaseReference' }
  & Pick<DiseaseReference, 'id'>
  & { citationsDVData?: Maybe<Array<Maybe<DrByFeatureQuery_reference_ReferenceQueries_disease_DiseaseReference_citationsDVData_CitationDiseaseData>>>, disease?: Maybe<Array<Maybe<DiseaseReferenceDataFragment_DiseaseReference_disease_QualifiedFeature>>>, findings?: Maybe<Array<Maybe<DiseaseReferenceDataFragment_DiseaseReference_findings_DiseaseFindingMetrics>>>, citations?: Maybe<DiseaseReferenceDataFragment_DiseaseReference_citations_Citations>, metrics?: Maybe<DiseaseReferenceDataFragment_DiseaseReference_metrics_RUnaryMetrics> }
);

export type DrByFeatureQuery_reference_ReferenceQueries = (
  { __typename?: 'ReferenceQueries' }
  & { disease?: Maybe<DrByFeatureQuery_reference_ReferenceQueries_disease_DiseaseReference> }
);

export type DrByFeatureQuery_Query = (
  { __typename?: 'Query' }
  & { reference?: Maybe<DrByFeatureQuery_reference_ReferenceQueries> }
);


export type DrByFeatureQueryVariables = Exact<{
  featureid: Scalars['ID']['input'];
  category?: InputMaybe<Scalars['String']['input']>;
  qfLight?: InputMaybe<Scalars['Boolean']['input']>;
  includeFeatureRange?: InputMaybe<Scalars['Boolean']['input']>;
  withCitations?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type DrByFeatureQuery = DrByFeatureQuery_Query;

export type DrOverviewByFeatureQuery_reference_ReferenceQueries_disease_DiseaseReference = (
  { __typename?: 'DiseaseReference' }
  & Pick<DiseaseReference, 'id'>
  & { disease?: Maybe<Array<Maybe<DiseaseReferenceOverviewDataFragment_DiseaseReference_disease_QualifiedFeature>>>, metrics?: Maybe<DiseaseReferenceOverviewDataFragment_DiseaseReference_metrics_RUnaryMetrics>, ageDistribution?: Maybe<DiseaseReferenceOverviewDataFragment_DiseaseReference_ageDistribution_RAgeDistribution> }
);

export type DrOverviewByFeatureQuery_reference_ReferenceQueries = (
  { __typename?: 'ReferenceQueries' }
  & { disease?: Maybe<DrOverviewByFeatureQuery_reference_ReferenceQueries_disease_DiseaseReference> }
);

export type DrOverviewByFeatureQuery_Query = (
  { __typename?: 'Query' }
  & { reference?: Maybe<DrOverviewByFeatureQuery_reference_ReferenceQueries> }
);


export type DrOverviewByFeatureQueryVariables = Exact<{
  featureid: Scalars['ID']['input'];
  qfLight?: InputMaybe<Scalars['Boolean']['input']>;
  includeFeatureRange?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type DrOverviewByFeatureQuery = DrOverviewByFeatureQuery_Query;

export type DrAndFindingPairQuery_reference_ReferenceQueries_diseaseWithFinding_DiseaseReference = (
  { __typename?: 'DiseaseReference' }
  & Pick<DiseaseReference, 'id'>
  & { disease?: Maybe<Array<Maybe<DiseaseReferenceDataFragment_DiseaseReference_disease_QualifiedFeature>>>, findings?: Maybe<Array<Maybe<DiseaseReferenceDataFragment_DiseaseReference_findings_DiseaseFindingMetrics>>>, citations?: Maybe<DiseaseReferenceDataFragment_DiseaseReference_citations_Citations>, citationsDVData?: Maybe<Array<Maybe<DiseaseReferenceDataFragment_DiseaseReference_citationsDVData_CitationDiseaseData>>>, metrics?: Maybe<DiseaseReferenceDataFragment_DiseaseReference_metrics_RUnaryMetrics> }
);

export type DrAndFindingPairQuery_reference_ReferenceQueries = (
  { __typename?: 'ReferenceQueries' }
  & { diseaseWithFinding?: Maybe<DrAndFindingPairQuery_reference_ReferenceQueries_diseaseWithFinding_DiseaseReference> }
);

export type DrAndFindingPairQuery_Query = (
  { __typename?: 'Query' }
  & { reference?: Maybe<DrAndFindingPairQuery_reference_ReferenceQueries> }
);


export type DrAndFindingPairQueryVariables = Exact<{
  featureid: Scalars['ID']['input'];
  finding?: InputMaybe<QualifiedFeatureInput>;
  qfLight?: InputMaybe<Scalars['Boolean']['input']>;
  includeFeatureRange?: InputMaybe<Scalars['Boolean']['input']>;
  withCitations?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type DrAndFindingPairQuery = DrAndFindingPairQuery_Query;

export type DrAndCohortPairQuery_reference_ReferenceQueries_diseaseWithFinding_DiseaseReference = (
  { __typename?: 'DiseaseReference' }
  & Pick<DiseaseReference, 'id'>
  & { disease?: Maybe<Array<Maybe<DiseaseReferenceDataFragment_DiseaseReference_disease_QualifiedFeature>>>, findings?: Maybe<Array<Maybe<DiseaseReferenceDataFragment_DiseaseReference_findings_DiseaseFindingMetrics>>>, citations?: Maybe<DiseaseReferenceDataFragment_DiseaseReference_citations_Citations>, citationsDVData?: Maybe<Array<Maybe<DiseaseReferenceDataFragment_DiseaseReference_citationsDVData_CitationDiseaseData>>>, metrics?: Maybe<DiseaseReferenceDataFragment_DiseaseReference_metrics_RUnaryMetrics> }
);

export type DrAndCohortPairQuery_reference_ReferenceQueries = (
  { __typename?: 'ReferenceQueries' }
  & { diseaseWithFinding?: Maybe<DrAndCohortPairQuery_reference_ReferenceQueries_diseaseWithFinding_DiseaseReference> }
);

export type DrAndCohortPairQuery_Query = (
  { __typename?: 'Query' }
  & { reference?: Maybe<DrAndCohortPairQuery_reference_ReferenceQueries> }
);


export type DrAndCohortPairQueryVariables = Exact<{
  diseaseCohortid: Scalars['ID']['input'];
  cohortid: Scalars['ID']['input'];
  qfLight?: InputMaybe<Scalars['Boolean']['input']>;
  includeFeatureRange?: InputMaybe<Scalars['Boolean']['input']>;
  withCitations?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type DrAndCohortPairQuery = DrAndCohortPairQuery_Query;

export type RuleValueFragment_RuleValue_citationsObj_CitationData = (
  { __typename?: 'CitationData' }
  & Pick<CitationData, 'id' | 'vancouver' | 'url' | 'title' | 'containerTitle' | 'DOI'>
);

export type RuleValueFragment = (
  { __typename?: 'RuleValue' }
  & Pick<RuleValue, 'ruleValueId' | 'prob' | 'lift' | 'type' | 'citations' | 'exactCitation'>
  & { citationsObj?: Maybe<RuleValueFragment_RuleValue_citationsObj_CitationData> }
);

export type RuleStatFragment_RuleStat_overloadSource_QualifiedFeature = (
  { __typename?: 'QualifiedFeature' }
  & Pick<QualifiedFeature, 'id' | 'name' | 'negate' | 'skip'>
  & { feature?: Maybe<FindingMetricsFragment_DiseaseFindingMetrics_finding_RCohort_qfs_QualifiedFeature_feature_Feature>, qualifiers?: Maybe<Array<Maybe<FindingMetricsFragment_DiseaseFindingMetrics_finding_RCohort_qfs_QualifiedFeature_qualifiers_Qualifier>>>, mandatory?: Maybe<FindingMetricsFragment_DiseaseFindingMetrics_finding_RCohort_qfs_QualifiedFeature_mandatory_Qualifier> }
);

export type RuleStatFragment_RuleStat_overloadTarget_QualifiedFeature = (
  { __typename?: 'QualifiedFeature' }
  & Pick<QualifiedFeature, 'id' | 'name' | 'negate' | 'skip'>
  & { feature?: Maybe<FindingMetricsFragment_DiseaseFindingMetrics_finding_RCohort_qfs_QualifiedFeature_feature_Feature>, qualifiers?: Maybe<Array<Maybe<FindingMetricsFragment_DiseaseFindingMetrics_finding_RCohort_qfs_QualifiedFeature_qualifiers_Qualifier>>>, mandatory?: Maybe<FindingMetricsFragment_DiseaseFindingMetrics_finding_RCohort_qfs_QualifiedFeature_mandatory_Qualifier> }
);

export type RuleStatFragment_RuleStat_ruleValue_RuleValue = (
  { __typename?: 'RuleValue' }
  & Pick<RuleValue, 'ruleValueId' | 'prob' | 'lift' | 'type' | 'citations' | 'exactCitation'>
  & { citationsObj?: Maybe<RuleValueFragment_RuleValue_citationsObj_CitationData> }
);

export type RuleStatFragment_RuleStat_edgeStat_MetricsEdgeStat = (
  { __typename?: 'MetricsEdgeStat' }
  & Pick<MetricsEdgeStat, 'rate' | 'unit'>
);

export type RuleStatFragment = (
  { __typename?: 'RuleStat' }
  & Pick<RuleStat, 'overloadSourceType' | 'overloadTargetType' | 'prob' | 'lift' | 'type'>
  & { overloadSource?: Maybe<Array<Maybe<RuleStatFragment_RuleStat_overloadSource_QualifiedFeature>>>, overloadTarget?: Maybe<Array<Maybe<RuleStatFragment_RuleStat_overloadTarget_QualifiedFeature>>>, ruleValue?: Maybe<RuleStatFragment_RuleStat_ruleValue_RuleValue>, edgeStat?: Maybe<RuleStatFragment_RuleStat_edgeStat_MetricsEdgeStat> }
);

export type PairGraphFragment_Graph_nodes_Node_qfs_QualifiedFeature = (
  { __typename?: 'QualifiedFeature' }
  & Pick<QualifiedFeature, 'id' | 'name' | 'negate' | 'skip'>
  & { feature?: Maybe<FindingMetricsFragment_DiseaseFindingMetrics_finding_RCohort_qfs_QualifiedFeature_feature_Feature>, qualifiers?: Maybe<Array<Maybe<FindingMetricsFragment_DiseaseFindingMetrics_finding_RCohort_qfs_QualifiedFeature_qualifiers_Qualifier>>>, mandatory?: Maybe<FindingMetricsFragment_DiseaseFindingMetrics_finding_RCohort_qfs_QualifiedFeature_mandatory_Qualifier> }
);

export type PairGraphFragment_Graph_nodes_Node_percentRange_Range = (
  { __typename?: 'Range' }
  & Pick<Range, 'min' | 'max'>
);

export type PairGraphFragment_Graph_nodes_Node = (
  { __typename?: 'Node' }
  & Pick<Node, 'id' | 'probability' | 'isConnected' | 'type' | 'sourceQFIndex'>
  & { qfs?: Maybe<Array<Maybe<PairGraphFragment_Graph_nodes_Node_qfs_QualifiedFeature>>>, percentRange?: Maybe<PairGraphFragment_Graph_nodes_Node_percentRange_Range> }
);

export type PairGraphFragment_Graph_edges_Edge_ruleValues_RuleStat = (
  { __typename?: 'RuleStat' }
  & Pick<RuleStat, 'overloadSourceType' | 'overloadTargetType' | 'prob' | 'lift' | 'type'>
  & { overloadSource?: Maybe<Array<Maybe<RuleStatFragment_RuleStat_overloadSource_QualifiedFeature>>>, overloadTarget?: Maybe<Array<Maybe<RuleStatFragment_RuleStat_overloadTarget_QualifiedFeature>>>, ruleValue?: Maybe<RuleStatFragment_RuleStat_ruleValue_RuleValue>, edgeStat?: Maybe<RuleStatFragment_RuleStat_edgeStat_MetricsEdgeStat> }
);

export type PairGraphFragment_Graph_edges_Edge = (
  { __typename?: 'Edge' }
  & Pick<Edge, 'id' | 'sourceID' | 'targetID' | 'prob' | 'lift' | 'type' | 'usedInComputation' | 'ruleValueId'>
  & { ruleValues?: Maybe<Array<Maybe<PairGraphFragment_Graph_edges_Edge_ruleValues_RuleStat>>> }
);

export type PairGraphFragment = (
  { __typename?: 'Graph' }
  & { nodes?: Maybe<Array<Maybe<PairGraphFragment_Graph_nodes_Node>>>, edges?: Maybe<Array<Maybe<PairGraphFragment_Graph_edges_Edge>>> }
);

export type GetGraphQuery_graph_GraphResponse_graph_Graph = (
  { __typename?: 'Graph' }
  & { nodes?: Maybe<Array<Maybe<PairGraphFragment_Graph_nodes_Node>>>, edges?: Maybe<Array<Maybe<PairGraphFragment_Graph_edges_Edge>>> }
);

export type GetGraphQuery_graph_GraphResponse = (
  { __typename?: 'GraphResponse' }
  & { graph?: Maybe<GetGraphQuery_graph_GraphResponse_graph_Graph> }
);

export type GetGraphQuery_Query = (
  { __typename?: 'Query' }
  & { graph?: Maybe<GetGraphQuery_graph_GraphResponse> }
);


export type GetGraphQueryVariables = Exact<{
  root?: InputMaybe<QualifiedFeatureInput>;
  nodes?: InputMaybe<Array<InputMaybe<GroupedFeature>> | InputMaybe<GroupedFeature>>;
  qfLight?: InputMaybe<Scalars['Boolean']['input']>;
  includeFeatureRange?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type GetGraphQuery = GetGraphQuery_Query;

export type GetGraphByIdsQuery_graphByCohorts_GraphResponse_graph_Graph = (
  { __typename?: 'Graph' }
  & { nodes?: Maybe<Array<Maybe<PairGraphFragment_Graph_nodes_Node>>>, edges?: Maybe<Array<Maybe<PairGraphFragment_Graph_edges_Edge>>> }
);

export type GetGraphByIdsQuery_graphByCohorts_GraphResponse = (
  { __typename?: 'GraphResponse' }
  & { graph?: Maybe<GetGraphByIdsQuery_graphByCohorts_GraphResponse_graph_Graph> }
);

export type GetGraphByIdsQuery_Query = (
  { __typename?: 'Query' }
  & { graphByCohorts?: Maybe<GetGraphByIdsQuery_graphByCohorts_GraphResponse> }
);


export type GetGraphByIdsQueryVariables = Exact<{
  root?: InputMaybe<Scalars['ID']['input']>;
  active?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>> | InputMaybe<Scalars['ID']['input']>>;
  background?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>> | InputMaybe<Scalars['ID']['input']>>;
  subtypes?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>> | InputMaybe<Scalars['ID']['input']>>;
  simplify?: InputMaybe<Scalars['Boolean']['input']>;
  qfLight?: InputMaybe<Scalars['Boolean']['input']>;
  includeFeatureRange?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type GetGraphByIdsQuery = GetGraphByIdsQuery_Query;

export type GroundingFragment_Grounding_sentences_GroundedSentence_statements_GroundedStatement_elementA_NodeValidation = (
  { __typename?: 'NodeValidation' }
  & Pick<NodeValidation, 'element' | 'match' | 'diff'>
);

export type GroundingFragment_Grounding_sentences_GroundedSentence_statements_GroundedStatement_elementB_NodeValidation = (
  { __typename?: 'NodeValidation' }
  & Pick<NodeValidation, 'element' | 'match' | 'diff'>
);

export type GroundingFragment_Grounding_sentences_GroundedSentence_statements_GroundedStatement_edgesWithTextualReferences_EdgeWithTextualReferences_rvWithTextualReference_TextualWithRuleReference_ruleValue_RuleValue_citationsObj_CitationData = (
  { __typename?: 'CitationData' }
  & Pick<CitationData, 'id' | 'kahunId' | 'vancouver' | 'url' | 'title' | 'containerTitle' | 'DOI'>
);

export type GroundingFragment_Grounding_sentences_GroundedSentence_statements_GroundedStatement_edgesWithTextualReferences_EdgeWithTextualReferences_rvWithTextualReference_TextualWithRuleReference_ruleValue_RuleValue = (
  { __typename?: 'RuleValue' }
  & { citationsObj?: Maybe<GroundingFragment_Grounding_sentences_GroundedSentence_statements_GroundedStatement_edgesWithTextualReferences_EdgeWithTextualReferences_rvWithTextualReference_TextualWithRuleReference_ruleValue_RuleValue_citationsObj_CitationData> }
);

export type GroundingFragment_Grounding_sentences_GroundedSentence_statements_GroundedStatement_edgesWithTextualReferences_EdgeWithTextualReferences_rvWithTextualReference_TextualWithRuleReference = (
  { __typename?: 'TextualWithRuleReference' }
  & Pick<TextualWithRuleReference, 'priority' | 'textual'>
  & { ruleValue?: Maybe<GroundingFragment_Grounding_sentences_GroundedSentence_statements_GroundedStatement_edgesWithTextualReferences_EdgeWithTextualReferences_rvWithTextualReference_TextualWithRuleReference_ruleValue_RuleValue> }
);

export type GroundingFragment_Grounding_sentences_GroundedSentence_statements_GroundedStatement_edgesWithTextualReferences_EdgeWithTextualReferences = (
  { __typename?: 'EdgeWithTextualReferences' }
  & Pick<EdgeWithTextualReferences, 'priority'>
  & { rvWithTextualReference?: Maybe<Array<Maybe<GroundingFragment_Grounding_sentences_GroundedSentence_statements_GroundedStatement_edgesWithTextualReferences_EdgeWithTextualReferences_rvWithTextualReference_TextualWithRuleReference>>> }
);

export type GroundingFragment_Grounding_sentences_GroundedSentence_statements_GroundedStatement = (
  { __typename?: 'GroundedStatement' }
  & Pick<GroundedStatement, 'id' | 'runningIndex' | 'statement' | 'wordIndexForReferencePoint' | 'wordsIndices' | 'hypothesis' | 'connectionStrength'>
  & { elementA?: Maybe<GroundingFragment_Grounding_sentences_GroundedSentence_statements_GroundedStatement_elementA_NodeValidation>, elementB?: Maybe<GroundingFragment_Grounding_sentences_GroundedSentence_statements_GroundedStatement_elementB_NodeValidation>, edgesWithTextualReferences?: Maybe<Array<Maybe<GroundingFragment_Grounding_sentences_GroundedSentence_statements_GroundedStatement_edgesWithTextualReferences_EdgeWithTextualReferences>>> }
);

export type GroundingFragment_Grounding_sentences_GroundedSentence = (
  { __typename?: 'GroundedSentence' }
  & Pick<GroundedSentence, 'sentence'>
  & { statements?: Maybe<Array<Maybe<GroundingFragment_Grounding_sentences_GroundedSentence_statements_GroundedStatement>>> }
);

export type GroundingFragment = (
  { __typename?: 'Grounding' }
  & Pick<Grounding, 'debugData'>
  & { sentences?: Maybe<Array<Maybe<GroundingFragment_Grounding_sentences_GroundedSentence>>> }
);

export type GroundTextQuery_groundText_Grounding = (
  { __typename?: 'Grounding' }
  & Pick<Grounding, 'debugData'>
  & { sentences?: Maybe<Array<Maybe<GroundingFragment_Grounding_sentences_GroundedSentence>>> }
);

export type GroundTextQuery_Query = (
  { __typename?: 'Query' }
  & { groundText?: Maybe<GroundTextQuery_groundText_Grounding> }
);


export type GroundTextQueryVariables = Exact<{
  text: Scalars['String']['input'];
  caseId?: InputMaybe<Scalars['String']['input']>;
}>;


export type GroundTextQuery = GroundTextQuery_Query;

export type MeasurementRangeFragment = (
  { __typename?: 'MeasurementRange' }
  & Pick<MeasurementRange, 'low' | 'high' | 'units'>
  & { complexUnits?: Maybe<FindingMetricsFragment_DiseaseFindingMetrics_finding_RCohort_qfs_QualifiedFeature_feature_Feature_range_MeasurementRange_complexUnits_ComplexUnits> }
);

export type MetricValueFragment = (
  { __typename?: 'RMetric' }
  & Pick<RMetric, 'value' | 'exactness'>
);

export type QualifierFragment = (
  { __typename?: 'Qualifier' }
  & Pick<Qualifier, 'name' | 'negate' | 'freeText' | 'source'>
  & { relation: FindingMetricsFragment_DiseaseFindingMetrics_finding_RCohort_qfs_QualifiedFeature_feature_Feature_qualifiers_Qualifier_relation_Relation, value?: Maybe<FindingMetricsFragment_DiseaseFindingMetrics_finding_RCohort_qfs_QualifiedFeature_feature_Feature_qualifiers_Qualifier_value_Feature>, range?: Maybe<FindingMetricsFragment_DiseaseFindingMetrics_finding_RCohort_qfs_QualifiedFeature_feature_Feature_qualifiers_Qualifier_range_MeasurementRange> }
);

export type FeatureFragment = (
  { __typename?: 'Feature' }
  & Pick<Feature, 'name' | 'id' | 'shortname' | 'patientDescription' | 'alias' | 'skipDuration' | 'hasRefinement'>
  & { organSystem?: Maybe<FindingMetricsFragment_DiseaseFindingMetrics_finding_RCohort_qfs_QualifiedFeature_feature_Feature_organSystem_Feature>, category?: Maybe<FindingMetricsFragment_DiseaseFindingMetrics_finding_RCohort_qfs_QualifiedFeature_feature_Feature_category_Feature>, qualifierSpec?: Maybe<Array<Maybe<FindingMetricsFragment_DiseaseFindingMetrics_finding_RCohort_qfs_QualifiedFeature_feature_Feature_qualifierSpec_QualifierSpec>>>, description?: Maybe<FindingMetricsFragment_DiseaseFindingMetrics_finding_RCohort_qfs_QualifiedFeature_feature_Feature_description_Description>, range?: Maybe<FindingMetricsFragment_DiseaseFindingMetrics_finding_RCohort_qfs_QualifiedFeature_feature_Feature_range_MeasurementRange>, inferredParents?: Maybe<Array<Maybe<FindingMetricsFragment_DiseaseFindingMetrics_finding_RCohort_qfs_QualifiedFeature_feature_Feature_inferredParents_Feature>>>, inferredChildren?: Maybe<Array<Maybe<FindingMetricsFragment_DiseaseFindingMetrics_finding_RCohort_qfs_QualifiedFeature_feature_Feature_inferredChildren_Feature>>>, qualifiers?: Maybe<Array<Maybe<FindingMetricsFragment_DiseaseFindingMetrics_finding_RCohort_qfs_QualifiedFeature_feature_Feature_qualifiers_Qualifier>>>, inferredQualifiers?: Maybe<Array<Maybe<FindingMetricsFragment_DiseaseFindingMetrics_finding_RCohort_qfs_QualifiedFeature_feature_Feature_inferredQualifiers_Qualifier>>> }
);

export type QualifiedFeatureFragment = (
  { __typename?: 'QualifiedFeature' }
  & Pick<QualifiedFeature, 'id' | 'name' | 'negate' | 'skip'>
  & { feature?: Maybe<FindingMetricsFragment_DiseaseFindingMetrics_finding_RCohort_qfs_QualifiedFeature_feature_Feature>, qualifiers?: Maybe<Array<Maybe<FindingMetricsFragment_DiseaseFindingMetrics_finding_RCohort_qfs_QualifiedFeature_qualifiers_Qualifier>>>, mandatory?: Maybe<FindingMetricsFragment_DiseaseFindingMetrics_finding_RCohort_qfs_QualifiedFeature_mandatory_Qualifier> }
);

export type GroupedFeatureResponseFragment_GroupedFeatureResponse_feature_QualifiedFeature = (
  { __typename?: 'QualifiedFeature' }
  & Pick<QualifiedFeature, 'id' | 'name' | 'negate' | 'skip'>
  & { feature?: Maybe<FindingMetricsFragment_DiseaseFindingMetrics_finding_RCohort_qfs_QualifiedFeature_feature_Feature>, qualifiers?: Maybe<Array<Maybe<FindingMetricsFragment_DiseaseFindingMetrics_finding_RCohort_qfs_QualifiedFeature_qualifiers_Qualifier>>>, mandatory?: Maybe<FindingMetricsFragment_DiseaseFindingMetrics_finding_RCohort_qfs_QualifiedFeature_mandatory_Qualifier> }
);

export type GroupedFeatureResponseFragment = (
  { __typename?: 'GroupedFeatureResponse' }
  & Pick<GroupedFeatureResponse, 'skip' | 'source' | 'group' | 'validation'>
  & { feature?: Maybe<GroupedFeatureResponseFragment_GroupedFeatureResponse_feature_QualifiedFeature> }
);

export type CitationDataFragment = (
  { __typename?: 'CitationData' }
  & Pick<CitationData, 'id' | 'kahunId' | 'vancouver' | 'url' | 'title' | 'containerTitle' | 'DOI'>
);

export type CitationsFragment = (
  { __typename?: 'Citations' }
  & Pick<Citations, 'totalCount'>
  & { citationsData?: Maybe<Array<Maybe<DiseaseReferenceDataFragment_DiseaseReference_citations_Citations_citationsData_CitationData>>> }
);

export type SheetFragment_Sheet_rows_Row = (
  { __typename?: 'Row' }
  & Pick<Row, 'cols'>
);

export type SheetFragment = (
  { __typename?: 'Sheet' }
  & { rows?: Maybe<Array<Maybe<SheetFragment_Sheet_rows_Row>>> }
);

export type DebugSheetFragment_DebugSheet_sheet_Sheet = (
  { __typename?: 'Sheet' }
  & { rows?: Maybe<Array<Maybe<SheetFragment_Sheet_rows_Row>>> }
);

export type DebugSheetFragment = (
  { __typename?: 'DebugSheet' }
  & Pick<DebugSheet, 'name'>
  & { sheet?: Maybe<DebugSheetFragment_DebugSheet_sheet_Sheet> }
);

export type FlagFragment_Flag_ref_QualifiedFeature_feature_Feature = (
  { __typename?: 'Feature' }
  & Pick<Feature, 'name'>
);

export type FlagFragment_Flag_ref_QualifiedFeature = (
  { __typename?: 'QualifiedFeature' }
  & Pick<QualifiedFeature, 'negate'>
  & { feature?: Maybe<FlagFragment_Flag_ref_QualifiedFeature_feature_Feature> }
);

export type FlagFragment = (
  { __typename?: 'Flag' }
  & Pick<Flag, 'type'>
  & { ref?: Maybe<FlagFragment_Flag_ref_QualifiedFeature> }
);

export type NextStepFragment_NextStep_suggestedFeatures_SuggestedFeature_qualifiedFeature_QualifiedFeature = (
  { __typename?: 'QualifiedFeature' }
  & Pick<QualifiedFeature, 'id' | 'name' | 'negate' | 'skip'>
  & { feature?: Maybe<FindingMetricsFragment_DiseaseFindingMetrics_finding_RCohort_qfs_QualifiedFeature_feature_Feature>, qualifiers?: Maybe<Array<Maybe<FindingMetricsFragment_DiseaseFindingMetrics_finding_RCohort_qfs_QualifiedFeature_qualifiers_Qualifier>>>, mandatory?: Maybe<FindingMetricsFragment_DiseaseFindingMetrics_finding_RCohort_qfs_QualifiedFeature_mandatory_Qualifier> }
);

export type NextStepFragment_NextStep_suggestedFeatures_SuggestedFeature_liftScores_LiftScore_qualifiedFeature_QualifiedFeature = (
  { __typename?: 'QualifiedFeature' }
  & Pick<QualifiedFeature, 'id'>
);

export type NextStepFragment_NextStep_suggestedFeatures_SuggestedFeature_liftScores_LiftScore = (
  { __typename?: 'LiftScore' }
  & Pick<LiftScore, 'liftScore'>
  & { qualifiedFeature?: Maybe<NextStepFragment_NextStep_suggestedFeatures_SuggestedFeature_liftScores_LiftScore_qualifiedFeature_QualifiedFeature> }
);

export type NextStepFragment_NextStep_suggestedFeatures_SuggestedFeature = (
  { __typename?: 'SuggestedFeature' }
  & Pick<SuggestedFeature, 'sumDiseaseGivenFinding' | 'sumLiftScores' | 'category'>
  & { qualifiedFeature?: Maybe<NextStepFragment_NextStep_suggestedFeatures_SuggestedFeature_qualifiedFeature_QualifiedFeature>, liftScores?: Maybe<Array<Maybe<NextStepFragment_NextStep_suggestedFeatures_SuggestedFeature_liftScores_LiftScore>>> }
);

export type NextStepFragment_NextStep_debugSheet_Sheet = (
  { __typename?: 'Sheet' }
  & { rows?: Maybe<Array<Maybe<SheetFragment_Sheet_rows_Row>>> }
);

export type NextStepFragment = (
  { __typename?: 'NextStep' }
  & { suggestedFeatures?: Maybe<Array<Maybe<NextStepFragment_NextStep_suggestedFeatures_SuggestedFeature>>>, debugSheet?: Maybe<NextStepFragment_NextStep_debugSheet_Sheet> }
);

export type PatientSuggestionsFragment_PatientSuggestions_debugSheet_Sheet = (
  { __typename?: 'Sheet' }
  & { rows?: Maybe<Array<Maybe<SheetFragment_Sheet_rows_Row>>> }
);

export type PatientSuggestionsFragment_PatientSuggestions_suggestions_PatientSuggestion_suggestion_QualifiedFeature = (
  { __typename?: 'QualifiedFeature' }
  & Pick<QualifiedFeature, 'id' | 'name' | 'negate' | 'skip'>
  & { feature?: Maybe<FindingMetricsFragment_DiseaseFindingMetrics_finding_RCohort_qfs_QualifiedFeature_feature_Feature>, qualifiers?: Maybe<Array<Maybe<FindingMetricsFragment_DiseaseFindingMetrics_finding_RCohort_qfs_QualifiedFeature_qualifiers_Qualifier>>>, mandatory?: Maybe<FindingMetricsFragment_DiseaseFindingMetrics_finding_RCohort_qfs_QualifiedFeature_mandatory_Qualifier> }
);

export type PatientSuggestionsFragment_PatientSuggestions_suggestions_PatientSuggestion_perDiseaseMetrics_SuggestionDiseaseMetric_suggestion_QualifiedFeature_qualifiers_Qualifier = (
  { __typename?: 'Qualifier' }
  & Pick<Qualifier, 'name' | 'negate' | 'freeText' | 'source'>
  & { relation: FindingMetricsFragment_DiseaseFindingMetrics_finding_RCohort_qfs_QualifiedFeature_feature_Feature_qualifiers_Qualifier_relation_Relation, value?: Maybe<FindingMetricsFragment_DiseaseFindingMetrics_finding_RCohort_qfs_QualifiedFeature_feature_Feature_qualifiers_Qualifier_value_Feature>, range?: Maybe<FindingMetricsFragment_DiseaseFindingMetrics_finding_RCohort_qfs_QualifiedFeature_feature_Feature_qualifiers_Qualifier_range_MeasurementRange> }
);

export type PatientSuggestionsFragment_PatientSuggestions_suggestions_PatientSuggestion_perDiseaseMetrics_SuggestionDiseaseMetric_suggestion_QualifiedFeature = (
  { __typename?: 'QualifiedFeature' }
  & { qualifiers?: Maybe<Array<Maybe<PatientSuggestionsFragment_PatientSuggestions_suggestions_PatientSuggestion_perDiseaseMetrics_SuggestionDiseaseMetric_suggestion_QualifiedFeature_qualifiers_Qualifier>>> }
);

export type PatientSuggestionsFragment_PatientSuggestions_suggestions_PatientSuggestion_perDiseaseMetrics_SuggestionDiseaseMetric_pairMetrics_RPairMetrics_sensitivity_RMetric = (
  { __typename?: 'RMetric' }
  & Pick<RMetric, 'value' | 'exactness'>
);

export type PatientSuggestionsFragment_PatientSuggestions_suggestions_PatientSuggestion_perDiseaseMetrics_SuggestionDiseaseMetric_pairMetrics_RPairMetrics = (
  { __typename?: 'RPairMetrics' }
  & { sensitivity?: Maybe<PatientSuggestionsFragment_PatientSuggestions_suggestions_PatientSuggestion_perDiseaseMetrics_SuggestionDiseaseMetric_pairMetrics_RPairMetrics_sensitivity_RMetric> }
);

export type PatientSuggestionsFragment_PatientSuggestions_suggestions_PatientSuggestion_perDiseaseMetrics_SuggestionDiseaseMetric = (
  { __typename?: 'SuggestionDiseaseMetric' }
  & Pick<SuggestionDiseaseMetric, 'specificity' | 'diseaseIndex' | 'findingGivenDisease' | 'adjustedBinaryEntropy'>
  & { suggestion?: Maybe<PatientSuggestionsFragment_PatientSuggestions_suggestions_PatientSuggestion_perDiseaseMetrics_SuggestionDiseaseMetric_suggestion_QualifiedFeature>, pairMetrics?: Maybe<PatientSuggestionsFragment_PatientSuggestions_suggestions_PatientSuggestion_perDiseaseMetrics_SuggestionDiseaseMetric_pairMetrics_RPairMetrics> }
);

export type PatientSuggestionsFragment_PatientSuggestions_suggestions_PatientSuggestion = (
  { __typename?: 'PatientSuggestion' }
  & Pick<PatientSuggestion, 'entropy' | 'mutualInformation' | 'mutualInformationUrgencyDifferentiation' | 'findingProbability' | 'findingEntropy' | 'findingLeakAdjustedEntropy' | 'findingLeak' | 'category' | 'inPatient' | 'inPatientId'>
  & { suggestion?: Maybe<PatientSuggestionsFragment_PatientSuggestions_suggestions_PatientSuggestion_suggestion_QualifiedFeature>, perDiseaseMetrics?: Maybe<Array<Maybe<PatientSuggestionsFragment_PatientSuggestions_suggestions_PatientSuggestion_perDiseaseMetrics_SuggestionDiseaseMetric>>> }
);

export type PatientSuggestionsFragment_PatientSuggestions_clustered_ClusterSuggestion_title_Feature = (
  { __typename?: 'Feature' }
  & Pick<Feature, 'name' | 'id' | 'shortname' | 'patientDescription' | 'alias' | 'skipDuration' | 'hasRefinement'>
  & { organSystem?: Maybe<FindingMetricsFragment_DiseaseFindingMetrics_finding_RCohort_qfs_QualifiedFeature_feature_Feature_organSystem_Feature>, category?: Maybe<FindingMetricsFragment_DiseaseFindingMetrics_finding_RCohort_qfs_QualifiedFeature_feature_Feature_category_Feature>, qualifierSpec?: Maybe<Array<Maybe<FindingMetricsFragment_DiseaseFindingMetrics_finding_RCohort_qfs_QualifiedFeature_feature_Feature_qualifierSpec_QualifierSpec>>>, description?: Maybe<FindingMetricsFragment_DiseaseFindingMetrics_finding_RCohort_qfs_QualifiedFeature_feature_Feature_description_Description>, range?: Maybe<FindingMetricsFragment_DiseaseFindingMetrics_finding_RCohort_qfs_QualifiedFeature_feature_Feature_range_MeasurementRange>, inferredParents?: Maybe<Array<Maybe<FindingMetricsFragment_DiseaseFindingMetrics_finding_RCohort_qfs_QualifiedFeature_feature_Feature_inferredParents_Feature>>>, inferredChildren?: Maybe<Array<Maybe<FindingMetricsFragment_DiseaseFindingMetrics_finding_RCohort_qfs_QualifiedFeature_feature_Feature_inferredChildren_Feature>>>, qualifiers?: Maybe<Array<Maybe<FindingMetricsFragment_DiseaseFindingMetrics_finding_RCohort_qfs_QualifiedFeature_feature_Feature_qualifiers_Qualifier>>>, inferredQualifiers?: Maybe<Array<Maybe<FindingMetricsFragment_DiseaseFindingMetrics_finding_RCohort_qfs_QualifiedFeature_feature_Feature_inferredQualifiers_Qualifier>>> }
);

export type PatientSuggestionsFragment_PatientSuggestions_clustered_ClusterSuggestion_items_PatientSuggestion_suggestion_QualifiedFeature = (
  { __typename?: 'QualifiedFeature' }
  & Pick<QualifiedFeature, 'id' | 'name' | 'negate' | 'skip'>
  & { feature?: Maybe<FindingMetricsFragment_DiseaseFindingMetrics_finding_RCohort_qfs_QualifiedFeature_feature_Feature>, qualifiers?: Maybe<Array<Maybe<FindingMetricsFragment_DiseaseFindingMetrics_finding_RCohort_qfs_QualifiedFeature_qualifiers_Qualifier>>>, mandatory?: Maybe<FindingMetricsFragment_DiseaseFindingMetrics_finding_RCohort_qfs_QualifiedFeature_mandatory_Qualifier> }
);

export type PatientSuggestionsFragment_PatientSuggestions_clustered_ClusterSuggestion_items_PatientSuggestion_perDiseaseMetrics_SuggestionDiseaseMetric_suggestion_QualifiedFeature_qualifiers_Qualifier = (
  { __typename?: 'Qualifier' }
  & Pick<Qualifier, 'name' | 'negate' | 'freeText' | 'source'>
  & { relation: FindingMetricsFragment_DiseaseFindingMetrics_finding_RCohort_qfs_QualifiedFeature_feature_Feature_qualifiers_Qualifier_relation_Relation, value?: Maybe<FindingMetricsFragment_DiseaseFindingMetrics_finding_RCohort_qfs_QualifiedFeature_feature_Feature_qualifiers_Qualifier_value_Feature>, range?: Maybe<FindingMetricsFragment_DiseaseFindingMetrics_finding_RCohort_qfs_QualifiedFeature_feature_Feature_qualifiers_Qualifier_range_MeasurementRange> }
);

export type PatientSuggestionsFragment_PatientSuggestions_clustered_ClusterSuggestion_items_PatientSuggestion_perDiseaseMetrics_SuggestionDiseaseMetric_suggestion_QualifiedFeature = (
  { __typename?: 'QualifiedFeature' }
  & { qualifiers?: Maybe<Array<Maybe<PatientSuggestionsFragment_PatientSuggestions_clustered_ClusterSuggestion_items_PatientSuggestion_perDiseaseMetrics_SuggestionDiseaseMetric_suggestion_QualifiedFeature_qualifiers_Qualifier>>> }
);

export type PatientSuggestionsFragment_PatientSuggestions_clustered_ClusterSuggestion_items_PatientSuggestion_perDiseaseMetrics_SuggestionDiseaseMetric = (
  { __typename?: 'SuggestionDiseaseMetric' }
  & Pick<SuggestionDiseaseMetric, 'diseaseIndex' | 'findingGivenDisease'>
  & { suggestion?: Maybe<PatientSuggestionsFragment_PatientSuggestions_clustered_ClusterSuggestion_items_PatientSuggestion_perDiseaseMetrics_SuggestionDiseaseMetric_suggestion_QualifiedFeature> }
);

export type PatientSuggestionsFragment_PatientSuggestions_clustered_ClusterSuggestion_items_PatientSuggestion = (
  { __typename?: 'PatientSuggestion' }
  & Pick<PatientSuggestion, 'entropy' | 'mutualInformation' | 'mutualInformationUrgencyDifferentiation'>
  & { suggestion?: Maybe<PatientSuggestionsFragment_PatientSuggestions_clustered_ClusterSuggestion_items_PatientSuggestion_suggestion_QualifiedFeature>, perDiseaseMetrics?: Maybe<Array<Maybe<PatientSuggestionsFragment_PatientSuggestions_clustered_ClusterSuggestion_items_PatientSuggestion_perDiseaseMetrics_SuggestionDiseaseMetric>>> }
);

export type PatientSuggestionsFragment_PatientSuggestions_clustered_ClusterSuggestion = (
  { __typename?: 'ClusterSuggestion' }
  & Pick<ClusterSuggestion, 'category'>
  & { title?: Maybe<PatientSuggestionsFragment_PatientSuggestions_clustered_ClusterSuggestion_title_Feature>, items?: Maybe<Array<Maybe<PatientSuggestionsFragment_PatientSuggestions_clustered_ClusterSuggestion_items_PatientSuggestion>>> }
);

export type PatientSuggestionsFragment = (
  { __typename?: 'PatientSuggestions' }
  & { debugSheet?: Maybe<PatientSuggestionsFragment_PatientSuggestions_debugSheet_Sheet>, suggestions?: Maybe<Array<Maybe<PatientSuggestionsFragment_PatientSuggestions_suggestions_PatientSuggestion>>>, clustered?: Maybe<Array<Maybe<PatientSuggestionsFragment_PatientSuggestions_clustered_ClusterSuggestion>>> }
);

export type PatientSuggestionMiExplanationsFragment_PatientSuggestion_perDiseaseMetrics_SuggestionDiseaseMetric_pairMetrics_RPairMetrics_sensitivity_RMetric = (
  { __typename?: 'RMetric' }
  & Pick<RMetric, 'value' | 'exactness'>
);

export type PatientSuggestionMiExplanationsFragment_PatientSuggestion_perDiseaseMetrics_SuggestionDiseaseMetric_pairMetrics_RPairMetrics_ppv_RMetric = (
  { __typename?: 'RMetric' }
  & Pick<RMetric, 'value' | 'exactness'>
);

export type PatientSuggestionMiExplanationsFragment_PatientSuggestion_perDiseaseMetrics_SuggestionDiseaseMetric_pairMetrics_RPairMetrics_incidence_RMetric = (
  { __typename?: 'RMetric' }
  & Pick<RMetric, 'value' | 'exactness'>
);

export type PatientSuggestionMiExplanationsFragment_PatientSuggestion_perDiseaseMetrics_SuggestionDiseaseMetric_pairMetrics_RPairMetrics_rrisk_cause_RMetric = (
  { __typename?: 'RMetric' }
  & Pick<RMetric, 'value' | 'exactness'>
);

export type PatientSuggestionMiExplanationsFragment_PatientSuggestion_perDiseaseMetrics_SuggestionDiseaseMetric_pairMetrics_RPairMetrics_rrisk_effect_RMetric = (
  { __typename?: 'RMetric' }
  & Pick<RMetric, 'value' | 'exactness'>
);

export type PatientSuggestionMiExplanationsFragment_PatientSuggestion_perDiseaseMetrics_SuggestionDiseaseMetric_pairMetrics_RPairMetrics = (
  { __typename?: 'RPairMetrics' }
  & { sensitivity?: Maybe<PatientSuggestionMiExplanationsFragment_PatientSuggestion_perDiseaseMetrics_SuggestionDiseaseMetric_pairMetrics_RPairMetrics_sensitivity_RMetric>, ppv?: Maybe<PatientSuggestionMiExplanationsFragment_PatientSuggestion_perDiseaseMetrics_SuggestionDiseaseMetric_pairMetrics_RPairMetrics_ppv_RMetric>, incidence?: Maybe<PatientSuggestionMiExplanationsFragment_PatientSuggestion_perDiseaseMetrics_SuggestionDiseaseMetric_pairMetrics_RPairMetrics_incidence_RMetric>, rrisk_cause?: Maybe<PatientSuggestionMiExplanationsFragment_PatientSuggestion_perDiseaseMetrics_SuggestionDiseaseMetric_pairMetrics_RPairMetrics_rrisk_cause_RMetric>, rrisk_effect?: Maybe<PatientSuggestionMiExplanationsFragment_PatientSuggestion_perDiseaseMetrics_SuggestionDiseaseMetric_pairMetrics_RPairMetrics_rrisk_effect_RMetric> }
);

export type PatientSuggestionMiExplanationsFragment_PatientSuggestion_perDiseaseMetrics_SuggestionDiseaseMetric_suggestion_QualifiedFeature = (
  { __typename?: 'QualifiedFeature' }
  & Pick<QualifiedFeature, 'id' | 'name' | 'negate' | 'skip'>
  & { feature?: Maybe<FindingMetricsFragment_DiseaseFindingMetrics_finding_RCohort_qfs_QualifiedFeature_feature_Feature>, qualifiers?: Maybe<Array<Maybe<FindingMetricsFragment_DiseaseFindingMetrics_finding_RCohort_qfs_QualifiedFeature_qualifiers_Qualifier>>>, mandatory?: Maybe<FindingMetricsFragment_DiseaseFindingMetrics_finding_RCohort_qfs_QualifiedFeature_mandatory_Qualifier> }
);

export type PatientSuggestionMiExplanationsFragment_PatientSuggestion_perDiseaseMetrics_SuggestionDiseaseMetric = (
  { __typename?: 'SuggestionDiseaseMetric' }
  & Pick<SuggestionDiseaseMetric, 'diseaseIndex' | 'findingGivenDisease' | 'adjustedBinaryEntropy' | 'specificity' | 'likelihoodRatioNeg' | 'likelihoodRatioPos'>
  & { pairMetrics?: Maybe<PatientSuggestionMiExplanationsFragment_PatientSuggestion_perDiseaseMetrics_SuggestionDiseaseMetric_pairMetrics_RPairMetrics>, suggestion?: Maybe<PatientSuggestionMiExplanationsFragment_PatientSuggestion_perDiseaseMetrics_SuggestionDiseaseMetric_suggestion_QualifiedFeature> }
);

export type PatientSuggestionMiExplanationsFragment_PatientSuggestion_bestSubtype_QualifiedFeature = (
  { __typename?: 'QualifiedFeature' }
  & Pick<QualifiedFeature, 'id' | 'name' | 'negate' | 'skip'>
  & { feature?: Maybe<FindingMetricsFragment_DiseaseFindingMetrics_finding_RCohort_qfs_QualifiedFeature_feature_Feature>, qualifiers?: Maybe<Array<Maybe<FindingMetricsFragment_DiseaseFindingMetrics_finding_RCohort_qfs_QualifiedFeature_qualifiers_Qualifier>>>, mandatory?: Maybe<FindingMetricsFragment_DiseaseFindingMetrics_finding_RCohort_qfs_QualifiedFeature_mandatory_Qualifier> }
);

export type PatientSuggestionMiExplanationsFragment = (
  { __typename?: 'PatientSuggestion' }
  & Pick<PatientSuggestion, 'findingProbability' | 'findingEntropy' | 'findingLeak' | 'findingLeakAdjustedEntropy' | 'defaultFindingGivenDisease' | 'defaultFindingGivenDiseaseAdjustedEntropy'>
  & { perDiseaseMetrics?: Maybe<Array<Maybe<PatientSuggestionMiExplanationsFragment_PatientSuggestion_perDiseaseMetrics_SuggestionDiseaseMetric>>>, bestSubtype?: Maybe<PatientSuggestionMiExplanationsFragment_PatientSuggestion_bestSubtype_QualifiedFeature> }
);

export type ConversationDdFragment_DDResponse_allFindings_QualifiedFeature = (
  { __typename?: 'QualifiedFeature' }
  & Pick<QualifiedFeature, 'id' | 'name' | 'negate' | 'skip'>
  & { feature?: Maybe<FindingMetricsFragment_DiseaseFindingMetrics_finding_RCohort_qfs_QualifiedFeature_feature_Feature>, qualifiers?: Maybe<Array<Maybe<FindingMetricsFragment_DiseaseFindingMetrics_finding_RCohort_qfs_QualifiedFeature_qualifiers_Qualifier>>>, mandatory?: Maybe<FindingMetricsFragment_DiseaseFindingMetrics_finding_RCohort_qfs_QualifiedFeature_mandatory_Qualifier> }
);

export type ConversationDdFragment_DDResponse_clinicalReasoning_ClinicalReasoning_disease_QualifiedFeature_urgencyInfo_Feature = (
  { __typename?: 'Feature' }
  & Pick<Feature, 'id' | 'urgency' | 'urgencyId'>
);

export type ConversationDdFragment_DDResponse_clinicalReasoning_ClinicalReasoning_disease_QualifiedFeature = (
  { __typename?: 'QualifiedFeature' }
  & Pick<QualifiedFeature, 'id' | 'name' | 'negate' | 'skip'>
  & { urgencyInfo?: Maybe<ConversationDdFragment_DDResponse_clinicalReasoning_ClinicalReasoning_disease_QualifiedFeature_urgencyInfo_Feature>, feature?: Maybe<FindingMetricsFragment_DiseaseFindingMetrics_finding_RCohort_qfs_QualifiedFeature_feature_Feature>, qualifiers?: Maybe<Array<Maybe<FindingMetricsFragment_DiseaseFindingMetrics_finding_RCohort_qfs_QualifiedFeature_qualifiers_Qualifier>>>, mandatory?: Maybe<FindingMetricsFragment_DiseaseFindingMetrics_finding_RCohort_qfs_QualifiedFeature_mandatory_Qualifier> }
);

export type ConversationDdFragment_DDResponse_clinicalReasoning_ClinicalReasoning_diseaseCitations_Citations = (
  { __typename?: 'Citations' }
  & Pick<Citations, 'totalCount'>
  & { citationsData?: Maybe<Array<Maybe<DiseaseReferenceDataFragment_DiseaseReference_citations_Citations_citationsData_CitationData>>> }
);

export type ConversationDdFragment_DDResponse_clinicalReasoning_ClinicalReasoning_findings_ClinicalReasoningFinding_finding_QualifiedFeature = (
  { __typename?: 'QualifiedFeature' }
  & Pick<QualifiedFeature, 'id'>
);

export type ConversationDdFragment_DDResponse_clinicalReasoning_ClinicalReasoning_findings_ClinicalReasoningFinding = (
  { __typename?: 'ClinicalReasoningFinding' }
  & Pick<ClinicalReasoningFinding, 'sourceQFIndex' | 'absolutePredictiveValue' | 'likelihoodRatio'>
  & { finding?: Maybe<ConversationDdFragment_DDResponse_clinicalReasoning_ClinicalReasoning_findings_ClinicalReasoningFinding_finding_QualifiedFeature> }
);

export type ConversationDdFragment_DDResponse_clinicalReasoning_ClinicalReasoning_scores_ScoreByType = (
  { __typename?: 'ScoreByType' }
  & Pick<ScoreByType, 'postClusterAdjustment' | 'sortType'>
);

export type ConversationDdFragment_DDResponse_clinicalReasoning_ClinicalReasoning_flags_Flag = (
  { __typename?: 'Flag' }
  & Pick<Flag, 'type'>
  & { ref?: Maybe<FlagFragment_Flag_ref_QualifiedFeature> }
);

export type ConversationDdFragment_DDResponse_clinicalReasoning_ClinicalReasoning = (
  { __typename?: 'ClinicalReasoning' }
  & Pick<ClinicalReasoning, 'id' | 'inInitialDisorders' | 'forcedInSort' | 'score' | 'urgency' | 'diseaseGivenIndependentFindings' | 'diseaseGivenDependentFindings' | 'inTopCRPerSortType' | 'missingPresentingSymptoms' | 'presentableDisease' | 'patientIncidence'>
  & { disease?: Maybe<Array<Maybe<ConversationDdFragment_DDResponse_clinicalReasoning_ClinicalReasoning_disease_QualifiedFeature>>>, diseaseCitations?: Maybe<ConversationDdFragment_DDResponse_clinicalReasoning_ClinicalReasoning_diseaseCitations_Citations>, findings?: Maybe<Array<Maybe<ConversationDdFragment_DDResponse_clinicalReasoning_ClinicalReasoning_findings_ClinicalReasoningFinding>>>, scores?: Maybe<Array<Maybe<ConversationDdFragment_DDResponse_clinicalReasoning_ClinicalReasoning_scores_ScoreByType>>>, flags?: Maybe<Array<Maybe<ConversationDdFragment_DDResponse_clinicalReasoning_ClinicalReasoning_flags_Flag>>> }
);

export type ConversationDdFragment_DDResponse_clustersToConsider_DiseaseCluster_scores_ScoreByType = (
  { __typename?: 'ScoreByType' }
  & Pick<ScoreByType, 'adjustedNormalized'>
);

export type ConversationDdFragment_DDResponse_clustersToConsider_DiseaseCluster_title_QualifiedFeature_urgencyInfo_Feature = (
  { __typename?: 'Feature' }
  & Pick<Feature, 'id' | 'urgency' | 'urgencyId'>
);

export type ConversationDdFragment_DDResponse_clustersToConsider_DiseaseCluster_title_QualifiedFeature = (
  { __typename?: 'QualifiedFeature' }
  & Pick<QualifiedFeature, 'id' | 'name' | 'negate' | 'skip'>
  & { urgencyInfo?: Maybe<ConversationDdFragment_DDResponse_clustersToConsider_DiseaseCluster_title_QualifiedFeature_urgencyInfo_Feature>, feature?: Maybe<FindingMetricsFragment_DiseaseFindingMetrics_finding_RCohort_qfs_QualifiedFeature_feature_Feature>, qualifiers?: Maybe<Array<Maybe<FindingMetricsFragment_DiseaseFindingMetrics_finding_RCohort_qfs_QualifiedFeature_qualifiers_Qualifier>>>, mandatory?: Maybe<FindingMetricsFragment_DiseaseFindingMetrics_finding_RCohort_qfs_QualifiedFeature_mandatory_Qualifier> }
);

export type ConversationDdFragment_DDResponse_clustersToConsider_DiseaseCluster = (
  { __typename?: 'DiseaseCluster' }
  & Pick<DiseaseCluster, 'id' | 'crIds' | 'sortType' | 'bestCrId' | 'flags' | 'urgencyId'>
  & { scores?: Maybe<ConversationDdFragment_DDResponse_clustersToConsider_DiseaseCluster_scores_ScoreByType>, title?: Maybe<ConversationDdFragment_DDResponse_clustersToConsider_DiseaseCluster_title_QualifiedFeature> }
);

export type ConversationDdFragment = (
  { __typename?: 'DDResponse' }
  & Pick<DdResponse, 'options'>
  & { allFindings?: Maybe<Array<Maybe<ConversationDdFragment_DDResponse_allFindings_QualifiedFeature>>>, clinicalReasoning?: Maybe<Array<Maybe<ConversationDdFragment_DDResponse_clinicalReasoning_ClinicalReasoning>>>, clustersToConsider?: Maybe<Array<Maybe<ConversationDdFragment_DDResponse_clustersToConsider_DiseaseCluster>>> }
);

export type ConversationNextSuggestionsFragment_PatientSuggestions_clusters_DiseaseCluster_title_QualifiedFeature = (
  { __typename?: 'QualifiedFeature' }
  & Pick<QualifiedFeature, 'id' | 'name' | 'negate' | 'skip'>
  & { feature?: Maybe<FindingMetricsFragment_DiseaseFindingMetrics_finding_RCohort_qfs_QualifiedFeature_feature_Feature>, qualifiers?: Maybe<Array<Maybe<FindingMetricsFragment_DiseaseFindingMetrics_finding_RCohort_qfs_QualifiedFeature_qualifiers_Qualifier>>>, mandatory?: Maybe<FindingMetricsFragment_DiseaseFindingMetrics_finding_RCohort_qfs_QualifiedFeature_mandatory_Qualifier> }
);

export type ConversationNextSuggestionsFragment_PatientSuggestions_clusters_DiseaseCluster = (
  { __typename?: 'DiseaseCluster' }
  & Pick<DiseaseCluster, 'id' | 'crIds' | 'sortType'>
  & { title?: Maybe<ConversationNextSuggestionsFragment_PatientSuggestions_clusters_DiseaseCluster_title_QualifiedFeature> }
);

export type ConversationNextSuggestionsFragment_PatientSuggestions_diseases_DiseaseForPlan_disease_QualifiedFeature_feature_Feature = (
  { __typename?: 'Feature' }
  & Pick<Feature, 'urgencyId'>
);

export type ConversationNextSuggestionsFragment_PatientSuggestions_diseases_DiseaseForPlan_disease_QualifiedFeature = (
  { __typename?: 'QualifiedFeature' }
  & Pick<QualifiedFeature, 'id' | 'name'>
  & { feature?: Maybe<ConversationNextSuggestionsFragment_PatientSuggestions_diseases_DiseaseForPlan_disease_QualifiedFeature_feature_Feature> }
);

export type ConversationNextSuggestionsFragment_PatientSuggestions_diseases_DiseaseForPlan_complicationOf_QualifiedFeature = (
  { __typename?: 'QualifiedFeature' }
  & Pick<QualifiedFeature, 'id' | 'name'>
);

export type ConversationNextSuggestionsFragment_PatientSuggestions_diseases_DiseaseForPlan_complicationOfObj_EtiologiesOfComplication_etiologies_EtiologyOfComplication_disease_QualifiedFeature = (
  { __typename?: 'QualifiedFeature' }
  & Pick<QualifiedFeature, 'name' | 'id'>
);

export type ConversationNextSuggestionsFragment_PatientSuggestions_diseases_DiseaseForPlan_complicationOfObj_EtiologiesOfComplication_etiologies_EtiologyOfComplication = (
  { __typename?: 'EtiologyOfComplication' }
  & Pick<EtiologyOfComplication, 'sensitivity'>
  & { disease?: Maybe<ConversationNextSuggestionsFragment_PatientSuggestions_diseases_DiseaseForPlan_complicationOfObj_EtiologiesOfComplication_etiologies_EtiologyOfComplication_disease_QualifiedFeature> }
);

export type ConversationNextSuggestionsFragment_PatientSuggestions_diseases_DiseaseForPlan_complicationOfObj_EtiologiesOfComplication = (
  { __typename?: 'EtiologiesOfComplication' }
  & { etiologies?: Maybe<Array<Maybe<ConversationNextSuggestionsFragment_PatientSuggestions_diseases_DiseaseForPlan_complicationOfObj_EtiologiesOfComplication_etiologies_EtiologyOfComplication>>> }
);

export type ConversationNextSuggestionsFragment_PatientSuggestions_diseases_DiseaseForPlan_diseaseCitations_Citations = (
  { __typename?: 'Citations' }
  & Pick<Citations, 'totalCount'>
  & { citationsData?: Maybe<Array<Maybe<DiseaseReferenceDataFragment_DiseaseReference_citations_Citations_citationsData_CitationData>>> }
);

export type ConversationNextSuggestionsFragment_PatientSuggestions_diseases_DiseaseForPlan_crFindings_ClinicalReasoningFinding_finding_QualifiedFeature = (
  { __typename?: 'QualifiedFeature' }
  & Pick<QualifiedFeature, 'id' | 'name' | 'negate' | 'skip'>
  & { feature?: Maybe<FindingMetricsFragment_DiseaseFindingMetrics_finding_RCohort_qfs_QualifiedFeature_feature_Feature>, qualifiers?: Maybe<Array<Maybe<FindingMetricsFragment_DiseaseFindingMetrics_finding_RCohort_qfs_QualifiedFeature_qualifiers_Qualifier>>>, mandatory?: Maybe<FindingMetricsFragment_DiseaseFindingMetrics_finding_RCohort_qfs_QualifiedFeature_mandatory_Qualifier> }
);

export type ConversationNextSuggestionsFragment_PatientSuggestions_diseases_DiseaseForPlan_crFindings_ClinicalReasoningFinding_gfinding_GroupedFeatureResponse = (
  { __typename?: 'GroupedFeatureResponse' }
  & Pick<GroupedFeatureResponse, 'skip' | 'source' | 'group' | 'validation'>
  & { feature?: Maybe<GroupedFeatureResponseFragment_GroupedFeatureResponse_feature_QualifiedFeature> }
);

export type ConversationNextSuggestionsFragment_PatientSuggestions_diseases_DiseaseForPlan_crFindings_ClinicalReasoningFinding = (
  { __typename?: 'ClinicalReasoningFinding' }
  & Pick<ClinicalReasoningFinding, 'score' | 'absolutePredictiveValue' | 'likelihoodRatio'>
  & { finding?: Maybe<ConversationNextSuggestionsFragment_PatientSuggestions_diseases_DiseaseForPlan_crFindings_ClinicalReasoningFinding_finding_QualifiedFeature>, gfinding?: Maybe<ConversationNextSuggestionsFragment_PatientSuggestions_diseases_DiseaseForPlan_crFindings_ClinicalReasoningFinding_gfinding_GroupedFeatureResponse> }
);

export type ConversationNextSuggestionsFragment_PatientSuggestions_diseases_DiseaseForPlan = (
  { __typename?: 'DiseaseForPlan' }
  & Pick<DiseaseForPlan, 'crId' | 'prob' | 'inTopCRPerSortType' | 'selectedBySortType' | 'patientIncidence'>
  & { disease?: Maybe<ConversationNextSuggestionsFragment_PatientSuggestions_diseases_DiseaseForPlan_disease_QualifiedFeature>, complicationOf?: Maybe<ConversationNextSuggestionsFragment_PatientSuggestions_diseases_DiseaseForPlan_complicationOf_QualifiedFeature>, complicationOfObj?: Maybe<ConversationNextSuggestionsFragment_PatientSuggestions_diseases_DiseaseForPlan_complicationOfObj_EtiologiesOfComplication>, diseaseCitations?: Maybe<ConversationNextSuggestionsFragment_PatientSuggestions_diseases_DiseaseForPlan_diseaseCitations_Citations>, crFindings?: Maybe<Array<Maybe<ConversationNextSuggestionsFragment_PatientSuggestions_diseases_DiseaseForPlan_crFindings_ClinicalReasoningFinding>>> }
);

export type ConversationNextSuggestionsFragment_PatientSuggestions_suggestions_PatientSuggestion_suggestion_QualifiedFeature = (
  { __typename?: 'QualifiedFeature' }
  & Pick<QualifiedFeature, 'id' | 'name' | 'negate' | 'skip'>
  & { feature?: Maybe<FindingMetricsFragment_DiseaseFindingMetrics_finding_RCohort_qfs_QualifiedFeature_feature_Feature>, qualifiers?: Maybe<Array<Maybe<FindingMetricsFragment_DiseaseFindingMetrics_finding_RCohort_qfs_QualifiedFeature_qualifiers_Qualifier>>>, mandatory?: Maybe<FindingMetricsFragment_DiseaseFindingMetrics_finding_RCohort_qfs_QualifiedFeature_mandatory_Qualifier> }
);

export type ConversationNextSuggestionsFragment_PatientSuggestions_suggestions_PatientSuggestion = (
  { __typename?: 'PatientSuggestion' }
  & Pick<PatientSuggestion, 'category' | 'entropy' | 'mutualInformation' | 'mutualInformationUrgencyDifferentiation' | 'findingProbability' | 'findingEntropy' | 'findingLeak' | 'findingLeakAdjustedEntropy' | 'defaultFindingGivenDisease' | 'defaultFindingGivenDiseaseAdjustedEntropy'>
  & { suggestion?: Maybe<ConversationNextSuggestionsFragment_PatientSuggestions_suggestions_PatientSuggestion_suggestion_QualifiedFeature>, perDiseaseMetrics?: Maybe<Array<Maybe<PatientSuggestionMiExplanationsFragment_PatientSuggestion_perDiseaseMetrics_SuggestionDiseaseMetric>>>, bestSubtype?: Maybe<PatientSuggestionMiExplanationsFragment_PatientSuggestion_bestSubtype_QualifiedFeature> }
);

export type ConversationNextSuggestionsFragment = (
  { __typename?: 'PatientSuggestions' }
  & MakeOptional<Pick<PatientSuggestions, 'debugReport'>, 'debugReport'>
  & { clusters?: Maybe<Array<Maybe<ConversationNextSuggestionsFragment_PatientSuggestions_clusters_DiseaseCluster>>>, diseases?: Maybe<Array<Maybe<ConversationNextSuggestionsFragment_PatientSuggestions_diseases_DiseaseForPlan>>>, suggestions?: Maybe<Array<Maybe<ConversationNextSuggestionsFragment_PatientSuggestions_suggestions_PatientSuggestion>>> }
);

export type GraphFragment_Graph_nodes_Node_qfs_QualifiedFeature = (
  { __typename?: 'QualifiedFeature' }
  & Pick<QualifiedFeature, 'id' | 'name' | 'negate' | 'skip'>
  & { feature?: Maybe<FindingMetricsFragment_DiseaseFindingMetrics_finding_RCohort_qfs_QualifiedFeature_feature_Feature>, qualifiers?: Maybe<Array<Maybe<FindingMetricsFragment_DiseaseFindingMetrics_finding_RCohort_qfs_QualifiedFeature_qualifiers_Qualifier>>>, mandatory?: Maybe<FindingMetricsFragment_DiseaseFindingMetrics_finding_RCohort_qfs_QualifiedFeature_mandatory_Qualifier> }
);

export type GraphFragment_Graph_nodes_Node_percentRange_Range = (
  { __typename?: 'Range' }
  & Pick<Range, 'min' | 'max'>
);

export type GraphFragment_Graph_nodes_Node_sourceQF_QualifiedFeature = (
  { __typename?: 'QualifiedFeature' }
  & Pick<QualifiedFeature, 'id' | 'name' | 'negate' | 'skip'>
  & { feature?: Maybe<FindingMetricsFragment_DiseaseFindingMetrics_finding_RCohort_qfs_QualifiedFeature_feature_Feature>, qualifiers?: Maybe<Array<Maybe<FindingMetricsFragment_DiseaseFindingMetrics_finding_RCohort_qfs_QualifiedFeature_qualifiers_Qualifier>>>, mandatory?: Maybe<FindingMetricsFragment_DiseaseFindingMetrics_finding_RCohort_qfs_QualifiedFeature_mandatory_Qualifier> }
);

export type GraphFragment_Graph_nodes_Node = (
  { __typename?: 'Node' }
  & Pick<Node, 'id' | 'probability' | 'isConnected' | 'type' | 'sourceQFIndex'>
  & { qfs?: Maybe<Array<Maybe<GraphFragment_Graph_nodes_Node_qfs_QualifiedFeature>>>, percentRange?: Maybe<GraphFragment_Graph_nodes_Node_percentRange_Range>, sourceQF?: Maybe<GraphFragment_Graph_nodes_Node_sourceQF_QualifiedFeature> }
);

export type GraphFragment_Graph_edges_Edge = (
  { __typename?: 'Edge' }
  & Pick<Edge, 'id' | 'sourceID' | 'targetID' | 'prob' | 'lift' | 'type' | 'usedInComputation' | 'ruleValueId'>
);

export type GraphFragment = (
  { __typename?: 'Graph' }
  & { nodes?: Maybe<Array<Maybe<GraphFragment_Graph_nodes_Node>>>, edges?: Maybe<Array<Maybe<GraphFragment_Graph_edges_Edge>>> }
);

export type CategoryFragment = (
  { __typename?: 'Feature' }
  & Pick<Feature, 'name' | 'id' | 'shortname'>
);

export type PanelFragment_Panel_category_Feature = (
  { __typename?: 'Feature' }
  & Pick<Feature, 'name' | 'id' | 'shortname'>
);

export type PanelFragment_Panel_panelGroup_Feature = (
  { __typename?: 'Feature' }
  & Pick<Feature, 'name' | 'id' | 'shortname'>
);

export type PanelFragment_Panel_panelSubgroup_Feature = (
  { __typename?: 'Feature' }
  & Pick<Feature, 'name' | 'id' | 'shortname'>
);

export type PanelFragment_Panel_findings_QualifiedFeature = (
  { __typename?: 'QualifiedFeature' }
  & Pick<QualifiedFeature, 'id' | 'name' | 'negate' | 'skip'>
  & { feature?: Maybe<FindingMetricsFragment_DiseaseFindingMetrics_finding_RCohort_qfs_QualifiedFeature_feature_Feature>, qualifiers?: Maybe<Array<Maybe<FindingMetricsFragment_DiseaseFindingMetrics_finding_RCohort_qfs_QualifiedFeature_qualifiers_Qualifier>>>, mandatory?: Maybe<FindingMetricsFragment_DiseaseFindingMetrics_finding_RCohort_qfs_QualifiedFeature_mandatory_Qualifier> }
);

export type PanelFragment = (
  { __typename?: 'Panel' }
  & Pick<Panel, 'name' | 'id' | 'shortname'>
  & { category?: Maybe<PanelFragment_Panel_category_Feature>, panelGroup?: Maybe<PanelFragment_Panel_panelGroup_Feature>, panelSubgroup?: Maybe<PanelFragment_Panel_panelSubgroup_Feature>, findings?: Maybe<Array<Maybe<PanelFragment_Panel_findings_QualifiedFeature>>> }
);

export type PatientFirstSummaryFragment_SummeryData_visitReason_SummaryVisitReason = (
  { __typename?: 'SummaryVisitReason' }
  & Pick<SummaryVisitReason, 'id' | 'name'>
);

export type PatientFirstSummaryFragment_SummeryData_sections_SummerySection = (
  { __typename?: 'SummerySection' }
  & Pick<SummerySection, 'content' | 'title' | 'type'>
);

export type PatientFirstSummaryFragment = (
  { __typename?: 'SummeryData' }
  & Pick<SummeryData, 'age' | 'gender' | 'main'>
  & { visitReason?: Maybe<Array<Maybe<PatientFirstSummaryFragment_SummeryData_visitReason_SummaryVisitReason>>>, sections?: Maybe<Array<Maybe<PatientFirstSummaryFragment_SummeryData_sections_SummerySection>>> }
);

export type ConversationSuggestionFragment_PatientSuggestion_suggestion_QualifiedFeature = (
  { __typename?: 'QualifiedFeature' }
  & Pick<QualifiedFeature, 'id' | 'name' | 'negate' | 'skip'>
  & { feature?: Maybe<FindingMetricsFragment_DiseaseFindingMetrics_finding_RCohort_qfs_QualifiedFeature_feature_Feature>, qualifiers?: Maybe<Array<Maybe<FindingMetricsFragment_DiseaseFindingMetrics_finding_RCohort_qfs_QualifiedFeature_qualifiers_Qualifier>>>, mandatory?: Maybe<FindingMetricsFragment_DiseaseFindingMetrics_finding_RCohort_qfs_QualifiedFeature_mandatory_Qualifier> }
);

export type ConversationSuggestionFragment_PatientSuggestion_refinements_QualifiedFeature = (
  { __typename?: 'QualifiedFeature' }
  & Pick<QualifiedFeature, 'id' | 'name' | 'negate' | 'skip'>
  & { feature?: Maybe<FindingMetricsFragment_DiseaseFindingMetrics_finding_RCohort_qfs_QualifiedFeature_feature_Feature>, qualifiers?: Maybe<Array<Maybe<FindingMetricsFragment_DiseaseFindingMetrics_finding_RCohort_qfs_QualifiedFeature_qualifiers_Qualifier>>>, mandatory?: Maybe<FindingMetricsFragment_DiseaseFindingMetrics_finding_RCohort_qfs_QualifiedFeature_mandatory_Qualifier> }
);

export type ConversationSuggestionFragment = (
  { __typename?: 'PatientSuggestion' }
  & Pick<PatientSuggestion, 'questionType' | 'entropy' | 'entropyYes' | 'entropyNo' | 'mutualInformation' | 'mutualInformationUrgencyDifferentiation' | 'expectation' | 'findingProbability' | 'findingEntropy' | 'findingLeak' | 'findingLeakAdjustedEntropy' | 'defaultFindingGivenDisease' | 'defaultFindingGivenDiseaseAdjustedEntropy'>
  & { suggestion?: Maybe<ConversationSuggestionFragment_PatientSuggestion_suggestion_QualifiedFeature>, refinements?: Maybe<Array<Maybe<ConversationSuggestionFragment_PatientSuggestion_refinements_QualifiedFeature>>>, perDiseaseMetrics?: Maybe<Array<Maybe<PatientSuggestionMiExplanationsFragment_PatientSuggestion_perDiseaseMetrics_SuggestionDiseaseMetric>>>, bestSubtype?: Maybe<PatientSuggestionMiExplanationsFragment_PatientSuggestion_bestSubtype_QualifiedFeature> }
);

export type ShareCodeDataFragmentFragment = (
  { __typename?: 'ShareCodeData' }
  & Pick<ShareCodeData, 'id' | 'date' | 'shareid' | 'seen' | 'digitCode' | 'comment'>
);

export type VisitStatusFragmentFragment_VisitStatusStructure_visitReason_Feature = (
  { __typename?: 'Feature' }
  & Pick<Feature, 'id' | 'name'>
);

export type VisitStatusFragmentFragment_VisitStatusStructure_chiefComplaint_Feature = (
  { __typename?: 'Feature' }
  & Pick<Feature, 'id' | 'name' | 'shortname'>
);

export type VisitStatusFragmentFragment = (
  { __typename?: 'VisitStatusStructure' }
  & Pick<VisitStatusStructure, 'age' | 'gender' | 'status'>
  & { visitReason?: Maybe<Array<Maybe<VisitStatusFragmentFragment_VisitStatusStructure_visitReason_Feature>>>, chiefComplaint?: Maybe<VisitStatusFragmentFragment_VisitStatusStructure_chiefComplaint_Feature> }
);

export type CreateCodeDataFragmentFragment = (
  { __typename?: 'CreatedCode' }
  & Pick<CreatedCode, 'id' | 'ehrid' | 'shareid' | 'digitCode'>
);

export type ConversationRecommendationFragment_PolicyRecommendation_feature_QualifiedFeature = (
  { __typename?: 'QualifiedFeature' }
  & Pick<QualifiedFeature, 'id' | 'name' | 'negate' | 'skip'>
  & { feature?: Maybe<FindingMetricsFragment_DiseaseFindingMetrics_finding_RCohort_qfs_QualifiedFeature_feature_Feature>, qualifiers?: Maybe<Array<Maybe<FindingMetricsFragment_DiseaseFindingMetrics_finding_RCohort_qfs_QualifiedFeature_qualifiers_Qualifier>>>, mandatory?: Maybe<FindingMetricsFragment_DiseaseFindingMetrics_finding_RCohort_qfs_QualifiedFeature_mandatory_Qualifier> }
);

export type ConversationRecommendationFragment = (
  { __typename?: 'PolicyRecommendation' }
  & Pick<PolicyRecommendation, 'policyName' | 'policyid' | 'protocolid' | 'protocolName'>
  & { feature?: Maybe<ConversationRecommendationFragment_PolicyRecommendation_feature_QualifiedFeature> }
);

export type ConversationInfoMessageFragment = (
  { __typename?: 'ConversationInfoMessage' }
  & Pick<ConversationInfoMessage, 'id' | 'infoText' | 'type' | 'confirm' | 'confirmText'>
);

export type ConversationExchangeResultFragment_ConversationExchange_question_ConversationQuestion_suggestions_PatientSuggestion = (
  { __typename?: 'PatientSuggestion' }
  & Pick<PatientSuggestion, 'questionType' | 'entropy' | 'entropyYes' | 'entropyNo' | 'mutualInformation' | 'mutualInformationUrgencyDifferentiation' | 'expectation' | 'findingProbability' | 'findingEntropy' | 'findingLeak' | 'findingLeakAdjustedEntropy' | 'defaultFindingGivenDisease' | 'defaultFindingGivenDiseaseAdjustedEntropy'>
  & { suggestion?: Maybe<ConversationSuggestionFragment_PatientSuggestion_suggestion_QualifiedFeature>, refinements?: Maybe<Array<Maybe<ConversationSuggestionFragment_PatientSuggestion_refinements_QualifiedFeature>>>, perDiseaseMetrics?: Maybe<Array<Maybe<PatientSuggestionMiExplanationsFragment_PatientSuggestion_perDiseaseMetrics_SuggestionDiseaseMetric>>>, bestSubtype?: Maybe<PatientSuggestionMiExplanationsFragment_PatientSuggestion_bestSubtype_QualifiedFeature> }
);

export type ConversationExchangeResultFragment_ConversationExchange_question_ConversationQuestion = (
  { __typename?: 'ConversationQuestion' }
  & Pick<ConversationQuestion, 'questionType' | 'basedOnReasoning'>
  & { suggestions?: Maybe<Array<Maybe<ConversationExchangeResultFragment_ConversationExchange_question_ConversationQuestion_suggestions_PatientSuggestion>>> }
);

export type ConversationExchangeResultFragment_ConversationExchange_answer_ConversationExchangeAnswer_finding_QualifiedFeature_feature_Feature = (
  { __typename?: 'Feature' }
  & Pick<Feature, 'name' | 'id' | 'shortname' | 'patientDescription' | 'alias' | 'skipDuration' | 'hasRefinement'>
  & { organSystem?: Maybe<FindingMetricsFragment_DiseaseFindingMetrics_finding_RCohort_qfs_QualifiedFeature_feature_Feature_organSystem_Feature>, category?: Maybe<FindingMetricsFragment_DiseaseFindingMetrics_finding_RCohort_qfs_QualifiedFeature_feature_Feature_category_Feature>, qualifierSpec?: Maybe<Array<Maybe<FindingMetricsFragment_DiseaseFindingMetrics_finding_RCohort_qfs_QualifiedFeature_feature_Feature_qualifierSpec_QualifierSpec>>>, description?: Maybe<FindingMetricsFragment_DiseaseFindingMetrics_finding_RCohort_qfs_QualifiedFeature_feature_Feature_description_Description>, range?: Maybe<FindingMetricsFragment_DiseaseFindingMetrics_finding_RCohort_qfs_QualifiedFeature_feature_Feature_range_MeasurementRange>, inferredParents?: Maybe<Array<Maybe<FindingMetricsFragment_DiseaseFindingMetrics_finding_RCohort_qfs_QualifiedFeature_feature_Feature_inferredParents_Feature>>>, inferredChildren?: Maybe<Array<Maybe<FindingMetricsFragment_DiseaseFindingMetrics_finding_RCohort_qfs_QualifiedFeature_feature_Feature_inferredChildren_Feature>>>, qualifiers?: Maybe<Array<Maybe<FindingMetricsFragment_DiseaseFindingMetrics_finding_RCohort_qfs_QualifiedFeature_feature_Feature_qualifiers_Qualifier>>>, inferredQualifiers?: Maybe<Array<Maybe<FindingMetricsFragment_DiseaseFindingMetrics_finding_RCohort_qfs_QualifiedFeature_feature_Feature_inferredQualifiers_Qualifier>>> }
);

export type ConversationExchangeResultFragment_ConversationExchange_answer_ConversationExchangeAnswer_finding_QualifiedFeature_qualifiers_Qualifier_relation_Relation = (
  { __typename?: 'Relation' }
  & Pick<Relation, 'name' | 'id' | 'type' | 'multi'>
);

export type ConversationExchangeResultFragment_ConversationExchange_answer_ConversationExchangeAnswer_finding_QualifiedFeature_qualifiers_Qualifier_value_Feature_category_Feature = (
  { __typename?: 'Feature' }
  & Pick<Feature, 'id' | 'name' | 'shortname'>
);

export type ConversationExchangeResultFragment_ConversationExchange_answer_ConversationExchangeAnswer_finding_QualifiedFeature_qualifiers_Qualifier_value_Feature_range_MeasurementRange = (
  { __typename?: 'MeasurementRange' }
  & Pick<MeasurementRange, 'low' | 'high' | 'units'>
  & { complexUnits?: Maybe<FindingMetricsFragment_DiseaseFindingMetrics_finding_RCohort_qfs_QualifiedFeature_feature_Feature_range_MeasurementRange_complexUnits_ComplexUnits> }
);

export type ConversationExchangeResultFragment_ConversationExchange_answer_ConversationExchangeAnswer_finding_QualifiedFeature_qualifiers_Qualifier_value_Feature_parents_FeatureSet_features_Feature = (
  { __typename?: 'Feature' }
  & Pick<Feature, 'id' | 'name' | 'childrenSetType'>
);

export type ConversationExchangeResultFragment_ConversationExchange_answer_ConversationExchangeAnswer_finding_QualifiedFeature_qualifiers_Qualifier_value_Feature_parents_FeatureSet = (
  { __typename?: 'FeatureSet' }
  & { features?: Maybe<Array<Maybe<ConversationExchangeResultFragment_ConversationExchange_answer_ConversationExchangeAnswer_finding_QualifiedFeature_qualifiers_Qualifier_value_Feature_parents_FeatureSet_features_Feature>>> }
);

export type ConversationExchangeResultFragment_ConversationExchange_answer_ConversationExchangeAnswer_finding_QualifiedFeature_qualifiers_Qualifier_value_Feature_description_Description = (
  { __typename?: 'Description' }
  & Pick<Description, 'text'>
);

export type ConversationExchangeResultFragment_ConversationExchange_answer_ConversationExchangeAnswer_finding_QualifiedFeature_qualifiers_Qualifier_value_Feature = (
  { __typename?: 'Feature' }
  & Pick<Feature, 'name' | 'shortname' | 'id' | 'patientDescription'>
  & { category?: Maybe<ConversationExchangeResultFragment_ConversationExchange_answer_ConversationExchangeAnswer_finding_QualifiedFeature_qualifiers_Qualifier_value_Feature_category_Feature>, range?: Maybe<ConversationExchangeResultFragment_ConversationExchange_answer_ConversationExchangeAnswer_finding_QualifiedFeature_qualifiers_Qualifier_value_Feature_range_MeasurementRange>, parents?: Maybe<ConversationExchangeResultFragment_ConversationExchange_answer_ConversationExchangeAnswer_finding_QualifiedFeature_qualifiers_Qualifier_value_Feature_parents_FeatureSet>, description?: Maybe<ConversationExchangeResultFragment_ConversationExchange_answer_ConversationExchangeAnswer_finding_QualifiedFeature_qualifiers_Qualifier_value_Feature_description_Description> }
);

export type ConversationExchangeResultFragment_ConversationExchange_answer_ConversationExchangeAnswer_finding_QualifiedFeature_qualifiers_Qualifier_range_MeasurementRange = (
  { __typename?: 'MeasurementRange' }
  & Pick<MeasurementRange, 'low' | 'high' | 'units'>
  & { complexUnits?: Maybe<FindingMetricsFragment_DiseaseFindingMetrics_finding_RCohort_qfs_QualifiedFeature_feature_Feature_range_MeasurementRange_complexUnits_ComplexUnits> }
);

export type ConversationExchangeResultFragment_ConversationExchange_answer_ConversationExchangeAnswer_finding_QualifiedFeature_qualifiers_Qualifier = (
  { __typename?: 'Qualifier' }
  & Pick<Qualifier, 'source' | 'name' | 'negate' | 'freeText'>
  & { relation: ConversationExchangeResultFragment_ConversationExchange_answer_ConversationExchangeAnswer_finding_QualifiedFeature_qualifiers_Qualifier_relation_Relation, value?: Maybe<ConversationExchangeResultFragment_ConversationExchange_answer_ConversationExchangeAnswer_finding_QualifiedFeature_qualifiers_Qualifier_value_Feature>, range?: Maybe<ConversationExchangeResultFragment_ConversationExchange_answer_ConversationExchangeAnswer_finding_QualifiedFeature_qualifiers_Qualifier_range_MeasurementRange> }
);

export type ConversationExchangeResultFragment_ConversationExchange_answer_ConversationExchangeAnswer_finding_QualifiedFeature_mandatory_Qualifier_relation_Relation = (
  { __typename?: 'Relation' }
  & Pick<Relation, 'name' | 'id' | 'type'>
);

export type ConversationExchangeResultFragment_ConversationExchange_answer_ConversationExchangeAnswer_finding_QualifiedFeature_mandatory_Qualifier_value_Feature = (
  { __typename?: 'Feature' }
  & Pick<Feature, 'name' | 'id'>
);

export type ConversationExchangeResultFragment_ConversationExchange_answer_ConversationExchangeAnswer_finding_QualifiedFeature_mandatory_Qualifier_range_MeasurementRange = (
  { __typename?: 'MeasurementRange' }
  & Pick<MeasurementRange, 'low' | 'high' | 'units'>
  & { complexUnits?: Maybe<FindingMetricsFragment_DiseaseFindingMetrics_finding_RCohort_qfs_QualifiedFeature_feature_Feature_range_MeasurementRange_complexUnits_ComplexUnits> }
);

export type ConversationExchangeResultFragment_ConversationExchange_answer_ConversationExchangeAnswer_finding_QualifiedFeature_mandatory_Qualifier = (
  { __typename?: 'Qualifier' }
  & Pick<Qualifier, 'freeText'>
  & { relation: ConversationExchangeResultFragment_ConversationExchange_answer_ConversationExchangeAnswer_finding_QualifiedFeature_mandatory_Qualifier_relation_Relation, value?: Maybe<ConversationExchangeResultFragment_ConversationExchange_answer_ConversationExchangeAnswer_finding_QualifiedFeature_mandatory_Qualifier_value_Feature>, range?: Maybe<ConversationExchangeResultFragment_ConversationExchange_answer_ConversationExchangeAnswer_finding_QualifiedFeature_mandatory_Qualifier_range_MeasurementRange> }
);

export type ConversationExchangeResultFragment_ConversationExchange_answer_ConversationExchangeAnswer_finding_QualifiedFeature = (
  { __typename?: 'QualifiedFeature' }
  & Pick<QualifiedFeature, 'id' | 'name' | 'negate' | 'skip'>
  & { feature?: Maybe<ConversationExchangeResultFragment_ConversationExchange_answer_ConversationExchangeAnswer_finding_QualifiedFeature_feature_Feature>, qualifiers?: Maybe<Array<Maybe<ConversationExchangeResultFragment_ConversationExchange_answer_ConversationExchangeAnswer_finding_QualifiedFeature_qualifiers_Qualifier>>>, mandatory?: Maybe<ConversationExchangeResultFragment_ConversationExchange_answer_ConversationExchangeAnswer_finding_QualifiedFeature_mandatory_Qualifier> }
);

export type ConversationExchangeResultFragment_ConversationExchange_answer_ConversationExchangeAnswer = (
  { __typename?: 'ConversationExchangeAnswer' }
  & Pick<ConversationExchangeAnswer, 'suggestionId' | 'refinementId' | 'patientAnswer'>
  & { finding?: Maybe<ConversationExchangeResultFragment_ConversationExchange_answer_ConversationExchangeAnswer_finding_QualifiedFeature> }
);

export type ConversationExchangeResultFragment_ConversationExchange_state_ConversationState_nextSuggestions_PatientSuggestions_diseases_DiseaseForPlan_disease_QualifiedFeature = (
  { __typename?: 'QualifiedFeature' }
  & Pick<QualifiedFeature, 'id' | 'name'>
);

export type ConversationExchangeResultFragment_ConversationExchange_state_ConversationState_nextSuggestions_PatientSuggestions_diseases_DiseaseForPlan = (
  { __typename?: 'DiseaseForPlan' }
  & Pick<DiseaseForPlan, 'prob'>
  & { disease?: Maybe<ConversationExchangeResultFragment_ConversationExchange_state_ConversationState_nextSuggestions_PatientSuggestions_diseases_DiseaseForPlan_disease_QualifiedFeature> }
);

export type ConversationExchangeResultFragment_ConversationExchange_state_ConversationState_nextSuggestions_PatientSuggestions_suggestions_PatientSuggestion_perDiseaseMetrics_SuggestionDiseaseMetric_suggestion_QualifiedFeature = (
  { __typename?: 'QualifiedFeature' }
  & Pick<QualifiedFeature, 'id'>
);

export type ConversationExchangeResultFragment_ConversationExchange_state_ConversationState_nextSuggestions_PatientSuggestions_suggestions_PatientSuggestion_perDiseaseMetrics_SuggestionDiseaseMetric_disease_QualifiedFeature = (
  { __typename?: 'QualifiedFeature' }
  & Pick<QualifiedFeature, 'id'>
);

export type ConversationExchangeResultFragment_ConversationExchange_state_ConversationState_nextSuggestions_PatientSuggestions_suggestions_PatientSuggestion_perDiseaseMetrics_SuggestionDiseaseMetric = (
  { __typename?: 'SuggestionDiseaseMetric' }
  & Pick<SuggestionDiseaseMetric, 'findingGivenDisease'>
  & { suggestion?: Maybe<ConversationExchangeResultFragment_ConversationExchange_state_ConversationState_nextSuggestions_PatientSuggestions_suggestions_PatientSuggestion_perDiseaseMetrics_SuggestionDiseaseMetric_suggestion_QualifiedFeature>, disease?: Maybe<ConversationExchangeResultFragment_ConversationExchange_state_ConversationState_nextSuggestions_PatientSuggestions_suggestions_PatientSuggestion_perDiseaseMetrics_SuggestionDiseaseMetric_disease_QualifiedFeature> }
);

export type ConversationExchangeResultFragment_ConversationExchange_state_ConversationState_nextSuggestions_PatientSuggestions_suggestions_PatientSuggestion_suggestion_QualifiedFeature_qualifiers_Qualifier_relation_Relation = (
  { __typename?: 'Relation' }
  & Pick<Relation, 'id'>
);

export type ConversationExchangeResultFragment_ConversationExchange_state_ConversationState_nextSuggestions_PatientSuggestions_suggestions_PatientSuggestion_suggestion_QualifiedFeature_qualifiers_Qualifier_range_MeasurementRange = (
  { __typename?: 'MeasurementRange' }
  & Pick<MeasurementRange, 'low' | 'high' | 'units'>
);

export type ConversationExchangeResultFragment_ConversationExchange_state_ConversationState_nextSuggestions_PatientSuggestions_suggestions_PatientSuggestion_suggestion_QualifiedFeature_qualifiers_Qualifier = (
  { __typename?: 'Qualifier' }
  & Pick<Qualifier, 'name'>
  & { relation: ConversationExchangeResultFragment_ConversationExchange_state_ConversationState_nextSuggestions_PatientSuggestions_suggestions_PatientSuggestion_suggestion_QualifiedFeature_qualifiers_Qualifier_relation_Relation, range?: Maybe<ConversationExchangeResultFragment_ConversationExchange_state_ConversationState_nextSuggestions_PatientSuggestions_suggestions_PatientSuggestion_suggestion_QualifiedFeature_qualifiers_Qualifier_range_MeasurementRange> }
);

export type ConversationExchangeResultFragment_ConversationExchange_state_ConversationState_nextSuggestions_PatientSuggestions_suggestions_PatientSuggestion_suggestion_QualifiedFeature = (
  { __typename?: 'QualifiedFeature' }
  & Pick<QualifiedFeature, 'id' | 'name'>
  & { qualifiers?: Maybe<Array<Maybe<ConversationExchangeResultFragment_ConversationExchange_state_ConversationState_nextSuggestions_PatientSuggestions_suggestions_PatientSuggestion_suggestion_QualifiedFeature_qualifiers_Qualifier>>> }
);

export type ConversationExchangeResultFragment_ConversationExchange_state_ConversationState_nextSuggestions_PatientSuggestions_suggestions_PatientSuggestion = (
  { __typename?: 'PatientSuggestion' }
  & Pick<PatientSuggestion, 'findingEntropy' | 'findingLeak' | 'findingProbability' | 'category' | 'mutualInformation' | 'mutualInformationUrgencyDifferentiation'>
  & { perDiseaseMetrics?: Maybe<Array<Maybe<ConversationExchangeResultFragment_ConversationExchange_state_ConversationState_nextSuggestions_PatientSuggestions_suggestions_PatientSuggestion_perDiseaseMetrics_SuggestionDiseaseMetric>>>, suggestion?: Maybe<ConversationExchangeResultFragment_ConversationExchange_state_ConversationState_nextSuggestions_PatientSuggestions_suggestions_PatientSuggestion_suggestion_QualifiedFeature> }
);

export type ConversationExchangeResultFragment_ConversationExchange_state_ConversationState_nextSuggestions_PatientSuggestions = (
  { __typename?: 'PatientSuggestions' }
  & { diseases?: Maybe<Array<Maybe<ConversationExchangeResultFragment_ConversationExchange_state_ConversationState_nextSuggestions_PatientSuggestions_diseases_DiseaseForPlan>>>, suggestions?: Maybe<Array<Maybe<ConversationExchangeResultFragment_ConversationExchange_state_ConversationState_nextSuggestions_PatientSuggestions_suggestions_PatientSuggestion>>> }
);

export type ConversationExchangeResultFragment_ConversationExchange_state_ConversationState_diagnosis_ClinicalReasoning_disease_QualifiedFeature_feature_Feature_parents_FeatureSet_features_Feature = (
  { __typename?: 'Feature' }
  & Pick<Feature, 'id'>
);

export type ConversationExchangeResultFragment_ConversationExchange_state_ConversationState_diagnosis_ClinicalReasoning_disease_QualifiedFeature_feature_Feature_parents_FeatureSet = (
  { __typename?: 'FeatureSet' }
  & { features?: Maybe<Array<Maybe<ConversationExchangeResultFragment_ConversationExchange_state_ConversationState_diagnosis_ClinicalReasoning_disease_QualifiedFeature_feature_Feature_parents_FeatureSet_features_Feature>>> }
);

export type ConversationExchangeResultFragment_ConversationExchange_state_ConversationState_diagnosis_ClinicalReasoning_disease_QualifiedFeature_feature_Feature = (
  { __typename?: 'Feature' }
  & Pick<Feature, 'id'>
  & { parents?: Maybe<ConversationExchangeResultFragment_ConversationExchange_state_ConversationState_diagnosis_ClinicalReasoning_disease_QualifiedFeature_feature_Feature_parents_FeatureSet> }
);

export type ConversationExchangeResultFragment_ConversationExchange_state_ConversationState_diagnosis_ClinicalReasoning_disease_QualifiedFeature = (
  { __typename?: 'QualifiedFeature' }
  & Pick<QualifiedFeature, 'name'>
  & { feature?: Maybe<ConversationExchangeResultFragment_ConversationExchange_state_ConversationState_diagnosis_ClinicalReasoning_disease_QualifiedFeature_feature_Feature> }
);

export type ConversationExchangeResultFragment_ConversationExchange_state_ConversationState_diagnosis_ClinicalReasoning = (
  { __typename?: 'ClinicalReasoning' }
  & Pick<ClinicalReasoning, 'diseaseGivenDependentFindings' | 'urgency'>
  & { disease?: Maybe<Array<Maybe<ConversationExchangeResultFragment_ConversationExchange_state_ConversationState_diagnosis_ClinicalReasoning_disease_QualifiedFeature>>> }
);

export type ConversationExchangeResultFragment_ConversationExchange_state_ConversationState = (
  { __typename?: 'ConversationState' }
  & Pick<ConversationState, 'context' | 'entropy' | 'mutualInformation' | 'caseId'>
  & { nextSuggestions?: Maybe<ConversationExchangeResultFragment_ConversationExchange_state_ConversationState_nextSuggestions_PatientSuggestions>, diagnosis?: Maybe<Array<Maybe<ConversationExchangeResultFragment_ConversationExchange_state_ConversationState_diagnosis_ClinicalReasoning>>> }
);

export type ConversationExchangeResultFragment = (
  { __typename?: 'ConversationExchange' }
  & { question?: Maybe<ConversationExchangeResultFragment_ConversationExchange_question_ConversationQuestion>, answer?: Maybe<Array<Maybe<ConversationExchangeResultFragment_ConversationExchange_answer_ConversationExchangeAnswer>>>, state?: Maybe<ConversationExchangeResultFragment_ConversationExchange_state_ConversationState> }
);

export type ConversationNextQuestionFragment_ConversationQuestion_question_PatientQuestion = (
  { __typename?: 'PatientQuestion' }
  & Pick<PatientQuestion, 'text'>
);

export type ConversationNextQuestionFragment_ConversationQuestion_suggestions_PatientSuggestion_refinementLocationRange_Feature = (
  { __typename?: 'Feature' }
  & Pick<Feature, 'id' | 'name'>
);

export type ConversationNextQuestionFragment_ConversationQuestion_suggestions_PatientSuggestion_question_PatientQuestion = (
  { __typename?: 'PatientQuestion' }
  & Pick<PatientQuestion, 'text'>
);

export type ConversationNextQuestionFragment_ConversationQuestion_suggestions_PatientSuggestion_suggestion_QualifiedFeature = (
  { __typename?: 'QualifiedFeature' }
  & Pick<QualifiedFeature, 'id' | 'name' | 'negate' | 'skip'>
  & { feature?: Maybe<FindingMetricsFragment_DiseaseFindingMetrics_finding_RCohort_qfs_QualifiedFeature_feature_Feature>, qualifiers?: Maybe<Array<Maybe<FindingMetricsFragment_DiseaseFindingMetrics_finding_RCohort_qfs_QualifiedFeature_qualifiers_Qualifier>>>, mandatory?: Maybe<FindingMetricsFragment_DiseaseFindingMetrics_finding_RCohort_qfs_QualifiedFeature_mandatory_Qualifier> }
);

export type ConversationNextQuestionFragment_ConversationQuestion_suggestions_PatientSuggestion_refinements_QualifiedFeature = (
  { __typename?: 'QualifiedFeature' }
  & Pick<QualifiedFeature, 'id' | 'name' | 'negate' | 'skip'>
  & { feature?: Maybe<FindingMetricsFragment_DiseaseFindingMetrics_finding_RCohort_qfs_QualifiedFeature_feature_Feature>, qualifiers?: Maybe<Array<Maybe<FindingMetricsFragment_DiseaseFindingMetrics_finding_RCohort_qfs_QualifiedFeature_qualifiers_Qualifier>>>, mandatory?: Maybe<FindingMetricsFragment_DiseaseFindingMetrics_finding_RCohort_qfs_QualifiedFeature_mandatory_Qualifier> }
);

export type ConversationNextQuestionFragment_ConversationQuestion_suggestions_PatientSuggestion = (
  { __typename?: 'PatientSuggestion' }
  & Pick<PatientSuggestion, 'questionType' | 'canBeUnknown' | 'refinementQuestionType' | 'mutualInformation' | 'mutualInformationUrgencyDifferentiation' | 'findingProbability' | 'findingEntropy' | 'findingLeak' | 'findingLeakAdjustedEntropy' | 'defaultFindingGivenDisease' | 'defaultFindingGivenDiseaseAdjustedEntropy'>
  & { refinementLocationRange?: Maybe<ConversationNextQuestionFragment_ConversationQuestion_suggestions_PatientSuggestion_refinementLocationRange_Feature>, question?: Maybe<ConversationNextQuestionFragment_ConversationQuestion_suggestions_PatientSuggestion_question_PatientQuestion>, suggestion?: Maybe<ConversationNextQuestionFragment_ConversationQuestion_suggestions_PatientSuggestion_suggestion_QualifiedFeature>, refinements?: Maybe<Array<Maybe<ConversationNextQuestionFragment_ConversationQuestion_suggestions_PatientSuggestion_refinements_QualifiedFeature>>>, perDiseaseMetrics?: Maybe<Array<Maybe<PatientSuggestionMiExplanationsFragment_PatientSuggestion_perDiseaseMetrics_SuggestionDiseaseMetric>>>, bestSubtype?: Maybe<PatientSuggestionMiExplanationsFragment_PatientSuggestion_bestSubtype_QualifiedFeature> }
);

export type ConversationNextQuestionFragment = (
  { __typename?: 'ConversationQuestion' }
  & MakeOptional<Pick<ConversationQuestion, 'id' | 'questionType' | 'questionChoiceType' | 'description' | 'debugInfo' | 'elapsed' | 'basedOnReasoning'>, 'description' | 'debugInfo'>
  & { question?: Maybe<ConversationNextQuestionFragment_ConversationQuestion_question_PatientQuestion>, suggestions?: Maybe<Array<Maybe<ConversationNextQuestionFragment_ConversationQuestion_suggestions_PatientSuggestion>>> }
);

export type ConversationExchangeFragment_ConversationExchange_question_ConversationQuestion = (
  { __typename?: 'ConversationQuestion' }
  & MakeOptional<Pick<ConversationQuestion, 'id' | 'questionType' | 'questionChoiceType' | 'description' | 'debugInfo' | 'elapsed' | 'basedOnReasoning'>, 'description' | 'debugInfo'>
  & { question?: Maybe<ConversationNextQuestionFragment_ConversationQuestion_question_PatientQuestion>, suggestions?: Maybe<Array<Maybe<ConversationNextQuestionFragment_ConversationQuestion_suggestions_PatientSuggestion>>> }
);

export type ConversationExchangeFragment_ConversationExchange_answer_ConversationExchangeAnswer_finding_QualifiedFeature = (
  { __typename?: 'QualifiedFeature' }
  & Pick<QualifiedFeature, 'id' | 'name' | 'negate' | 'skip'>
  & { feature?: Maybe<FindingMetricsFragment_DiseaseFindingMetrics_finding_RCohort_qfs_QualifiedFeature_feature_Feature>, qualifiers?: Maybe<Array<Maybe<FindingMetricsFragment_DiseaseFindingMetrics_finding_RCohort_qfs_QualifiedFeature_qualifiers_Qualifier>>>, mandatory?: Maybe<FindingMetricsFragment_DiseaseFindingMetrics_finding_RCohort_qfs_QualifiedFeature_mandatory_Qualifier> }
);

export type ConversationExchangeFragment_ConversationExchange_answer_ConversationExchangeAnswer = (
  { __typename?: 'ConversationExchangeAnswer' }
  & Pick<ConversationExchangeAnswer, 'suggestionId' | 'refinementId' | 'patientAnswer' | 'findingAlias'>
  & { finding?: Maybe<ConversationExchangeFragment_ConversationExchange_answer_ConversationExchangeAnswer_finding_QualifiedFeature> }
);

export type ConversationExchangeFragment_ConversationExchange_messages_ConversationInfoMessage = (
  { __typename?: 'ConversationInfoMessage' }
  & Pick<ConversationInfoMessage, 'id' | 'infoText' | 'type' | 'confirm' | 'confirmText'>
);

export type ConversationExchangeFragment = (
  { __typename?: 'ConversationExchange' }
  & Pick<ConversationExchange, 'patientAnswer' | 'progress'>
  & { question?: Maybe<ConversationExchangeFragment_ConversationExchange_question_ConversationQuestion>, answer?: Maybe<Array<Maybe<ConversationExchangeFragment_ConversationExchange_answer_ConversationExchangeAnswer>>>, messages?: Maybe<Array<Maybe<ConversationExchangeFragment_ConversationExchange_messages_ConversationInfoMessage>>> }
);

export type ConversationStateFragment_ConversationState_initialMessages_ConversationInfoMessage = (
  { __typename?: 'ConversationInfoMessage' }
  & Pick<ConversationInfoMessage, 'id' | 'infoText' | 'type' | 'confirm' | 'confirmText'>
);

export type ConversationStateFragment_ConversationState_urgent_DDUrgency = (
  { __typename?: 'DDUrgency' }
  & Pick<DdUrgency, 'urgencyLevelId'>
);

export type ConversationStateFragment_ConversationState_nextSuggestions_PatientSuggestions = (
  { __typename?: 'PatientSuggestions' }
  & MakeOptional<Pick<PatientSuggestions, 'debugReport'>, 'debugReport'>
  & { clusters?: Maybe<Array<Maybe<ConversationNextSuggestionsFragment_PatientSuggestions_clusters_DiseaseCluster>>>, diseases?: Maybe<Array<Maybe<ConversationNextSuggestionsFragment_PatientSuggestions_diseases_DiseaseForPlan>>>, suggestions?: Maybe<Array<Maybe<ConversationNextSuggestionsFragment_PatientSuggestions_suggestions_PatientSuggestion>>> }
);

export type ConversationStateFragment_ConversationState_ddClusters_DDResponse = (
  { __typename?: 'DDResponse' }
  & Pick<DdResponse, 'debugReport' | 'options'>
  & { allFindings?: Maybe<Array<Maybe<ConversationDdFragment_DDResponse_allFindings_QualifiedFeature>>>, clinicalReasoning?: Maybe<Array<Maybe<ConversationDdFragment_DDResponse_clinicalReasoning_ClinicalReasoning>>>, clustersToConsider?: Maybe<Array<Maybe<ConversationDdFragment_DDResponse_clustersToConsider_DiseaseCluster>>> }
);

export type ConversationStateFragment_ConversationState_recommendations_PolicyRecommendation = (
  { __typename?: 'PolicyRecommendation' }
  & Pick<PolicyRecommendation, 'policyName' | 'policyid' | 'protocolid' | 'protocolName'>
  & { feature?: Maybe<ConversationRecommendationFragment_PolicyRecommendation_feature_QualifiedFeature> }
);

export type ConversationStateFragment_ConversationState_navigationRecommendation_PolicyRecommendation = (
  { __typename?: 'PolicyRecommendation' }
  & Pick<PolicyRecommendation, 'policyName' | 'policyid' | 'protocolid' | 'protocolName'>
  & { feature?: Maybe<ConversationRecommendationFragment_PolicyRecommendation_feature_QualifiedFeature> }
);

export type ConversationStateFragment_ConversationState_patientFindings_GroupedFeatureResponse = (
  { __typename?: 'GroupedFeatureResponse' }
  & Pick<GroupedFeatureResponse, 'skip' | 'source' | 'group' | 'validation'>
  & { feature?: Maybe<GroupedFeatureResponseFragment_GroupedFeatureResponse_feature_QualifiedFeature> }
);

export type ConversationStateFragment_ConversationState_patientIcd_StateICDCodes_diseases_ICDCode_dueTo_QualifiedFeature = (
  { __typename?: 'QualifiedFeature' }
  & Pick<QualifiedFeature, 'id' | 'name' | 'negate' | 'skip'>
  & { feature?: Maybe<FindingMetricsFragment_DiseaseFindingMetrics_finding_RCohort_qfs_QualifiedFeature_feature_Feature>, qualifiers?: Maybe<Array<Maybe<FindingMetricsFragment_DiseaseFindingMetrics_finding_RCohort_qfs_QualifiedFeature_qualifiers_Qualifier>>>, mandatory?: Maybe<FindingMetricsFragment_DiseaseFindingMetrics_finding_RCohort_qfs_QualifiedFeature_mandatory_Qualifier> }
);

export type ConversationStateFragment_ConversationState_patientIcd_StateICDCodes_diseases_ICDCode = (
  { __typename?: 'ICDCode' }
  & Pick<IcdCode, 'code' | 'desc'>
  & { dueTo?: Maybe<Array<Maybe<ConversationStateFragment_ConversationState_patientIcd_StateICDCodes_diseases_ICDCode_dueTo_QualifiedFeature>>> }
);

export type ConversationStateFragment_ConversationState_patientIcd_StateICDCodes_findings_ICDCode_dueTo_QualifiedFeature = (
  { __typename?: 'QualifiedFeature' }
  & Pick<QualifiedFeature, 'id' | 'name' | 'negate' | 'skip'>
  & { feature?: Maybe<FindingMetricsFragment_DiseaseFindingMetrics_finding_RCohort_qfs_QualifiedFeature_feature_Feature>, qualifiers?: Maybe<Array<Maybe<FindingMetricsFragment_DiseaseFindingMetrics_finding_RCohort_qfs_QualifiedFeature_qualifiers_Qualifier>>>, mandatory?: Maybe<FindingMetricsFragment_DiseaseFindingMetrics_finding_RCohort_qfs_QualifiedFeature_mandatory_Qualifier> }
);

export type ConversationStateFragment_ConversationState_patientIcd_StateICDCodes_findings_ICDCode = (
  { __typename?: 'ICDCode' }
  & Pick<IcdCode, 'code' | 'desc'>
  & { dueTo?: Maybe<Array<Maybe<ConversationStateFragment_ConversationState_patientIcd_StateICDCodes_findings_ICDCode_dueTo_QualifiedFeature>>> }
);

export type ConversationStateFragment_ConversationState_patientIcd_StateICDCodes = (
  { __typename?: 'StateICDCodes' }
  & { diseases?: Maybe<Array<Maybe<ConversationStateFragment_ConversationState_patientIcd_StateICDCodes_diseases_ICDCode>>>, findings?: Maybe<Array<Maybe<ConversationStateFragment_ConversationState_patientIcd_StateICDCodes_findings_ICDCode>>> }
);

export type ConversationStateFragment = (
  { __typename?: 'ConversationState' }
  & MakeOptional<Pick<ConversationState, 'gender' | 'progress' | 'entropy' | 'context' | 'caseId' | 'caseReadOnly' | 'caseBasedOn' | 'options'>, 'entropy' | 'caseReadOnly' | 'caseBasedOn' | 'options'>
  & { initialMessages?: Maybe<Array<Maybe<ConversationStateFragment_ConversationState_initialMessages_ConversationInfoMessage>>>, urgent?: Maybe<ConversationStateFragment_ConversationState_urgent_DDUrgency>, nextSuggestions?: Maybe<ConversationStateFragment_ConversationState_nextSuggestions_PatientSuggestions>, ddClusters?: Maybe<ConversationStateFragment_ConversationState_ddClusters_DDResponse>, recommendations?: Maybe<Array<Maybe<ConversationStateFragment_ConversationState_recommendations_PolicyRecommendation>>>, navigationRecommendation?: Maybe<ConversationStateFragment_ConversationState_navigationRecommendation_PolicyRecommendation>, patientFindings?: Maybe<Array<Maybe<ConversationStateFragment_ConversationState_patientFindings_GroupedFeatureResponse>>>, patientIcd?: Maybe<ConversationStateFragment_ConversationState_patientIcd_StateICDCodes> }
);

export type ConversationStateNextQFragment_ConversationState_nextQuestion_ConversationQuestion = (
  { __typename?: 'ConversationQuestion' }
  & MakeOptional<Pick<ConversationQuestion, 'id' | 'questionType' | 'questionChoiceType' | 'description' | 'debugInfo' | 'elapsed' | 'basedOnReasoning'>, 'description' | 'debugInfo'>
  & { question?: Maybe<ConversationNextQuestionFragment_ConversationQuestion_question_PatientQuestion>, suggestions?: Maybe<Array<Maybe<ConversationNextQuestionFragment_ConversationQuestion_suggestions_PatientSuggestion>>> }
);

export type ConversationStateNextQFragment = (
  { __typename?: 'ConversationState' }
  & MakeOptional<Pick<ConversationState, 'gender' | 'progress' | 'entropy' | 'context' | 'caseId' | 'caseReadOnly' | 'caseBasedOn' | 'options'>, 'entropy' | 'caseReadOnly' | 'caseBasedOn' | 'options'>
  & { nextQuestion?: Maybe<ConversationStateNextQFragment_ConversationState_nextQuestion_ConversationQuestion>, initialMessages?: Maybe<Array<Maybe<ConversationStateFragment_ConversationState_initialMessages_ConversationInfoMessage>>>, urgent?: Maybe<ConversationStateFragment_ConversationState_urgent_DDUrgency>, nextSuggestions?: Maybe<ConversationStateFragment_ConversationState_nextSuggestions_PatientSuggestions>, ddClusters?: Maybe<ConversationStateFragment_ConversationState_ddClusters_DDResponse>, recommendations?: Maybe<Array<Maybe<ConversationStateFragment_ConversationState_recommendations_PolicyRecommendation>>>, navigationRecommendation?: Maybe<ConversationStateFragment_ConversationState_navigationRecommendation_PolicyRecommendation>, patientFindings?: Maybe<Array<Maybe<ConversationStateFragment_ConversationState_patientFindings_GroupedFeatureResponse>>>, patientIcd?: Maybe<ConversationStateFragment_ConversationState_patientIcd_StateICDCodes> }
);

export type ConversationStateNextResponseFragment_ConversationState_nextResponse_ConversationResponse_question_ConversationQuestion = (
  { __typename?: 'ConversationQuestion' }
  & MakeOptional<Pick<ConversationQuestion, 'id' | 'questionType' | 'questionChoiceType' | 'description' | 'debugInfo' | 'elapsed' | 'basedOnReasoning'>, 'description' | 'debugInfo'>
  & { question?: Maybe<ConversationNextQuestionFragment_ConversationQuestion_question_PatientQuestion>, suggestions?: Maybe<Array<Maybe<ConversationNextQuestionFragment_ConversationQuestion_suggestions_PatientSuggestion>>> }
);

export type ConversationStateNextResponseFragment_ConversationState_nextResponse_ConversationResponse_messages_ConversationInfoMessage = (
  { __typename?: 'ConversationInfoMessage' }
  & Pick<ConversationInfoMessage, 'id' | 'infoText' | 'type' | 'confirm' | 'confirmText'>
);

export type ConversationStateNextResponseFragment_ConversationState_nextResponse_ConversationResponse = (
  { __typename?: 'ConversationResponse' }
  & { question?: Maybe<ConversationStateNextResponseFragment_ConversationState_nextResponse_ConversationResponse_question_ConversationQuestion>, messages?: Maybe<Array<Maybe<ConversationStateNextResponseFragment_ConversationState_nextResponse_ConversationResponse_messages_ConversationInfoMessage>>> }
);

export type ConversationStateNextResponseFragment = (
  { __typename?: 'ConversationState' }
  & MakeOptional<Pick<ConversationState, 'gender' | 'progress' | 'entropy' | 'context' | 'caseId' | 'caseReadOnly' | 'caseBasedOn' | 'options'>, 'entropy' | 'caseReadOnly' | 'caseBasedOn' | 'options'>
  & { nextResponse?: Maybe<ConversationStateNextResponseFragment_ConversationState_nextResponse_ConversationResponse>, initialMessages?: Maybe<Array<Maybe<ConversationStateFragment_ConversationState_initialMessages_ConversationInfoMessage>>>, urgent?: Maybe<ConversationStateFragment_ConversationState_urgent_DDUrgency>, nextSuggestions?: Maybe<ConversationStateFragment_ConversationState_nextSuggestions_PatientSuggestions>, ddClusters?: Maybe<ConversationStateFragment_ConversationState_ddClusters_DDResponse>, recommendations?: Maybe<Array<Maybe<ConversationStateFragment_ConversationState_recommendations_PolicyRecommendation>>>, navigationRecommendation?: Maybe<ConversationStateFragment_ConversationState_navigationRecommendation_PolicyRecommendation>, patientFindings?: Maybe<Array<Maybe<ConversationStateFragment_ConversationState_patientFindings_GroupedFeatureResponse>>>, patientIcd?: Maybe<ConversationStateFragment_ConversationState_patientIcd_StateICDCodes> }
);

type GeneratedOutputGeneratedGroundingFragment = (
  { __typename?: 'GeneratedGrounding' }
  & Pick<GeneratedGrounding, 'generating' | 'error' | 'errorText' | 'etag'>
);

type GeneratedOutputGroundedSummaryTextFragment = (
  { __typename?: 'GroundedSummaryText' }
  & Pick<GroundedSummaryText, 'generating' | 'error' | 'errorText' | 'etag'>
);

type GeneratedOutputUngroundedSummaryTextFragment = (
  { __typename?: 'UngroundedSummaryText' }
  & Pick<UngroundedSummaryText, 'generating' | 'error' | 'errorText' | 'etag'>
);

type GeneratedOutputWorkupActionItemsFragment = (
  { __typename?: 'WorkupActionItems' }
  & Pick<WorkupActionItems, 'generating' | 'error' | 'errorText' | 'etag'>
);

export type GeneratedOutputFragment = GeneratedOutputGeneratedGroundingFragment | GeneratedOutputGroundedSummaryTextFragment | GeneratedOutputUngroundedSummaryTextFragment | GeneratedOutputWorkupActionItemsFragment;

type SummaryTextGroundedSummaryTextFragment = (
  { __typename?: 'GroundedSummaryText' }
  & Pick<GroundedSummaryText, 'text' | 'generating' | 'error' | 'errorText' | 'etag'>
);

type SummaryTextUngroundedSummaryTextFragment = (
  { __typename?: 'UngroundedSummaryText' }
  & Pick<UngroundedSummaryText, 'text' | 'generating' | 'error' | 'errorText' | 'etag'>
);

export type SummaryTextFragment = SummaryTextGroundedSummaryTextFragment | SummaryTextUngroundedSummaryTextFragment;

export type GuidelineFragmentFragment_RagGuideline_properties_KeyValue = (
  { __typename?: 'KeyValue' }
  & Pick<KeyValue, 'key' | 'value'>
);

export type GuidelineFragmentFragment = (
  { __typename?: 'RagGuideline' }
  & Pick<RagGuideline, 'id' | 'title' | 'url'>
  & { properties?: Maybe<Array<Maybe<GuidelineFragmentFragment_RagGuideline_properties_KeyValue>>> }
);

export type CitationFragmentFragment = (
  { __typename?: 'RagCitation' }
  & Pick<RagCitation, 'text' | 'rvids' | 'ruleCitations'>
);

export type GroundedSummaryTextFragment_GroundedSummaryText_citations_RagCitation = (
  { __typename?: 'RagCitation' }
  & Pick<RagCitation, 'text' | 'rvids' | 'ruleCitations'>
);

export type GroundedSummaryTextFragment_GroundedSummaryText_guidelines_RagGuideline = (
  { __typename?: 'RagGuideline' }
  & Pick<RagGuideline, 'id' | 'title' | 'url'>
  & { properties?: Maybe<Array<Maybe<GuidelineFragmentFragment_RagGuideline_properties_KeyValue>>> }
);

export type GroundedSummaryTextFragment_GroundedSummaryText_altGuidelines_RagGuideline = (
  { __typename?: 'RagGuideline' }
  & Pick<RagGuideline, 'id' | 'title' | 'url'>
  & { properties?: Maybe<Array<Maybe<GuidelineFragmentFragment_RagGuideline_properties_KeyValue>>> }
);

export type GroundedSummaryTextFragment_GroundedSummaryText_grounding_GeneratedGrounding_grounding_Grounding = (
  { __typename?: 'Grounding' }
  & Pick<Grounding, 'debugData'>
  & { sentences?: Maybe<Array<Maybe<GroundingFragment_Grounding_sentences_GroundedSentence>>> }
);

export type GroundedSummaryTextFragment_GroundedSummaryText_grounding_GeneratedGrounding = (
  { __typename?: 'GeneratedGrounding' }
  & Pick<GeneratedGrounding, 'generating' | 'error' | 'errorText' | 'etag'>
  & { grounding?: Maybe<GroundedSummaryTextFragment_GroundedSummaryText_grounding_GeneratedGrounding_grounding_Grounding> }
);

export type GroundedSummaryTextFragment = (
  { __typename?: 'GroundedSummaryText' }
  & Pick<GroundedSummaryText, 'text' | 'generating' | 'error' | 'errorText' | 'etag'>
  & { citations?: Maybe<Array<Maybe<GroundedSummaryTextFragment_GroundedSummaryText_citations_RagCitation>>>, guidelines?: Maybe<Array<Maybe<GroundedSummaryTextFragment_GroundedSummaryText_guidelines_RagGuideline>>>, altGuidelines?: Maybe<Array<Maybe<GroundedSummaryTextFragment_GroundedSummaryText_altGuidelines_RagGuideline>>>, grounding?: Maybe<GroundedSummaryTextFragment_GroundedSummaryText_grounding_GeneratedGrounding> }
);

export type LoadedModelInfoFragment = (
  { __typename?: 'LoadedModelInfo' }
  & Pick<LoadedModelInfo, 'commitSerial' | 'revision'>
);

export type BackendModelInfoFragment_gatewayModel_LoadedModelInfo = (
  { __typename?: 'LoadedModelInfo' }
  & Pick<LoadedModelInfo, 'commitSerial' | 'revision'>
);

export type BackendModelInfoFragment_diagnosisModel_LoadedModelInfo = (
  { __typename?: 'LoadedModelInfo' }
  & Pick<LoadedModelInfo, 'commitSerial' | 'revision'>
);

export type BackendModelInfoFragment = (
  { __typename?: 'Query' }
  & { gatewayModel?: Maybe<BackendModelInfoFragment_gatewayModel_LoadedModelInfo>, diagnosisModel?: Maybe<BackendModelInfoFragment_diagnosisModel_LoadedModelInfo> }
);

export type SummaryDiseaseClusterFragment_SummaryDiseaseCluster_title_QualifiedFeature = (
  { __typename?: 'QualifiedFeature' }
  & Pick<QualifiedFeature, 'id' | 'name' | 'negate' | 'skip'>
  & { feature?: Maybe<FindingMetricsFragment_DiseaseFindingMetrics_finding_RCohort_qfs_QualifiedFeature_feature_Feature>, qualifiers?: Maybe<Array<Maybe<FindingMetricsFragment_DiseaseFindingMetrics_finding_RCohort_qfs_QualifiedFeature_qualifiers_Qualifier>>>, mandatory?: Maybe<FindingMetricsFragment_DiseaseFindingMetrics_finding_RCohort_qfs_QualifiedFeature_mandatory_Qualifier> }
);

export type SummaryDiseaseClusterFragment_SummaryDiseaseCluster_scores_ScoreByType = (
  { __typename?: 'ScoreByType' }
  & Pick<ScoreByType, 'sortType' | 'adjustedNormalized' | 'postClusterAdjustment'>
);

export type SummaryDiseaseClusterFragment_SummaryDiseaseCluster_icd_SummaryICDCode = (
  { __typename?: 'SummaryICDCode' }
  & Pick<SummaryIcdCode, 'code' | 'desc'>
);

export type SummaryDiseaseClusterFragment_SummaryDiseaseCluster_explanation_GroundedSummaryText = (
  { __typename?: 'GroundedSummaryText' }
  & Pick<GroundedSummaryText, 'text' | 'generating' | 'error' | 'errorText' | 'etag'>
  & { citations?: Maybe<Array<Maybe<GroundedSummaryTextFragment_GroundedSummaryText_citations_RagCitation>>>, guidelines?: Maybe<Array<Maybe<GroundedSummaryTextFragment_GroundedSummaryText_guidelines_RagGuideline>>>, altGuidelines?: Maybe<Array<Maybe<GroundedSummaryTextFragment_GroundedSummaryText_altGuidelines_RagGuideline>>>, grounding?: Maybe<GroundedSummaryTextFragment_GroundedSummaryText_grounding_GeneratedGrounding> }
);

export type SummaryDiseaseClusterFragment = (
  { __typename?: 'SummaryDiseaseCluster' }
  & Pick<SummaryDiseaseCluster, 'inTopCRPerSortType'>
  & { title?: Maybe<SummaryDiseaseClusterFragment_SummaryDiseaseCluster_title_QualifiedFeature>, scores?: Maybe<SummaryDiseaseClusterFragment_SummaryDiseaseCluster_scores_ScoreByType>, icd?: Maybe<Array<Maybe<SummaryDiseaseClusterFragment_SummaryDiseaseCluster_icd_SummaryICDCode>>>, explanation?: Maybe<SummaryDiseaseClusterFragment_SummaryDiseaseCluster_explanation_GroundedSummaryText> }
);

export type SummaryProblemFragment_SummaryProblem_problem_QualifiedFeature = (
  { __typename?: 'QualifiedFeature' }
  & Pick<QualifiedFeature, 'id' | 'name' | 'negate' | 'skip'>
  & { feature?: Maybe<FindingMetricsFragment_DiseaseFindingMetrics_finding_RCohort_qfs_QualifiedFeature_feature_Feature>, qualifiers?: Maybe<Array<Maybe<FindingMetricsFragment_DiseaseFindingMetrics_finding_RCohort_qfs_QualifiedFeature_qualifiers_Qualifier>>>, mandatory?: Maybe<FindingMetricsFragment_DiseaseFindingMetrics_finding_RCohort_qfs_QualifiedFeature_mandatory_Qualifier> }
);

export type SummaryProblemFragment_SummaryProblem_icd_SummaryICDCode = (
  { __typename?: 'SummaryICDCode' }
  & Pick<SummaryIcdCode, 'code' | 'desc'>
);

export type SummaryProblemFragment = (
  { __typename?: 'SummaryProblem' }
  & { problem?: Maybe<SummaryProblemFragment_SummaryProblem_problem_QualifiedFeature>, icd?: Maybe<Array<Maybe<SummaryProblemFragment_SummaryProblem_icd_SummaryICDCode>>> }
);

export type GetUserRolesQuery_Query = (
  { __typename?: 'Query' }
  & Pick<Query, 'getUserRoles'>
);


export type GetUserRolesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetUserRolesQuery = GetUserRolesQuery_Query;

export type DdOverviewQuery_dd_DDResponse_clinicalReasoning_ClinicalReasoning_disease_QualifiedFeature = (
  { __typename?: 'QualifiedFeature' }
  & Pick<QualifiedFeature, 'id' | 'name' | 'negate' | 'skip'>
  & { feature?: Maybe<FindingMetricsFragment_DiseaseFindingMetrics_finding_RCohort_qfs_QualifiedFeature_feature_Feature>, qualifiers?: Maybe<Array<Maybe<FindingMetricsFragment_DiseaseFindingMetrics_finding_RCohort_qfs_QualifiedFeature_qualifiers_Qualifier>>>, mandatory?: Maybe<FindingMetricsFragment_DiseaseFindingMetrics_finding_RCohort_qfs_QualifiedFeature_mandatory_Qualifier> }
);

export type DdOverviewQuery_dd_DDResponse_clinicalReasoning_ClinicalReasoning_flags_Flag = (
  { __typename?: 'Flag' }
  & Pick<Flag, 'type'>
  & { ref?: Maybe<FlagFragment_Flag_ref_QualifiedFeature> }
);

export type DdOverviewQuery_dd_DDResponse_clinicalReasoning_ClinicalReasoning = (
  { __typename?: 'ClinicalReasoning' }
  & Pick<ClinicalReasoning, 'id' | 'inInitialDisorders' | 'isKahunDisorder' | 'forcedInBestMatch' | 'forcedInHighestProb' | 'forcedInSort' | 'score' | 'urgency' | 'diseaseGivenIndependentFindings' | 'diseaseGivenDependentFindings' | 'liftWithDependentFindings' | 'prevalence' | 'prevalenceDescription' | 'incidence' | 'incidenceDescription' | 'isRedundant'>
  & { disease?: Maybe<Array<Maybe<DdOverviewQuery_dd_DDResponse_clinicalReasoning_ClinicalReasoning_disease_QualifiedFeature>>>, flags?: Maybe<Array<Maybe<DdOverviewQuery_dd_DDResponse_clinicalReasoning_ClinicalReasoning_flags_Flag>>> }
);

export type DdOverviewQuery_dd_DDResponse = (
  { __typename?: 'DDResponse' }
  & Pick<DdResponse, 'citations'>
  & { clinicalReasoning?: Maybe<Array<Maybe<DdOverviewQuery_dd_DDResponse_clinicalReasoning_ClinicalReasoning>>> }
);

export type DdOverviewQuery_Query = (
  { __typename?: 'Query' }
  & { dd?: Maybe<DdOverviewQuery_dd_DDResponse> }
);


export type DdOverviewQueryVariables = Exact<{
  qfs?: InputMaybe<Array<InputMaybe<QualifiedFeatureInput>> | InputMaybe<QualifiedFeatureInput>>;
  consider?: InputMaybe<Array<InputMaybe<QualifiedFeatureInput>> | InputMaybe<QualifiedFeatureInput>>;
  pathOptions?: InputMaybe<PathOptions>;
  diagnosisOptions?: InputMaybe<Scalars['DiagnosisOptionsInput']['input']>;
  depth?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  qfLight?: InputMaybe<Scalars['Boolean']['input']>;
  includeFeatureRange?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type DdOverviewQuery = DdOverviewQuery_Query;

export type DdWithCaseQuery_dd_DDResponse_allFindings_QualifiedFeature = (
  { __typename?: 'QualifiedFeature' }
  & Pick<QualifiedFeature, 'id' | 'name' | 'negate' | 'skip'>
  & { feature?: Maybe<FindingMetricsFragment_DiseaseFindingMetrics_finding_RCohort_qfs_QualifiedFeature_feature_Feature>, qualifiers?: Maybe<Array<Maybe<FindingMetricsFragment_DiseaseFindingMetrics_finding_RCohort_qfs_QualifiedFeature_qualifiers_Qualifier>>>, mandatory?: Maybe<FindingMetricsFragment_DiseaseFindingMetrics_finding_RCohort_qfs_QualifiedFeature_mandatory_Qualifier> }
);

export type DdWithCaseQuery_dd_DDResponse_clinicalReasoning_ClinicalReasoning_disease_QualifiedFeature_urgencyInfo_Feature = (
  { __typename?: 'Feature' }
  & Pick<Feature, 'id' | 'urgency' | 'urgencyId'>
);

export type DdWithCaseQuery_dd_DDResponse_clinicalReasoning_ClinicalReasoning_disease_QualifiedFeature = (
  { __typename?: 'QualifiedFeature' }
  & Pick<QualifiedFeature, 'id' | 'name' | 'negate' | 'skip'>
  & { urgencyInfo?: Maybe<DdWithCaseQuery_dd_DDResponse_clinicalReasoning_ClinicalReasoning_disease_QualifiedFeature_urgencyInfo_Feature>, feature?: Maybe<FindingMetricsFragment_DiseaseFindingMetrics_finding_RCohort_qfs_QualifiedFeature_feature_Feature>, qualifiers?: Maybe<Array<Maybe<FindingMetricsFragment_DiseaseFindingMetrics_finding_RCohort_qfs_QualifiedFeature_qualifiers_Qualifier>>>, mandatory?: Maybe<FindingMetricsFragment_DiseaseFindingMetrics_finding_RCohort_qfs_QualifiedFeature_mandatory_Qualifier> }
);

export type DdWithCaseQuery_dd_DDResponse_clinicalReasoning_ClinicalReasoning_diseaseCitations_Citations = (
  { __typename?: 'Citations' }
  & Pick<Citations, 'totalCount'>
  & { citationsData?: Maybe<Array<Maybe<DiseaseReferenceDataFragment_DiseaseReference_citations_Citations_citationsData_CitationData>>> }
);

export type DdWithCaseQuery_dd_DDResponse_clinicalReasoning_ClinicalReasoning_scores_ScoreByType = (
  { __typename?: 'ScoreByType' }
  & Pick<ScoreByType, 'sortType' | 'adjusted' | 'postClusterAdjustment'>
);

export type DdWithCaseQuery_dd_DDResponse_clinicalReasoning_ClinicalReasoning_findings_ClinicalReasoningFinding_finding_QualifiedFeature = (
  { __typename?: 'QualifiedFeature' }
  & Pick<QualifiedFeature, 'id'>
);

export type DdWithCaseQuery_dd_DDResponse_clinicalReasoning_ClinicalReasoning_findings_ClinicalReasoningFinding = (
  { __typename?: 'ClinicalReasoningFinding' }
  & Pick<ClinicalReasoningFinding, 'sourceQFIndex' | 'absolutePredictiveValue' | 'likelihoodRatio'>
  & { finding?: Maybe<DdWithCaseQuery_dd_DDResponse_clinicalReasoning_ClinicalReasoning_findings_ClinicalReasoningFinding_finding_QualifiedFeature> }
);

export type DdWithCaseQuery_dd_DDResponse_clinicalReasoning_ClinicalReasoning_subTypes_QualifiedFeature = (
  { __typename?: 'QualifiedFeature' }
  & Pick<QualifiedFeature, 'id' | 'name' | 'negate' | 'skip'>
  & { feature?: Maybe<FindingMetricsFragment_DiseaseFindingMetrics_finding_RCohort_qfs_QualifiedFeature_feature_Feature>, qualifiers?: Maybe<Array<Maybe<FindingMetricsFragment_DiseaseFindingMetrics_finding_RCohort_qfs_QualifiedFeature_qualifiers_Qualifier>>>, mandatory?: Maybe<FindingMetricsFragment_DiseaseFindingMetrics_finding_RCohort_qfs_QualifiedFeature_mandatory_Qualifier> }
);

export type DdWithCaseQuery_dd_DDResponse_clinicalReasoning_ClinicalReasoning_flags_Flag = (
  { __typename?: 'Flag' }
  & Pick<Flag, 'type'>
  & { ref?: Maybe<FlagFragment_Flag_ref_QualifiedFeature> }
);

export type DdWithCaseQuery_dd_DDResponse_clinicalReasoning_ClinicalReasoning_redundantDueToBySort_RedundantBySort_redundantDueTo_QualifiedFeature = (
  { __typename?: 'QualifiedFeature' }
  & Pick<QualifiedFeature, 'id' | 'name' | 'negate' | 'skip'>
  & { feature?: Maybe<FindingMetricsFragment_DiseaseFindingMetrics_finding_RCohort_qfs_QualifiedFeature_feature_Feature>, qualifiers?: Maybe<Array<Maybe<FindingMetricsFragment_DiseaseFindingMetrics_finding_RCohort_qfs_QualifiedFeature_qualifiers_Qualifier>>>, mandatory?: Maybe<FindingMetricsFragment_DiseaseFindingMetrics_finding_RCohort_qfs_QualifiedFeature_mandatory_Qualifier> }
);

export type DdWithCaseQuery_dd_DDResponse_clinicalReasoning_ClinicalReasoning_redundantDueToBySort_RedundantBySort = (
  { __typename?: 'RedundantBySort' }
  & Pick<RedundantBySort, 'sortType'>
  & { redundantDueTo?: Maybe<DdWithCaseQuery_dd_DDResponse_clinicalReasoning_ClinicalReasoning_redundantDueToBySort_RedundantBySort_redundantDueTo_QualifiedFeature> }
);

export type DdWithCaseQuery_dd_DDResponse_clinicalReasoning_ClinicalReasoning_matchedRankings_MatchedRanking_condition_CaseCondition_feature_Feature = (
  { __typename?: 'Feature' }
  & Pick<Feature, 'id'>
);

export type DdWithCaseQuery_dd_DDResponse_clinicalReasoning_ClinicalReasoning_matchedRankings_MatchedRanking_condition_CaseCondition = (
  { __typename?: 'CaseCondition' }
  & Pick<CaseCondition, 'sortType' | 'ddMode'>
  & { feature?: Maybe<DdWithCaseQuery_dd_DDResponse_clinicalReasoning_ClinicalReasoning_matchedRankings_MatchedRanking_condition_CaseCondition_feature_Feature> }
);

export type DdWithCaseQuery_dd_DDResponse_clinicalReasoning_ClinicalReasoning_matchedRankings_MatchedRanking = (
  { __typename?: 'MatchedRanking' }
  & Pick<MatchedRanking, 'matchType'>
  & { condition?: Maybe<DdWithCaseQuery_dd_DDResponse_clinicalReasoning_ClinicalReasoning_matchedRankings_MatchedRanking_condition_CaseCondition> }
);

export type DdWithCaseQuery_dd_DDResponse_clinicalReasoning_ClinicalReasoning = (
  { __typename?: 'ClinicalReasoning' }
  & MakeOptional<Pick<ClinicalReasoning, 'id' | 'inInitialDisorders' | 'isKahunDisorder' | 'forcedInBestMatch' | 'forcedInHighestProb' | 'forcedInSort' | 'missingPresentingSymptoms' | 'presentableDisease' | 'score' | 'urgency' | 'diseaseGivenIndependentFindings' | 'diseaseGivenDependentFindings' | 'liftWithDependentFindings' | 'prevalence' | 'prevalenceDescription' | 'incidence' | 'incidenceDescription' | 'isRedundant' | 'inTopCR' | 'inTopCRPerSortType' | 'patientIncidence'>, 'inInitialDisorders' | 'isKahunDisorder' | 'forcedInBestMatch' | 'forcedInHighestProb' | 'forcedInSort' | 'missingPresentingSymptoms' | 'presentableDisease' | 'liftWithDependentFindings' | 'prevalence' | 'prevalenceDescription' | 'incidence' | 'incidenceDescription' | 'isRedundant'>
  & { disease?: Maybe<Array<Maybe<DdWithCaseQuery_dd_DDResponse_clinicalReasoning_ClinicalReasoning_disease_QualifiedFeature>>>, diseaseCitations?: Maybe<DdWithCaseQuery_dd_DDResponse_clinicalReasoning_ClinicalReasoning_diseaseCitations_Citations>, scores?: Maybe<Array<Maybe<DdWithCaseQuery_dd_DDResponse_clinicalReasoning_ClinicalReasoning_scores_ScoreByType>>>, findings?: Maybe<Array<Maybe<DdWithCaseQuery_dd_DDResponse_clinicalReasoning_ClinicalReasoning_findings_ClinicalReasoningFinding>>>, subTypes?: Maybe<Array<Maybe<DdWithCaseQuery_dd_DDResponse_clinicalReasoning_ClinicalReasoning_subTypes_QualifiedFeature>>>, flags?: Maybe<Array<Maybe<DdWithCaseQuery_dd_DDResponse_clinicalReasoning_ClinicalReasoning_flags_Flag>>>, redundantDueToBySort?: Maybe<Array<Maybe<DdWithCaseQuery_dd_DDResponse_clinicalReasoning_ClinicalReasoning_redundantDueToBySort_RedundantBySort>>>, matchedRankings?: Maybe<Array<Maybe<DdWithCaseQuery_dd_DDResponse_clinicalReasoning_ClinicalReasoning_matchedRankings_MatchedRanking>>> }
);

export type DdWithCaseQuery_dd_DDResponse_meetsConditions_MeetCondition_condition_CaseCondition_feature_Feature = (
  { __typename?: 'Feature' }
  & Pick<Feature, 'id' | 'name'>
);

export type DdWithCaseQuery_dd_DDResponse_meetsConditions_MeetCondition_condition_CaseCondition_payload_CaseConditionPayload_feature_Feature = (
  { __typename?: 'Feature' }
  & Pick<Feature, 'id' | 'name'>
);

export type DdWithCaseQuery_dd_DDResponse_meetsConditions_MeetCondition_condition_CaseCondition_payload_CaseConditionPayload = (
  { __typename?: 'CaseConditionPayload' }
  & Pick<CaseConditionPayload, 'val'>
  & { feature?: Maybe<DdWithCaseQuery_dd_DDResponse_meetsConditions_MeetCondition_condition_CaseCondition_payload_CaseConditionPayload_feature_Feature> }
);

export type DdWithCaseQuery_dd_DDResponse_meetsConditions_MeetCondition_condition_CaseCondition = (
  { __typename?: 'CaseCondition' }
  & Pick<CaseCondition, 'type' | 'sortType' | 'ddMode'>
  & { feature?: Maybe<DdWithCaseQuery_dd_DDResponse_meetsConditions_MeetCondition_condition_CaseCondition_feature_Feature>, payload?: Maybe<DdWithCaseQuery_dd_DDResponse_meetsConditions_MeetCondition_condition_CaseCondition_payload_CaseConditionPayload> }
);

export type DdWithCaseQuery_dd_DDResponse_meetsConditions_MeetCondition = (
  { __typename?: 'MeetCondition' }
  & Pick<MeetCondition, 'meets'>
  & { condition?: Maybe<DdWithCaseQuery_dd_DDResponse_meetsConditions_MeetCondition_condition_CaseCondition> }
);

export type DdWithCaseQuery_dd_DDResponse_strengthForSortType_StrengthForSortType = (
  { __typename?: 'StrengthForSortType' }
  & Pick<StrengthForSortType, 'sortType' | 'strength'>
);

export type DdWithCaseQuery_dd_DDResponse_clustersToConsider_DiseaseCluster_title_QualifiedFeature_urgencyInfo_Feature = (
  { __typename?: 'Feature' }
  & Pick<Feature, 'id' | 'urgency' | 'urgencyId'>
);

export type DdWithCaseQuery_dd_DDResponse_clustersToConsider_DiseaseCluster_title_QualifiedFeature = (
  { __typename?: 'QualifiedFeature' }
  & Pick<QualifiedFeature, 'id' | 'name' | 'negate' | 'skip'>
  & { urgencyInfo?: Maybe<DdWithCaseQuery_dd_DDResponse_clustersToConsider_DiseaseCluster_title_QualifiedFeature_urgencyInfo_Feature>, feature?: Maybe<FindingMetricsFragment_DiseaseFindingMetrics_finding_RCohort_qfs_QualifiedFeature_feature_Feature>, qualifiers?: Maybe<Array<Maybe<FindingMetricsFragment_DiseaseFindingMetrics_finding_RCohort_qfs_QualifiedFeature_qualifiers_Qualifier>>>, mandatory?: Maybe<FindingMetricsFragment_DiseaseFindingMetrics_finding_RCohort_qfs_QualifiedFeature_mandatory_Qualifier> }
);

export type DdWithCaseQuery_dd_DDResponse_clustersToConsider_DiseaseCluster_citations_Citations = (
  { __typename?: 'Citations' }
  & Pick<Citations, 'totalCount'>
  & { citationsData?: Maybe<Array<Maybe<DiseaseReferenceDataFragment_DiseaseReference_citations_Citations_citationsData_CitationData>>> }
);

export type DdWithCaseQuery_dd_DDResponse_clustersToConsider_DiseaseCluster_scores_ScoreByType = (
  { __typename?: 'ScoreByType' }
  & Pick<ScoreByType, 'adjustedNormalized'>
);

export type DdWithCaseQuery_dd_DDResponse_clustersToConsider_DiseaseCluster = (
  { __typename?: 'DiseaseCluster' }
  & Pick<DiseaseCluster, 'id' | 'crIds' | 'sortType' | 'bestCrId' | 'flags' | 'urgencyId'>
  & { title?: Maybe<DdWithCaseQuery_dd_DDResponse_clustersToConsider_DiseaseCluster_title_QualifiedFeature>, citations?: Maybe<DdWithCaseQuery_dd_DDResponse_clustersToConsider_DiseaseCluster_citations_Citations>, scores?: Maybe<DdWithCaseQuery_dd_DDResponse_clustersToConsider_DiseaseCluster_scores_ScoreByType> }
);

export type DdWithCaseQuery_dd_DDResponse_debugSheet_Sheet_rows_Row = (
  { __typename?: 'Row' }
  & Pick<Row, 'cols'>
);

export type DdWithCaseQuery_dd_DDResponse_debugSheet_Sheet = (
  { __typename?: 'Sheet' }
  & { rows?: Maybe<Array<Maybe<DdWithCaseQuery_dd_DDResponse_debugSheet_Sheet_rows_Row>>> }
);

export type DdWithCaseQuery_dd_DDResponse_debugSheets_DebugSheet = (
  { __typename?: 'DebugSheet' }
  & Pick<DebugSheet, 'name'>
  & { sheet?: Maybe<DebugSheetFragment_DebugSheet_sheet_Sheet> }
);

export type DdWithCaseQuery_dd_DDResponse_urgencyBySortType_UrgencyByType = (
  { __typename?: 'UrgencyByType' }
  & Pick<UrgencyByType, 'sortType' | 'urgencyLevelId'>
);

export type DdWithCaseQuery_dd_DDResponse = (
  { __typename?: 'DDResponse' }
  & MakeOptional<Pick<DdResponse, 'citations' | 'strength' | 'debugReport' | 'options'>, 'debugReport'>
  & { allFindings?: Maybe<Array<Maybe<DdWithCaseQuery_dd_DDResponse_allFindings_QualifiedFeature>>>, clinicalReasoning?: Maybe<Array<Maybe<DdWithCaseQuery_dd_DDResponse_clinicalReasoning_ClinicalReasoning>>>, meetsConditions?: Maybe<Array<Maybe<DdWithCaseQuery_dd_DDResponse_meetsConditions_MeetCondition>>>, strengthForSortType?: Maybe<Array<Maybe<DdWithCaseQuery_dd_DDResponse_strengthForSortType_StrengthForSortType>>>, clustersToConsider?: Maybe<Array<Maybe<DdWithCaseQuery_dd_DDResponse_clustersToConsider_DiseaseCluster>>>, debugSheet?: Maybe<DdWithCaseQuery_dd_DDResponse_debugSheet_Sheet>, debugSheets?: Maybe<Array<Maybe<DdWithCaseQuery_dd_DDResponse_debugSheets_DebugSheet>>>, urgencyBySortType?: Maybe<Array<Maybe<DdWithCaseQuery_dd_DDResponse_urgencyBySortType_UrgencyByType>>> }
);

export type DdWithCaseQuery_Query = (
  { __typename?: 'Query' }
  & { dd?: Maybe<DdWithCaseQuery_dd_DDResponse> }
);


export type DdWithCaseQueryVariables = Exact<{
  qfs?: InputMaybe<Array<InputMaybe<GroupedFeature>> | InputMaybe<GroupedFeature>>;
  considerPanels?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>> | InputMaybe<Scalars['String']['input']>>;
  diseasesToDiscard?: InputMaybe<Array<InputMaybe<QualifiedFeatureInput>> | InputMaybe<QualifiedFeatureInput>>;
  diseasesToAdd?: InputMaybe<Array<InputMaybe<QualifiedFeatureInput>> | InputMaybe<QualifiedFeatureInput>>;
  nextStepDiseasesToConsider?: InputMaybe<Array<InputMaybe<QualifiedFeatureInput>> | InputMaybe<QualifiedFeatureInput>>;
  pathOptions?: InputMaybe<PathOptions>;
  diagnosisOptions?: InputMaybe<Scalars['DiagnosisOptionsInput']['input']>;
  depth?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  withDebug: Scalars['Boolean']['input'];
  adaptiveRatio?: InputMaybe<Scalars['Float']['input']>;
  qfLight?: InputMaybe<Scalars['Boolean']['input']>;
  sortTypes?: InputMaybe<Array<InputMaybe<SortType>> | InputMaybe<SortType>>;
  conditions?: InputMaybe<Array<InputMaybe<CaseConditionInput>> | InputMaybe<CaseConditionInput>>;
  backEndMode?: InputMaybe<Scalars['Boolean']['input']>;
  includeCitations?: InputMaybe<Scalars['Boolean']['input']>;
  includeFeatureRange?: InputMaybe<Scalars['Boolean']['input']>;
  caseId?: InputMaybe<Scalars['String']['input']>;
}>;


export type DdWithCaseQuery = DdWithCaseQuery_Query;

export type DdReportOnlyQuery_dd_DDResponse = (
  { __typename?: 'DDResponse' }
  & Pick<DdResponse, 'debugReport'>
);

export type DdReportOnlyQuery_Query = (
  { __typename?: 'Query' }
  & { dd?: Maybe<DdReportOnlyQuery_dd_DDResponse> }
);


export type DdReportOnlyQueryVariables = Exact<{
  qfs?: InputMaybe<Array<InputMaybe<GroupedFeature>> | InputMaybe<GroupedFeature>>;
  considerPanels?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>> | InputMaybe<Scalars['String']['input']>>;
  diseasesToDiscard?: InputMaybe<Array<InputMaybe<QualifiedFeatureInput>> | InputMaybe<QualifiedFeatureInput>>;
  diseasesToAdd?: InputMaybe<Array<InputMaybe<QualifiedFeatureInput>> | InputMaybe<QualifiedFeatureInput>>;
  nextStepDiseasesToConsider?: InputMaybe<Array<InputMaybe<QualifiedFeatureInput>> | InputMaybe<QualifiedFeatureInput>>;
  pathOptions?: InputMaybe<PathOptions>;
  diagnosisOptions?: InputMaybe<Scalars['DiagnosisOptionsInput']['input']>;
  depth?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  adaptiveRatio?: InputMaybe<Scalars['Float']['input']>;
  sortTypes?: InputMaybe<Array<InputMaybe<SortType>> | InputMaybe<SortType>>;
  conditions?: InputMaybe<Array<InputMaybe<CaseConditionInput>> | InputMaybe<CaseConditionInput>>;
}>;


export type DdReportOnlyQuery = DdReportOnlyQuery_Query;

export type PlanQuery_plan_PatientSuggestions = (
  { __typename?: 'PatientSuggestions' }
  & { debugSheet?: Maybe<PatientSuggestionsFragment_PatientSuggestions_debugSheet_Sheet>, suggestions?: Maybe<Array<Maybe<PatientSuggestionsFragment_PatientSuggestions_suggestions_PatientSuggestion>>>, clustered?: Maybe<Array<Maybe<PatientSuggestionsFragment_PatientSuggestions_clustered_ClusterSuggestion>>> }
);

export type PlanQuery_Query = (
  { __typename?: 'Query' }
  & { plan?: Maybe<PlanQuery_plan_PatientSuggestions> }
);


export type PlanQueryVariables = Exact<{
  diseases?: InputMaybe<Array<InputMaybe<DiseaseForPlanInput>> | InputMaybe<DiseaseForPlanInput>>;
  patientCase?: InputMaybe<PatientCaseInput>;
  pathOptions?: InputMaybe<PathOptions>;
  diagnosisOptions?: InputMaybe<Scalars['DiagnosisOptionsInput']['input']>;
  withDebug: Scalars['Boolean']['input'];
  qfLight?: InputMaybe<Scalars['Boolean']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  categories?: InputMaybe<Array<InputMaybe<DiseaseCategoryType>> | InputMaybe<DiseaseCategoryType>>;
  withDiseaseMetrics?: InputMaybe<Scalars['Boolean']['input']>;
  limitPerCategory?: InputMaybe<Array<InputMaybe<PlanLimits>> | InputMaybe<PlanLimits>>;
  diseasesAliasing?: InputMaybe<Array<InputMaybe<DiseasesAliasing>> | InputMaybe<DiseasesAliasing>>;
  includeFeatureRange?: InputMaybe<Scalars['Boolean']['input']>;
  caseId?: InputMaybe<Scalars['String']['input']>;
}>;


export type PlanQuery = PlanQuery_Query;

export type RestoreCaseQuery_qualifiedFeatures_QualifiedFeature = (
  { __typename?: 'QualifiedFeature' }
  & Pick<QualifiedFeature, 'id' | 'name' | 'negate' | 'skip'>
  & { feature?: Maybe<FindingMetricsFragment_DiseaseFindingMetrics_finding_RCohort_qfs_QualifiedFeature_feature_Feature>, qualifiers?: Maybe<Array<Maybe<FindingMetricsFragment_DiseaseFindingMetrics_finding_RCohort_qfs_QualifiedFeature_qualifiers_Qualifier>>>, mandatory?: Maybe<FindingMetricsFragment_DiseaseFindingMetrics_finding_RCohort_qfs_QualifiedFeature_mandatory_Qualifier> }
);

export type RestoreCaseQuery_Query = (
  { __typename?: 'Query' }
  & { qualifiedFeatures?: Maybe<Array<Maybe<RestoreCaseQuery_qualifiedFeatures_QualifiedFeature>>> }
);


export type RestoreCaseQueryVariables = Exact<{
  findings?: InputMaybe<Array<InputMaybe<QualifiedFeatureInput>> | InputMaybe<QualifiedFeatureInput>>;
  qfLight?: InputMaybe<Scalars['Boolean']['input']>;
  includeFeatureRange?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type RestoreCaseQuery = RestoreCaseQuery_Query;

export type PatientCaseMetaDataQuery_patientCaseMetaData_CaseMetaData = (
  { __typename?: 'CaseMetaData' }
  & Pick<CaseMetaData, 'clinicId' | 'etag'>
);

export type PatientCaseMetaDataQuery_Query = (
  { __typename?: 'Query' }
  & { patientCaseMetaData?: Maybe<PatientCaseMetaDataQuery_patientCaseMetaData_CaseMetaData> }
);


export type PatientCaseMetaDataQueryVariables = Exact<{
  id?: InputMaybe<Scalars['String']['input']>;
}>;


export type PatientCaseMetaDataQuery = PatientCaseMetaDataQuery_Query;

export type RestorePatientCaseQuery_restorePatientCase_SavedCase_findings_SavedCaseGroup_features_GroupedFeatureResponse_feature_QualifiedFeature = (
  { __typename?: 'QualifiedFeature' }
  & Pick<QualifiedFeature, 'id' | 'name' | 'negate' | 'skip'>
  & { feature?: Maybe<FindingMetricsFragment_DiseaseFindingMetrics_finding_RCohort_qfs_QualifiedFeature_feature_Feature>, qualifiers?: Maybe<Array<Maybe<FindingMetricsFragment_DiseaseFindingMetrics_finding_RCohort_qfs_QualifiedFeature_qualifiers_Qualifier>>>, mandatory?: Maybe<FindingMetricsFragment_DiseaseFindingMetrics_finding_RCohort_qfs_QualifiedFeature_mandatory_Qualifier> }
);

export type RestorePatientCaseQuery_restorePatientCase_SavedCase_findings_SavedCaseGroup_features_GroupedFeatureResponse = (
  { __typename?: 'GroupedFeatureResponse' }
  & Pick<GroupedFeatureResponse, 'group' | 'source'>
  & { feature?: Maybe<RestorePatientCaseQuery_restorePatientCase_SavedCase_findings_SavedCaseGroup_features_GroupedFeatureResponse_feature_QualifiedFeature> }
);

export type RestorePatientCaseQuery_restorePatientCase_SavedCase_findings_SavedCaseGroup = (
  { __typename?: 'SavedCaseGroup' }
  & Pick<SavedCaseGroup, 'group'>
  & { features?: Maybe<Array<Maybe<RestorePatientCaseQuery_restorePatientCase_SavedCase_findings_SavedCaseGroup_features_GroupedFeatureResponse>>> }
);

export type RestorePatientCaseQuery_restorePatientCase_SavedCase_data_OpaqueData = (
  { __typename?: 'OpaqueData' }
  & Pick<OpaqueData, 'payload'>
);

export type RestorePatientCaseQuery_restorePatientCase_SavedCase = (
  { __typename?: 'SavedCase' }
  & Pick<SavedCase, 'etag'>
  & { findings?: Maybe<Array<Maybe<RestorePatientCaseQuery_restorePatientCase_SavedCase_findings_SavedCaseGroup>>>, data?: Maybe<RestorePatientCaseQuery_restorePatientCase_SavedCase_data_OpaqueData> }
);

export type RestorePatientCaseQuery_Query = (
  { __typename?: 'Query' }
  & { restorePatientCase?: Maybe<RestorePatientCaseQuery_restorePatientCase_SavedCase> }
);


export type RestorePatientCaseQueryVariables = Exact<{
  id?: InputMaybe<Scalars['String']['input']>;
  clinicId?: InputMaybe<Scalars['String']['input']>;
  qfLight?: InputMaybe<Scalars['Boolean']['input']>;
  includeFeatureRange?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type RestorePatientCaseQuery = RestorePatientCaseQuery_Query;

export type CheckForPiiQuery_checkForPII_UpdateSummaryResponse = (
  { __typename?: 'UpdateSummaryResponse' }
  & Pick<UpdateSummaryResponse, 'status' | 'errors'>
);

export type CheckForPiiQuery_Query = (
  { __typename?: 'Query' }
  & { checkForPII?: Maybe<CheckForPiiQuery_checkForPII_UpdateSummaryResponse> }
);


export type CheckForPiiQueryVariables = Exact<{
  input?: InputMaybe<Scalars['String']['input']>;
}>;


export type CheckForPiiQuery = CheckForPiiQuery_Query;

export type StorePatientCaseMutation_Mutation = (
  { __typename?: 'Mutation' }
  & Pick<Mutation, 'storePatientCase'>
);


export type StorePatientCaseMutationVariables = Exact<{
  qfs?: InputMaybe<Array<InputMaybe<SavedCaseGroupInput>> | InputMaybe<SavedCaseGroupInput>>;
  data?: InputMaybe<OpaqueDataInput>;
  auto?: InputMaybe<Scalars['Boolean']['input']>;
  clinicId?: InputMaybe<Scalars['String']['input']>;
  readOnly?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type StorePatientCaseMutation = StorePatientCaseMutation_Mutation;

export type UpdatePatientCaseMutation_updatePatientCase_UpdateCaseResponse = (
  { __typename?: 'UpdateCaseResponse' }
  & Pick<UpdateCaseResponse, 'status' | 'etag'>
);

export type UpdatePatientCaseMutation_Mutation = (
  { __typename?: 'Mutation' }
  & { updatePatientCase?: Maybe<UpdatePatientCaseMutation_updatePatientCase_UpdateCaseResponse> }
);


export type UpdatePatientCaseMutationVariables = Exact<{
  qfs?: InputMaybe<Array<InputMaybe<SavedCaseGroupInput>> | InputMaybe<SavedCaseGroupInput>>;
  data?: InputMaybe<OpaqueDataInput>;
  id?: InputMaybe<Scalars['String']['input']>;
  etag?: InputMaybe<Scalars['String']['input']>;
  clinicId?: InputMaybe<Scalars['String']['input']>;
}>;


export type UpdatePatientCaseMutation = UpdatePatientCaseMutation_Mutation;

export type UpdatePatientSummaryMutation_updateSummary_UpdateSummaryResponse = (
  { __typename?: 'UpdateSummaryResponse' }
  & Pick<UpdateSummaryResponse, 'status' | 'errors' | 'etag'>
);

export type UpdatePatientSummaryMutation_Mutation = (
  { __typename?: 'Mutation' }
  & { updateSummary?: Maybe<UpdatePatientSummaryMutation_updateSummary_UpdateSummaryResponse> }
);


export type UpdatePatientSummaryMutationVariables = Exact<{
  caseId?: InputMaybe<Scalars['String']['input']>;
  clinicId?: InputMaybe<Scalars['String']['input']>;
  summaryInput?: InputMaybe<SummaryInput>;
}>;


export type UpdatePatientSummaryMutation = UpdatePatientSummaryMutation_Mutation;

export type CopyPatientCaseMutation_Mutation = (
  { __typename?: 'Mutation' }
  & Pick<Mutation, 'copyPatientCase'>
);


export type CopyPatientCaseMutationVariables = Exact<{
  id?: InputMaybe<Scalars['String']['input']>;
  clinicId?: InputMaybe<Scalars['String']['input']>;
}>;


export type CopyPatientCaseMutation = CopyPatientCaseMutation_Mutation;

export type StoreOpaqueDataMutation_Mutation = (
  { __typename?: 'Mutation' }
  & Pick<Mutation, 'storeOpaqueData'>
);


export type StoreOpaqueDataMutationVariables = Exact<{
  data?: InputMaybe<StoredData>;
  type?: InputMaybe<Scalars['String']['input']>;
  auto?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type StoreOpaqueDataMutation = StoreOpaqueDataMutation_Mutation;

export type UpdateOpaqueDataMutation_Mutation = (
  { __typename?: 'Mutation' }
  & Pick<Mutation, 'updateOpaqueData'>
);


export type UpdateOpaqueDataMutationVariables = Exact<{
  id?: InputMaybe<Scalars['String']['input']>;
  data?: InputMaybe<StoredData>;
  type?: InputMaybe<Scalars['String']['input']>;
}>;


export type UpdateOpaqueDataMutation = UpdateOpaqueDataMutation_Mutation;

export type RestoreOpaqueDataQuery_restoreOpaqueData_RestoredData_features_GroupedFeatureResponse_feature_QualifiedFeature = (
  { __typename?: 'QualifiedFeature' }
  & Pick<QualifiedFeature, 'id' | 'name' | 'negate' | 'skip'>
  & { feature?: Maybe<FindingMetricsFragment_DiseaseFindingMetrics_finding_RCohort_qfs_QualifiedFeature_feature_Feature>, qualifiers?: Maybe<Array<Maybe<FindingMetricsFragment_DiseaseFindingMetrics_finding_RCohort_qfs_QualifiedFeature_qualifiers_Qualifier>>>, mandatory?: Maybe<FindingMetricsFragment_DiseaseFindingMetrics_finding_RCohort_qfs_QualifiedFeature_mandatory_Qualifier> }
);

export type RestoreOpaqueDataQuery_restoreOpaqueData_RestoredData_features_GroupedFeatureResponse = (
  { __typename?: 'GroupedFeatureResponse' }
  & Pick<GroupedFeatureResponse, 'group' | 'skip'>
  & { feature?: Maybe<RestoreOpaqueDataQuery_restoreOpaqueData_RestoredData_features_GroupedFeatureResponse_feature_QualifiedFeature> }
);

export type RestoreOpaqueDataQuery_restoreOpaqueData_RestoredData = (
  { __typename?: 'RestoredData' }
  & Pick<RestoredData, 'data'>
  & { features?: Maybe<Array<Maybe<RestoreOpaqueDataQuery_restoreOpaqueData_RestoredData_features_GroupedFeatureResponse>>> }
);

export type RestoreOpaqueDataQuery_Query = (
  { __typename?: 'Query' }
  & { restoreOpaqueData?: Maybe<RestoreOpaqueDataQuery_restoreOpaqueData_RestoredData> }
);


export type RestoreOpaqueDataQueryVariables = Exact<{
  id?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
  qfLight?: InputMaybe<Scalars['Boolean']['input']>;
  includeFeatureRange?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type RestoreOpaqueDataQuery = RestoreOpaqueDataQuery_Query;

export type SendFeedbackMutation_Mutation = (
  { __typename?: 'Mutation' }
  & Pick<Mutation, 'sendFeedback'>
);


export type SendFeedbackMutationVariables = Exact<{
  clinicName?: InputMaybe<Scalars['String']['input']>;
  rating?: InputMaybe<Scalars['Int']['input']>;
  text?: InputMaybe<Scalars['String']['input']>;
  sharedCase?: InputMaybe<Scalars['String']['input']>;
  sharedCaseId?: InputMaybe<Scalars['String']['input']>;
  urlPrefix?: InputMaybe<Scalars['String']['input']>;
  sender?: InputMaybe<Scalars['String']['input']>;
}>;


export type SendFeedbackMutation = SendFeedbackMutation_Mutation;

export type GetPanelQuery_panel_Panel = (
  { __typename?: 'Panel' }
  & Pick<Panel, 'name' | 'id' | 'shortname'>
  & { category?: Maybe<PanelFragment_Panel_category_Feature>, panelGroup?: Maybe<PanelFragment_Panel_panelGroup_Feature>, panelSubgroup?: Maybe<PanelFragment_Panel_panelSubgroup_Feature>, findings?: Maybe<Array<Maybe<PanelFragment_Panel_findings_QualifiedFeature>>> }
);

export type GetPanelQuery_Query = (
  { __typename?: 'Query' }
  & { panel?: Maybe<GetPanelQuery_panel_Panel> }
);


export type GetPanelQueryVariables = Exact<{
  id: Scalars['ID']['input'];
  qfLight?: InputMaybe<Scalars['Boolean']['input']>;
  includeFeatureRange?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type GetPanelQuery = GetPanelQuery_Query;

export type GetPanelWithChildrenQuery_panel_Panel_children_Panel = (
  { __typename?: 'Panel' }
  & Pick<Panel, 'name' | 'id' | 'shortname'>
  & { category?: Maybe<PanelFragment_Panel_category_Feature>, panelGroup?: Maybe<PanelFragment_Panel_panelGroup_Feature>, panelSubgroup?: Maybe<PanelFragment_Panel_panelSubgroup_Feature>, findings?: Maybe<Array<Maybe<PanelFragment_Panel_findings_QualifiedFeature>>> }
);

export type GetPanelWithChildrenQuery_panel_Panel = (
  { __typename?: 'Panel' }
  & Pick<Panel, 'id'>
  & { children?: Maybe<Array<Maybe<GetPanelWithChildrenQuery_panel_Panel_children_Panel>>> }
);

export type GetPanelWithChildrenQuery_Query = (
  { __typename?: 'Query' }
  & { panel?: Maybe<GetPanelWithChildrenQuery_panel_Panel> }
);


export type GetPanelWithChildrenQueryVariables = Exact<{
  id: Scalars['ID']['input'];
  qfLight?: InputMaybe<Scalars['Boolean']['input']>;
  includeFeatureRange?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type GetPanelWithChildrenQuery = GetPanelWithChildrenQuery_Query;

export type SearchQualifiedFeaturesQueryQuery_qualifiedFeatureSearch_QualifiedFeature = (
  { __typename?: 'QualifiedFeature' }
  & Pick<QualifiedFeature, 'id' | 'name' | 'negate' | 'skip'>
  & { feature?: Maybe<FindingMetricsFragment_DiseaseFindingMetrics_finding_RCohort_qfs_QualifiedFeature_feature_Feature>, qualifiers?: Maybe<Array<Maybe<FindingMetricsFragment_DiseaseFindingMetrics_finding_RCohort_qfs_QualifiedFeature_qualifiers_Qualifier>>>, mandatory?: Maybe<FindingMetricsFragment_DiseaseFindingMetrics_finding_RCohort_qfs_QualifiedFeature_mandatory_Qualifier> }
);

export type SearchQualifiedFeaturesQueryQuery_Query = (
  { __typename?: 'Query' }
  & { qualifiedFeatureSearch?: Maybe<Array<Maybe<SearchQualifiedFeaturesQueryQuery_qualifiedFeatureSearch_QualifiedFeature>>> }
);


export type SearchQualifiedFeaturesQueryQueryVariables = Exact<{
  search?: InputMaybe<Scalars['String']['input']>;
  categories?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>> | InputMaybe<Scalars['ID']['input']>>;
  gender?: InputMaybe<Scalars['ID']['input']>;
  qfLight?: InputMaybe<Scalars['Boolean']['input']>;
  patientFacing?: InputMaybe<Scalars['Boolean']['input']>;
  includeFeatureRange?: InputMaybe<Scalars['Boolean']['input']>;
  panelIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>> | InputMaybe<Scalars['ID']['input']>>;
  ancestors?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>> | InputMaybe<Scalars['ID']['input']>>;
  customPatientFacingPropertyValues?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>> | InputMaybe<Scalars['String']['input']>>;
}>;


export type SearchQualifiedFeaturesQueryQuery = SearchQualifiedFeaturesQueryQuery_Query;

export type QualifierSearchQueryQuery_qualifierSearch_Qualifier = (
  { __typename?: 'Qualifier' }
  & Pick<Qualifier, 'name' | 'negate' | 'freeText' | 'source'>
  & { relation: FindingMetricsFragment_DiseaseFindingMetrics_finding_RCohort_qfs_QualifiedFeature_feature_Feature_qualifiers_Qualifier_relation_Relation, value?: Maybe<FindingMetricsFragment_DiseaseFindingMetrics_finding_RCohort_qfs_QualifiedFeature_feature_Feature_qualifiers_Qualifier_value_Feature>, range?: Maybe<FindingMetricsFragment_DiseaseFindingMetrics_finding_RCohort_qfs_QualifiedFeature_feature_Feature_qualifiers_Qualifier_range_MeasurementRange> }
);

export type QualifierSearchQueryQuery_Query = (
  { __typename?: 'Query' }
  & { qualifierSearch?: Maybe<Array<Maybe<QualifierSearchQueryQuery_qualifierSearch_Qualifier>>> }
);


export type QualifierSearchQueryQueryVariables = Exact<{
  feature: Scalars['ID']['input'];
  relation?: InputMaybe<Scalars['ID']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  qfLight?: InputMaybe<Scalars['Boolean']['input']>;
  includeFeatureRange?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type QualifierSearchQueryQuery = QualifierSearchQueryQuery_Query;

export type FreeTextToPatientCaseQuery_freeTextToPatientCase_FreeTextToPatientResponse_patientFindings_GroupedFeatureResponse = (
  { __typename?: 'GroupedFeatureResponse' }
  & Pick<GroupedFeatureResponse, 'skip' | 'source' | 'group' | 'validation'>
  & { feature?: Maybe<GroupedFeatureResponseFragment_GroupedFeatureResponse_feature_QualifiedFeature> }
);

export type FreeTextToPatientCaseQuery_freeTextToPatientCase_FreeTextToPatientResponse = (
  { __typename?: 'FreeTextToPatientResponse' }
  & Pick<FreeTextToPatientResponse, 'debug'>
  & { patientFindings?: Maybe<Array<Maybe<FreeTextToPatientCaseQuery_freeTextToPatientCase_FreeTextToPatientResponse_patientFindings_GroupedFeatureResponse>>> }
);

export type FreeTextToPatientCaseQuery_Query = (
  { __typename?: 'Query' }
  & { freeTextToPatientCase?: Maybe<FreeTextToPatientCaseQuery_freeTextToPatientCase_FreeTextToPatientResponse> }
);


export type FreeTextToPatientCaseQueryVariables = Exact<{
  text?: InputMaybe<Scalars['String']['input']>;
  qfLight?: InputMaybe<Scalars['Boolean']['input']>;
  includeFeatureRange?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type FreeTextToPatientCaseQuery = FreeTextToPatientCaseQuery_Query;

export type RunLoadersStatusQueryQuery_runLoadersStatus_RunLoadersStatusResult_loaders_LoaderInfoResult = (
  { __typename?: 'LoaderInfoResult' }
  & Pick<LoaderInfoResult, 'shard' | 'shardtotal' | 'processed' | 'processedtotal' | 'date' | 'lastevent' | 'state'>
);

export type RunLoadersStatusQueryQuery_runLoadersStatus_RunLoadersStatusResult = (
  { __typename?: 'RunLoadersStatusResult' }
  & Pick<RunLoadersStatusResult, 'id' | 'filter' | 'startedat' | 'shardtotal' | 'version' | 'commitserial' | 'revision' | 'codeversion' | 'state' | 'url' | 'runningEnv'>
  & { loaders?: Maybe<Array<Maybe<RunLoadersStatusQueryQuery_runLoadersStatus_RunLoadersStatusResult_loaders_LoaderInfoResult>>> }
);

export type RunLoadersStatusQueryQuery_Query = (
  { __typename?: 'Query' }
  & { runLoadersStatus?: Maybe<Array<Maybe<RunLoadersStatusQueryQuery_runLoadersStatus_RunLoadersStatusResult>>> }
);


export type RunLoadersStatusQueryQueryVariables = Exact<{
  env?: InputMaybe<Scalars['String']['input']>;
}>;


export type RunLoadersStatusQueryQuery = RunLoadersStatusQueryQuery_Query;

export type MetricsPreloadMutation_metricsPreload_MetricsPreloadResult = (
  { __typename?: 'MetricsPreloadResult' }
  & Pick<MetricsPreloadResult, 'success'>
);

export type MetricsPreloadMutation_Mutation = (
  { __typename?: 'Mutation' }
  & { metricsPreload?: Maybe<MetricsPreloadMutation_metricsPreload_MetricsPreloadResult> }
);


export type MetricsPreloadMutationVariables = Exact<{
  env?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<Scalars['String']['input']>;
  shards?: InputMaybe<Scalars['Int']['input']>;
  taskversion?: InputMaybe<Scalars['String']['input']>;
}>;


export type MetricsPreloadMutation = MetricsPreloadMutation_Mutation;

export type SetVersionStateMutation_Mutation = (
  { __typename?: 'Mutation' }
  & Pick<Mutation, 'setVersionState'>
);


export type SetVersionStateMutationVariables = Exact<{
  env?: InputMaybe<Scalars['String']['input']>;
  version?: InputMaybe<Scalars['String']['input']>;
  state?: InputMaybe<GVersionState>;
}>;


export type SetVersionStateMutation = SetVersionStateMutation_Mutation;

export type SetVersionRunningEnvMutation_Mutation = (
  { __typename?: 'Mutation' }
  & Pick<Mutation, 'setVersionRunningEnv'>
);


export type SetVersionRunningEnvMutationVariables = Exact<{
  env?: InputMaybe<Scalars['String']['input']>;
  version?: InputMaybe<Scalars['String']['input']>;
  runningEnv?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>> | InputMaybe<Scalars['String']['input']>>;
}>;


export type SetVersionRunningEnvMutation = SetVersionRunningEnvMutation_Mutation;

export type MetricsQfQuery_metricsQF_QFMetrics = (
  { __typename?: 'QFMetrics' }
  & Pick<QfMetrics, 'id' | 'incidence' | 'prevalence' | 'incidenceDescription' | 'incidenceSource' | 'prevalenceDescription' | 'prevalenceSource'>
);

export type MetricsQfQuery_Query = (
  { __typename?: 'Query' }
  & { metricsQF?: Maybe<Array<Maybe<MetricsQfQuery_metricsQF_QFMetrics>>> }
);


export type MetricsQfQueryVariables = Exact<{
  qfs?: InputMaybe<Array<InputMaybe<QualifiedFeatureInput>> | InputMaybe<QualifiedFeatureInput>>;
}>;


export type MetricsQfQuery = MetricsQfQuery_Query;

export type QfsCorrelateQuery_qfsCorrelate_QFSCorrelate_qfs1_QFDetails = (
  { __typename?: 'QFDetails' }
  & Pick<QfDetails, 'name'>
);

export type QfsCorrelateQuery_qfsCorrelate_QFSCorrelate_qfs2_QFDetails = (
  { __typename?: 'QFDetails' }
  & Pick<QfDetails, 'name'>
);

export type QfsCorrelateQuery_qfsCorrelate_QFSCorrelate = (
  { __typename?: 'QFSCorrelate' }
  & Pick<QfsCorrelate, 'correlate'>
  & { qfs1?: Maybe<QfsCorrelateQuery_qfsCorrelate_QFSCorrelate_qfs1_QFDetails>, qfs2?: Maybe<QfsCorrelateQuery_qfsCorrelate_QFSCorrelate_qfs2_QFDetails> }
);

export type QfsCorrelateQuery_Query = (
  { __typename?: 'Query' }
  & { qfsCorrelate?: Maybe<QfsCorrelateQuery_qfsCorrelate_QFSCorrelate> }
);


export type QfsCorrelateQueryVariables = Exact<{
  qfs1?: InputMaybe<Array<InputMaybe<QualifiedFeatureInput>> | InputMaybe<QualifiedFeatureInput>>;
  qfs2?: InputMaybe<Array<InputMaybe<QualifiedFeatureInput>> | InputMaybe<QualifiedFeatureInput>>;
}>;


export type QfsCorrelateQuery = QfsCorrelateQuery_Query;

export type QfsCorrelateListsQuery_qfsCorrelateLists_QFSCorrelate_qfs1_QFDetails = (
  { __typename?: 'QFDetails' }
  & Pick<QfDetails, 'name'>
);

export type QfsCorrelateListsQuery_qfsCorrelateLists_QFSCorrelate_qfs2_QFDetails = (
  { __typename?: 'QFDetails' }
  & Pick<QfDetails, 'name'>
);

export type QfsCorrelateListsQuery_qfsCorrelateLists_QFSCorrelate = (
  { __typename?: 'QFSCorrelate' }
  & Pick<QfsCorrelate, 'correlate'>
  & { qfs1?: Maybe<QfsCorrelateListsQuery_qfsCorrelateLists_QFSCorrelate_qfs1_QFDetails>, qfs2?: Maybe<QfsCorrelateListsQuery_qfsCorrelateLists_QFSCorrelate_qfs2_QFDetails> }
);

export type QfsCorrelateListsQuery_Query = (
  { __typename?: 'Query' }
  & { qfsCorrelateLists?: Maybe<Array<Maybe<QfsCorrelateListsQuery_qfsCorrelateLists_QFSCorrelate>>> }
);


export type QfsCorrelateListsQueryVariables = Exact<{
  qfsList1?: InputMaybe<Array<InputMaybe<Array<InputMaybe<QualifiedFeatureInput>> | InputMaybe<QualifiedFeatureInput>>> | InputMaybe<Array<InputMaybe<QualifiedFeatureInput>> | InputMaybe<QualifiedFeatureInput>>>;
  qfsList2?: InputMaybe<Array<InputMaybe<Array<InputMaybe<QualifiedFeatureInput>> | InputMaybe<QualifiedFeatureInput>>> | InputMaybe<Array<InputMaybe<QualifiedFeatureInput>> | InputMaybe<QualifiedFeatureInput>>>;
}>;


export type QfsCorrelateListsQuery = QfsCorrelateListsQuery_Query;

export type LambdaTestsMutation_lambdaTests_LambdaTestResult = (
  { __typename?: 'LambdaTestResult' }
  & Pick<LambdaTestResult, 'success'>
);

export type LambdaTestsMutation_Mutation = (
  { __typename?: 'Mutation' }
  & { lambdaTests?: Maybe<LambdaTestsMutation_lambdaTests_LambdaTestResult> }
);


export type LambdaTestsMutationVariables = Exact<{
  devEnv?: InputMaybe<Scalars['String']['input']>;
  project?: InputMaybe<Scalars['String']['input']>;
  headline?: InputMaybe<Scalars['String']['input']>;
  cases?: InputMaybe<Scalars['String']['input']>;
  multiFilter?: InputMaybe<Scalars['String']['input']>;
  tagsFilter?: InputMaybe<Scalars['String']['input']>;
  taskVersion?: InputMaybe<Scalars['String']['input']>;
  modelVersion?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<Scalars['String']['input']>;
  panel?: InputMaybe<Scalars['String']['input']>;
  keepFunctions?: InputMaybe<Scalars['Int']['input']>;
  disableLogs?: InputMaybe<Scalars['Int']['input']>;
  concurrency?: InputMaybe<Scalars['Int']['input']>;
  loops?: InputMaybe<Scalars['String']['input']>;
}>;


export type LambdaTestsMutation = LambdaTestsMutation_Mutation;

export type CreateClinicMutation_user_UserMutations_createClinic_ClinicData = (
  { __typename?: 'ClinicData' }
  & Pick<ClinicData, 'id' | 'name' | 'config' | 'displayName'>
);

export type CreateClinicMutation_user_UserMutations = (
  { __typename?: 'UserMutations' }
  & { createClinic?: Maybe<CreateClinicMutation_user_UserMutations_createClinic_ClinicData> }
);

export type CreateClinicMutation_Mutation = (
  { __typename?: 'Mutation' }
  & { user?: Maybe<CreateClinicMutation_user_UserMutations> }
);


export type CreateClinicMutationVariables = Exact<{
  name?: InputMaybe<Scalars['String']['input']>;
  config?: InputMaybe<Scalars['Config']['input']>;
  displayName?: InputMaybe<Scalars['String']['input']>;
}>;


export type CreateClinicMutation = CreateClinicMutation_Mutation;

export type RenameClinicMutation_clinic_ClinicMutations_renameClinic_Result = (
  { __typename?: 'Result' }
  & Pick<Result, 'status'>
);

export type RenameClinicMutation_clinic_ClinicMutations = (
  { __typename?: 'ClinicMutations' }
  & { renameClinic?: Maybe<RenameClinicMutation_clinic_ClinicMutations_renameClinic_Result> }
);

export type RenameClinicMutation_Mutation = (
  { __typename?: 'Mutation' }
  & { clinic?: Maybe<RenameClinicMutation_clinic_ClinicMutations> }
);


export type RenameClinicMutationVariables = Exact<{
  id?: InputMaybe<Scalars['ID']['input']>;
  newName?: InputMaybe<Scalars['String']['input']>;
  newDisplayName?: InputMaybe<Scalars['String']['input']>;
}>;


export type RenameClinicMutation = RenameClinicMutation_Mutation;

export type SetClinicConfigMutation_clinic_ClinicMutations_setConfig_Result = (
  { __typename?: 'Result' }
  & Pick<Result, 'status'>
);

export type SetClinicConfigMutation_clinic_ClinicMutations = (
  { __typename?: 'ClinicMutations' }
  & { setConfig?: Maybe<SetClinicConfigMutation_clinic_ClinicMutations_setConfig_Result> }
);

export type SetClinicConfigMutation_Mutation = (
  { __typename?: 'Mutation' }
  & { clinic?: Maybe<SetClinicConfigMutation_clinic_ClinicMutations> }
);


export type SetClinicConfigMutationVariables = Exact<{
  id?: InputMaybe<Scalars['ID']['input']>;
  config?: InputMaybe<Scalars['Config']['input']>;
}>;


export type SetClinicConfigMutation = SetClinicConfigMutation_Mutation;

export type AddUserMutation_clinic_ClinicMutations_addUser_Result = (
  { __typename?: 'Result' }
  & Pick<Result, 'status'>
);

export type AddUserMutation_clinic_ClinicMutations = (
  { __typename?: 'ClinicMutations' }
  & { addUser?: Maybe<AddUserMutation_clinic_ClinicMutations_addUser_Result> }
);

export type AddUserMutation_Mutation = (
  { __typename?: 'Mutation' }
  & { clinic?: Maybe<AddUserMutation_clinic_ClinicMutations> }
);


export type AddUserMutationVariables = Exact<{
  clinicId?: InputMaybe<Scalars['ID']['input']>;
  user?: InputMaybe<Scalars['ID']['input']>;
  role?: InputMaybe<UserRoles>;
}>;


export type AddUserMutation = AddUserMutation_Mutation;

export type DelUserMutation_clinic_ClinicMutations_delUser_Result = (
  { __typename?: 'Result' }
  & Pick<Result, 'status'>
);

export type DelUserMutation_clinic_ClinicMutations = (
  { __typename?: 'ClinicMutations' }
  & { delUser?: Maybe<DelUserMutation_clinic_ClinicMutations_delUser_Result> }
);

export type DelUserMutation_Mutation = (
  { __typename?: 'Mutation' }
  & { clinic?: Maybe<DelUserMutation_clinic_ClinicMutations> }
);


export type DelUserMutationVariables = Exact<{
  clinicId?: InputMaybe<Scalars['ID']['input']>;
  user?: InputMaybe<Scalars['ID']['input']>;
}>;


export type DelUserMutation = DelUserMutation_Mutation;

export type GetUsersOfClinicQuery_clinic_ClinicQueries_users_UserData = (
  { __typename?: 'UserData' }
  & Pick<UserData, 'email' | 'role'>
);

export type GetUsersOfClinicQuery_clinic_ClinicQueries = (
  { __typename?: 'ClinicQueries' }
  & { users?: Maybe<Array<Maybe<GetUsersOfClinicQuery_clinic_ClinicQueries_users_UserData>>> }
);

export type GetUsersOfClinicQuery_Query = (
  { __typename?: 'Query' }
  & { clinic?: Maybe<GetUsersOfClinicQuery_clinic_ClinicQueries> }
);


export type GetUsersOfClinicQueryVariables = Exact<{
  id?: InputMaybe<Scalars['ID']['input']>;
}>;


export type GetUsersOfClinicQuery = GetUsersOfClinicQuery_Query;

export type GetUserDataQuery_clinic_ClinicQueries_userData_UserData = (
  { __typename?: 'UserData' }
  & Pick<UserData, 'email' | 'role'>
);

export type GetUserDataQuery_clinic_ClinicQueries = (
  { __typename?: 'ClinicQueries' }
  & { userData?: Maybe<GetUserDataQuery_clinic_ClinicQueries_userData_UserData> }
);

export type GetUserDataQuery_Query = (
  { __typename?: 'Query' }
  & { clinic?: Maybe<GetUserDataQuery_clinic_ClinicQueries> }
);


export type GetUserDataQueryVariables = Exact<{
  id?: InputMaybe<Scalars['ID']['input']>;
}>;


export type GetUserDataQuery = GetUserDataQuery_Query;

export type UserClinicsQuery_user_UserQueries_clinics_ClinicData = (
  { __typename?: 'ClinicData' }
  & Pick<ClinicData, 'config' | 'id' | 'name' | 'displayName'>
);

export type UserClinicsQuery_user_UserQueries = (
  { __typename?: 'UserQueries' }
  & { clinics?: Maybe<Array<Maybe<UserClinicsQuery_user_UserQueries_clinics_ClinicData>>> }
);

export type UserClinicsQuery_Query = (
  { __typename?: 'Query' }
  & { user?: Maybe<UserClinicsQuery_user_UserQueries> }
);


export type UserClinicsQueryVariables = Exact<{
  onlyMyClinics?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type UserClinicsQuery = UserClinicsQuery_Query;

export type IsClinicNameAvailableQuery_user_UserQueries = (
  { __typename?: 'UserQueries' }
  & Pick<UserQueries, 'isClinicNameAvailable'>
);

export type IsClinicNameAvailableQuery_Query = (
  { __typename?: 'Query' }
  & { user?: Maybe<IsClinicNameAvailableQuery_user_UserQueries> }
);


export type IsClinicNameAvailableQueryVariables = Exact<{
  name?: InputMaybe<Scalars['String']['input']>;
}>;


export type IsClinicNameAvailableQuery = IsClinicNameAvailableQuery_Query;

export type RecentCodesQuery_clinic_ClinicQueries_recentCodes_ShareCodeData = (
  { __typename?: 'ShareCodeData' }
  & Pick<ShareCodeData, 'patientProperties' | 'visitStatus' | 'id' | 'date' | 'shareid' | 'seen' | 'digitCode' | 'comment'>
);

export type RecentCodesQuery_clinic_ClinicQueries = (
  { __typename?: 'ClinicQueries' }
  & { recentCodes?: Maybe<Array<Maybe<RecentCodesQuery_clinic_ClinicQueries_recentCodes_ShareCodeData>>> }
);

export type RecentCodesQuery_Query = (
  { __typename?: 'Query' }
  & { clinic?: Maybe<RecentCodesQuery_clinic_ClinicQueries> }
);


export type RecentCodesQueryVariables = Exact<{
  id?: InputMaybe<Scalars['ID']['input']>;
  daysPrior?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  isFinished?: InputMaybe<Scalars['Boolean']['input']>;
  exclusiveStartId?: InputMaybe<Scalars['String']['input']>;
  exclusiveStartDate?: InputMaybe<Scalars['Float']['input']>;
}>;


export type RecentCodesQuery = RecentCodesQuery_Query;

export type RecentVisitsQuery_clinic_ClinicQueries_recentVisits_Visits_visits_ShareCodeData = (
  { __typename?: 'ShareCodeData' }
  & Pick<ShareCodeData, 'patientProperties' | 'visitStatus' | 'id' | 'date' | 'shareid' | 'seen' | 'digitCode' | 'comment'>
);

export type RecentVisitsQuery_clinic_ClinicQueries_recentVisits_Visits = (
  { __typename?: 'Visits' }
  & Pick<Visits, 'startKey'>
  & { visits?: Maybe<Array<Maybe<RecentVisitsQuery_clinic_ClinicQueries_recentVisits_Visits_visits_ShareCodeData>>> }
);

export type RecentVisitsQuery_clinic_ClinicQueries = (
  { __typename?: 'ClinicQueries' }
  & { recentVisits?: Maybe<RecentVisitsQuery_clinic_ClinicQueries_recentVisits_Visits> }
);

export type RecentVisitsQuery_Query = (
  { __typename?: 'Query' }
  & { clinic?: Maybe<RecentVisitsQuery_clinic_ClinicQueries> }
);


export type RecentVisitsQueryVariables = Exact<{
  id?: InputMaybe<Scalars['ID']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  isFinished?: InputMaybe<Scalars['Boolean']['input']>;
  startKey?: InputMaybe<Scalars['StartKey']['input']>;
  order?: InputMaybe<Order>;
}>;


export type RecentVisitsQuery = RecentVisitsQuery_Query;

export type FilteredVisitsQuery_clinic_ClinicQueries_filteredVisits_Visits_visits_ShareCodeData_visitStatusStructure_VisitStatusStructure = (
  { __typename?: 'VisitStatusStructure' }
  & Pick<VisitStatusStructure, 'age' | 'gender' | 'status'>
  & { visitReason?: Maybe<Array<Maybe<VisitStatusFragmentFragment_VisitStatusStructure_visitReason_Feature>>>, chiefComplaint?: Maybe<VisitStatusFragmentFragment_VisitStatusStructure_chiefComplaint_Feature> }
);

export type FilteredVisitsQuery_clinic_ClinicQueries_filteredVisits_Visits_visits_ShareCodeData = (
  { __typename?: 'ShareCodeData' }
  & Pick<ShareCodeData, 'visitStatus' | 'patientProperties' | 'id' | 'date' | 'shareid' | 'seen' | 'digitCode' | 'comment'>
  & { visitStatusStructure?: Maybe<FilteredVisitsQuery_clinic_ClinicQueries_filteredVisits_Visits_visits_ShareCodeData_visitStatusStructure_VisitStatusStructure> }
);

export type FilteredVisitsQuery_clinic_ClinicQueries_filteredVisits_Visits = (
  { __typename?: 'Visits' }
  & Pick<Visits, 'startKey' | 'count'>
  & { visits?: Maybe<Array<Maybe<FilteredVisitsQuery_clinic_ClinicQueries_filteredVisits_Visits_visits_ShareCodeData>>> }
);

export type FilteredVisitsQuery_clinic_ClinicQueries = (
  { __typename?: 'ClinicQueries' }
  & { filteredVisits?: Maybe<FilteredVisitsQuery_clinic_ClinicQueries_filteredVisits_Visits> }
);

export type FilteredVisitsQuery_Query = (
  { __typename?: 'Query' }
  & { clinic?: Maybe<FilteredVisitsQuery_clinic_ClinicQueries> }
);


export type FilteredVisitsQueryVariables = Exact<{
  id?: InputMaybe<Scalars['ID']['input']>;
  filter?: InputMaybe<FilterInput>;
  startKey?: InputMaybe<Scalars['StartKey']['input']>;
  sortKey?: InputMaybe<Scalars['String']['input']>;
  limitRequested?: InputMaybe<Scalars['Int']['input']>;
  isFinished?: InputMaybe<Scalars['Boolean']['input']>;
  order?: InputMaybe<Order>;
}>;


export type FilteredVisitsQuery = FilteredVisitsQuery_Query;

export type GetCodeQuery_clinic_ClinicQueries_getCodeByDigits_ShareCodeData_visitStatusStructure_VisitStatusStructure = (
  { __typename?: 'VisitStatusStructure' }
  & Pick<VisitStatusStructure, 'age' | 'gender' | 'status'>
  & { visitReason?: Maybe<Array<Maybe<VisitStatusFragmentFragment_VisitStatusStructure_visitReason_Feature>>>, chiefComplaint?: Maybe<VisitStatusFragmentFragment_VisitStatusStructure_chiefComplaint_Feature> }
);

export type GetCodeQuery_clinic_ClinicQueries_getCodeByDigits_ShareCodeData = (
  { __typename?: 'ShareCodeData' }
  & Pick<ShareCodeData, 'patientProperties' | 'id' | 'date' | 'shareid' | 'seen' | 'digitCode' | 'comment'>
  & { visitStatusStructure?: Maybe<GetCodeQuery_clinic_ClinicQueries_getCodeByDigits_ShareCodeData_visitStatusStructure_VisitStatusStructure> }
);

export type GetCodeQuery_clinic_ClinicQueries = (
  { __typename?: 'ClinicQueries' }
  & { getCodeByDigits?: Maybe<GetCodeQuery_clinic_ClinicQueries_getCodeByDigits_ShareCodeData> }
);

export type GetCodeQuery_Query = (
  { __typename?: 'Query' }
  & { clinic?: Maybe<GetCodeQuery_clinic_ClinicQueries> }
);


export type GetCodeQueryVariables = Exact<{
  id?: InputMaybe<Scalars['ID']['input']>;
  code?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetCodeQuery = GetCodeQuery_Query;

export type GetCodeByIdQuery_clinic_ClinicQueries_getCodeById_ShareCodeData = (
  { __typename?: 'ShareCodeData' }
  & Pick<ShareCodeData, 'id' | 'digitCode' | 'shareid' | 'date'>
);

export type GetCodeByIdQuery_clinic_ClinicQueries = (
  { __typename?: 'ClinicQueries' }
  & { getCodeById?: Maybe<GetCodeByIdQuery_clinic_ClinicQueries_getCodeById_ShareCodeData> }
);

export type GetCodeByIdQuery_Query = (
  { __typename?: 'Query' }
  & { clinic?: Maybe<GetCodeByIdQuery_clinic_ClinicQueries> }
);


export type GetCodeByIdQueryVariables = Exact<{
  clinicId?: InputMaybe<Scalars['ID']['input']>;
  shareId?: InputMaybe<Scalars['ID']['input']>;
  ehrid?: InputMaybe<Scalars['ID']['input']>;
}>;


export type GetCodeByIdQuery = GetCodeByIdQuery_Query;

export type DeleteCodeMutation_clinic_ClinicMutations_deleteCode_Result = (
  { __typename?: 'Result' }
  & Pick<Result, 'status'>
);

export type DeleteCodeMutation_clinic_ClinicMutations = (
  { __typename?: 'ClinicMutations' }
  & { deleteCode?: Maybe<DeleteCodeMutation_clinic_ClinicMutations_deleteCode_Result> }
);

export type DeleteCodeMutation_Mutation = (
  { __typename?: 'Mutation' }
  & { clinic?: Maybe<DeleteCodeMutation_clinic_ClinicMutations> }
);


export type DeleteCodeMutationVariables = Exact<{
  clinicId?: InputMaybe<Scalars['ID']['input']>;
  code?: InputMaybe<Scalars['String']['input']>;
}>;


export type DeleteCodeMutation = DeleteCodeMutation_Mutation;

export type AddUserCommentMutation_clinic_ClinicMutations_addUserComment_Result = (
  { __typename?: 'Result' }
  & Pick<Result, 'status'>
);

export type AddUserCommentMutation_clinic_ClinicMutations = (
  { __typename?: 'ClinicMutations' }
  & { addUserComment?: Maybe<AddUserCommentMutation_clinic_ClinicMutations_addUserComment_Result> }
);

export type AddUserCommentMutation_Mutation = (
  { __typename?: 'Mutation' }
  & { clinic?: Maybe<AddUserCommentMutation_clinic_ClinicMutations> }
);


export type AddUserCommentMutationVariables = Exact<{
  clinicId?: InputMaybe<Scalars['ID']['input']>;
  code?: InputMaybe<Scalars['String']['input']>;
  comment?: InputMaybe<Scalars['String']['input']>;
}>;


export type AddUserCommentMutation = AddUserCommentMutation_Mutation;

export type ClinicDataQuery_clinic_ClinicQueries_data_ClinicData = (
  { __typename?: 'ClinicData' }
  & Pick<ClinicData, 'config' | 'mergedConfiguration' | 'name' | 'id' | 'displayName'>
);

export type ClinicDataQuery_clinic_ClinicQueries = (
  { __typename?: 'ClinicQueries' }
  & { data?: Maybe<ClinicDataQuery_clinic_ClinicQueries_data_ClinicData> }
);

export type ClinicDataQuery_Query = (
  { __typename?: 'Query' }
  & { clinic?: Maybe<ClinicDataQuery_clinic_ClinicQueries> }
);


export type ClinicDataQueryVariables = Exact<{
  id?: InputMaybe<Scalars['ID']['input']>;
}>;


export type ClinicDataQuery = ClinicDataQuery_Query;

export type GetClinicConfigQuery_clinic_ClinicQueries_data_ClinicData = (
  { __typename?: 'ClinicData' }
  & Pick<ClinicData, 'config' | 'mergedConfiguration' | 'name'>
);

export type GetClinicConfigQuery_clinic_ClinicQueries = (
  { __typename?: 'ClinicQueries' }
  & { data?: Maybe<GetClinicConfigQuery_clinic_ClinicQueries_data_ClinicData> }
);

export type GetClinicConfigQuery_Query = (
  { __typename?: 'Query' }
  & { clinic?: Maybe<GetClinicConfigQuery_clinic_ClinicQueries> }
);


export type GetClinicConfigQueryVariables = Exact<{
  id?: InputMaybe<Scalars['ID']['input']>;
}>;


export type GetClinicConfigQuery = GetClinicConfigQuery_Query;

export type ClinicByNameQuery_clinicByName_ClinicQueries_data_ClinicData = (
  { __typename?: 'ClinicData' }
  & Pick<ClinicData, 'config' | 'mergedConfiguration' | 'name' | 'displayName' | 'id'>
);

export type ClinicByNameQuery_clinicByName_ClinicQueries = (
  { __typename?: 'ClinicQueries' }
  & { data?: Maybe<ClinicByNameQuery_clinicByName_ClinicQueries_data_ClinicData> }
);

export type ClinicByNameQuery_Query = (
  { __typename?: 'Query' }
  & { clinicByName?: Maybe<ClinicByNameQuery_clinicByName_ClinicQueries> }
);


export type ClinicByNameQueryVariables = Exact<{
  name?: InputMaybe<Scalars['String']['input']>;
}>;


export type ClinicByNameQuery = ClinicByNameQuery_Query;

export type MakeClinicShortCodeMutation_clinic_ClinicMutations_updateFinished_ShareCodeData = (
  { __typename?: 'ShareCodeData' }
  & Pick<ShareCodeData, 'id' | 'date' | 'shareid' | 'seen' | 'digitCode' | 'comment'>
);

export type MakeClinicShortCodeMutation_clinic_ClinicMutations = (
  { __typename?: 'ClinicMutations' }
  & { updateFinished?: Maybe<MakeClinicShortCodeMutation_clinic_ClinicMutations_updateFinished_ShareCodeData> }
);

export type MakeClinicShortCodeMutation_Mutation = (
  { __typename?: 'Mutation' }
  & { clinic?: Maybe<MakeClinicShortCodeMutation_clinic_ClinicMutations> }
);


export type MakeClinicShortCodeMutationVariables = Exact<{
  id?: InputMaybe<Scalars['ID']['input']>;
  shareid?: InputMaybe<Scalars['String']['input']>;
}>;


export type MakeClinicShortCodeMutation = MakeClinicShortCodeMutation_Mutation;

export type CopyCaseToClinicMutation_clinic_ClinicMutations_copyCaseToClinic_Result = (
  { __typename?: 'Result' }
  & Pick<Result, 'status'>
);

export type CopyCaseToClinicMutation_clinic_ClinicMutations = (
  { __typename?: 'ClinicMutations' }
  & { copyCaseToClinic?: Maybe<CopyCaseToClinicMutation_clinic_ClinicMutations_copyCaseToClinic_Result> }
);

export type CopyCaseToClinicMutation_Mutation = (
  { __typename?: 'Mutation' }
  & { clinic?: Maybe<CopyCaseToClinicMutation_clinic_ClinicMutations> }
);


export type CopyCaseToClinicMutationVariables = Exact<{
  clinicId?: InputMaybe<Scalars['ID']['input']>;
  caseId?: InputMaybe<Scalars['String']['input']>;
  destClinicId?: InputMaybe<Scalars['String']['input']>;
}>;


export type CopyCaseToClinicMutation = CopyCaseToClinicMutation_Mutation;

export type UpdateSeenByUserMutation_clinic_ClinicMutations_updateSeenByUser_ShareCodeData = (
  { __typename?: 'ShareCodeData' }
  & Pick<ShareCodeData, 'id' | 'date' | 'shareid' | 'seen' | 'digitCode' | 'comment'>
);

export type UpdateSeenByUserMutation_clinic_ClinicMutations = (
  { __typename?: 'ClinicMutations' }
  & { updateSeenByUser?: Maybe<UpdateSeenByUserMutation_clinic_ClinicMutations_updateSeenByUser_ShareCodeData> }
);

export type UpdateSeenByUserMutation_Mutation = (
  { __typename?: 'Mutation' }
  & { clinic?: Maybe<UpdateSeenByUserMutation_clinic_ClinicMutations> }
);


export type UpdateSeenByUserMutationVariables = Exact<{
  clinicId?: InputMaybe<Scalars['ID']['input']>;
  code?: InputMaybe<Scalars['String']['input']>;
  user?: InputMaybe<Scalars['String']['input']>;
  isSeen?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type UpdateSeenByUserMutation = UpdateSeenByUserMutation_Mutation;

export type DeleteClinicMutation_clinic_ClinicMutations_deleteClinic_Result = (
  { __typename?: 'Result' }
  & Pick<Result, 'status'>
);

export type DeleteClinicMutation_clinic_ClinicMutations = (
  { __typename?: 'ClinicMutations' }
  & { deleteClinic?: Maybe<DeleteClinicMutation_clinic_ClinicMutations_deleteClinic_Result> }
);

export type DeleteClinicMutation_Mutation = (
  { __typename?: 'Mutation' }
  & { clinic?: Maybe<DeleteClinicMutation_clinic_ClinicMutations> }
);


export type DeleteClinicMutationVariables = Exact<{
  id?: InputMaybe<Scalars['ID']['input']>;
}>;


export type DeleteClinicMutation = DeleteClinicMutation_Mutation;

export type PatientSummaryByCaseQuery_patientSummaryByCase_Summary_data_SummeryData = (
  { __typename?: 'SummeryData' }
  & Pick<SummeryData, 'age' | 'gender' | 'main'>
  & { visitReason?: Maybe<Array<Maybe<PatientFirstSummaryFragment_SummeryData_visitReason_SummaryVisitReason>>>, sections?: Maybe<Array<Maybe<PatientFirstSummaryFragment_SummeryData_sections_SummerySection>>> }
);

export type PatientSummaryByCaseQuery_patientSummaryByCase_Summary = (
  { __typename?: 'Summary' }
  & { data?: Maybe<PatientSummaryByCaseQuery_patientSummaryByCase_Summary_data_SummeryData> }
);

export type PatientSummaryByCaseQuery_Query = (
  { __typename?: 'Query' }
  & { patientSummaryByCase?: Maybe<PatientSummaryByCaseQuery_patientSummaryByCase_Summary> }
);


export type PatientSummaryByCaseQueryVariables = Exact<{
  patientCase?: InputMaybe<PatientCaseInput>;
  diseases?: InputMaybe<Array<InputMaybe<QualifiedFeatureInput>> | InputMaybe<QualifiedFeatureInput>>;
  suggestions?: InputMaybe<Array<InputMaybe<QualifiedFeatureInput>> | InputMaybe<QualifiedFeatureInput>>;
  options?: InputMaybe<SummaryOptions>;
  summaryOptions?: InputMaybe<Scalars['SummaryOptionsInput']['input']>;
}>;


export type PatientSummaryByCaseQuery = PatientSummaryByCaseQuery_Query;

export type MetricsPathsQuery_metricsPaths_MetricsPath_nodes_MetricsNode = (
  { __typename?: 'MetricsNode' }
  & Pick<MetricsNode, 'name' | 'desc'>
);

export type MetricsPathsQuery_metricsPaths_MetricsPath_edges_MetricsEdge_stats_MetricsEdgeStat_ruleValue_RuleValue_citationsObj_CitationData = (
  { __typename?: 'CitationData' }
  & Pick<CitationData, 'id' | 'vancouver'>
);

export type MetricsPathsQuery_metricsPaths_MetricsPath_edges_MetricsEdge_stats_MetricsEdgeStat_ruleValue_RuleValue = (
  { __typename?: 'RuleValue' }
  & Pick<RuleValue, 'id' | 'ruleValueId' | 'type' | 'exactCitation'>
  & { citationsObj?: Maybe<MetricsPathsQuery_metricsPaths_MetricsPath_edges_MetricsEdge_stats_MetricsEdgeStat_ruleValue_RuleValue_citationsObj_CitationData> }
);

export type MetricsPathsQuery_metricsPaths_MetricsPath_edges_MetricsEdge_stats_MetricsEdgeStat = (
  { __typename?: 'MetricsEdgeStat' }
  & Pick<MetricsEdgeStat, 'rate' | 'unit' | 'lastCommitDate'>
  & { ruleValue?: Maybe<MetricsPathsQuery_metricsPaths_MetricsPath_edges_MetricsEdge_stats_MetricsEdgeStat_ruleValue_RuleValue> }
);

export type MetricsPathsQuery_metricsPaths_MetricsPath_edges_MetricsEdge = (
  { __typename?: 'MetricsEdge' }
  & Pick<MetricsEdge, 'type' | 'prob' | 'incidence' | 'lift'>
  & { stats?: Maybe<Array<Maybe<MetricsPathsQuery_metricsPaths_MetricsPath_edges_MetricsEdge_stats_MetricsEdgeStat>>> }
);

export type MetricsPathsQuery_metricsPaths_MetricsPath = (
  { __typename?: 'MetricsPath' }
  & Pick<MetricsPath, 'causeId' | 'effectId' | 'prob'>
  & { nodes?: Maybe<Array<Maybe<MetricsPathsQuery_metricsPaths_MetricsPath_nodes_MetricsNode>>>, edges?: Maybe<Array<Maybe<MetricsPathsQuery_metricsPaths_MetricsPath_edges_MetricsEdge>>> }
);

export type MetricsPathsQuery_Query = (
  { __typename?: 'Query' }
  & { metricsPaths?: Maybe<Array<Maybe<MetricsPathsQuery_metricsPaths_MetricsPath>>> }
);


export type MetricsPathsQueryVariables = Exact<{
  causeids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>> | InputMaybe<Scalars['String']['input']>>;
  effectids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>> | InputMaybe<Scalars['String']['input']>>;
  causeqfs?: InputMaybe<Array<InputMaybe<QualifiedFeatureInput>> | InputMaybe<QualifiedFeatureInput>>;
  effectqfs?: InputMaybe<Array<InputMaybe<QualifiedFeatureInput>> | InputMaybe<QualifiedFeatureInput>>;
  effectIsDisease?: InputMaybe<Scalars['Boolean']['input']>;
  patient?: InputMaybe<PatientCaseInput>;
}>;


export type MetricsPathsQuery = MetricsPathsQuery_Query;

export type UndoConversationQuery_conversation_ConversationQueries_state_ConversationState_undo_ConversationState_nextSuggestions_PatientSuggestions = (
  { __typename?: 'PatientSuggestions' }
  & MakeOptional<Pick<PatientSuggestions, 'debugReport'>, 'debugReport'>
  & { clusters?: Maybe<Array<Maybe<ConversationNextSuggestionsFragment_PatientSuggestions_clusters_DiseaseCluster>>>, diseases?: Maybe<Array<Maybe<ConversationNextSuggestionsFragment_PatientSuggestions_diseases_DiseaseForPlan>>>, suggestions?: Maybe<Array<Maybe<ConversationNextSuggestionsFragment_PatientSuggestions_suggestions_PatientSuggestion>>> }
);

export type UndoConversationQuery_conversation_ConversationQueries_state_ConversationState_undo_ConversationState = (
  { __typename?: 'ConversationState' }
  & MakeOptional<Pick<ConversationState, 'gender' | 'entropy' | 'context'>, 'entropy'>
  & { nextSuggestions?: Maybe<UndoConversationQuery_conversation_ConversationQueries_state_ConversationState_undo_ConversationState_nextSuggestions_PatientSuggestions> }
);

export type UndoConversationQuery_conversation_ConversationQueries_state_ConversationState = (
  { __typename?: 'ConversationState' }
  & { undo?: Maybe<UndoConversationQuery_conversation_ConversationQueries_state_ConversationState_undo_ConversationState> }
);

export type UndoConversationQuery_conversation_ConversationQueries = (
  { __typename?: 'ConversationQueries' }
  & { state?: Maybe<UndoConversationQuery_conversation_ConversationQueries_state_ConversationState> }
);

export type UndoConversationQuery_Query = (
  { __typename?: 'Query' }
  & { conversation?: Maybe<UndoConversationQuery_conversation_ConversationQueries> }
);


export type UndoConversationQueryVariables = Exact<{
  context?: InputMaybe<Scalars['ConversationContext']['input']>;
  debug?: InputMaybe<Scalars['Boolean']['input']>;
  qfLight?: InputMaybe<Scalars['Boolean']['input']>;
  includeFeatureRange?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<ConversationOptions>;
  conversationOptions?: InputMaybe<Scalars['ConversationOptionsInput']['input']>;
}>;


export type UndoConversationQuery = UndoConversationQuery_Query;

export type AbandonedPatientConversationQuery_conversation_ConversationQueries_state_ConversationState_abandoned_ConversationState_initialMessages_ConversationInfoMessage = (
  { __typename?: 'ConversationInfoMessage' }
  & Pick<ConversationInfoMessage, 'id' | 'infoText' | 'type' | 'confirm' | 'confirmText'>
);

export type AbandonedPatientConversationQuery_conversation_ConversationQueries_state_ConversationState_abandoned_ConversationState_urgent_DDUrgency = (
  { __typename?: 'DDUrgency' }
  & Pick<DdUrgency, 'urgencyLevelId'>
);

export type AbandonedPatientConversationQuery_conversation_ConversationQueries_state_ConversationState_abandoned_ConversationState_nextSuggestions_PatientSuggestions_clusters_DiseaseCluster = (
  { __typename?: 'DiseaseCluster' }
  & Pick<DiseaseCluster, 'id' | 'crIds' | 'sortType'>
  & { title?: Maybe<DrByFeatureQuery_reference_ReferenceQueries_disease_DiseaseReference_citationsDVData_CitationDiseaseData_findings_RCohort_qfs_QualifiedFeature> }
);

export type AbandonedPatientConversationQuery_conversation_ConversationQueries_state_ConversationState_abandoned_ConversationState_nextSuggestions_PatientSuggestions_diseases_DiseaseForPlan_disease_QualifiedFeature_feature_Feature = (
  { __typename?: 'Feature' }
  & Pick<Feature, 'urgencyId'>
);

export type AbandonedPatientConversationQuery_conversation_ConversationQueries_state_ConversationState_abandoned_ConversationState_nextSuggestions_PatientSuggestions_diseases_DiseaseForPlan_disease_QualifiedFeature = (
  { __typename?: 'QualifiedFeature' }
  & Pick<QualifiedFeature, 'id' | 'name'>
  & { feature?: Maybe<AbandonedPatientConversationQuery_conversation_ConversationQueries_state_ConversationState_abandoned_ConversationState_nextSuggestions_PatientSuggestions_diseases_DiseaseForPlan_disease_QualifiedFeature_feature_Feature> }
);

export type AbandonedPatientConversationQuery_conversation_ConversationQueries_state_ConversationState_abandoned_ConversationState_nextSuggestions_PatientSuggestions_diseases_DiseaseForPlan_complicationOf_QualifiedFeature = (
  { __typename?: 'QualifiedFeature' }
  & Pick<QualifiedFeature, 'id' | 'name'>
);

export type AbandonedPatientConversationQuery_conversation_ConversationQueries_state_ConversationState_abandoned_ConversationState_nextSuggestions_PatientSuggestions_diseases_DiseaseForPlan_complicationOfObj_EtiologiesOfComplication_etiologies_EtiologyOfComplication = (
  { __typename?: 'EtiologyOfComplication' }
  & Pick<EtiologyOfComplication, 'sensitivity'>
  & { disease?: Maybe<AbandonedPatientConversationQuery_conversation_ConversationQueries_state_ConversationState_abandoned_ConversationState_nextSuggestions_PatientSuggestions_diseases_DiseaseForPlan_complicationOf_QualifiedFeature> }
);

export type AbandonedPatientConversationQuery_conversation_ConversationQueries_state_ConversationState_abandoned_ConversationState_nextSuggestions_PatientSuggestions_diseases_DiseaseForPlan_complicationOfObj_EtiologiesOfComplication = (
  { __typename?: 'EtiologiesOfComplication' }
  & { etiologies?: Maybe<Array<Maybe<AbandonedPatientConversationQuery_conversation_ConversationQueries_state_ConversationState_abandoned_ConversationState_nextSuggestions_PatientSuggestions_diseases_DiseaseForPlan_complicationOfObj_EtiologiesOfComplication_etiologies_EtiologyOfComplication>>> }
);

export type AbandonedPatientConversationQuery_conversation_ConversationQueries_state_ConversationState_abandoned_ConversationState_nextSuggestions_PatientSuggestions_diseases_DiseaseForPlan_diseaseCitations_Citations_citationsData_CitationData = (
  { __typename?: 'CitationData' }
  & Pick<CitationData, 'id' | 'kahunId' | 'vancouver' | 'url' | 'title' | 'containerTitle' | 'DOI'>
);

export type AbandonedPatientConversationQuery_conversation_ConversationQueries_state_ConversationState_abandoned_ConversationState_nextSuggestions_PatientSuggestions_diseases_DiseaseForPlan_diseaseCitations_Citations = (
  { __typename?: 'Citations' }
  & Pick<Citations, 'totalCount'>
  & { citationsData?: Maybe<Array<Maybe<AbandonedPatientConversationQuery_conversation_ConversationQueries_state_ConversationState_abandoned_ConversationState_nextSuggestions_PatientSuggestions_diseases_DiseaseForPlan_diseaseCitations_Citations_citationsData_CitationData>>> }
);

export type AbandonedPatientConversationQuery_conversation_ConversationQueries_state_ConversationState_abandoned_ConversationState_nextSuggestions_PatientSuggestions_diseases_DiseaseForPlan_crFindings_ClinicalReasoningFinding_gfinding_GroupedFeatureResponse = (
  { __typename?: 'GroupedFeatureResponse' }
  & Pick<GroupedFeatureResponse, 'skip' | 'source' | 'group' | 'validation'>
  & { feature?: Maybe<DrByFeatureQuery_reference_ReferenceQueries_disease_DiseaseReference_citationsDVData_CitationDiseaseData_findings_RCohort_qfs_QualifiedFeature> }
);

export type AbandonedPatientConversationQuery_conversation_ConversationQueries_state_ConversationState_abandoned_ConversationState_nextSuggestions_PatientSuggestions_diseases_DiseaseForPlan_crFindings_ClinicalReasoningFinding = (
  { __typename?: 'ClinicalReasoningFinding' }
  & Pick<ClinicalReasoningFinding, 'score' | 'absolutePredictiveValue' | 'likelihoodRatio'>
  & { finding?: Maybe<DrByFeatureQuery_reference_ReferenceQueries_disease_DiseaseReference_citationsDVData_CitationDiseaseData_findings_RCohort_qfs_QualifiedFeature>, gfinding?: Maybe<AbandonedPatientConversationQuery_conversation_ConversationQueries_state_ConversationState_abandoned_ConversationState_nextSuggestions_PatientSuggestions_diseases_DiseaseForPlan_crFindings_ClinicalReasoningFinding_gfinding_GroupedFeatureResponse> }
);

export type AbandonedPatientConversationQuery_conversation_ConversationQueries_state_ConversationState_abandoned_ConversationState_nextSuggestions_PatientSuggestions_diseases_DiseaseForPlan = (
  { __typename?: 'DiseaseForPlan' }
  & Pick<DiseaseForPlan, 'crId' | 'prob' | 'inTopCRPerSortType' | 'selectedBySortType' | 'patientIncidence'>
  & { disease?: Maybe<AbandonedPatientConversationQuery_conversation_ConversationQueries_state_ConversationState_abandoned_ConversationState_nextSuggestions_PatientSuggestions_diseases_DiseaseForPlan_disease_QualifiedFeature>, complicationOf?: Maybe<AbandonedPatientConversationQuery_conversation_ConversationQueries_state_ConversationState_abandoned_ConversationState_nextSuggestions_PatientSuggestions_diseases_DiseaseForPlan_complicationOf_QualifiedFeature>, complicationOfObj?: Maybe<AbandonedPatientConversationQuery_conversation_ConversationQueries_state_ConversationState_abandoned_ConversationState_nextSuggestions_PatientSuggestions_diseases_DiseaseForPlan_complicationOfObj_EtiologiesOfComplication>, diseaseCitations?: Maybe<AbandonedPatientConversationQuery_conversation_ConversationQueries_state_ConversationState_abandoned_ConversationState_nextSuggestions_PatientSuggestions_diseases_DiseaseForPlan_diseaseCitations_Citations>, crFindings?: Maybe<Array<Maybe<AbandonedPatientConversationQuery_conversation_ConversationQueries_state_ConversationState_abandoned_ConversationState_nextSuggestions_PatientSuggestions_diseases_DiseaseForPlan_crFindings_ClinicalReasoningFinding>>> }
);

export type AbandonedPatientConversationQuery_conversation_ConversationQueries_state_ConversationState_abandoned_ConversationState_nextSuggestions_PatientSuggestions_suggestions_PatientSuggestion_perDiseaseMetrics_SuggestionDiseaseMetric_pairMetrics_RPairMetrics_sensitivity_RMetric = (
  { __typename?: 'RMetric' }
  & Pick<RMetric, 'value' | 'exactness'>
);

export type AbandonedPatientConversationQuery_conversation_ConversationQueries_state_ConversationState_abandoned_ConversationState_nextSuggestions_PatientSuggestions_suggestions_PatientSuggestion_perDiseaseMetrics_SuggestionDiseaseMetric_pairMetrics_RPairMetrics = (
  { __typename?: 'RPairMetrics' }
  & { sensitivity?: Maybe<AbandonedPatientConversationQuery_conversation_ConversationQueries_state_ConversationState_abandoned_ConversationState_nextSuggestions_PatientSuggestions_suggestions_PatientSuggestion_perDiseaseMetrics_SuggestionDiseaseMetric_pairMetrics_RPairMetrics_sensitivity_RMetric>, ppv?: Maybe<AbandonedPatientConversationQuery_conversation_ConversationQueries_state_ConversationState_abandoned_ConversationState_nextSuggestions_PatientSuggestions_suggestions_PatientSuggestion_perDiseaseMetrics_SuggestionDiseaseMetric_pairMetrics_RPairMetrics_sensitivity_RMetric>, incidence?: Maybe<AbandonedPatientConversationQuery_conversation_ConversationQueries_state_ConversationState_abandoned_ConversationState_nextSuggestions_PatientSuggestions_suggestions_PatientSuggestion_perDiseaseMetrics_SuggestionDiseaseMetric_pairMetrics_RPairMetrics_sensitivity_RMetric>, rrisk_cause?: Maybe<AbandonedPatientConversationQuery_conversation_ConversationQueries_state_ConversationState_abandoned_ConversationState_nextSuggestions_PatientSuggestions_suggestions_PatientSuggestion_perDiseaseMetrics_SuggestionDiseaseMetric_pairMetrics_RPairMetrics_sensitivity_RMetric>, rrisk_effect?: Maybe<AbandonedPatientConversationQuery_conversation_ConversationQueries_state_ConversationState_abandoned_ConversationState_nextSuggestions_PatientSuggestions_suggestions_PatientSuggestion_perDiseaseMetrics_SuggestionDiseaseMetric_pairMetrics_RPairMetrics_sensitivity_RMetric> }
);

export type AbandonedPatientConversationQuery_conversation_ConversationQueries_state_ConversationState_abandoned_ConversationState_nextSuggestions_PatientSuggestions_suggestions_PatientSuggestion_perDiseaseMetrics_SuggestionDiseaseMetric = (
  { __typename?: 'SuggestionDiseaseMetric' }
  & Pick<SuggestionDiseaseMetric, 'diseaseIndex' | 'findingGivenDisease' | 'adjustedBinaryEntropy' | 'specificity' | 'likelihoodRatioNeg' | 'likelihoodRatioPos'>
  & { pairMetrics?: Maybe<AbandonedPatientConversationQuery_conversation_ConversationQueries_state_ConversationState_abandoned_ConversationState_nextSuggestions_PatientSuggestions_suggestions_PatientSuggestion_perDiseaseMetrics_SuggestionDiseaseMetric_pairMetrics_RPairMetrics>, suggestion?: Maybe<DrByFeatureQuery_reference_ReferenceQueries_disease_DiseaseReference_citationsDVData_CitationDiseaseData_findings_RCohort_qfs_QualifiedFeature> }
);

export type AbandonedPatientConversationQuery_conversation_ConversationQueries_state_ConversationState_abandoned_ConversationState_nextSuggestions_PatientSuggestions_suggestions_PatientSuggestion = (
  { __typename?: 'PatientSuggestion' }
  & Pick<PatientSuggestion, 'category' | 'entropy' | 'mutualInformation' | 'mutualInformationUrgencyDifferentiation' | 'findingProbability' | 'findingEntropy' | 'findingLeak' | 'findingLeakAdjustedEntropy' | 'defaultFindingGivenDisease' | 'defaultFindingGivenDiseaseAdjustedEntropy'>
  & { suggestion?: Maybe<DrByFeatureQuery_reference_ReferenceQueries_disease_DiseaseReference_citationsDVData_CitationDiseaseData_findings_RCohort_qfs_QualifiedFeature>, perDiseaseMetrics?: Maybe<Array<Maybe<AbandonedPatientConversationQuery_conversation_ConversationQueries_state_ConversationState_abandoned_ConversationState_nextSuggestions_PatientSuggestions_suggestions_PatientSuggestion_perDiseaseMetrics_SuggestionDiseaseMetric>>>, bestSubtype?: Maybe<DrByFeatureQuery_reference_ReferenceQueries_disease_DiseaseReference_citationsDVData_CitationDiseaseData_findings_RCohort_qfs_QualifiedFeature> }
);

export type AbandonedPatientConversationQuery_conversation_ConversationQueries_state_ConversationState_abandoned_ConversationState_nextSuggestions_PatientSuggestions = (
  { __typename?: 'PatientSuggestions' }
  & MakeOptional<Pick<PatientSuggestions, 'debugReport'>, 'debugReport'>
  & { clusters?: Maybe<Array<Maybe<AbandonedPatientConversationQuery_conversation_ConversationQueries_state_ConversationState_abandoned_ConversationState_nextSuggestions_PatientSuggestions_clusters_DiseaseCluster>>>, diseases?: Maybe<Array<Maybe<AbandonedPatientConversationQuery_conversation_ConversationQueries_state_ConversationState_abandoned_ConversationState_nextSuggestions_PatientSuggestions_diseases_DiseaseForPlan>>>, suggestions?: Maybe<Array<Maybe<AbandonedPatientConversationQuery_conversation_ConversationQueries_state_ConversationState_abandoned_ConversationState_nextSuggestions_PatientSuggestions_suggestions_PatientSuggestion>>> }
);

export type AbandonedPatientConversationQuery_conversation_ConversationQueries_state_ConversationState_abandoned_ConversationState_ddClusters_DDResponse_clinicalReasoning_ClinicalReasoning_disease_QualifiedFeature_urgencyInfo_Feature = (
  { __typename?: 'Feature' }
  & Pick<Feature, 'id' | 'urgency' | 'urgencyId'>
);

export type AbandonedPatientConversationQuery_conversation_ConversationQueries_state_ConversationState_abandoned_ConversationState_ddClusters_DDResponse_clinicalReasoning_ClinicalReasoning_disease_QualifiedFeature = (
  { __typename?: 'QualifiedFeature' }
  & Pick<QualifiedFeature, 'id' | 'name' | 'negate' | 'skip'>
  & { urgencyInfo?: Maybe<AbandonedPatientConversationQuery_conversation_ConversationQueries_state_ConversationState_abandoned_ConversationState_ddClusters_DDResponse_clinicalReasoning_ClinicalReasoning_disease_QualifiedFeature_urgencyInfo_Feature>, feature?: Maybe<DrByFeatureQuery_reference_ReferenceQueries_disease_DiseaseReference_citationsDVData_CitationDiseaseData_findings_RCohort_qfs_QualifiedFeature_feature_Feature>, qualifiers?: Maybe<Array<Maybe<DrByFeatureQuery_reference_ReferenceQueries_disease_DiseaseReference_citationsDVData_CitationDiseaseData_findings_RCohort_qfs_QualifiedFeature_feature_Feature_qualifiers_Qualifier>>>, mandatory?: Maybe<DrByFeatureQuery_reference_ReferenceQueries_disease_DiseaseReference_citationsDVData_CitationDiseaseData_findings_RCohort_qfs_QualifiedFeature_mandatory_Qualifier> }
);

export type AbandonedPatientConversationQuery_conversation_ConversationQueries_state_ConversationState_abandoned_ConversationState_ddClusters_DDResponse_clinicalReasoning_ClinicalReasoning_findings_ClinicalReasoningFinding_finding_QualifiedFeature = (
  { __typename?: 'QualifiedFeature' }
  & Pick<QualifiedFeature, 'id'>
);

export type AbandonedPatientConversationQuery_conversation_ConversationQueries_state_ConversationState_abandoned_ConversationState_ddClusters_DDResponse_clinicalReasoning_ClinicalReasoning_findings_ClinicalReasoningFinding = (
  { __typename?: 'ClinicalReasoningFinding' }
  & Pick<ClinicalReasoningFinding, 'sourceQFIndex' | 'absolutePredictiveValue' | 'likelihoodRatio'>
  & { finding?: Maybe<AbandonedPatientConversationQuery_conversation_ConversationQueries_state_ConversationState_abandoned_ConversationState_ddClusters_DDResponse_clinicalReasoning_ClinicalReasoning_findings_ClinicalReasoningFinding_finding_QualifiedFeature> }
);

export type AbandonedPatientConversationQuery_conversation_ConversationQueries_state_ConversationState_abandoned_ConversationState_ddClusters_DDResponse_clinicalReasoning_ClinicalReasoning_scores_ScoreByType = (
  { __typename?: 'ScoreByType' }
  & Pick<ScoreByType, 'postClusterAdjustment' | 'sortType'>
);

export type AbandonedPatientConversationQuery_conversation_ConversationQueries_state_ConversationState_abandoned_ConversationState_ddClusters_DDResponse_clinicalReasoning_ClinicalReasoning_flags_Flag_ref_QualifiedFeature_feature_Feature = (
  { __typename?: 'Feature' }
  & Pick<Feature, 'name'>
);

export type AbandonedPatientConversationQuery_conversation_ConversationQueries_state_ConversationState_abandoned_ConversationState_ddClusters_DDResponse_clinicalReasoning_ClinicalReasoning_flags_Flag_ref_QualifiedFeature = (
  { __typename?: 'QualifiedFeature' }
  & Pick<QualifiedFeature, 'negate'>
  & { feature?: Maybe<AbandonedPatientConversationQuery_conversation_ConversationQueries_state_ConversationState_abandoned_ConversationState_ddClusters_DDResponse_clinicalReasoning_ClinicalReasoning_flags_Flag_ref_QualifiedFeature_feature_Feature> }
);

export type AbandonedPatientConversationQuery_conversation_ConversationQueries_state_ConversationState_abandoned_ConversationState_ddClusters_DDResponse_clinicalReasoning_ClinicalReasoning_flags_Flag = (
  { __typename?: 'Flag' }
  & Pick<Flag, 'type'>
  & { ref?: Maybe<AbandonedPatientConversationQuery_conversation_ConversationQueries_state_ConversationState_abandoned_ConversationState_ddClusters_DDResponse_clinicalReasoning_ClinicalReasoning_flags_Flag_ref_QualifiedFeature> }
);

export type AbandonedPatientConversationQuery_conversation_ConversationQueries_state_ConversationState_abandoned_ConversationState_ddClusters_DDResponse_clinicalReasoning_ClinicalReasoning = (
  { __typename?: 'ClinicalReasoning' }
  & Pick<ClinicalReasoning, 'id' | 'inInitialDisorders' | 'forcedInSort' | 'score' | 'urgency' | 'diseaseGivenIndependentFindings' | 'diseaseGivenDependentFindings' | 'inTopCRPerSortType' | 'missingPresentingSymptoms' | 'presentableDisease' | 'patientIncidence'>
  & { disease?: Maybe<Array<Maybe<AbandonedPatientConversationQuery_conversation_ConversationQueries_state_ConversationState_abandoned_ConversationState_ddClusters_DDResponse_clinicalReasoning_ClinicalReasoning_disease_QualifiedFeature>>>, diseaseCitations?: Maybe<AbandonedPatientConversationQuery_conversation_ConversationQueries_state_ConversationState_abandoned_ConversationState_nextSuggestions_PatientSuggestions_diseases_DiseaseForPlan_diseaseCitations_Citations>, findings?: Maybe<Array<Maybe<AbandonedPatientConversationQuery_conversation_ConversationQueries_state_ConversationState_abandoned_ConversationState_ddClusters_DDResponse_clinicalReasoning_ClinicalReasoning_findings_ClinicalReasoningFinding>>>, scores?: Maybe<Array<Maybe<AbandonedPatientConversationQuery_conversation_ConversationQueries_state_ConversationState_abandoned_ConversationState_ddClusters_DDResponse_clinicalReasoning_ClinicalReasoning_scores_ScoreByType>>>, flags?: Maybe<Array<Maybe<AbandonedPatientConversationQuery_conversation_ConversationQueries_state_ConversationState_abandoned_ConversationState_ddClusters_DDResponse_clinicalReasoning_ClinicalReasoning_flags_Flag>>> }
);

export type AbandonedPatientConversationQuery_conversation_ConversationQueries_state_ConversationState_abandoned_ConversationState_ddClusters_DDResponse_clustersToConsider_DiseaseCluster_scores_ScoreByType = (
  { __typename?: 'ScoreByType' }
  & Pick<ScoreByType, 'adjustedNormalized'>
);

export type AbandonedPatientConversationQuery_conversation_ConversationQueries_state_ConversationState_abandoned_ConversationState_ddClusters_DDResponse_clustersToConsider_DiseaseCluster = (
  { __typename?: 'DiseaseCluster' }
  & Pick<DiseaseCluster, 'id' | 'crIds' | 'sortType' | 'bestCrId' | 'flags' | 'urgencyId'>
  & { scores?: Maybe<AbandonedPatientConversationQuery_conversation_ConversationQueries_state_ConversationState_abandoned_ConversationState_ddClusters_DDResponse_clustersToConsider_DiseaseCluster_scores_ScoreByType>, title?: Maybe<AbandonedPatientConversationQuery_conversation_ConversationQueries_state_ConversationState_abandoned_ConversationState_ddClusters_DDResponse_clinicalReasoning_ClinicalReasoning_disease_QualifiedFeature> }
);

export type AbandonedPatientConversationQuery_conversation_ConversationQueries_state_ConversationState_abandoned_ConversationState_ddClusters_DDResponse = (
  { __typename?: 'DDResponse' }
  & Pick<DdResponse, 'debugReport' | 'options'>
  & { allFindings?: Maybe<Array<Maybe<DrByFeatureQuery_reference_ReferenceQueries_disease_DiseaseReference_citationsDVData_CitationDiseaseData_findings_RCohort_qfs_QualifiedFeature>>>, clinicalReasoning?: Maybe<Array<Maybe<AbandonedPatientConversationQuery_conversation_ConversationQueries_state_ConversationState_abandoned_ConversationState_ddClusters_DDResponse_clinicalReasoning_ClinicalReasoning>>>, clustersToConsider?: Maybe<Array<Maybe<AbandonedPatientConversationQuery_conversation_ConversationQueries_state_ConversationState_abandoned_ConversationState_ddClusters_DDResponse_clustersToConsider_DiseaseCluster>>> }
);

export type AbandonedPatientConversationQuery_conversation_ConversationQueries_state_ConversationState_abandoned_ConversationState_recommendations_PolicyRecommendation = (
  { __typename?: 'PolicyRecommendation' }
  & Pick<PolicyRecommendation, 'policyName' | 'policyid' | 'protocolid' | 'protocolName'>
  & { feature?: Maybe<DrByFeatureQuery_reference_ReferenceQueries_disease_DiseaseReference_citationsDVData_CitationDiseaseData_findings_RCohort_qfs_QualifiedFeature> }
);

export type AbandonedPatientConversationQuery_conversation_ConversationQueries_state_ConversationState_abandoned_ConversationState_patientIcd_StateICDCodes_diseases_ICDCode = (
  { __typename?: 'ICDCode' }
  & Pick<IcdCode, 'code' | 'desc'>
  & { dueTo?: Maybe<Array<Maybe<DrByFeatureQuery_reference_ReferenceQueries_disease_DiseaseReference_citationsDVData_CitationDiseaseData_findings_RCohort_qfs_QualifiedFeature>>> }
);

export type AbandonedPatientConversationQuery_conversation_ConversationQueries_state_ConversationState_abandoned_ConversationState_patientIcd_StateICDCodes = (
  { __typename?: 'StateICDCodes' }
  & { diseases?: Maybe<Array<Maybe<AbandonedPatientConversationQuery_conversation_ConversationQueries_state_ConversationState_abandoned_ConversationState_patientIcd_StateICDCodes_diseases_ICDCode>>>, findings?: Maybe<Array<Maybe<AbandonedPatientConversationQuery_conversation_ConversationQueries_state_ConversationState_abandoned_ConversationState_patientIcd_StateICDCodes_diseases_ICDCode>>> }
);

export type AbandonedPatientConversationQuery_conversation_ConversationQueries_state_ConversationState_abandoned_ConversationState = (
  { __typename?: 'ConversationState' }
  & MakeOptional<Pick<ConversationState, 'gender' | 'progress' | 'entropy' | 'context' | 'caseId' | 'caseReadOnly' | 'caseBasedOn' | 'options'>, 'entropy' | 'caseReadOnly' | 'caseBasedOn' | 'options'>
  & { initialMessages?: Maybe<Array<Maybe<AbandonedPatientConversationQuery_conversation_ConversationQueries_state_ConversationState_abandoned_ConversationState_initialMessages_ConversationInfoMessage>>>, urgent?: Maybe<AbandonedPatientConversationQuery_conversation_ConversationQueries_state_ConversationState_abandoned_ConversationState_urgent_DDUrgency>, nextSuggestions?: Maybe<AbandonedPatientConversationQuery_conversation_ConversationQueries_state_ConversationState_abandoned_ConversationState_nextSuggestions_PatientSuggestions>, ddClusters?: Maybe<AbandonedPatientConversationQuery_conversation_ConversationQueries_state_ConversationState_abandoned_ConversationState_ddClusters_DDResponse>, recommendations?: Maybe<Array<Maybe<AbandonedPatientConversationQuery_conversation_ConversationQueries_state_ConversationState_abandoned_ConversationState_recommendations_PolicyRecommendation>>>, navigationRecommendation?: Maybe<AbandonedPatientConversationQuery_conversation_ConversationQueries_state_ConversationState_abandoned_ConversationState_recommendations_PolicyRecommendation>, patientFindings?: Maybe<Array<Maybe<AbandonedPatientConversationQuery_conversation_ConversationQueries_state_ConversationState_abandoned_ConversationState_nextSuggestions_PatientSuggestions_diseases_DiseaseForPlan_crFindings_ClinicalReasoningFinding_gfinding_GroupedFeatureResponse>>>, patientIcd?: Maybe<AbandonedPatientConversationQuery_conversation_ConversationQueries_state_ConversationState_abandoned_ConversationState_patientIcd_StateICDCodes>, nextResponse?: Maybe<ConversationStateNextResponseFragment_ConversationState_nextResponse_ConversationResponse> }
);

export type AbandonedPatientConversationQuery_conversation_ConversationQueries_state_ConversationState = (
  { __typename?: 'ConversationState' }
  & { abandoned?: Maybe<AbandonedPatientConversationQuery_conversation_ConversationQueries_state_ConversationState_abandoned_ConversationState> }
);

export type AbandonedPatientConversationQuery_conversation_ConversationQueries = (
  { __typename?: 'ConversationQueries' }
  & { state?: Maybe<AbandonedPatientConversationQuery_conversation_ConversationQueries_state_ConversationState> }
);

export type AbandonedPatientConversationQuery_Query = (
  { __typename?: 'Query' }
  & { conversation?: Maybe<AbandonedPatientConversationQuery_conversation_ConversationQueries> }
);


export type AbandonedPatientConversationQueryVariables = Exact<{
  context?: InputMaybe<Scalars['ConversationContext']['input']>;
  debug?: InputMaybe<Scalars['Boolean']['input']>;
  qfLight?: InputMaybe<Scalars['Boolean']['input']>;
  includeFeatureRange?: InputMaybe<Scalars['Boolean']['input']>;
  saveToCase?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<ConversationOptions>;
  conversationOptions?: InputMaybe<Scalars['ConversationOptionsInput']['input']>;
  abandonedStatus?: InputMaybe<SubStatus>;
}>;


export type AbandonedPatientConversationQuery = AbandonedPatientConversationQuery_Query;

export type GetRecommendationsQuery_conversation_ConversationQueries_start_ConversationState_recommendations_PolicyRecommendation = (
  { __typename?: 'PolicyRecommendation' }
  & Pick<PolicyRecommendation, 'policyName' | 'policyid' | 'protocolid' | 'protocolName'>
  & { feature?: Maybe<ConversationRecommendationFragment_PolicyRecommendation_feature_QualifiedFeature> }
);

export type GetRecommendationsQuery_conversation_ConversationQueries_start_ConversationState_navigationRecommendation_PolicyRecommendation = (
  { __typename?: 'PolicyRecommendation' }
  & Pick<PolicyRecommendation, 'policyName' | 'policyid' | 'protocolid' | 'protocolName'>
  & { feature?: Maybe<ConversationRecommendationFragment_PolicyRecommendation_feature_QualifiedFeature> }
);

export type GetRecommendationsQuery_conversation_ConversationQueries_start_ConversationState = (
  { __typename?: 'ConversationState' }
  & { recommendations?: Maybe<Array<Maybe<GetRecommendationsQuery_conversation_ConversationQueries_start_ConversationState_recommendations_PolicyRecommendation>>>, navigationRecommendation?: Maybe<GetRecommendationsQuery_conversation_ConversationQueries_start_ConversationState_navigationRecommendation_PolicyRecommendation> }
);

export type GetRecommendationsQuery_conversation_ConversationQueries = (
  { __typename?: 'ConversationQueries' }
  & { start?: Maybe<GetRecommendationsQuery_conversation_ConversationQueries_start_ConversationState> }
);

export type GetRecommendationsQuery_Query = (
  { __typename?: 'Query' }
  & { conversation?: Maybe<GetRecommendationsQuery_conversation_ConversationQueries> }
);


export type GetRecommendationsQueryVariables = Exact<{
  qfLight?: InputMaybe<Scalars['Boolean']['input']>;
  includeFeatureRange?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<ConversationOptions>;
  conversationOptions?: InputMaybe<Scalars['ConversationOptionsInput']['input']>;
  saveToCase?: InputMaybe<Scalars['Boolean']['input']>;
  patientCaseId?: InputMaybe<Scalars['String']['input']>;
  clinicId?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetRecommendationsQuery = GetRecommendationsQuery_Query;

export type NextResponseQuery_conversation_ConversationQueries_state_ConversationState = (
  { __typename?: 'ConversationState' }
  & MakeOptional<Pick<ConversationState, 'gender' | 'progress' | 'entropy' | 'context' | 'caseId' | 'caseReadOnly' | 'caseBasedOn' | 'options'>, 'entropy' | 'caseReadOnly' | 'caseBasedOn' | 'options'>
  & { nextResponse?: Maybe<ConversationStateNextResponseFragment_ConversationState_nextResponse_ConversationResponse>, initialMessages?: Maybe<Array<Maybe<ConversationStateFragment_ConversationState_initialMessages_ConversationInfoMessage>>>, urgent?: Maybe<ConversationStateFragment_ConversationState_urgent_DDUrgency>, nextSuggestions?: Maybe<ConversationStateFragment_ConversationState_nextSuggestions_PatientSuggestions>, ddClusters?: Maybe<ConversationStateFragment_ConversationState_ddClusters_DDResponse>, recommendations?: Maybe<Array<Maybe<ConversationStateFragment_ConversationState_recommendations_PolicyRecommendation>>>, navigationRecommendation?: Maybe<ConversationStateFragment_ConversationState_navigationRecommendation_PolicyRecommendation>, patientFindings?: Maybe<Array<Maybe<ConversationStateFragment_ConversationState_patientFindings_GroupedFeatureResponse>>>, patientIcd?: Maybe<ConversationStateFragment_ConversationState_patientIcd_StateICDCodes> }
);

export type NextResponseQuery_conversation_ConversationQueries = (
  { __typename?: 'ConversationQueries' }
  & { state?: Maybe<NextResponseQuery_conversation_ConversationQueries_state_ConversationState> }
);

export type NextResponseQuery_Query = (
  { __typename?: 'Query' }
  & { conversation?: Maybe<NextResponseQuery_conversation_ConversationQueries>, gatewayModel?: Maybe<BackendModelInfoFragment_gatewayModel_LoadedModelInfo>, diagnosisModel?: Maybe<BackendModelInfoFragment_diagnosisModel_LoadedModelInfo> }
);


export type NextResponseQueryVariables = Exact<{
  context?: InputMaybe<Scalars['ConversationContext']['input']>;
  debug?: InputMaybe<Scalars['Boolean']['input']>;
  qfLight?: InputMaybe<Scalars['Boolean']['input']>;
  includeFeatureRange?: InputMaybe<Scalars['Boolean']['input']>;
  saveToCase?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<ConversationOptions>;
  conversationOptions?: InputMaybe<Scalars['ConversationOptionsInput']['input']>;
}>;


export type NextResponseQuery = NextResponseQuery_Query;

export type AddPatientAnswerConversationQuery_conversation_ConversationQueries_state_ConversationState_addAnswer_ConversationState = (
  { __typename?: 'ConversationState' }
  & MakeOptional<Pick<ConversationState, 'gender' | 'progress' | 'entropy' | 'context' | 'caseId' | 'caseReadOnly' | 'caseBasedOn' | 'options'>, 'entropy' | 'caseReadOnly' | 'caseBasedOn' | 'options'>
  & { nextResponse?: Maybe<ConversationStateNextResponseFragment_ConversationState_nextResponse_ConversationResponse>, initialMessages?: Maybe<Array<Maybe<ConversationStateFragment_ConversationState_initialMessages_ConversationInfoMessage>>>, urgent?: Maybe<ConversationStateFragment_ConversationState_urgent_DDUrgency>, nextSuggestions?: Maybe<ConversationStateFragment_ConversationState_nextSuggestions_PatientSuggestions>, ddClusters?: Maybe<ConversationStateFragment_ConversationState_ddClusters_DDResponse>, recommendations?: Maybe<Array<Maybe<ConversationStateFragment_ConversationState_recommendations_PolicyRecommendation>>>, navigationRecommendation?: Maybe<ConversationStateFragment_ConversationState_navigationRecommendation_PolicyRecommendation>, patientFindings?: Maybe<Array<Maybe<ConversationStateFragment_ConversationState_patientFindings_GroupedFeatureResponse>>>, patientIcd?: Maybe<ConversationStateFragment_ConversationState_patientIcd_StateICDCodes> }
);

export type AddPatientAnswerConversationQuery_conversation_ConversationQueries_state_ConversationState = (
  { __typename?: 'ConversationState' }
  & { addAnswer?: Maybe<AddPatientAnswerConversationQuery_conversation_ConversationQueries_state_ConversationState_addAnswer_ConversationState> }
);

export type AddPatientAnswerConversationQuery_conversation_ConversationQueries = (
  { __typename?: 'ConversationQueries' }
  & { state?: Maybe<AddPatientAnswerConversationQuery_conversation_ConversationQueries_state_ConversationState> }
);

export type AddPatientAnswerConversationQuery_Query = (
  { __typename?: 'Query' }
  & { conversation?: Maybe<AddPatientAnswerConversationQuery_conversation_ConversationQueries>, gatewayModel?: Maybe<BackendModelInfoFragment_gatewayModel_LoadedModelInfo>, diagnosisModel?: Maybe<BackendModelInfoFragment_diagnosisModel_LoadedModelInfo> }
);


export type AddPatientAnswerConversationQueryVariables = Exact<{
  context?: InputMaybe<Scalars['ConversationContext']['input']>;
  answer?: InputMaybe<ConversationAnswer>;
  debug?: InputMaybe<Scalars['Boolean']['input']>;
  qfLight?: InputMaybe<Scalars['Boolean']['input']>;
  includeFeatureRange?: InputMaybe<Scalars['Boolean']['input']>;
  saveToCase?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<ConversationOptions>;
  conversationOptions?: InputMaybe<Scalars['ConversationOptionsInput']['input']>;
}>;


export type AddPatientAnswerConversationQuery = AddPatientAnswerConversationQuery_Query;

export type DoPatientExchangeQuery_conversation_ConversationQueries_state_ConversationState_doExchange_ConversationExchange = (
  { __typename?: 'ConversationExchange' }
  & { question?: Maybe<ConversationExchangeResultFragment_ConversationExchange_question_ConversationQuestion>, answer?: Maybe<Array<Maybe<ConversationExchangeResultFragment_ConversationExchange_answer_ConversationExchangeAnswer>>>, state?: Maybe<ConversationExchangeResultFragment_ConversationExchange_state_ConversationState> }
);

export type DoPatientExchangeQuery_conversation_ConversationQueries_state_ConversationState = (
  { __typename?: 'ConversationState' }
  & { doExchange?: Maybe<DoPatientExchangeQuery_conversation_ConversationQueries_state_ConversationState_doExchange_ConversationExchange> }
);

export type DoPatientExchangeQuery_conversation_ConversationQueries = (
  { __typename?: 'ConversationQueries' }
  & { state?: Maybe<DoPatientExchangeQuery_conversation_ConversationQueries_state_ConversationState> }
);

export type DoPatientExchangeQuery_Query = (
  { __typename?: 'Query' }
  & { conversation?: Maybe<DoPatientExchangeQuery_conversation_ConversationQueries> }
);


export type DoPatientExchangeQueryVariables = Exact<{
  context?: InputMaybe<Scalars['ConversationContext']['input']>;
  patient?: InputMaybe<Array<InputMaybe<GroupedFeature>> | InputMaybe<GroupedFeature>>;
  patientVolunteered?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>> | InputMaybe<Scalars['Int']['input']>>;
  missingInCase?: InputMaybe<MissingInCaseAction>;
  qfLight?: InputMaybe<Scalars['Boolean']['input']>;
  includeFeatureRange?: InputMaybe<Scalars['Boolean']['input']>;
  debug?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<ConversationOptions>;
  conversationOptions?: InputMaybe<Scalars['ConversationOptionsInput']['input']>;
}>;


export type DoPatientExchangeQuery = DoPatientExchangeQuery_Query;

export type DoPatientExchangeResultQuery_conversation_ConversationQueries_state_ConversationState_doExchange_ConversationExchange = (
  { __typename?: 'ConversationExchange' }
  & { question?: Maybe<ConversationExchangeResultFragment_ConversationExchange_question_ConversationQuestion>, answer?: Maybe<Array<Maybe<ConversationExchangeResultFragment_ConversationExchange_answer_ConversationExchangeAnswer>>>, state?: Maybe<ConversationExchangeResultFragment_ConversationExchange_state_ConversationState> }
);

export type DoPatientExchangeResultQuery_conversation_ConversationQueries_state_ConversationState_ddClusters_DDResponse_clustersToConsider_DiseaseCluster_title_QualifiedFeature = (
  { __typename?: 'QualifiedFeature' }
  & Pick<QualifiedFeature, 'name'>
);

export type DoPatientExchangeResultQuery_conversation_ConversationQueries_state_ConversationState_ddClusters_DDResponse_clustersToConsider_DiseaseCluster = (
  { __typename?: 'DiseaseCluster' }
  & Pick<DiseaseCluster, 'crIds'>
  & { title?: Maybe<DoPatientExchangeResultQuery_conversation_ConversationQueries_state_ConversationState_ddClusters_DDResponse_clustersToConsider_DiseaseCluster_title_QualifiedFeature> }
);

export type DoPatientExchangeResultQuery_conversation_ConversationQueries_state_ConversationState_ddClusters_DDResponse_clinicalReasoning_ClinicalReasoning_disease_QualifiedFeature_qualifiers_Qualifier = (
  { __typename?: 'Qualifier' }
  & Pick<Qualifier, 'name'>
);

export type DoPatientExchangeResultQuery_conversation_ConversationQueries_state_ConversationState_ddClusters_DDResponse_clinicalReasoning_ClinicalReasoning_disease_QualifiedFeature = (
  { __typename?: 'QualifiedFeature' }
  & Pick<QualifiedFeature, 'id' | 'name'>
  & { qualifiers?: Maybe<Array<Maybe<DoPatientExchangeResultQuery_conversation_ConversationQueries_state_ConversationState_ddClusters_DDResponse_clinicalReasoning_ClinicalReasoning_disease_QualifiedFeature_qualifiers_Qualifier>>> }
);

export type DoPatientExchangeResultQuery_conversation_ConversationQueries_state_ConversationState_ddClusters_DDResponse_clinicalReasoning_ClinicalReasoning_scores_ScoreByType = (
  { __typename?: 'ScoreByType' }
  & Pick<ScoreByType, 'postClusterAdjustment' | 'sortType'>
);

export type DoPatientExchangeResultQuery_conversation_ConversationQueries_state_ConversationState_ddClusters_DDResponse_clinicalReasoning_ClinicalReasoning = (
  { __typename?: 'ClinicalReasoning' }
  & Pick<ClinicalReasoning, 'id' | 'urgency'>
  & { disease?: Maybe<Array<Maybe<DoPatientExchangeResultQuery_conversation_ConversationQueries_state_ConversationState_ddClusters_DDResponse_clinicalReasoning_ClinicalReasoning_disease_QualifiedFeature>>>, scores?: Maybe<Array<Maybe<DoPatientExchangeResultQuery_conversation_ConversationQueries_state_ConversationState_ddClusters_DDResponse_clinicalReasoning_ClinicalReasoning_scores_ScoreByType>>> }
);

export type DoPatientExchangeResultQuery_conversation_ConversationQueries_state_ConversationState_ddClusters_DDResponse = (
  { __typename?: 'DDResponse' }
  & { clustersToConsider?: Maybe<Array<Maybe<DoPatientExchangeResultQuery_conversation_ConversationQueries_state_ConversationState_ddClusters_DDResponse_clustersToConsider_DiseaseCluster>>>, clinicalReasoning?: Maybe<Array<Maybe<DoPatientExchangeResultQuery_conversation_ConversationQueries_state_ConversationState_ddClusters_DDResponse_clinicalReasoning_ClinicalReasoning>>> }
);

export type DoPatientExchangeResultQuery_conversation_ConversationQueries_state_ConversationState_urgent_DDUrgency = (
  { __typename?: 'DDUrgency' }
  & Pick<DdUrgency, 'urgencyLevelId' | 'urgent'>
);

export type DoPatientExchangeResultQuery_conversation_ConversationQueries_state_ConversationState_nextSuggestions_PatientSuggestions_diseases_DiseaseForPlan_disease_QualifiedFeature = (
  { __typename?: 'QualifiedFeature' }
  & Pick<QualifiedFeature, 'id' | 'name'>
);

export type DoPatientExchangeResultQuery_conversation_ConversationQueries_state_ConversationState_nextSuggestions_PatientSuggestions_diseases_DiseaseForPlan = (
  { __typename?: 'DiseaseForPlan' }
  & Pick<DiseaseForPlan, 'prob'>
  & { disease?: Maybe<DoPatientExchangeResultQuery_conversation_ConversationQueries_state_ConversationState_nextSuggestions_PatientSuggestions_diseases_DiseaseForPlan_disease_QualifiedFeature> }
);

export type DoPatientExchangeResultQuery_conversation_ConversationQueries_state_ConversationState_nextSuggestions_PatientSuggestions_suggestions_PatientSuggestion_perDiseaseMetrics_SuggestionDiseaseMetric_suggestion_QualifiedFeature = (
  { __typename?: 'QualifiedFeature' }
  & Pick<QualifiedFeature, 'id'>
);

export type DoPatientExchangeResultQuery_conversation_ConversationQueries_state_ConversationState_nextSuggestions_PatientSuggestions_suggestions_PatientSuggestion_perDiseaseMetrics_SuggestionDiseaseMetric_disease_QualifiedFeature = (
  { __typename?: 'QualifiedFeature' }
  & Pick<QualifiedFeature, 'id'>
);

export type DoPatientExchangeResultQuery_conversation_ConversationQueries_state_ConversationState_nextSuggestions_PatientSuggestions_suggestions_PatientSuggestion_perDiseaseMetrics_SuggestionDiseaseMetric = (
  { __typename?: 'SuggestionDiseaseMetric' }
  & Pick<SuggestionDiseaseMetric, 'findingGivenDisease'>
  & { suggestion?: Maybe<DoPatientExchangeResultQuery_conversation_ConversationQueries_state_ConversationState_nextSuggestions_PatientSuggestions_suggestions_PatientSuggestion_perDiseaseMetrics_SuggestionDiseaseMetric_suggestion_QualifiedFeature>, disease?: Maybe<DoPatientExchangeResultQuery_conversation_ConversationQueries_state_ConversationState_nextSuggestions_PatientSuggestions_suggestions_PatientSuggestion_perDiseaseMetrics_SuggestionDiseaseMetric_disease_QualifiedFeature> }
);

export type DoPatientExchangeResultQuery_conversation_ConversationQueries_state_ConversationState_nextSuggestions_PatientSuggestions_suggestions_PatientSuggestion_suggestion_QualifiedFeature_qualifiers_Qualifier_relation_Relation = (
  { __typename?: 'Relation' }
  & Pick<Relation, 'id'>
);

export type DoPatientExchangeResultQuery_conversation_ConversationQueries_state_ConversationState_nextSuggestions_PatientSuggestions_suggestions_PatientSuggestion_suggestion_QualifiedFeature_qualifiers_Qualifier_range_MeasurementRange = (
  { __typename?: 'MeasurementRange' }
  & Pick<MeasurementRange, 'low' | 'high' | 'units'>
);

export type DoPatientExchangeResultQuery_conversation_ConversationQueries_state_ConversationState_nextSuggestions_PatientSuggestions_suggestions_PatientSuggestion_suggestion_QualifiedFeature_qualifiers_Qualifier = (
  { __typename?: 'Qualifier' }
  & Pick<Qualifier, 'name'>
  & { relation: DoPatientExchangeResultQuery_conversation_ConversationQueries_state_ConversationState_nextSuggestions_PatientSuggestions_suggestions_PatientSuggestion_suggestion_QualifiedFeature_qualifiers_Qualifier_relation_Relation, range?: Maybe<DoPatientExchangeResultQuery_conversation_ConversationQueries_state_ConversationState_nextSuggestions_PatientSuggestions_suggestions_PatientSuggestion_suggestion_QualifiedFeature_qualifiers_Qualifier_range_MeasurementRange> }
);

export type DoPatientExchangeResultQuery_conversation_ConversationQueries_state_ConversationState_nextSuggestions_PatientSuggestions_suggestions_PatientSuggestion_suggestion_QualifiedFeature = (
  { __typename?: 'QualifiedFeature' }
  & Pick<QualifiedFeature, 'id' | 'name'>
  & { qualifiers?: Maybe<Array<Maybe<DoPatientExchangeResultQuery_conversation_ConversationQueries_state_ConversationState_nextSuggestions_PatientSuggestions_suggestions_PatientSuggestion_suggestion_QualifiedFeature_qualifiers_Qualifier>>> }
);

export type DoPatientExchangeResultQuery_conversation_ConversationQueries_state_ConversationState_nextSuggestions_PatientSuggestions_suggestions_PatientSuggestion = (
  { __typename?: 'PatientSuggestion' }
  & Pick<PatientSuggestion, 'findingEntropy' | 'findingLeak' | 'findingProbability' | 'category' | 'mutualInformation' | 'mutualInformationUrgencyDifferentiation'>
  & { perDiseaseMetrics?: Maybe<Array<Maybe<DoPatientExchangeResultQuery_conversation_ConversationQueries_state_ConversationState_nextSuggestions_PatientSuggestions_suggestions_PatientSuggestion_perDiseaseMetrics_SuggestionDiseaseMetric>>>, suggestion?: Maybe<DoPatientExchangeResultQuery_conversation_ConversationQueries_state_ConversationState_nextSuggestions_PatientSuggestions_suggestions_PatientSuggestion_suggestion_QualifiedFeature> }
);

export type DoPatientExchangeResultQuery_conversation_ConversationQueries_state_ConversationState_nextSuggestions_PatientSuggestions = (
  { __typename?: 'PatientSuggestions' }
  & { diseases?: Maybe<Array<Maybe<DoPatientExchangeResultQuery_conversation_ConversationQueries_state_ConversationState_nextSuggestions_PatientSuggestions_diseases_DiseaseForPlan>>>, suggestions?: Maybe<Array<Maybe<DoPatientExchangeResultQuery_conversation_ConversationQueries_state_ConversationState_nextSuggestions_PatientSuggestions_suggestions_PatientSuggestion>>> }
);

export type DoPatientExchangeResultQuery_conversation_ConversationQueries_state_ConversationState = (
  { __typename?: 'ConversationState' }
  & Pick<ConversationState, 'entropy'>
  & { doExchange?: Maybe<DoPatientExchangeResultQuery_conversation_ConversationQueries_state_ConversationState_doExchange_ConversationExchange>, ddClusters?: Maybe<DoPatientExchangeResultQuery_conversation_ConversationQueries_state_ConversationState_ddClusters_DDResponse>, urgent?: Maybe<DoPatientExchangeResultQuery_conversation_ConversationQueries_state_ConversationState_urgent_DDUrgency>, nextSuggestions?: Maybe<DoPatientExchangeResultQuery_conversation_ConversationQueries_state_ConversationState_nextSuggestions_PatientSuggestions> }
);

export type DoPatientExchangeResultQuery_conversation_ConversationQueries = (
  { __typename?: 'ConversationQueries' }
  & { state?: Maybe<DoPatientExchangeResultQuery_conversation_ConversationQueries_state_ConversationState> }
);

export type DoPatientExchangeResultQuery_Query = (
  { __typename?: 'Query' }
  & { conversation?: Maybe<DoPatientExchangeResultQuery_conversation_ConversationQueries> }
);


export type DoPatientExchangeResultQueryVariables = Exact<{
  context?: InputMaybe<Scalars['ConversationContext']['input']>;
  patient?: InputMaybe<Array<InputMaybe<GroupedFeature>> | InputMaybe<GroupedFeature>>;
  patientVolunteered?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>> | InputMaybe<Scalars['Int']['input']>>;
  missingInCase?: InputMaybe<MissingInCaseAction>;
  qfLight?: InputMaybe<Scalars['Boolean']['input']>;
  includeFeatureRange?: InputMaybe<Scalars['Boolean']['input']>;
  debug?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<ConversationOptions>;
  conversationOptions?: InputMaybe<Scalars['ConversationOptionsInput']['input']>;
}>;


export type DoPatientExchangeResultQuery = DoPatientExchangeResultQuery_Query;

export type BuildCaseFromConversationQuery_conversation_ConversationQueries_buildSavedCase_SavedCaseResponse_findings_GroupedFeatureResponse = (
  { __typename?: 'GroupedFeatureResponse' }
  & Pick<GroupedFeatureResponse, 'skip' | 'source' | 'group' | 'validation'>
  & { feature?: Maybe<GroupedFeatureResponseFragment_GroupedFeatureResponse_feature_QualifiedFeature> }
);

export type BuildCaseFromConversationQuery_conversation_ConversationQueries_buildSavedCase_SavedCaseResponse = (
  { __typename?: 'SavedCaseResponse' }
  & { findings?: Maybe<Array<Maybe<BuildCaseFromConversationQuery_conversation_ConversationQueries_buildSavedCase_SavedCaseResponse_findings_GroupedFeatureResponse>>> }
);

export type BuildCaseFromConversationQuery_conversation_ConversationQueries = (
  { __typename?: 'ConversationQueries' }
  & { buildSavedCase?: Maybe<BuildCaseFromConversationQuery_conversation_ConversationQueries_buildSavedCase_SavedCaseResponse> }
);

export type BuildCaseFromConversationQuery_Query = (
  { __typename?: 'Query' }
  & { conversation?: Maybe<BuildCaseFromConversationQuery_conversation_ConversationQueries> }
);


export type BuildCaseFromConversationQueryVariables = Exact<{
  context?: InputMaybe<Scalars['ConversationContext']['input']>;
  buildCaseOptions?: InputMaybe<BuildCaseOptions>;
  qfLight?: InputMaybe<Scalars['Boolean']['input']>;
  includeFeatureRange?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<ConversationOptions>;
  conversationOptions?: InputMaybe<Scalars['ConversationOptionsInput']['input']>;
  caseId?: InputMaybe<Scalars['ID']['input']>;
}>;


export type BuildCaseFromConversationQuery = BuildCaseFromConversationQuery_Query;

export type SaveAsPatientConversationQuery_conversation_ConversationQueries_saveAsNewCase_ConversationState = (
  { __typename?: 'ConversationState' }
  & Pick<ConversationState, 'caseId'>
);

export type SaveAsPatientConversationQuery_conversation_ConversationQueries = (
  { __typename?: 'ConversationQueries' }
  & { saveAsNewCase?: Maybe<SaveAsPatientConversationQuery_conversation_ConversationQueries_saveAsNewCase_ConversationState> }
);

export type SaveAsPatientConversationQuery_Query = (
  { __typename?: 'Query' }
  & { conversation?: Maybe<SaveAsPatientConversationQuery_conversation_ConversationQueries> }
);


export type SaveAsPatientConversationQueryVariables = Exact<{
  context?: InputMaybe<Scalars['ConversationContext']['input']>;
  conversationOptions?: InputMaybe<Scalars['ConversationOptionsInput']['input']>;
  readOnly?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type SaveAsPatientConversationQuery = SaveAsPatientConversationQuery_Query;

export type PersistConversationQuery_conversation_ConversationQueries_state_ConversationState = (
  { __typename?: 'ConversationState' }
  & Pick<ConversationState, 'context'>
);

export type PersistConversationQuery_conversation_ConversationQueries = (
  { __typename?: 'ConversationQueries' }
  & { state?: Maybe<PersistConversationQuery_conversation_ConversationQueries_state_ConversationState> }
);

export type PersistConversationQuery_Query = (
  { __typename?: 'Query' }
  & { conversation?: Maybe<PersistConversationQuery_conversation_ConversationQueries> }
);


export type PersistConversationQueryVariables = Exact<{
  context?: InputMaybe<Scalars['ConversationContext']['input']>;
  options?: InputMaybe<ConversationOptions>;
  conversationOptions?: InputMaybe<Scalars['ConversationOptionsInput']['input']>;
}>;


export type PersistConversationQuery = PersistConversationQuery_Query;

export type PersistConversationByIdQuery_conversation_ConversationQueries_start_ConversationState_persist_ConversationState = (
  { __typename?: 'ConversationState' }
  & Pick<ConversationState, 'context'>
);

export type PersistConversationByIdQuery_conversation_ConversationQueries_start_ConversationState = (
  { __typename?: 'ConversationState' }
  & { persist?: Maybe<PersistConversationByIdQuery_conversation_ConversationQueries_start_ConversationState_persist_ConversationState> }
);

export type PersistConversationByIdQuery_conversation_ConversationQueries = (
  { __typename?: 'ConversationQueries' }
  & { start?: Maybe<PersistConversationByIdQuery_conversation_ConversationQueries_start_ConversationState> }
);

export type PersistConversationByIdQuery_Query = (
  { __typename?: 'Query' }
  & { conversation?: Maybe<PersistConversationByIdQuery_conversation_ConversationQueries> }
);


export type PersistConversationByIdQueryVariables = Exact<{
  existingCaseId?: InputMaybe<Scalars['String']['input']>;
  options?: InputMaybe<ConversationOptions>;
  conversationOptions?: InputMaybe<Scalars['ConversationOptionsInput']['input']>;
}>;


export type PersistConversationByIdQuery = PersistConversationByIdQuery_Query;

export type StartConversationQuery_conversation_ConversationQueries_start_ConversationState_exchanges_ConversationExchange = (
  { __typename?: 'ConversationExchange' }
  & Pick<ConversationExchange, 'patientAnswer' | 'progress'>
  & { question?: Maybe<ConversationExchangeFragment_ConversationExchange_question_ConversationQuestion>, answer?: Maybe<Array<Maybe<ConversationExchangeFragment_ConversationExchange_answer_ConversationExchangeAnswer>>>, messages?: Maybe<Array<Maybe<ConversationExchangeFragment_ConversationExchange_messages_ConversationInfoMessage>>> }
);

export type StartConversationQuery_conversation_ConversationQueries_start_ConversationState = (
  { __typename?: 'ConversationState' }
  & MakeOptional<Pick<ConversationState, 'caseId' | 'gender' | 'progress' | 'entropy' | 'context' | 'caseReadOnly' | 'caseBasedOn' | 'options'>, 'entropy' | 'caseReadOnly' | 'caseBasedOn' | 'options'>
  & { exchanges?: Maybe<Array<Maybe<StartConversationQuery_conversation_ConversationQueries_start_ConversationState_exchanges_ConversationExchange>>>, nextResponse?: Maybe<ConversationStateNextResponseFragment_ConversationState_nextResponse_ConversationResponse>, initialMessages?: Maybe<Array<Maybe<AbandonedPatientConversationQuery_conversation_ConversationQueries_state_ConversationState_abandoned_ConversationState_initialMessages_ConversationInfoMessage>>>, urgent?: Maybe<AbandonedPatientConversationQuery_conversation_ConversationQueries_state_ConversationState_abandoned_ConversationState_urgent_DDUrgency>, nextSuggestions?: Maybe<AbandonedPatientConversationQuery_conversation_ConversationQueries_state_ConversationState_abandoned_ConversationState_nextSuggestions_PatientSuggestions>, ddClusters?: Maybe<AbandonedPatientConversationQuery_conversation_ConversationQueries_state_ConversationState_abandoned_ConversationState_ddClusters_DDResponse>, recommendations?: Maybe<Array<Maybe<AbandonedPatientConversationQuery_conversation_ConversationQueries_state_ConversationState_abandoned_ConversationState_recommendations_PolicyRecommendation>>>, navigationRecommendation?: Maybe<AbandonedPatientConversationQuery_conversation_ConversationQueries_state_ConversationState_abandoned_ConversationState_recommendations_PolicyRecommendation>, patientFindings?: Maybe<Array<Maybe<AbandonedPatientConversationQuery_conversation_ConversationQueries_state_ConversationState_abandoned_ConversationState_nextSuggestions_PatientSuggestions_diseases_DiseaseForPlan_crFindings_ClinicalReasoningFinding_gfinding_GroupedFeatureResponse>>>, patientIcd?: Maybe<AbandonedPatientConversationQuery_conversation_ConversationQueries_state_ConversationState_abandoned_ConversationState_patientIcd_StateICDCodes> }
);

export type StartConversationQuery_conversation_ConversationQueries = (
  { __typename?: 'ConversationQueries' }
  & { start?: Maybe<StartConversationQuery_conversation_ConversationQueries_start_ConversationState> }
);

export type StartConversationQuery_Query = (
  { __typename?: 'Query' }
  & { conversation?: Maybe<StartConversationQuery_conversation_ConversationQueries>, gatewayModel?: Maybe<BackendModelInfoFragment_gatewayModel_LoadedModelInfo>, diagnosisModel?: Maybe<BackendModelInfoFragment_diagnosisModel_LoadedModelInfo> }
);


export type StartConversationQueryVariables = Exact<{
  qfLight?: InputMaybe<Scalars['Boolean']['input']>;
  includeFeatureRange?: InputMaybe<Scalars['Boolean']['input']>;
  debug?: InputMaybe<Scalars['Boolean']['input']>;
  patientCaseId?: InputMaybe<Scalars['String']['input']>;
  options?: InputMaybe<ConversationOptions>;
  conversationOptions?: InputMaybe<Scalars['ConversationOptionsInput']['input']>;
  clinicId?: InputMaybe<Scalars['String']['input']>;
}>;


export type StartConversationQuery = StartConversationQuery_Query;

export type PatientSummaryQuery_patientSummary_Summary_data_SummeryData = (
  { __typename?: 'SummeryData' }
  & Pick<SummeryData, 'age' | 'gender' | 'main'>
  & { visitReason?: Maybe<Array<Maybe<PatientFirstSummaryFragment_SummeryData_visitReason_SummaryVisitReason>>>, sections?: Maybe<Array<Maybe<PatientFirstSummaryFragment_SummeryData_sections_SummerySection>>> }
);

export type PatientSummaryQuery_patientSummary_Summary_recommendations_PolicyRecommendation = (
  { __typename?: 'PolicyRecommendation' }
  & Pick<PolicyRecommendation, 'policyName' | 'policyid' | 'protocolid' | 'protocolName'>
  & { feature?: Maybe<ConversationRecommendationFragment_PolicyRecommendation_feature_QualifiedFeature> }
);

export type PatientSummaryQuery_patientSummary_Summary_navigationAdvice_PolicyRecommendation = (
  { __typename?: 'PolicyRecommendation' }
  & Pick<PolicyRecommendation, 'policyName' | 'policyid' | 'protocolid' | 'protocolName'>
  & { feature?: Maybe<ConversationRecommendationFragment_PolicyRecommendation_feature_QualifiedFeature> }
);

export type PatientSummaryQuery_patientSummary_Summary_possibleCauses_PossibleCauses_possibleCauses_SummaryDiseaseCluster = (
  { __typename?: 'SummaryDiseaseCluster' }
  & Pick<SummaryDiseaseCluster, 'inTopCRPerSortType'>
  & { title?: Maybe<SummaryDiseaseClusterFragment_SummaryDiseaseCluster_title_QualifiedFeature>, scores?: Maybe<SummaryDiseaseClusterFragment_SummaryDiseaseCluster_scores_ScoreByType>, icd?: Maybe<Array<Maybe<SummaryDiseaseClusterFragment_SummaryDiseaseCluster_icd_SummaryICDCode>>>, explanation?: Maybe<SummaryDiseaseClusterFragment_SummaryDiseaseCluster_explanation_GroundedSummaryText> }
);

export type PatientSummaryQuery_patientSummary_Summary_possibleCauses_PossibleCauses = (
  { __typename?: 'PossibleCauses' }
  & Pick<PossibleCauses, 'etag'>
  & { possibleCauses?: Maybe<Array<Maybe<PatientSummaryQuery_patientSummary_Summary_possibleCauses_PossibleCauses_possibleCauses_SummaryDiseaseCluster>>> }
);

export type PatientSummaryQuery_patientSummary_Summary_problemList_SummaryProblem = (
  { __typename?: 'SummaryProblem' }
  & { problem?: Maybe<SummaryProblemFragment_SummaryProblem_problem_QualifiedFeature>, icd?: Maybe<Array<Maybe<SummaryProblemFragment_SummaryProblem_icd_SummaryICDCode>>> }
);

export type PatientSummaryQuery_patientSummary_Summary_assessment_GroundedSummaryText = (
  { __typename?: 'GroundedSummaryText' }
  & Pick<GroundedSummaryText, 'text' | 'generating' | 'error' | 'errorText' | 'etag'>
  & { citations?: Maybe<Array<Maybe<GroundedSummaryTextFragment_GroundedSummaryText_citations_RagCitation>>>, guidelines?: Maybe<Array<Maybe<GroundedSummaryTextFragment_GroundedSummaryText_guidelines_RagGuideline>>>, altGuidelines?: Maybe<Array<Maybe<GroundedSummaryTextFragment_GroundedSummaryText_altGuidelines_RagGuideline>>>, grounding?: Maybe<GroundedSummaryTextFragment_GroundedSummaryText_grounding_GeneratedGrounding> }
);

export type PatientSummaryQuery_patientSummary_Summary_workup_GroundedSummaryText = (
  { __typename?: 'GroundedSummaryText' }
  & Pick<GroundedSummaryText, 'text' | 'generating' | 'error' | 'errorText' | 'etag'>
);

export type PatientSummaryQuery_patientSummary_Summary_workup_UngroundedSummaryText = (
  { __typename?: 'UngroundedSummaryText' }
  & Pick<UngroundedSummaryText, 'text' | 'generating' | 'error' | 'errorText' | 'etag'>
);

export type PatientSummaryQuery_patientSummary_Summary_workup = PatientSummaryQuery_patientSummary_Summary_workup_GroundedSummaryText | PatientSummaryQuery_patientSummary_Summary_workup_UngroundedSummaryText;

export type PatientSummaryQuery_patientSummary_Summary_workupList_WorkupItem = (
  { __typename?: 'WorkupItem' }
  & Pick<WorkupItem, 'category' | 'title'>
);

export type PatientSummaryQuery_patientSummary_Summary_workupActionItems_WorkupActionItems_items_WorkupItem = (
  { __typename?: 'WorkupItem' }
  & Pick<WorkupItem, 'category' | 'title'>
);

export type PatientSummaryQuery_patientSummary_Summary_workupActionItems_WorkupActionItems = (
  { __typename?: 'WorkupActionItems' }
  & Pick<WorkupActionItems, 'generating' | 'error' | 'errorText' | 'etag'>
  & { items?: Maybe<Array<Maybe<PatientSummaryQuery_patientSummary_Summary_workupActionItems_WorkupActionItems_items_WorkupItem>>> }
);

export type PatientSummaryQuery_patientSummary_Summary_validCase_ValidCaseInfo = (
  { __typename?: 'ValidCaseInfo' }
  & Pick<ValidCaseInfo, 'isValid' | 'reason' | 'etag'>
);

export type PatientSummaryQuery_patientSummary_Summary = (
  { __typename?: 'Summary' }
  & Pick<Summary, 'status' | 'caseEtag'>
  & { data?: Maybe<PatientSummaryQuery_patientSummary_Summary_data_SummeryData>, recommendations?: Maybe<Array<Maybe<PatientSummaryQuery_patientSummary_Summary_recommendations_PolicyRecommendation>>>, navigationAdvice?: Maybe<PatientSummaryQuery_patientSummary_Summary_navigationAdvice_PolicyRecommendation>, possibleCauses?: Maybe<PatientSummaryQuery_patientSummary_Summary_possibleCauses_PossibleCauses>, problemList?: Maybe<Array<Maybe<PatientSummaryQuery_patientSummary_Summary_problemList_SummaryProblem>>>, assessment?: Maybe<PatientSummaryQuery_patientSummary_Summary_assessment_GroundedSummaryText>, workup?: Maybe<PatientSummaryQuery_patientSummary_Summary_workup>, workupList?: Maybe<Array<Maybe<PatientSummaryQuery_patientSummary_Summary_workupList_WorkupItem>>>, workupActionItems?: Maybe<PatientSummaryQuery_patientSummary_Summary_workupActionItems_WorkupActionItems>, validCase?: Maybe<PatientSummaryQuery_patientSummary_Summary_validCase_ValidCaseInfo> }
);

export type PatientSummaryQuery_Query = (
  { __typename?: 'Query' }
  & { patientSummary?: Maybe<PatientSummaryQuery_patientSummary_Summary> }
);


export type PatientSummaryQueryVariables = Exact<{
  id?: InputMaybe<Scalars['String']['input']>;
  options?: InputMaybe<SummaryOptions>;
  summaryOptions?: InputMaybe<Scalars['SummaryOptionsInput']['input']>;
  conversationOptions?: InputMaybe<ConversationOptions>;
  conversationOptionsInput?: InputMaybe<Scalars['ConversationOptionsInput']['input']>;
  qfLight?: InputMaybe<Scalars['Boolean']['input']>;
  includeFeatureRange?: InputMaybe<Scalars['Boolean']['input']>;
  clinicId?: InputMaybe<Scalars['String']['input']>;
}>;


export type PatientSummaryQuery = PatientSummaryQuery_Query;

export type PatientSummaryByContextQuery_conversation_ConversationQueries_state_ConversationState_summary_SummeryData = (
  { __typename?: 'SummeryData' }
  & Pick<SummeryData, 'age' | 'gender' | 'main'>
  & { visitReason?: Maybe<Array<Maybe<PatientFirstSummaryFragment_SummeryData_visitReason_SummaryVisitReason>>>, sections?: Maybe<Array<Maybe<PatientFirstSummaryFragment_SummeryData_sections_SummerySection>>> }
);

export type PatientSummaryByContextQuery_conversation_ConversationQueries_state_ConversationState_navigationRecommendation_PolicyRecommendation = (
  { __typename?: 'PolicyRecommendation' }
  & Pick<PolicyRecommendation, 'policyName' | 'policyid' | 'protocolid' | 'protocolName'>
  & { feature?: Maybe<ConversationRecommendationFragment_PolicyRecommendation_feature_QualifiedFeature> }
);

export type PatientSummaryByContextQuery_conversation_ConversationQueries_state_ConversationState = (
  { __typename?: 'ConversationState' }
  & { summary?: Maybe<PatientSummaryByContextQuery_conversation_ConversationQueries_state_ConversationState_summary_SummeryData>, navigationRecommendation?: Maybe<PatientSummaryByContextQuery_conversation_ConversationQueries_state_ConversationState_navigationRecommendation_PolicyRecommendation> }
);

export type PatientSummaryByContextQuery_conversation_ConversationQueries = (
  { __typename?: 'ConversationQueries' }
  & { state?: Maybe<PatientSummaryByContextQuery_conversation_ConversationQueries_state_ConversationState> }
);

export type PatientSummaryByContextQuery_Query = (
  { __typename?: 'Query' }
  & { conversation?: Maybe<PatientSummaryByContextQuery_conversation_ConversationQueries> }
);


export type PatientSummaryByContextQueryVariables = Exact<{
  context?: InputMaybe<Scalars['ConversationContext']['input']>;
  options?: InputMaybe<SummaryOptions>;
  conversationOptions?: InputMaybe<Scalars['ConversationOptionsInput']['input']>;
  qfLight?: InputMaybe<Scalars['Boolean']['input']>;
  includeFeatureRange?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type PatientSummaryByContextQuery = PatientSummaryByContextQuery_Query;

export type ConversationNextQuestionQuery_conversation_ConversationQueries_state_ConversationState = (
  { __typename?: 'ConversationState' }
  & MakeOptional<Pick<ConversationState, 'gender' | 'progress' | 'entropy' | 'context' | 'caseId' | 'caseReadOnly' | 'caseBasedOn' | 'options'>, 'entropy' | 'caseReadOnly' | 'caseBasedOn' | 'options'>
  & { nextQuestion?: Maybe<ConversationStateNextQFragment_ConversationState_nextQuestion_ConversationQuestion>, initialMessages?: Maybe<Array<Maybe<ConversationStateFragment_ConversationState_initialMessages_ConversationInfoMessage>>>, urgent?: Maybe<ConversationStateFragment_ConversationState_urgent_DDUrgency>, nextSuggestions?: Maybe<ConversationStateFragment_ConversationState_nextSuggestions_PatientSuggestions>, ddClusters?: Maybe<ConversationStateFragment_ConversationState_ddClusters_DDResponse>, recommendations?: Maybe<Array<Maybe<ConversationStateFragment_ConversationState_recommendations_PolicyRecommendation>>>, navigationRecommendation?: Maybe<ConversationStateFragment_ConversationState_navigationRecommendation_PolicyRecommendation>, patientFindings?: Maybe<Array<Maybe<ConversationStateFragment_ConversationState_patientFindings_GroupedFeatureResponse>>>, patientIcd?: Maybe<ConversationStateFragment_ConversationState_patientIcd_StateICDCodes> }
);

export type ConversationNextQuestionQuery_conversation_ConversationQueries = (
  { __typename?: 'ConversationQueries' }
  & { state?: Maybe<ConversationNextQuestionQuery_conversation_ConversationQueries_state_ConversationState> }
);

export type ConversationNextQuestionQuery_Query = (
  { __typename?: 'Query' }
  & { conversation?: Maybe<ConversationNextQuestionQuery_conversation_ConversationQueries> }
);


export type ConversationNextQuestionQueryVariables = Exact<{
  context?: InputMaybe<Scalars['ConversationContext']['input']>;
  endExchangeIndex?: InputMaybe<Scalars['Int']['input']>;
  qfLight?: InputMaybe<Scalars['Boolean']['input']>;
  debug?: InputMaybe<Scalars['Boolean']['input']>;
  includeFeatureRange?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<ConversationOptions>;
  conversationOptions?: InputMaybe<Scalars['ConversationOptionsInput']['input']>;
  panel?: InputMaybe<Scalars['ID']['input']>;
}>;


export type ConversationNextQuestionQuery = ConversationNextQuestionQuery_Query;

export type RestoreConversationQuery_conversation_ConversationQueries_state_ConversationState_exchanges_ConversationExchange = (
  { __typename?: 'ConversationExchange' }
  & Pick<ConversationExchange, 'patientAnswer' | 'progress'>
  & { question?: Maybe<ConversationExchangeFragment_ConversationExchange_question_ConversationQuestion>, answer?: Maybe<Array<Maybe<ConversationExchangeFragment_ConversationExchange_answer_ConversationExchangeAnswer>>>, messages?: Maybe<Array<Maybe<ConversationExchangeFragment_ConversationExchange_messages_ConversationInfoMessage>>> }
);

export type RestoreConversationQuery_conversation_ConversationQueries_state_ConversationState = (
  { __typename?: 'ConversationState' }
  & MakeOptional<Pick<ConversationState, 'gender' | 'progress' | 'entropy' | 'context' | 'caseId' | 'caseReadOnly' | 'caseBasedOn' | 'options'>, 'entropy' | 'caseReadOnly' | 'caseBasedOn' | 'options'>
  & { initialMessages?: Maybe<Array<Maybe<AbandonedPatientConversationQuery_conversation_ConversationQueries_state_ConversationState_abandoned_ConversationState_initialMessages_ConversationInfoMessage>>>, exchanges?: Maybe<Array<Maybe<RestoreConversationQuery_conversation_ConversationQueries_state_ConversationState_exchanges_ConversationExchange>>>, nextResponse?: Maybe<ConversationStateNextResponseFragment_ConversationState_nextResponse_ConversationResponse>, urgent?: Maybe<AbandonedPatientConversationQuery_conversation_ConversationQueries_state_ConversationState_abandoned_ConversationState_urgent_DDUrgency>, nextSuggestions?: Maybe<AbandonedPatientConversationQuery_conversation_ConversationQueries_state_ConversationState_abandoned_ConversationState_nextSuggestions_PatientSuggestions>, ddClusters?: Maybe<AbandonedPatientConversationQuery_conversation_ConversationQueries_state_ConversationState_abandoned_ConversationState_ddClusters_DDResponse>, recommendations?: Maybe<Array<Maybe<AbandonedPatientConversationQuery_conversation_ConversationQueries_state_ConversationState_abandoned_ConversationState_recommendations_PolicyRecommendation>>>, navigationRecommendation?: Maybe<AbandonedPatientConversationQuery_conversation_ConversationQueries_state_ConversationState_abandoned_ConversationState_recommendations_PolicyRecommendation>, patientFindings?: Maybe<Array<Maybe<AbandonedPatientConversationQuery_conversation_ConversationQueries_state_ConversationState_abandoned_ConversationState_nextSuggestions_PatientSuggestions_diseases_DiseaseForPlan_crFindings_ClinicalReasoningFinding_gfinding_GroupedFeatureResponse>>>, patientIcd?: Maybe<AbandonedPatientConversationQuery_conversation_ConversationQueries_state_ConversationState_abandoned_ConversationState_patientIcd_StateICDCodes> }
);

export type RestoreConversationQuery_conversation_ConversationQueries = (
  { __typename?: 'ConversationQueries' }
  & { state?: Maybe<RestoreConversationQuery_conversation_ConversationQueries_state_ConversationState> }
);

export type RestoreConversationQuery_Query = (
  { __typename?: 'Query' }
  & { conversation?: Maybe<RestoreConversationQuery_conversation_ConversationQueries>, gatewayModel?: Maybe<BackendModelInfoFragment_gatewayModel_LoadedModelInfo>, diagnosisModel?: Maybe<BackendModelInfoFragment_diagnosisModel_LoadedModelInfo> }
);


export type RestoreConversationQueryVariables = Exact<{
  context?: InputMaybe<Scalars['ConversationContext']['input']>;
  qfLight?: InputMaybe<Scalars['Boolean']['input']>;
  debug?: InputMaybe<Scalars['Boolean']['input']>;
  includeFeatureRange?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<ConversationOptions>;
  privateMode?: InputMaybe<Scalars['Boolean']['input']>;
  conversationOptions?: InputMaybe<Scalars['ConversationOptionsInput']['input']>;
}>;


export type RestoreConversationQuery = RestoreConversationQuery_Query;

export type DebugForLastQuestionQuery_conversation_ConversationQueries_state_ConversationState_exchanges_ConversationExchange = (
  { __typename?: 'ConversationExchange' }
  & Pick<ConversationExchange, 'patientAnswer' | 'progress'>
  & { question?: Maybe<ConversationExchangeFragment_ConversationExchange_question_ConversationQuestion>, answer?: Maybe<Array<Maybe<ConversationExchangeFragment_ConversationExchange_answer_ConversationExchangeAnswer>>>, messages?: Maybe<Array<Maybe<ConversationExchangeFragment_ConversationExchange_messages_ConversationInfoMessage>>> }
);

export type DebugForLastQuestionQuery_conversation_ConversationQueries_state_ConversationState = (
  { __typename?: 'ConversationState' }
  & MakeOptional<Pick<ConversationState, 'debugInfo' | 'gender' | 'progress' | 'entropy' | 'context' | 'caseId' | 'caseReadOnly' | 'caseBasedOn' | 'options'>, 'entropy' | 'caseReadOnly' | 'caseBasedOn' | 'options'>
  & { initialMessages?: Maybe<Array<Maybe<AbandonedPatientConversationQuery_conversation_ConversationQueries_state_ConversationState_abandoned_ConversationState_initialMessages_ConversationInfoMessage>>>, exchanges?: Maybe<Array<Maybe<DebugForLastQuestionQuery_conversation_ConversationQueries_state_ConversationState_exchanges_ConversationExchange>>>, nextResponse?: Maybe<ConversationStateNextResponseFragment_ConversationState_nextResponse_ConversationResponse>, urgent?: Maybe<AbandonedPatientConversationQuery_conversation_ConversationQueries_state_ConversationState_abandoned_ConversationState_urgent_DDUrgency>, nextSuggestions?: Maybe<AbandonedPatientConversationQuery_conversation_ConversationQueries_state_ConversationState_abandoned_ConversationState_nextSuggestions_PatientSuggestions>, ddClusters?: Maybe<AbandonedPatientConversationQuery_conversation_ConversationQueries_state_ConversationState_abandoned_ConversationState_ddClusters_DDResponse>, recommendations?: Maybe<Array<Maybe<AbandonedPatientConversationQuery_conversation_ConversationQueries_state_ConversationState_abandoned_ConversationState_recommendations_PolicyRecommendation>>>, navigationRecommendation?: Maybe<AbandonedPatientConversationQuery_conversation_ConversationQueries_state_ConversationState_abandoned_ConversationState_recommendations_PolicyRecommendation>, patientFindings?: Maybe<Array<Maybe<AbandonedPatientConversationQuery_conversation_ConversationQueries_state_ConversationState_abandoned_ConversationState_nextSuggestions_PatientSuggestions_diseases_DiseaseForPlan_crFindings_ClinicalReasoningFinding_gfinding_GroupedFeatureResponse>>>, patientIcd?: Maybe<AbandonedPatientConversationQuery_conversation_ConversationQueries_state_ConversationState_abandoned_ConversationState_patientIcd_StateICDCodes> }
);

export type DebugForLastQuestionQuery_conversation_ConversationQueries = (
  { __typename?: 'ConversationQueries' }
  & { state?: Maybe<DebugForLastQuestionQuery_conversation_ConversationQueries_state_ConversationState> }
);

export type DebugForLastQuestionQuery_Query = (
  { __typename?: 'Query' }
  & { conversation?: Maybe<DebugForLastQuestionQuery_conversation_ConversationQueries>, gatewayModel?: Maybe<BackendModelInfoFragment_gatewayModel_LoadedModelInfo>, diagnosisModel?: Maybe<BackendModelInfoFragment_diagnosisModel_LoadedModelInfo> }
);


export type DebugForLastQuestionQueryVariables = Exact<{
  context?: InputMaybe<Scalars['ConversationContext']['input']>;
  qfLight?: InputMaybe<Scalars['Boolean']['input']>;
  debug?: InputMaybe<Scalars['Boolean']['input']>;
  includeFeatureRange?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<ConversationOptions>;
  privateMode?: InputMaybe<Scalars['Boolean']['input']>;
  conversationOptions?: InputMaybe<Scalars['ConversationOptionsInput']['input']>;
  endExchangeIndex?: InputMaybe<Scalars['Int']['input']>;
}>;


export type DebugForLastQuestionQuery = DebugForLastQuestionQuery_Query;

export type DdFromConversationQuery_conversation_ConversationQueries_state_ConversationState_ddClusters_DDResponse = (
  { __typename?: 'DDResponse' }
  & Pick<DdResponse, 'debugReport' | 'options'>
  & { allFindings?: Maybe<Array<Maybe<ConversationDdFragment_DDResponse_allFindings_QualifiedFeature>>>, clinicalReasoning?: Maybe<Array<Maybe<ConversationDdFragment_DDResponse_clinicalReasoning_ClinicalReasoning>>>, clustersToConsider?: Maybe<Array<Maybe<ConversationDdFragment_DDResponse_clustersToConsider_DiseaseCluster>>> }
);

export type DdFromConversationQuery_conversation_ConversationQueries_state_ConversationState_urgent_DDUrgency = (
  { __typename?: 'DDUrgency' }
  & Pick<DdUrgency, 'urgencyLevelId'>
);

export type DdFromConversationQuery_conversation_ConversationQueries_state_ConversationState_navigationRecommendation_PolicyRecommendation = (
  { __typename?: 'PolicyRecommendation' }
  & Pick<PolicyRecommendation, 'policyName' | 'policyid' | 'protocolid' | 'protocolName'>
  & { feature?: Maybe<ConversationRecommendationFragment_PolicyRecommendation_feature_QualifiedFeature> }
);

export type DdFromConversationQuery_conversation_ConversationQueries_state_ConversationState = (
  { __typename?: 'ConversationState' }
  & Pick<ConversationState, 'primaryDDClusters'>
  & { ddClusters?: Maybe<DdFromConversationQuery_conversation_ConversationQueries_state_ConversationState_ddClusters_DDResponse>, urgent?: Maybe<DdFromConversationQuery_conversation_ConversationQueries_state_ConversationState_urgent_DDUrgency>, navigationRecommendation?: Maybe<DdFromConversationQuery_conversation_ConversationQueries_state_ConversationState_navigationRecommendation_PolicyRecommendation> }
);

export type DdFromConversationQuery_conversation_ConversationQueries = (
  { __typename?: 'ConversationQueries' }
  & { state?: Maybe<DdFromConversationQuery_conversation_ConversationQueries_state_ConversationState> }
);

export type DdFromConversationQuery_Query = (
  { __typename?: 'Query' }
  & { conversation?: Maybe<DdFromConversationQuery_conversation_ConversationQueries> }
);


export type DdFromConversationQueryVariables = Exact<{
  context?: InputMaybe<Scalars['ConversationContext']['input']>;
  qfLight?: InputMaybe<Scalars['Boolean']['input']>;
  includeFeatureRange?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<ConversationOptions>;
  conversationOptions?: InputMaybe<Scalars['ConversationOptionsInput']['input']>;
}>;


export type DdFromConversationQuery = DdFromConversationQuery_Query;

export type BackendModelQuery_Query = (
  { __typename?: 'Query' }
  & { gatewayModel?: Maybe<BackendModelInfoFragment_gatewayModel_LoadedModelInfo>, diagnosisModel?: Maybe<BackendModelInfoFragment_diagnosisModel_LoadedModelInfo> }
);


export type BackendModelQueryVariables = Exact<{
  debug?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type BackendModelQuery = BackendModelQuery_Query;

export type FeatureByIdQuery_feature_Feature = (
  { __typename?: 'Feature' }
  & Pick<Feature, 'name' | 'id' | 'shortname' | 'patientDescription' | 'alias' | 'skipDuration' | 'hasRefinement'>
  & { organSystem?: Maybe<FindingMetricsFragment_DiseaseFindingMetrics_finding_RCohort_qfs_QualifiedFeature_feature_Feature_organSystem_Feature>, category?: Maybe<FindingMetricsFragment_DiseaseFindingMetrics_finding_RCohort_qfs_QualifiedFeature_feature_Feature_category_Feature>, qualifierSpec?: Maybe<Array<Maybe<FindingMetricsFragment_DiseaseFindingMetrics_finding_RCohort_qfs_QualifiedFeature_feature_Feature_qualifierSpec_QualifierSpec>>>, description?: Maybe<FindingMetricsFragment_DiseaseFindingMetrics_finding_RCohort_qfs_QualifiedFeature_feature_Feature_description_Description>, range?: Maybe<FindingMetricsFragment_DiseaseFindingMetrics_finding_RCohort_qfs_QualifiedFeature_feature_Feature_range_MeasurementRange>, inferredParents?: Maybe<Array<Maybe<FindingMetricsFragment_DiseaseFindingMetrics_finding_RCohort_qfs_QualifiedFeature_feature_Feature_inferredParents_Feature>>>, inferredChildren?: Maybe<Array<Maybe<FindingMetricsFragment_DiseaseFindingMetrics_finding_RCohort_qfs_QualifiedFeature_feature_Feature_inferredChildren_Feature>>>, qualifiers?: Maybe<Array<Maybe<FindingMetricsFragment_DiseaseFindingMetrics_finding_RCohort_qfs_QualifiedFeature_feature_Feature_qualifiers_Qualifier>>>, inferredQualifiers?: Maybe<Array<Maybe<FindingMetricsFragment_DiseaseFindingMetrics_finding_RCohort_qfs_QualifiedFeature_feature_Feature_inferredQualifiers_Qualifier>>> }
);

export type FeatureByIdQuery_Query = (
  { __typename?: 'Query' }
  & { feature?: Maybe<FeatureByIdQuery_feature_Feature> }
);


export type FeatureByIdQueryVariables = Exact<{
  id: Scalars['ID']['input'];
  qfLight?: InputMaybe<Scalars['Boolean']['input']>;
  includeFeatureRange?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type FeatureByIdQuery = FeatureByIdQuery_Query;

export type GetPoliciesQuery_policies_Policy = (
  { __typename?: 'Policy' }
  & Pick<Policy, 'id' | 'name'>
);

export type GetPoliciesQuery_Query = (
  { __typename?: 'Query' }
  & { policies?: Maybe<Array<Maybe<GetPoliciesQuery_policies_Policy>>> }
);


export type GetPoliciesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetPoliciesQuery = GetPoliciesQuery_Query;

export type GetPanelsQuery_panels_Panel = (
  { __typename?: 'Panel' }
  & Pick<Panel, 'id' | 'name'>
);

export type GetPanelsQuery_Query = (
  { __typename?: 'Query' }
  & { panels?: Maybe<Array<Maybe<GetPanelsQuery_panels_Panel>>> }
);


export type GetPanelsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetPanelsQuery = GetPanelsQuery_Query;
